export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: string; output: string; }
  DateTime: { input: string; output: string; }
  JSON: { input: any; output: any; }
  Mixed: { input: any; output: any; }
  WorkflowStructure: { input: any; output: any; }
};

export type AdSetting = {
  __typename?: 'AdSetting';
  billboard?: Maybe<AdSettingConfig>;
  cad1?: Maybe<AdSettingConfig>;
  cad2?: Maybe<AdSettingConfig>;
  cad3?: Maybe<AdSettingConfig>;
  id: Scalars['ID']['output'];
  left?: Maybe<AdSettingConfig>;
  mobile_bottom?: Maybe<AdSettingConfig>;
  mobile_cad1?: Maybe<AdSettingConfig>;
  mobile_cad2?: Maybe<AdSettingConfig>;
  mobile_top?: Maybe<AdSettingConfig>;
  right1?: Maybe<AdSettingConfig>;
  right2?: Maybe<AdSettingConfig>;
  title?: Maybe<Scalars['String']['output']>;
  top?: Maybe<AdSettingConfig>;
  video?: Maybe<AdSettingConfig>;
};

export type AdSettingConfig = {
  __typename?: 'AdSettingConfig';
  breakpoints?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  yieldLab?: Maybe<Array<AdSettingYieldlab>>;
};

export type AdSettingYieldlab = {
  __typename?: 'AdSettingYieldlab';
  yieldlabAdsCheckId?: Maybe<Scalars['Int']['output']>;
  yieldlabAdslotVal?: Maybe<Scalars['Int']['output']>;
};

export type AmazonProduct = {
  __typename?: 'AmazonProduct';
  /** Brand */
  brand?: Maybe<Scalars['String']['output']>;
  /** Currency */
  currency?: Maybe<Scalars['String']['output']>;
  /** Text description */
  description?: Maybe<Scalars['String']['output']>;
  /** ID */
  id?: Maybe<Scalars['String']['output']>;
  /** Image */
  image?: Maybe<Scalars['String']['output']>;
  /** Price */
  price?: Maybe<Scalars['Float']['output']>;
  /** Savings */
  savings?: Maybe<Scalars['Float']['output']>;
  /** Saving base price */
  savings_base?: Maybe<Scalars['Float']['output']>;
  /** Title */
  title?: Maybe<Scalars['String']['output']>;
  /** Link */
  url?: Maybe<Scalars['String']['output']>;
};


export type AmazonProductDescriptionArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AppDeviceResult = {
  __typename?: 'AppDeviceResult';
  /** The channels the device follows now: exactly the set that was sent. */
  channels: Array<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type AppPushAnnouncement = {
  __typename?: 'AppPushAnnouncement';
  queued: Scalars['Boolean']['output'];
  /** Why nothing was queued, or 'dry run' while the portal's switch in the CP is off. */
  reason?: Maybe<Scalars['String']['output']>;
  recipients: Scalars['Int']['output'];
};

export type AppleTvAppLine = {
  __typename?: 'AppleTvAppLine';
  entities?: Maybe<Array<EntityEntry>>;
  headline?: Maybe<Scalars['String']['output']>;
};

export type ArchiveIssue = {
  __typename?: 'ArchiveIssue';
  /** Number of archive articles (APA/Visiolink) published on this issue date */
  article_count: Scalars['Int']['output'];
  articles?: Maybe<Array<Article>>;
  cover_image?: Maybe<FairuAsset>;
  cover_image_path?: Maybe<Scalars['ID']['output']>;
  /** Cover fallback: S3 URL of the first scanned page (when no Fairu cover exists) */
  cover_url?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  description_html?: Maybe<Scalars['String']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
  /** Entry point for the page viewer: id of the first xml_page of this issue */
  first_page_id?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  issue_number?: Maybe<Scalars['Int']['output']>;
  month?: Maybe<Scalars['String']['output']>;
  origin_id?: Maybe<Scalars['String']['output']>;
  /** Number of scanned pages (xml_pages) for this issue — 0 for article-only issues */
  page_count: Scalars['Int']['output'];
  published?: Maybe<Scalars['Boolean']['output']>;
  published_at?: Maybe<Scalars['DateTime']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<VgnArchiveMedia>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  year?: Maybe<Scalars['Int']['output']>;
};

export type ArchiveIssuePagination = {
  __typename?: 'ArchiveIssuePagination';
  data?: Maybe<Array<ArchiveIssue>>;
  paginatorInfo?: Maybe<DefaultPaginator>;
};

export type ArchivePage = {
  __typename?: 'ArchivePage';
  articles_on_page?: Maybe<Array<VgnArchiveArticle>>;
  id: Scalars['ID']['output'];
  image_height?: Maybe<Scalars['Int']['output']>;
  image_path?: Maybe<Scalars['String']['output']>;
  image_url?: Maybe<Scalars['String']['output']>;
  image_width?: Maybe<Scalars['Int']['output']>;
  issue: Scalars['String']['output'];
  large_image_path?: Maybe<Scalars['String']['output']>;
  large_image_url?: Maybe<Scalars['String']['output']>;
  medium: Scalars['String']['output'];
  page_number: Scalars['Int']['output'];
  pdf_url?: Maybe<Scalars['String']['output']>;
  publish_date?: Maybe<Scalars['Date']['output']>;
  reader_image_path?: Maybe<Scalars['String']['output']>;
  reader_image_url?: Maybe<Scalars['String']['output']>;
  regions?: Maybe<Array<ArchivePageRegion>>;
  text?: Maybe<Scalars['String']['output']>;
};

/** A clickable article area on a page, normalized 0..1 (top-left origin). */
export type ArchivePageRegion = {
  __typename?: 'ArchivePageRegion';
  article_id?: Maybe<Scalars['String']['output']>;
  article_slug?: Maybe<Scalars['String']['output']>;
  height: Scalars['Float']['output'];
  title?: Maybe<Scalars['String']['output']>;
  width: Scalars['Float']['output'];
  x: Scalars['Float']['output'];
  y: Scalars['Float']['output'];
};

export type ArchiveSearchPagination = {
  __typename?: 'ArchiveSearchPagination';
  data: Array<ArchiveSearchResult>;
  paginatorInfo?: Maybe<DefaultPaginator>;
};

/** One hit of the unified archive search — either a real article (APA/Visiolink) or a scanned page (xml_pages). */
export type ArchiveSearchResult = {
  __typename?: 'ArchiveSearchResult';
  /** Cover of the issue the hit belongs to — orientation while scanning results */
  cover_url?: Maybe<Scalars['String']['output']>;
  /** Highlighted, cropped text excerpt */
  excerpt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  kind: ArchiveSearchResultKind;
  /** Page hits: page number within the issue */
  page_number?: Maybe<Scalars['Int']['output']>;
  published?: Maybe<Scalars['String']['output']>;
  /** Article hits: slug for /archiv/article/{slug} */
  slug?: Maybe<Scalars['String']['output']>;
  thumbnail_url?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export enum ArchiveSearchResultKind {
  Article = 'ARTICLE',
  Page = 'PAGE'
}

export type ArchiveYearStats = {
  __typename?: 'ArchiveYearStats';
  count: Scalars['Int']['output'];
  cover_issue?: Maybe<ArchiveIssue>;
  year: Scalars['Int']['output'];
};

export type Article = ArticleInterface & {
  __typename?: 'Article';
  /** Ad settings for the page */
  ad_settings?: Maybe<AdSetting>;
  /** Advertorial entry */
  advertorial?: Maybe<Scalars['Boolean']['output']>;
  /** Which type of text should be visible in lists */
  advertorial_tag?: Maybe<Scalars['String']['output']>;
  /** Returns the text which should be displayed */
  advertorial_tag_text?: Maybe<Scalars['String']['output']>;
  /** Advertorial entry alternative text */
  advertorial_text?: Maybe<Scalars['String']['output']>;
  /** Alternative keywords for the article */
  alt_keywords?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  apa?: Maybe<Scalars['Boolean']['output']>;
  /** Authors of the article */
  authors?: Maybe<Array<Maybe<User>>>;
  /** Content elements */
  content?: Maybe<Array<Maybe<ContentElement>>>;
  /** Entry is a cornerstone entry */
  cornerstone?: Maybe<Scalars['Boolean']['output']>;
  cover_gallery?: Maybe<Gallery>;
  cover_image?: Maybe<FairuAsset>;
  cover_image_calculated?: Maybe<ArticleImage>;
  cover_image_disable_compression?: Maybe<Scalars['Boolean']['output']>;
  /** Play the cover as a muted loop when it is a video */
  cover_video_play?: Maybe<Scalars['Boolean']['output']>;
  /** Created at */
  created_at?: Maybe<Scalars['DateTime']['output']>;
  custom_badge?: Maybe<Scalars['String']['output']>;
  /** Disable ads for the article */
  disable_ads?: Maybe<Scalars['Boolean']['output']>;
  enforce_image_in_list?: Maybe<Scalars['Boolean']['output']>;
  /** goTom Kampagnen-ID (nur intern, für Reporting/PM-Tool) */
  gotom_id?: Maybe<Scalars['String']['output']>;
  /** Header order (news Layout tab): default | image_title_teaser | title_teaser_image */
  header_layout?: Maybe<Scalars['String']['output']>;
  /** Mobile only: full-width cover image with the title on it */
  header_mobile_overlay?: Maybe<Scalars['Boolean']['output']>;
  /** Headline of the article. */
  headline?: Maybe<Scalars['String']['output']>;
  /** Should the authors be not visible */
  hide_authors?: Maybe<Scalars['Boolean']['output']>;
  /** Should the authors be not visible at the bottom */
  hide_authors_bottom?: Maybe<Scalars['Boolean']['output']>;
  /** Should the cover image be not visible in the detail view */
  hide_cover_image?: Maybe<Scalars['Boolean']['output']>;
  hide_reading_time?: Maybe<Scalars['Boolean']['output']>;
  hide_updated_at?: Maybe<Scalars['Boolean']['output']>;
  /** Unique primary key. */
  id: Scalars['ID']['output'];
  /** Card image as a plain CardImage read from the baked sidecar (no FairuAsset federation) — for GeneralArticleInfosSimple so every card surface resolves cheap. */
  image_card?: Maybe<CardImage>;
  /** Interview participants/persons */
  interview_persons?: Maybe<Array<Maybe<Person>>>;
  /** Main key word for the article */
  keyword?: Maybe<Scalars['String']['output']>;
  /** Meta data */
  metadata?: Maybe<Meta>;
  /** Oewa data */
  oewa?: Maybe<Oewa>;
  /** Outbrain compliant */
  outbrain_compliant?: Maybe<Scalars['Boolean']['output']>;
  /** Outbrain deactivated */
  outbrain_disabled?: Maybe<Scalars['Boolean']['output']>;
  /** Paid content settings */
  paid_content?: Maybe<PaidContent>;
  /** Url or path for the article. */
  path?: Maybe<Scalars['String']['output']>;
  /** Portal of the article. */
  portal?: Maybe<Scalars['String']['output']>;
  /** Products linked to this article's ressort (editorial product catalog) */
  products?: Maybe<Array<Maybe<Product>>>;
  /** Is the entry published  */
  published?: Maybe<Scalars['Boolean']['output']>;
  /** Published at */
  published_at?: Maybe<Scalars['DateTime']['output']>;
  /** Reading time */
  reading_time?: Maybe<Scalars['Int']['output']>;
  /** Ressort */
  ressort?: Maybe<Ressort>;
  /** Similar articles as pre-projected flat cards — plain type, no @field per card (fast). */
  similar_article_cards?: Maybe<Array<Maybe<ArticleCard>>>;
  /** Similar articles or related articles */
  similar_articles?: Maybe<Array<Maybe<Article>>>;
  /** Slug or alias for the articles. */
  slug?: Maybe<Scalars['String']['output']>;
  /** Full slug. */
  slug_full?: Maybe<Scalars['String']['output']>;
  stage_headline?: Maybe<Scalars['String']['output']>;
  stage_image?: Maybe<FairuAsset>;
  stage_teaser?: Maybe<Scalars['String']['output']>;
  sticky_rank?: Maybe<Scalars['Boolean']['output']>;
  /** Teaser of the article */
  teaser?: Maybe<Scalars['String']['output']>;
  /** Teaser image as a plain CardImage from the baked sidecar — the card's PREFERRED image (teaser first, cover fallback), video-aware (carries the .mp4 url + video/ mime) so a video teaser plays without federating the FairuAsset. Feeds teaser_image on the FE cards; image_card stays the cover fallback. */
  teaser_card?: Maybe<CardImage>;
  teaser_description?: Maybe<Scalars['String']['output']>;
  teaser_headline?: Maybe<Scalars['String']['output']>;
  teaser_image?: Maybe<FairuAsset>;
  teaser_image_mode?: Maybe<Scalars['String']['output']>;
  /** Topics related to this article */
  topics?: Maybe<Array<Maybe<Topic>>>;
  /** Updated at */
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};


export type ArticleSimilar_Article_CardsArgs = {
  max?: InputMaybe<Scalars['Int']['input']>;
};


export type ArticleSimilar_ArticlesArgs = {
  max?: InputMaybe<Scalars['Int']['input']>;
};


export type ArticleSlugArgs = {
  simple?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ArticleStage_TeaserArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ArticleTeaserArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ArticleTeaser_DescriptionArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * Pre-projected, flat article card for the similar/related boxes. Every field is a plain scalar
 * read straight from the sidecar (default resolver = array access) — no @field resolvers, no
 * FairuAsset, so the router resolves a card without per-field recompute or federation.
 */
export type ArticleCard = {
  __typename?: 'ArticleCard';
  advertorial?: Maybe<Scalars['Boolean']['output']>;
  advertorial_tag?: Maybe<Scalars['String']['output']>;
  /** Pre-computed in the projection (mirrors @advertorialText) — plain scalar, no directive. */
  advertorial_tag_text?: Maybe<Scalars['String']['output']>;
  advertorial_text?: Maybe<Scalars['String']['output']>;
  apa?: Maybe<Scalars['Boolean']['output']>;
  authors?: Maybe<Array<Maybe<CardAuthor>>>;
  created_at?: Maybe<Scalars['String']['output']>;
  custom_badge?: Maybe<Scalars['String']['output']>;
  headline?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  /** Cover-sourced (first gallery asset fallback) — the card's regular/still image. */
  image?: Maybe<CardImage>;
  path?: Maybe<Scalars['String']['output']>;
  published_at?: Maybe<Scalars['String']['output']>;
  reading_time?: Maybe<Scalars['Int']['output']>;
  ressort?: Maybe<CardRessort>;
  slug?: Maybe<Scalars['String']['output']>;
  slug_full?: Maybe<Scalars['String']['output']>;
  teaser?: Maybe<Scalars['String']['output']>;
  teaser_description?: Maybe<Scalars['String']['output']>;
  teaser_headline?: Maybe<Scalars['String']['output']>;
  /** The card's PREFERRED image — teaser-first, cover fallback, video-aware (mime + raw .mp4 url). */
  teaser_image?: Maybe<CardImage>;
  teaser_image_mode?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['String']['output']>;
};

export type ArticleImage = FairuAsset | GustoRecipeCoverImage;

export type ArticleInterface = {
  /** Advertorial entry */
  advertorial?: Maybe<Scalars['Boolean']['output']>;
  /** Which type of text should be visible in lists */
  advertorial_tag?: Maybe<Scalars['String']['output']>;
  /** Alternative keywords for the article */
  alt_keywords?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Is this entry a corner stone entry? */
  cornerstone?: Maybe<Scalars['Boolean']['output']>;
  /** Created at */
  created_at?: Maybe<Scalars['DateTime']['output']>;
  /** Headline of the article. */
  headline?: Maybe<Scalars['String']['output']>;
  /** Unique primary key. */
  id: Scalars['ID']['output'];
  /** Main key word for the article */
  keyword?: Maybe<Scalars['String']['output']>;
  /** Meta data */
  metadata?: Maybe<Meta>;
  /** Outbrain compliant */
  outbrain_compliant?: Maybe<Scalars['Boolean']['output']>;
  /** Url or path for the article. */
  path?: Maybe<Scalars['String']['output']>;
  /** Portal of the article. */
  portal?: Maybe<Scalars['String']['output']>;
  /** Is the entry published  */
  published?: Maybe<Scalars['Boolean']['output']>;
  /** Similar articles or related articles */
  similar_articles?: Maybe<Array<Maybe<Article>>>;
  /** Slug or alias for the articles. */
  slug?: Maybe<Scalars['String']['output']>;
  /** Teaser of the article */
  teaser?: Maybe<Scalars['String']['output']>;
  /** Updated at */
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type ArticlePaginator = {
  __typename?: 'ArticlePaginator';
  data?: Maybe<Array<Maybe<Article>>>;
  paginatorInfo?: Maybe<PaginatorInfo>;
};

export type ArticlePaginatorSimple = {
  __typename?: 'ArticlePaginatorSimple';
  data?: Maybe<Array<Maybe<Article>>>;
  paginatorInfo?: Maybe<DefaultPaginator>;
};

export type ArticleShort = {
  __typename?: 'ArticleShort';
  /** Cover image url */
  cover_image?: Maybe<Scalars['String']['output']>;
  /** Article headline */
  headline?: Maybe<Scalars['String']['output']>;
  /** The id within the cms */
  id?: Maybe<Scalars['ID']['output']>;
  /** Url the article */
  path?: Maybe<Scalars['String']['output']>;
};

export type ArticleSubscriptionAd = {
  __typename?: 'ArticleSubscriptionAd';
  button_text?: Maybe<Scalars['String']['output']>;
  details?: Maybe<Scalars['String']['output']>;
  /** Title that will be displayed on the message */
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type Asset = {
  __typename?: 'Asset';
  /** Alt text for asset */
  alt?: Maybe<Scalars['String']['output']>;
  /** Caption */
  caption?: Maybe<Scalars['String']['output']>;
  /** Copyright */
  copyright?: Maybe<Scalars['String']['output']>;
  /** Orignal path to asset */
  external_path?: Maybe<Scalars['String']['output']>;
  file?: Maybe<GlideData>;
  focus_information?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  /** Height */
  height?: Maybe<Scalars['Int']['output']>;
  /** Id */
  id: Scalars['ID']['output'];
  /** Is audio */
  is_audio?: Maybe<Scalars['Boolean']['output']>;
  /** Is image */
  is_image?: Maybe<Scalars['Boolean']['output']>;
  /** Is video */
  is_video?: Maybe<Scalars['Boolean']['output']>;
  origin?: Maybe<Scalars['String']['output']>;
  /** Original height */
  original_height?: Maybe<Scalars['Int']['output']>;
  /** Original width */
  original_width?: Maybe<Scalars['Int']['output']>;
  /** Path to asset */
  path?: Maybe<Scalars['String']['output']>;
  /** Orignal path to asset */
  path_original?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  /** Width */
  width?: Maybe<Scalars['Int']['output']>;
};


export type AssetCaptionArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetFileArgs = {
  fit?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<Scalars['String']['input']>;
  height?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type BankAccountInput = {
  accountHolder?: InputMaybe<Scalars['String']['input']>;
  accountHolderFirstName?: InputMaybe<Scalars['String']['input']>;
  accountHolderLastName?: InputMaybe<Scalars['String']['input']>;
  bank: Scalars['String']['input'];
  bic: Scalars['String']['input'];
  iban: Scalars['String']['input'];
};

export type BarChart = {
  __typename?: 'BarChart';
  baseline?: Maybe<Scalars['Float']['output']>;
  items?: Maybe<Array<Maybe<BarChartItem>>>;
  mode?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type BarChartItem = {
  __typename?: 'BarChartItem';
  label?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type BaseInterface = {
  /** Unique primary key. */
  id?: Maybe<Scalars['String']['output']>;
};

export type BasketAddressInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<CustomerStatusInput>;
  door?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  houseNumber?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  salutation?: InputMaybe<CustomerStatusInput>;
  stairs?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type BasketShippingCharge = {
  __typename?: 'BasketShippingCharge';
  amount?: Maybe<Scalars['Float']['output']>;
  amountDiscounts?: Maybe<Scalars['Float']['output']>;
  amountNet?: Maybe<Scalars['Float']['output']>;
  amountNetDiscounts?: Maybe<Scalars['Float']['output']>;
  chargeMode?: Maybe<CustomerStatus>;
  chargeType?: Maybe<CustomerStatus>;
  shipment?: Maybe<CustomerStatus>;
  taxRate?: Maybe<Scalars['Float']['output']>;
  undiscountedAmount?: Maybe<Scalars['Float']['output']>;
  undiscountedAmountNet?: Maybe<Scalars['Float']['output']>;
};

/** Simple type for booked user info without federation */
export type BookedEventUser = {
  __typename?: 'BookedEventUser';
  /** User email */
  email?: Maybe<Scalars['String']['output']>;
  /** User ID */
  id: Scalars['ID']['output'];
};

export type CacheClearResult = {
  __typename?: 'CacheClearResult';
  keysDeleted?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  redisCleared?: Maybe<Scalars['Boolean']['output']>;
  success: Scalars['Boolean']['output'];
  varnishCleared?: Maybe<Scalars['Boolean']['output']>;
};

export type CalculatorForm = {
  __typename?: 'CalculatorForm';
  id: Scalars['ID']['output'];
  json?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type CardAuthor = {
  __typename?: 'CardAuthor';
  name?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
};

export type CardImage = {
  __typename?: 'CardImage';
  alt?: Maybe<Scalars['String']['output']>;
  /** Fairu caption (HTML), baked like the other fields — galleries show it under each image. */
  caption?: Maybe<Scalars['String']['output']>;
  copyright_text?: Maybe<Scalars['String']['output']>;
  focal_point?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  /** MIME (e.g. video/mp4) so the FE can detect a video teaser without federating the FairuAsset. */
  mime?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

export type CardRessort = {
  __typename?: 'CardRessort';
  path?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type CardsGridCard = {
  __typename?: 'CardsGridCard';
  body?: Maybe<Scalars['String']['output']>;
  headline?: Maybe<Scalars['String']['output']>;
  image?: Maybe<FairuAsset>;
  link_label?: Maybe<Scalars['String']['output']>;
  link_url?: Maybe<Scalars['String']['output']>;
  num_label?: Maybe<Scalars['String']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
};


export type CardsGridCardBodyArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ChallengeProgress = {
  __typename?: 'ChallengeProgress';
  active_to?: Maybe<Scalars['String']['output']>;
  completed: Scalars['Boolean']['output'];
  /** Distinct qualifying actions so far, capped at threshold. */
  current: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  event_type: Scalars['String']['output'];
  points: Scalars['Int']['output'];
  rule_key: Scalars['String']['output'];
  threshold: Scalars['Int']['output'];
  window_days: Scalars['Int']['output'];
};

/** A Joyn streaming link resolved from the broadcast map by air time — no tmdb match required. */
export type ChannelBroadcastLink = {
  __typename?: 'ChannelBroadcastLink';
  /** Joyn deep link */
  link?: Maybe<Scalars['String']['output']>;
  /** Pricing model (free | subscription) */
  pricing?: Maybe<Scalars['String']['output']>;
  /** Always "joyn" */
  provider?: Maybe<Scalars['String']['output']>;
  /** Air time this link was matched on */
  start?: Maybe<Scalars['DateTime']['output']>;
  /** Catalog @type (e.g. Movie, TVEpisode) */
  type?: Maybe<Scalars['String']['output']>;
};

export type ChannelDate = {
  __typename?: 'ChannelDate';
  /** Date end */
  date_end?: Maybe<Scalars['DateTime']['output']>;
  /** Human format for the date */
  date_human?: Maybe<Scalars['String']['output']>;
  /** Date start */
  date_start?: Maybe<Scalars['DateTime']['output']>;
};

/** Lean channel entry exposing only its Fairu logo assets, for the frontend channel-logo list. */
export type ChannelLogo = {
  __typename?: 'ChannelLogo';
  /** Raw Fairu asset id of the logo (null = not linked yet / needs mapping) */
  asset_id?: Maybe<Scalars['String']['output']>;
  /** Raw Fairu asset id of the white logo variant (null = not linked yet) */
  asset_white_id?: Maybe<Scalars['String']['output']>;
  /** Channel ID */
  id: Scalars['ID']['output'];
  /** Channel logo as Fairu asset (built from asset_id) */
  logo?: Maybe<FairuAsset>;
  /** White channel logo variant as Fairu asset (built from asset_white_id) */
  logo_white?: Maybe<FairuAsset>;
  /** Mediapress identifier (helps match a channel to its source logo) */
  mediapress_id?: Maybe<Scalars['String']['output']>;
  /** Name of the channel */
  name?: Maybe<Scalars['String']['output']>;
  /** Slug */
  slug?: Maybe<Scalars['String']['output']>;
  /** Sort */
  sort?: Maybe<Scalars['Int']['output']>;
};

/** Cinema entry. */
export type Cinema = {
  __typename?: 'Cinema';
  /** City */
  city?: Maybe<City>;
  /** External Id */
  external_id?: Maybe<Scalars['Int']['output']>;
  /** Unique primary key. */
  id: Scalars['ID']['output'];
  /** Title of the enitity */
  name?: Maybe<Scalars['String']['output']>;
  /** Showtimes */
  showtimes: CinemaShowtimePaginator;
  /** Showtimes for today */
  showtimesToday: CinemaShowtimePaginator;
  /** Showtimes today but only upcoming */
  showtimesUpcoming: CinemaShowtimePaginator;
  /** Url */
  url?: Maybe<Scalars['String']['output']>;
};


/** Cinema entry. */
export type CinemaShowtimesArgs = {
  first: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<DateRange>;
};


/** Cinema entry. */
export type CinemaShowtimesTodayArgs = {
  first: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};


/** Cinema entry. */
export type CinemaShowtimesUpcomingArgs = {
  first?: Scalars['Int']['input'];
  from?: InputMaybe<Scalars['DateTime']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  until?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CinemaDate = {
  __typename?: 'CinemaDate';
  /** Date end */
  date_end?: Maybe<Scalars['DateTime']['output']>;
  /** Human format for the date */
  date_human?: Maybe<Scalars['String']['output']>;
  /** Date start */
  date_start?: Maybe<Scalars['DateTime']['output']>;
};

/** A paginated list of Cinema items. */
export type CinemaPaginator = {
  __typename?: 'CinemaPaginator';
  /** A list of Cinema items. */
  data: Array<Cinema>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type CinemaPoster = {
  __typename?: 'CinemaPoster';
  poster?: Maybe<FairuAsset>;
  title?: Maybe<Scalars['String']['output']>;
};

/** Cinema showtime entry */
export type CinemaShowtime = {
  __typename?: 'CinemaShowtime';
  /** Auditorium */
  auditorium?: Maybe<Scalars['String']['output']>;
  /** Booking link */
  booking_link?: Maybe<Scalars['String']['output']>;
  /** Cinema */
  cinema?: Maybe<Cinema>;
  /** Unique primary key. */
  id: Scalars['ID']['output'];
  /** Movie entry from database */
  movie?: Maybe<Movie>;
  /** Starttime */
  start?: Maybe<Scalars['DateTime']['output']>;
  /** Title of the movie if it doesn not have a relationship to a entry in this service */
  title?: Maybe<Scalars['String']['output']>;
};

/** A paginated list of CinemaShowtime items. */
export type CinemaShowtimePaginator = {
  __typename?: 'CinemaShowtimePaginator';
  /** A list of CinemaShowtime items. */
  data: Array<CinemaShowtime>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

/** City entry. */
export type City = {
  __typename?: 'City';
  /** Cinemas */
  cinemas?: Maybe<Array<Maybe<Cinema>>>;
  /** External Id */
  external_id?: Maybe<Scalars['Int']['output']>;
  /** Unique primary key. */
  id: Scalars['ID']['output'];
  /** Latitude */
  latitude?: Maybe<Scalars['Float']['output']>;
  /** Longitude */
  longitude?: Maybe<Scalars['Float']['output']>;
  /** Title of the enitity */
  name?: Maybe<Scalars['String']['output']>;
  /** State */
  state?: Maybe<Scalars['String']['output']>;
  /** State code */
  state_code?: Maybe<Scalars['String']['output']>;
  /** Zip code */
  zip_code?: Maybe<Scalars['String']['output']>;
};

/** A paginated list of City items. */
export type CityPaginator = {
  __typename?: 'CityPaginator';
  /** A list of City items. */
  data: Array<City>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type Collage = {
  __typename?: 'Collage';
  /** Ad settings for the page */
  ad_settings?: Maybe<AdSetting>;
  /** Is an ad? */
  advertorial?: Maybe<Scalars['Boolean']['output']>;
  boxes?: Maybe<Array<Maybe<CollageBox>>>;
  /** Disable ads for the article */
  disable_ads?: Maybe<Scalars['Boolean']['output']>;
  /** Id of the topic */
  id: Scalars['ID']['output'];
  /** Logo */
  logo?: Maybe<FairuAsset>;
  /** Logo Url */
  logo_url?: Maybe<Scalars['String']['output']>;
  /** Meta data */
  metadata?: Maybe<Meta>;
  /** Modus for the collage */
  mode?: Maybe<Scalars['String']['output']>;
  /** More teaser is used for boxes */
  more_teaser?: Maybe<Scalars['String']['output']>;
  more_teaser_headline?: Maybe<Scalars['String']['output']>;
  /** More teaser image should be used in an overview box */
  more_teaser_image?: Maybe<FairuAsset>;
  /** Oewa data */
  oewa?: Maybe<Oewa>;
  /** Outbrain compliant */
  outbrain_compliant?: Maybe<Scalars['Boolean']['output']>;
  /** Outbrain deactivated */
  outbrain_disabled?: Maybe<Scalars['Boolean']['output']>;
  /** Portal for the collage */
  portal?: Maybe<Scalars['String']['output']>;
  /** Slug for the topic. Can be used to query the entry */
  slug?: Maybe<Scalars['String']['output']>;
  social_media?: Maybe<Array<Maybe<CollageSocialMedia>>>;
  /** Subhealdine for the topic */
  subtitle?: Maybe<Scalars['String']['output']>;
  /** Teaser for this collage */
  teaser?: Maybe<Scalars['String']['output']>;
  /** Title of the topic */
  title?: Maybe<Scalars['String']['output']>;
};


export type CollageMore_TeaserArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};


export type CollageTeaserArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CollageBox = {
  __typename?: 'CollageBox';
  /** Description for this collage box */
  description?: Maybe<Scalars['String']['output']>;
  /** Hide the complete box? */
  hide?: Maybe<Scalars['Boolean']['output']>;
  /** Image pre hover */
  image?: Maybe<FairuAsset>;
  /** Image hover */
  image_hover?: Maybe<FairuAsset>;
  /** Title for the box */
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};


export type CollageBoxDescriptionArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CollagePaginatorSimple = {
  __typename?: 'CollagePaginatorSimple';
  data?: Maybe<Array<Maybe<Collage>>>;
  paginatorInfo?: Maybe<DefaultPaginator>;
};

export type CollageSocialMedia = {
  __typename?: 'CollageSocialMedia';
  type?: Maybe<SocialMediaType>;
  url?: Maybe<Scalars['String']['output']>;
};

export type Collection = {
  __typename?: 'Collection';
  /** Description for the collection */
  description?: Maybe<Scalars['String']['output']>;
  /** Id of entry */
  id?: Maybe<Scalars['String']['output']>;
  /** Items of the collection */
  items?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  items_mapped?: Maybe<Array<Maybe<Entity>>>;
  items_query?: Maybe<TvmCollectionQuery>;
  /** Meta data */
  metadata?: Maybe<Meta>;
  random_item?: Maybe<Entity>;
  /** Slug for the entry */
  slug?: Maybe<Scalars['String']['output']>;
  /** Title for the collection */
  title?: Maybe<Scalars['String']['output']>;
};


export type CollectionDescriptionArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};


export type CollectionItems_MappedArgs = {
  amount?: InputMaybe<Scalars['Int']['input']>;
};


export type CollectionItems_QueryArgs = {
  amount?: InputMaybe<Scalars['Int']['input']>;
  onlyWithImages?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CompanyGroup = {
  __typename?: 'CompanyGroup';
  /** Group title */
  group_title?: Maybe<Scalars['String']['output']>;
  /** Group values */
  values?: Maybe<Array<Maybe<CompanyGroupValue>>>;
};

export type CompanyGroupValue = {
  __typename?: 'CompanyGroupValue';
  /** Item value */
  item?: Maybe<Scalars['String']['output']>;
  /** Title */
  title?: Maybe<Scalars['String']['output']>;
};

export type CompanyKeyFact = {
  __typename?: 'CompanyKeyFact';
  keyvalue?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type CompanyKeyFactHeadline = {
  __typename?: 'CompanyKeyFactHeadline';
  headline?: Maybe<Scalars['String']['output']>;
};

/**
 * Outcome of a session refresh. On failure exactly one of `refused` / `transient` is true:
 * refused = Compax rejected the refresh token or the session has ended (re-login needed for
 * anything Compax-backed, reading on a still valid token goes on); transient = Compax was
 * unreachable or answered 5xx (keep the tokens, retry later).
 */
export type CompaxAuthResult = {
  __typename?: 'CompaxAuthResult';
  compax_session_id?: Maybe<Scalars['String']['output']>;
  compax_token?: Maybe<Scalars['String']['output']>;
  error_text?: Maybe<Scalars['String']['output']>;
  refresh_token?: Maybe<Scalars['String']['output']>;
  refused?: Maybe<Scalars['Boolean']['output']>;
  staff_permissions?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
  token?: Maybe<Scalars['String']['output']>;
  transient?: Maybe<Scalars['Boolean']['output']>;
};

export type CompaxIssue = {
  __typename?: 'CompaxIssue';
  hasComplaint?: Maybe<Scalars['Boolean']['output']>;
  issueId?: Maybe<Scalars['String']['output']>;
  issueNumber?: Maybe<Scalars['String']['output']>;
  publicationDate?: Maybe<Scalars['String']['output']>;
};

export type CompaxLoginResult = {
  __typename?: 'CompaxLoginResult';
  compax_session_id?: Maybe<Scalars['String']['output']>;
  compax_token?: Maybe<Scalars['String']['output']>;
  error_text?: Maybe<Scalars['String']['output']>;
  refresh_token?: Maybe<Scalars['String']['output']>;
  /** Staff view of the user's permissions (column ∪ CMS roles incl. jwt- service permissions and portal_ scopes). Not a JWT claim on purpose: the JWT travels in the portal session cookie. */
  staff_permissions?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
  token?: Maybe<Scalars['String']['output']>;
};

export type CompaxSessionStatus = {
  __typename?: 'CompaxSessionStatus';
  compax_refused_at?: Maybe<Scalars['String']['output']>;
  compax_session_id?: Maybe<Scalars['String']['output']>;
  expires_at?: Maybe<Scalars['String']['output']>;
  is_expired?: Maybe<Scalars['Boolean']['output']>;
  last_active_at?: Maybe<Scalars['String']['output']>;
  portal?: Maybe<Scalars['String']['output']>;
};

export type CompaxSessionStatusResult = {
  __typename?: 'CompaxSessionStatusResult';
  status?: Maybe<CompaxSessionStatus>;
  success: Scalars['Boolean']['output'];
};

/**
 * Last known contracts of the caller's session (JSON as Compax returned it), with the time
 * the snapshot was taken. Available while the session lives, also after Compax refused it.
 */
export type CompaxSubscriptionsResult = {
  __typename?: 'CompaxSubscriptionsResult';
  compax_refused_at?: Maybe<Scalars['String']['output']>;
  fetched_at?: Maybe<Scalars['String']['output']>;
  subscriptions?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CompaxTokenResult = {
  __typename?: 'CompaxTokenResult';
  compax_token?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  superseded: Scalars['Boolean']['output'];
};

export type ContactForm = {
  __typename?: 'ContactForm';
  id: Scalars['ID']['output'];
  text?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};


export type ContactFormTextArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * Structured key/value pair for richer contact form submissions.
 * Each entry renders as its own paragraph in the resulting mail.
 */
export type ContactFormField = {
  label: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type ContentElement = ContentElementAffiliateLinks | ContentElementAffiliateLinksSimple | ContentElementBestArticles | ContentElementCalculator | ContentElementCompanyLogo | ContentElementCompanyLogos | ContentElementDownload | ContentElementEvent | ContentElementEventGallery | ContentElementEvents | ContentElementExternalLinks | ContentElementFaqs | ContentElementGallery | ContentElementGallerySimple | ContentElementHeroClean | ContentElementHowto | ContentElementHubspot | ContentElementIframe | ContentElementImage | ContentElementImmoUnited | ContentElementInfobox | ContentElementInfogram | ContentElementInterview | ContentElementList | ContentElementListicle | ContentElementMagazine | ContentElementNewsletter | ContentElementNewsletterSignup | ContentElementPersonList | ContentElementPodcastSimple | ContentElementPodigee | ContentElementProcontra | ContentElementProfileCompany | ContentElementProfilePerson | ContentElementProfileTvm | ContentElementQualifio | ContentElementQuote | ContentElementRecipe | ContentElementRecipeGusto | ContentElementReference | ContentElementRiddle | ContentElementSheet | ContentElementSimilarArticles | ContentElementSocialMedia | ContentElementStoryEmbed | ContentElementSubscriptionAd | ContentElementTable | ContentElementTableOfContents | ContentElementTeams | ContentElementText | ContentElementTextimage | ContentElementTicker | ContentElementTopics | ContentElementTracdelight | ContentElementVideo;

export type ContentElementAffiliateLinks = {
  __typename?: 'ContentElementAffiliateLinks';
  /** Partner */
  affiliate_partner?: Maybe<Scalars['String']['output']>;
  /** Style */
  affiliate_style?: Maybe<Scalars['String']['output']>;
  /** Headline. */
  headline?: Maybe<Scalars['String']['output']>;
  /** Headline size */
  headline_level?: Maybe<Scalars['Int']['output']>;
  /** Products */
  products?: Maybe<Array<Maybe<AmazonProduct>>>;
  show_percent?: Maybe<Scalars['Int']['output']>;
};

export type ContentElementAffiliateLinksSimple = {
  __typename?: 'ContentElementAffiliateLinksSimple';
  /** Partner */
  affiliate_partner?: Maybe<Scalars['String']['output']>;
  iframe_url?: Maybe<Scalars['String']['output']>;
  show_percent?: Maybe<Scalars['Int']['output']>;
};

export type ContentElementBestArticles = {
  __typename?: 'ContentElementBestArticles';
  /** Articles */
  best_articles?: Maybe<Array<Maybe<Article>>>;
  /** Enabled */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** Headline */
  headline?: Maybe<Scalars['String']['output']>;
  /** Initial articles */
  initial_articles?: Maybe<Scalars['Int']['output']>;
  /** Layout */
  layout?: Maybe<Scalars['String']['output']>;
  /** Max articles */
  max_articles?: Maybe<Scalars['Int']['output']>;
  /** Earliest publish date (cut-off, optional) */
  min_publish_date?: Maybe<Scalars['String']['output']>;
  /** Time span */
  time_span?: Maybe<Scalars['String']['output']>;
};

export type ContentElementCalculator = {
  __typename?: 'ContentElementCalculator';
  calculator?: Maybe<Form>;
  description?: Maybe<Scalars['String']['output']>;
  headline?: Maybe<Scalars['String']['output']>;
  /** Inline calculator schema JSON (avoids a clientside roundtrip to calculatorForm). */
  json?: Maybe<Scalars['String']['output']>;
};


export type ContentElementCalculatorDescriptionArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentElementCompanyLogo = {
  __typename?: 'ContentElementCompanyLogo';
  /** Headline. */
  headline?: Maybe<Scalars['String']['output']>;
  /** Headline size */
  headline_level?: Maybe<Scalars['Int']['output']>;
  link_new_window?: Maybe<Scalars['Boolean']['output']>;
  /** Company logo */
  logo?: Maybe<FairuAsset>;
  show_percent?: Maybe<Scalars['Int']['output']>;
  /** Social media links */
  social_media?: Maybe<Array<Maybe<CollageSocialMedia>>>;
  /** This text should be placed after the logo */
  text_after?: Maybe<Scalars['String']['output']>;
  text_before?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type ContentElementCompanyLogos = {
  __typename?: 'ContentElementCompanyLogos';
  /** Headline. */
  headline?: Maybe<Scalars['String']['output']>;
  /** Headline size */
  headline_level?: Maybe<Scalars['Int']['output']>;
  logos?: Maybe<Array<Maybe<ContentElementLogoSet>>>;
  max_height?: Maybe<Scalars['Int']['output']>;
  per_line?: Maybe<Scalars['Int']['output']>;
};

export type ContentElementDownload = {
  __typename?: 'ContentElementDownload';
  /** Anchor. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** Download button label. */
  button_text?: Maybe<Scalars['String']['output']>;
  /** Files. */
  files?: Maybe<Array<FairuAsset>>;
  /** Headline. */
  headline?: Maybe<Scalars['String']['output']>;
  /** Headline size */
  headline_level?: Maybe<Scalars['Int']['output']>;
  /** Small note below the button. */
  note?: Maybe<Scalars['String']['output']>;
  show_percent?: Maybe<Scalars['Int']['output']>;
  /** Source */
  source?: Maybe<Scalars['String']['output']>;
  /** Teaser test for the download. */
  teaser?: Maybe<Scalars['String']['output']>;
};


export type ContentElementDownloadTeaserArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentElementEvent = {
  __typename?: 'ContentElementEvent';
  event?: Maybe<VgnEvent>;
};

export type ContentElementEventGallery = {
  __typename?: 'ContentElementEventGallery';
  /** Anchor. */
  anchor?: Maybe<Scalars['String']['output']>;
  fairu_gallery?: Maybe<FairuGallery>;
  /** Headline. */
  headline?: Maybe<Scalars['String']['output']>;
  /** Headline size */
  headline_level?: Maybe<Scalars['Int']['output']>;
};

export type ContentElementEvents = {
  __typename?: 'ContentElementEvents';
  query?: Maybe<VgnEventQuery>;
};

export type ContentElementExternalLinks = {
  __typename?: 'ContentElementExternalLinks';
  /** Anchor. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** Headline. */
  headline?: Maybe<Scalars['String']['output']>;
  /** Headline size */
  headline_level?: Maybe<Scalars['Int']['output']>;
  /** Links collection id */
  link_collection_id?: Maybe<Scalars['ID']['output']>;
  /** Links - will be async loaded */
  links?: Maybe<Array<Maybe<Link>>>;
  show_percent?: Maybe<Scalars['Int']['output']>;
};

export type ContentElementFaqs = {
  __typename?: 'ContentElementFaqs';
  /** Anchor. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** Amount of columns */
  columns_amount?: Maybe<Scalars['Int']['output']>;
  /** Questions */
  faqs?: Maybe<Array<Maybe<Faq>>>;
  /** Headline. */
  headline?: Maybe<Scalars['String']['output']>;
  /** Headline size */
  headline_level?: Maybe<Scalars['Int']['output']>;
  show_percent?: Maybe<Scalars['Int']['output']>;
};

export type ContentElementGallery = {
  __typename?: 'ContentElementGallery';
  /** Anchor. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** Autoplay */
  autoplay?: Maybe<Scalars['Boolean']['output']>;
  /** Gallery item */
  gallery?: Maybe<Gallery>;
  /** Headline. */
  headline?: Maybe<Scalars['String']['output']>;
  /** Headline size */
  headline_level?: Maybe<Scalars['Int']['output']>;
  /** Gallery display mode */
  mode?: Maybe<Scalars['String']['output']>;
  show_percent?: Maybe<Scalars['Int']['output']>;
};

export type ContentElementGallerySimple = {
  __typename?: 'ContentElementGallerySimple';
  /** Anchor. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** Shared caption, shown centred below all images. */
  caption?: Maybe<Scalars['String']['output']>;
  /** Which captions to show: per_image (Fairu caption under each image), shared (one text below all images) or both. */
  caption_mode?: Maybe<Scalars['String']['output']>;
  columns_amount?: Maybe<Scalars['Int']['output']>;
  /** Headline. */
  headline?: Maybe<Scalars['String']['output']>;
  /** Headline size */
  headline_level?: Maybe<Scalars['Int']['output']>;
  images?: Maybe<Array<FairuAsset>>;
  /** Plain CardImages read from the baked sidecar (no FairuAsset federation). */
  images_cards?: Maybe<Array<Maybe<CardImage>>>;
  /** Two-column layout only: keep both columns on mobile instead of stacking them. */
  mobile_side_by_side?: Maybe<Scalars['Boolean']['output']>;
  /** Two-column layout only: render the images portrait (3:4) instead of landscape. */
  portrait_images?: Maybe<Scalars['Boolean']['output']>;
  show_percent?: Maybe<Scalars['Int']['output']>;
};


export type ContentElementGallerySimpleCaptionArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentElementHeroClean = {
  __typename?: 'ContentElementHeroClean';
  cta2_label?: Maybe<Scalars['String']['output']>;
  cta2_url?: Maybe<Scalars['String']['output']>;
  cta_label?: Maybe<Scalars['String']['output']>;
  cta_url?: Maybe<Scalars['String']['output']>;
  emphasis_color?: Maybe<Scalars['String']['output']>;
  eyebrow?: Maybe<Scalars['String']['output']>;
  headline_emphasis?: Maybe<Scalars['String']['output']>;
  headline_main?: Maybe<Scalars['String']['output']>;
  image?: Maybe<FairuAsset>;
  nav_anchors?: Maybe<Array<Maybe<HeroCleanNavAnchor>>>;
  stats?: Maybe<Array<Maybe<HeroCleanStat>>>;
  style_variant?: Maybe<Scalars['String']['output']>;
  sub?: Maybe<Scalars['String']['output']>;
};


export type ContentElementHeroCleanSubArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentElementHowto = {
  __typename?: 'ContentElementHowto';
  steps?: Maybe<Array<ContentElementHowtoStep>>;
};

export type ContentElementHowtoStep = {
  __typename?: 'ContentElementHowtoStep';
  description?: Maybe<Scalars['String']['output']>;
  headline?: Maybe<Scalars['String']['output']>;
  /** Image */
  image?: Maybe<FairuAsset>;
  /** Plain CardImage read from the baked sidecar (no FairuAsset federation). */
  image_card?: Maybe<CardImage>;
  time?: Maybe<Scalars['Int']['output']>;
};


export type ContentElementHowtoStepDescriptionArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};

/** ATTENTION: this type is used for Brevo */
export type ContentElementHubspot = {
  __typename?: 'ContentElementHubspot';
  /** Anchor. */
  anchor?: Maybe<Scalars['String']['output']>;
  form_id?: Maybe<Scalars['String']['output']>;
  /** Headline. */
  headline?: Maybe<Scalars['String']['output']>;
  /** Headline size */
  headline_level?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Obsolet */
  portal_id?: Maybe<Scalars['String']['output']>;
};

export type ContentElementIframe = {
  __typename?: 'ContentElementIframe';
  /** Caption shown below the iframe (plain text), e.g. AI labelling or the source */
  caption?: Maybe<Scalars['String']['output']>;
  /** Headline. */
  headline?: Maybe<Scalars['String']['output']>;
  /** Headline size */
  headline_level?: Maybe<Scalars['Int']['output']>;
  iframe_url?: Maybe<Scalars['String']['output']>;
  max_width?: Maybe<Scalars['Int']['output']>;
  min_height?: Maybe<Scalars['Int']['output']>;
  show_percent?: Maybe<Scalars['Int']['output']>;
};

export type ContentElementImage = Headline & {
  __typename?: 'ContentElementImage';
  /** Anchor. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** Caption text for image */
  caption?: Maybe<Scalars['String']['output']>;
  /** Copyright text for image */
  copyright?: Maybe<Scalars['String']['output']>;
  /** Headline. */
  headline?: Maybe<Scalars['String']['output']>;
  /** Headline size */
  headline_level?: Maybe<Scalars['Int']['output']>;
  /** Image path. If 'image not resize' is active the height and the fit property will not be used. */
  image?: Maybe<FairuAsset>;
  /** Plain CardImage read from the baked sidecar (no FairuAsset federation). */
  image_card?: Maybe<CardImage>;
  image_mode?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `image_mode`. */
  image_no_resize?: Maybe<Scalars['Boolean']['output']>;
  no_caption?: Maybe<Scalars['Boolean']['output']>;
  show_percent?: Maybe<Scalars['Int']['output']>;
  /** Link for the image */
  url?: Maybe<Scalars['String']['output']>;
};


export type ContentElementImageCaptionArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentElementImmoUnited = {
  __typename?: 'ContentElementImmoUnited';
  /** Listings fetched from the Immo United feed (cached, refreshed once daily) */
  listings?: Maybe<Array<Maybe<ImmoUnitedListing>>>;
  /** Title override */
  title_override?: Maybe<Scalars['String']['output']>;
};

export type ContentElementInfobox = {
  __typename?: 'ContentElementInfobox';
  /** Anchor. */
  anchor?: Maybe<Scalars['String']['output']>;
  background_color?: Maybe<Scalars['String']['output']>;
  /** Infobox entries */
  entries?: Maybe<Array<Maybe<Text>>>;
  foreground_color?: Maybe<Scalars['String']['output']>;
  /** Headline. */
  headline?: Maybe<Scalars['String']['output']>;
  /** Headline size */
  headline_level?: Maybe<Scalars['Int']['output']>;
  highlight_color?: Maybe<Scalars['String']['output']>;
  show_percent?: Maybe<Scalars['Int']['output']>;
  /** Style */
  style?: Maybe<Scalars['String']['output']>;
};

export type ContentElementInfogram = {
  __typename?: 'ContentElementInfogram';
  /** Anchor. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** Headline. */
  headline?: Maybe<Scalars['String']['output']>;
  /** Headline size */
  headline_level?: Maybe<Scalars['Int']['output']>;
  /** Infogram ID */
  infogram_id?: Maybe<Scalars['String']['output']>;
  max_width?: Maybe<Scalars['Int']['output']>;
  show_percent?: Maybe<Scalars['Int']['output']>;
};

export type ContentElementInterview = {
  __typename?: 'ContentElementInterview';
  /** Anchor. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** Interview dialog parts */
  dialog?: Maybe<Array<Maybe<InterviewPart>>>;
  /** Headline. */
  headline?: Maybe<Scalars['String']['output']>;
  /** Headline size */
  headline_level?: Maybe<Scalars['Int']['output']>;
  show_percent?: Maybe<Scalars['Int']['output']>;
};

export type ContentElementList = {
  __typename?: 'ContentElementList';
  items?: Maybe<Array<Maybe<ContentElementListItem>>>;
  mode?: Maybe<Scalars['String']['output']>;
  show_percent?: Maybe<Scalars['Int']['output']>;
};

export type ContentElementListItem = {
  __typename?: 'ContentElementListItem';
  /** Text. */
  description?: Maybe<Scalars['String']['output']>;
  /** Bullet point list item headline */
  headline?: Maybe<Scalars['String']['output']>;
};


export type ContentElementListItemDescriptionArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentElementListicle = {
  __typename?: 'ContentElementListicle';
  /** Anchor. */
  anchor?: Maybe<Scalars['String']['output']>;
  entities?: Maybe<Array<Maybe<EntityEntry>>>;
  /** Headline. */
  headline?: Maybe<Scalars['String']['output']>;
  /** Headline size */
  headline_level?: Maybe<Scalars['Int']['output']>;
  /** Listicle items */
  items?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Sorting direction of the listicle */
  listicle_sorting?: Maybe<Scalars['String']['output']>;
  /** Style of the listicle */
  listicle_style?: Maybe<Scalars['String']['output']>;
  /** Type of listicle */
  listicle_type?: Maybe<Scalars['String']['output']>;
};

export type ContentElementLogoSet = {
  __typename?: 'ContentElementLogoSet';
  /** Company logo */
  logo?: Maybe<FairuAsset>;
  show_percent?: Maybe<Scalars['Int']['output']>;
  /** Social media links */
  social_media?: Maybe<Array<Maybe<CollageSocialMedia>>>;
  /** This text should be placed after the logo */
  text_after?: Maybe<Scalars['String']['output']>;
  /** This text should be placed before the logo */
  text_before?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type ContentElementMagazine = {
  __typename?: 'ContentElementMagazine';
  magazine?: Maybe<Magazine>;
};

export type ContentElementNewsletter = {
  __typename?: 'ContentElementNewsletter';
  /** Anchor. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** Headline. */
  headline?: Maybe<Scalars['String']['output']>;
  /** Headline size */
  headline_level?: Maybe<Scalars['Int']['output']>;
  /** Distribution list id provided by mailion */
  newsletter?: Maybe<Newsletter>;
  show_percent?: Maybe<Scalars['Int']['output']>;
  /** Teaser for the download. */
  teaser?: Maybe<Scalars['String']['output']>;
};


export type ContentElementNewsletterTeaserArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Newsletter signup / CTA box. Same fields as Popover (ce_newsletter_signup fieldset). */
export type ContentElementNewsletterSignup = {
  __typename?: 'ContentElementNewsletterSignup';
  /** cta | newsletter */
  action_type?: Maybe<Scalars['String']['output']>;
  /** Anchor. */
  anchor?: Maybe<Scalars['String']['output']>;
  cta?: Maybe<Link>;
  cta_title?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** Headline. */
  headline?: Maybe<Scalars['String']['output']>;
  /** Headline size */
  headline_level?: Maybe<Scalars['Int']['output']>;
  image?: Maybe<FairuAsset>;
  /** Newsletter entry id, submit via the same signup mutation as popovers */
  newsletter_id?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};


/** Newsletter signup / CTA box. Same fields as Popover (ce_newsletter_signup fieldset). */
export type ContentElementNewsletterSignupDescriptionArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentElementPersonList = {
  __typename?: 'ContentElementPersonList';
  /** Anchor. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** Headline. */
  headline?: Maybe<Scalars['String']['output']>;
  /** Headline size */
  headline_level?: Maybe<Scalars['Int']['output']>;
  /** People in display order (01, 02, 03 …) */
  persons?: Maybe<Array<Maybe<PersonListEntry>>>;
  show_percent?: Maybe<Scalars['Int']['output']>;
};

export type ContentElementPodcastSimple = {
  __typename?: 'ContentElementPodcastSimple';
  /** Description of the episode */
  description?: Maybe<Scalars['String']['output']>;
  /** Image */
  image?: Maybe<FairuAsset>;
  /** Plain CardImage read from the baked sidecar (no FairuAsset federation). */
  image_card?: Maybe<CardImage>;
  show_percent?: Maybe<Scalars['Int']['output']>;
  /** Podcast title */
  title?: Maybe<Scalars['String']['output']>;
  /** Episode title */
  title_episode?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};


export type ContentElementPodcastSimpleDescriptionArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentElementPodigee = {
  __typename?: 'ContentElementPodigee';
  cover_image?: Maybe<Scalars['String']['output']>;
  episode_id?: Maybe<Scalars['String']['output']>;
  episode_title?: Maybe<Scalars['String']['output']>;
  /** Headline. */
  headline?: Maybe<Scalars['String']['output']>;
  /** Headline size */
  headline_level?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  show_percent?: Maybe<Scalars['Int']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type ContentElementProcontra = {
  __typename?: 'ContentElementProcontra';
  /** Anchor. */
  anchor?: Maybe<Scalars['String']['output']>;
  contra?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Headline. */
  headline?: Maybe<Scalars['String']['output']>;
  /** Headline size */
  headline_level?: Maybe<Scalars['Int']['output']>;
  pro?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  show_percent?: Maybe<Scalars['Int']['output']>;
};

export type ContentElementProfileCompany = {
  __typename?: 'ContentElementProfileCompany';
  /** Anchor. */
  anchor?: Maybe<Scalars['String']['output']>;
  background_color?: Maybe<Scalars['String']['output']>;
  foreground_color?: Maybe<Scalars['String']['output']>;
  groups?: Maybe<Array<Maybe<CompanyGroup>>>;
  /** Headline. */
  headline?: Maybe<Scalars['String']['output']>;
  /** Headline size */
  headline_level?: Maybe<Scalars['Int']['output']>;
  highlight_color?: Maybe<Scalars['String']['output']>;
  /** Image / Logo */
  image?: Maybe<FairuAsset>;
  /** Plain CardImage read from the baked sidecar (no FairuAsset federation). */
  image_card?: Maybe<CardImage>;
  /** Industry */
  industry?: Maybe<Scalars['String']['output']>;
  keyfacts?: Maybe<Array<Maybe<CompanyKeyFact>>>;
  keyfacts_grouped?: Maybe<Array<KeyfactGroupItem>>;
  link?: Maybe<Scalars['String']['output']>;
  link_new_window?: Maybe<Scalars['Boolean']['output']>;
  /** Name of the company */
  name?: Maybe<Scalars['String']['output']>;
  show_percent?: Maybe<Scalars['Int']['output']>;
};


export type ContentElementProfileCompanyIndustryArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentElementProfilePerson = {
  __typename?: 'ContentElementProfilePerson';
  /** Anchor. */
  anchor?: Maybe<Scalars['String']['output']>;
  background_color?: Maybe<Scalars['String']['output']>;
  custom?: Maybe<Array<Maybe<ContentElementProfilePersonItem>>>;
  foreground_color?: Maybe<Scalars['String']['output']>;
  /** Headline. */
  headline?: Maybe<Scalars['String']['output']>;
  /** Headline size */
  headline_level?: Maybe<Scalars['Int']['output']>;
  hide_information?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  highlight_color?: Maybe<Scalars['String']['output']>;
  links?: Maybe<Array<Maybe<ContentElementProfilePersonLink>>>;
  person?: Maybe<Person>;
  show_percent?: Maybe<Scalars['Int']['output']>;
};

export type ContentElementProfilePersonItem = {
  __typename?: 'ContentElementProfilePersonItem';
  /** Text. */
  description?: Maybe<Scalars['String']['output']>;
  /** Title for the item */
  headline?: Maybe<Scalars['String']['output']>;
};


export type ContentElementProfilePersonItemDescriptionArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentElementProfilePersonLink = {
  __typename?: 'ContentElementProfilePersonLink';
  /** Link */
  link?: Maybe<Scalars['String']['output']>;
  /** Link text */
  link_text?: Maybe<Scalars['String']['output']>;
  /**
   * Link text
   * @deprecated Use link_text
   */
  linktext?: Maybe<Scalars['String']['output']>;
  /** Should the link open in a new window */
  target_blank?: Maybe<Scalars['Boolean']['output']>;
};

export type ContentElementProfileTvm = {
  __typename?: 'ContentElementProfileTvm';
  /** Anchor. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** Headline. */
  headline?: Maybe<Scalars['String']['output']>;
  /** Headline size */
  headline_level?: Maybe<Scalars['Int']['output']>;
  /** Style */
  modus?: Maybe<Scalars['String']['output']>;
  person?: Maybe<TvmPerson>;
  show_percent?: Maybe<Scalars['Int']['output']>;
};

export type ContentElementQualifio = {
  __typename?: 'ContentElementQualifio';
  /** Anchor. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** Headline. */
  headline?: Maybe<Scalars['String']['output']>;
  /** Headline size */
  headline_level?: Maybe<Scalars['Int']['output']>;
  height?: Maybe<Scalars['Float']['output']>;
  iframe_url?: Maybe<Scalars['String']['output']>;
  show_percent?: Maybe<Scalars['Int']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
};

export type ContentElementQuote = {
  __typename?: 'ContentElementQuote';
  /** Anchor. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** Headline. */
  headline?: Maybe<Scalars['String']['output']>;
  /** Headline size */
  headline_level?: Maybe<Scalars['Int']['output']>;
  /** Image */
  image?: Maybe<FairuAsset>;
  /** Plain CardImage read from the baked sidecar (no FairuAsset federation). */
  image_card?: Maybe<CardImage>;
  /** The mode to display the element */
  mode?: Maybe<Scalars['String']['output']>;
  /** Quote */
  quote?: Maybe<Quote>;
  show_percent?: Maybe<Scalars['Int']['output']>;
};

export type ContentElementRecipe = {
  __typename?: 'ContentElementRecipe';
  /** Headline. */
  headline?: Maybe<Scalars['String']['output']>;
  /** Headline size */
  headline_level?: Maybe<Scalars['Int']['output']>;
  ingredients?: Maybe<Array<Maybe<ContentElementRecipeIngridient>>>;
  recipe_level?: Maybe<Scalars['String']['output']>;
  recipe_time?: Maybe<Scalars['Int']['output']>;
  show_percent?: Maybe<Scalars['Int']['output']>;
  steps?: Maybe<Array<Maybe<ContentElementRecipeStep>>>;
};

export type ContentElementRecipeGusto = {
  __typename?: 'ContentElementRecipeGusto';
  /** Headline. */
  headline?: Maybe<Scalars['String']['output']>;
  /** Headline size */
  headline_level?: Maybe<Scalars['Int']['output']>;
  recipe?: Maybe<GustoRecipe>;
  show_percent?: Maybe<Scalars['Int']['output']>;
};

export type ContentElementRecipeIngridient = {
  __typename?: 'ContentElementRecipeIngridient';
  amount?: Maybe<Scalars['String']['output']>;
  ingredient?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type ContentElementRecipeStep = {
  __typename?: 'ContentElementRecipeStep';
  /** Image */
  image?: Maybe<FairuAsset>;
  /** Plain CardImage read from the baked sidecar (no FairuAsset federation). */
  image_card?: Maybe<CardImage>;
  /** Text. */
  text?: Maybe<Scalars['String']['output']>;
};


export type ContentElementRecipeStepTextArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentElementReference = {
  __typename?: 'ContentElementReference';
  links?: Maybe<Array<ContentElementReferenceLink>>;
  show_percent?: Maybe<Scalars['Int']['output']>;
};

export type ContentElementReferenceLink = {
  __typename?: 'ContentElementReferenceLink';
  /** Link to the reference */
  link?: Maybe<Scalars['String']['output']>;
  /** Link text. */
  link_text?: Maybe<Scalars['String']['output']>;
  /** Link should open in new tab or window */
  target_blank?: Maybe<Scalars['Boolean']['output']>;
};

export type ContentElementRiddle = {
  __typename?: 'ContentElementRiddle';
  color_bg?: Maybe<Scalars['String']['output']>;
  color_fg?: Maybe<Scalars['String']['output']>;
  /** Headline. */
  headline?: Maybe<Scalars['String']['output']>;
  /** Headline size */
  headline_level?: Maybe<Scalars['Int']['output']>;
  riddle_id?: Maybe<Scalars['String']['output']>;
};

export type ContentElementSheet = {
  __typename?: 'ContentElementSheet';
  id?: Maybe<Scalars['String']['output']>;
  path?: Maybe<Scalars['String']['output']>;
  sheets?: Maybe<Scalars['JSON']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ContentElementSimilarArticles = {
  __typename?: 'ContentElementSimilarArticles';
  /** Anchor. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** Headline. */
  headline?: Maybe<Scalars['String']['output']>;
  /** Headline size */
  headline_level?: Maybe<Scalars['Int']['output']>;
  keyword?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  show_percent?: Maybe<Scalars['Int']['output']>;
  similar_articles?: Maybe<Array<Maybe<Article>>>;
};


export type ContentElementSimilarArticlesSimilar_ArticlesArgs = {
  max?: InputMaybe<Scalars['Int']['input']>;
};

export type ContentElementSocialEmbed = {
  __typename?: 'ContentElementSocialEmbed';
  /** The unique identifier to embed the element */
  id?: Maybe<Scalars['String']['output']>;
  /** Type of social embed */
  network?: Maybe<Scalars['String']['output']>;
};

export type ContentElementSocialMedia = {
  __typename?: 'ContentElementSocialMedia';
  /** Anchor. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use enable_caption */
  disable_caption?: Maybe<Scalars['Boolean']['output']>;
  enable_caption?: Maybe<Scalars['Boolean']['output']>;
  /** Headline. */
  headline?: Maybe<Scalars['String']['output']>;
  /** Headline size */
  headline_level?: Maybe<Scalars['Int']['output']>;
  /** Will be ignores for twitter */
  height?: Maybe<Scalars['Int']['output']>;
  /** Network (like facebook,twitter etc.) */
  network?: Maybe<SocialMediaNetwork>;
  /** The actual id for the entry */
  network_id?: Maybe<Scalars['String']['output']>;
  show_percent?: Maybe<Scalars['Int']['output']>;
};

/**
 * Scrollytelling embed: one generic element for all interactive story types.
 * `element` picks the renderer (sticky_crossfade, karte, timeline, ...), `steps`
 * is the editor's storyboard as a JSON array string (kicker, badge, headline,
 * text, image url, param), `story` optionally keys into storyPois/storyData for
 * data-driven elements. Steps as String keeps the federated schema stable — new
 * element types need no schema change (same pattern as calculator_forms.json).
 */
export type ContentElementStoryEmbed = {
  __typename?: 'ContentElementStoryEmbed';
  /** Anchor. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** Renderer key from the story registry (sticky_crossfade, karte, timeline, ...) */
  element?: Maybe<Scalars['String']['output']>;
  /** Headline. */
  headline?: Maybe<Scalars['String']['output']>;
  /** Headline size */
  headline_level?: Maybe<Scalars['Int']['output']>;
  /** Storyboard steps as JSON array string */
  steps?: Maybe<Scalars['String']['output']>;
  /** Optional data handle for storyPois/storyData */
  story?: Maybe<Scalars['String']['output']>;
};

export type ContentElementSubscriptionAd = {
  __typename?: 'ContentElementSubscriptionAd';
  /** Anchor. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** Headline. */
  headline?: Maybe<Scalars['String']['output']>;
  /** Headline size */
  headline_level?: Maybe<Scalars['Int']['output']>;
  show_percent?: Maybe<Scalars['Int']['output']>;
  /** Subscription ad */
  subscription_ad?: Maybe<SubscriptionAd>;
};

export type ContentElementTable = {
  __typename?: 'ContentElementTable';
  /** Anchor. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** Caption for the table */
  caption?: Maybe<Scalars['String']['output']>;
  /** Widths in fr unit */
  columns_width?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  /** Requires loading by client */
  file?: Maybe<Scalars['String']['output']>;
  /** First column is a header column */
  first_column_header?: Maybe<Scalars['Boolean']['output']>;
  /** First row is a header row */
  first_row_header?: Maybe<Scalars['Boolean']['output']>;
  /** Headline. */
  headline?: Maybe<Scalars['String']['output']>;
  /** Headline size */
  headline_level?: Maybe<Scalars['Int']['output']>;
  /** Last column is a 'header' row */
  last_row_header?: Maybe<Scalars['Boolean']['output']>;
  /** Requires loading by client */
  manual_loading_required?: Maybe<Scalars['Boolean']['output']>;
  /** Data rows */
  rows?: Maybe<Array<Maybe<TableRow>>>;
  show_percent?: Maybe<Scalars['Int']['output']>;
  /** Sortable columns */
  sortable_columns?: Maybe<Scalars['Boolean']['output']>;
  /** Type */
  type?: Maybe<Scalars['String']['output']>;
};


export type ContentElementTableCaptionArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentElementTableOfContents = {
  __typename?: 'ContentElementTableOfContents';
  /** List of headlines as a tree */
  list?: Maybe<Array<Maybe<ContentElementTableOfContentsChild>>>;
  /** Should the table of content be open */
  list_expanded?: Maybe<Scalars['Boolean']['output']>;
  /** Max level */
  max_level?: Maybe<Scalars['Int']['output']>;
  show_percent?: Maybe<Scalars['Int']['output']>;
};

export type ContentElementTableOfContentsChild = {
  __typename?: 'ContentElementTableOfContentsChild';
  /** Anchor. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** Children */
  children?: Maybe<Array<Maybe<ContentElementTableOfContentsChild>>>;
  /** Headline */
  headline?: Maybe<Scalars['String']['output']>;
  /** Headline size */
  headline_level?: Maybe<Scalars['Int']['output']>;
  /** ID */
  id?: Maybe<Scalars['String']['output']>;
  show_percent?: Maybe<Scalars['Int']['output']>;
};

export type ContentElementTeams = {
  __typename?: 'ContentElementTeams';
  /** Anchor. */
  anchor?: Maybe<Scalars['String']['output']>;
  disable_more_button?: Maybe<Scalars['Boolean']['output']>;
  /** Headline. */
  headline?: Maybe<Scalars['String']['output']>;
  /** Headline size */
  headline_level?: Maybe<Scalars['Int']['output']>;
  /** Display mode for the list */
  mode?: Maybe<Scalars['String']['output']>;
  show_percent?: Maybe<Scalars['Int']['output']>;
  teams?: Maybe<Array<Maybe<Team>>>;
};

export type ContentElementText = Headline & {
  __typename?: 'ContentElementText';
  /** Anchor. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** Headline. */
  headline?: Maybe<Scalars['String']['output']>;
  /** Headline size */
  headline_level?: Maybe<Scalars['Int']['output']>;
  show_percent?: Maybe<Scalars['Int']['output']>;
  /** Text. */
  text?: Maybe<Scalars['String']['output']>;
};


export type ContentElementTextTextArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentElementTextimage = Headline & {
  __typename?: 'ContentElementTextimage';
  /** Additional text */
  additional_text?: Maybe<Scalars['String']['output']>;
  /** Anchor. */
  anchor?: Maybe<Scalars['String']['output']>;
  flip_image?: Maybe<Scalars['Boolean']['output']>;
  /** Headline. */
  headline?: Maybe<Scalars['String']['output']>;
  /** Headline size */
  headline_level?: Maybe<Scalars['Int']['output']>;
  /** Image */
  image?: Maybe<FairuAsset>;
  /** Plain CardImage read from the baked sidecar (no FairuAsset federation). */
  image_card?: Maybe<CardImage>;
  show_percent?: Maybe<Scalars['Int']['output']>;
  /** Text for the box */
  text?: Maybe<Scalars['String']['output']>;
};


export type ContentElementTextimageAdditional_TextArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentElementTicker = {
  __typename?: 'ContentElementTicker';
  show_percent?: Maybe<Scalars['Int']['output']>;
  ticker_text?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type ContentElementTickerTicker_TextArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentElementTopics = {
  __typename?: 'ContentElementTopics';
  /** Articles */
  articles?: Maybe<ArticlePaginatorSimple>;
  /** Headline. */
  headline?: Maybe<Scalars['String']['output']>;
  show_percent?: Maybe<Scalars['Int']['output']>;
};


export type ContentElementTopicsArticlesArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};

export type ContentElementTracdelight = {
  __typename?: 'ContentElementTracdelight';
  /** Headline. */
  headline?: Maybe<Scalars['String']['output']>;
  /** Headline size */
  headline_level?: Maybe<Scalars['Int']['output']>;
  show_percent?: Maybe<Scalars['Int']['output']>;
  /** Tracdelight widget id */
  widget?: Maybe<Scalars['String']['output']>;
};

export type ContentElementVideo = Headline & {
  __typename?: 'ContentElementVideo';
  /** Anchor. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** Caption text for video */
  caption?: Maybe<Scalars['String']['output']>;
  /** Let a portrait video span the full column on desktop instead of shrinking to a third. */
  full_width?: Maybe<Scalars['Boolean']['output']>;
  /** Headline. */
  headline?: Maybe<Scalars['String']['output']>;
  /** Headline size */
  headline_level?: Maybe<Scalars['Int']['output']>;
  /** JWPlayer Embed Code */
  jw_embed?: Maybe<Scalars['String']['output']>;
  /** JWPlayer Id */
  jw_player?: Maybe<Scalars['String']['output']>;
  show_percent?: Maybe<Scalars['Int']['output']>;
  video?: Maybe<FairuAsset>;
  /** Video source */
  video_source?: Maybe<Scalars['String']['output']>;
  /** Youtube Id */
  youtube?: Maybe<Scalars['String']['output']>;
};


export type ContentElementVideoCaptionArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CountryState = {
  __typename?: 'CountryState';
  /** Code */
  state_code?: Maybe<Scalars['String']['output']>;
  /** Text */
  state_text?: Maybe<Scalars['String']['output']>;
};

export type CreateArchiveIssue = {
  articles?: InputMaybe<Array<Scalars['String']['input']>>;
  cover_image_path?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  filename?: InputMaybe<Scalars['String']['input']>;
  issue_number?: InputMaybe<Scalars['Int']['input']>;
  month?: InputMaybe<Scalars['String']['input']>;
  origin_id?: InputMaybe<Scalars['String']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  published_at?: InputMaybe<Scalars['DateTime']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  type?: InputMaybe<VgnArchiveMedia>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateArticle = {
  advertorial?: InputMaybe<Scalars['Boolean']['input']>;
  advertorial_text?: InputMaybe<Scalars['String']['input']>;
  alt_keywords?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  apa_id?: InputMaybe<Scalars['String']['input']>;
  authors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  category?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Array<InputMaybe<CreateArticleContent>>>;
  cornerstone?: InputMaybe<Scalars['Boolean']['input']>;
  cover_image?: InputMaybe<Scalars['String']['input']>;
  cover_image_alt?: InputMaybe<Scalars['String']['input']>;
  cover_image_caption?: InputMaybe<Scalars['String']['input']>;
  cover_image_copyright?: InputMaybe<Scalars['String']['input']>;
  cover_image_title?: InputMaybe<Scalars['String']['input']>;
  disable_ads?: InputMaybe<Scalars['Boolean']['input']>;
  gallery?: InputMaybe<CreateArticleGallery>;
  google_news_title?: InputMaybe<Scalars['String']['input']>;
  headline: Scalars['String']['input'];
  hide_authors?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  import_id?: InputMaybe<Scalars['String']['input']>;
  import_url?: InputMaybe<Scalars['String']['input']>;
  interview_persons?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  is_paid_content?: InputMaybe<Scalars['Boolean']['input']>;
  is_published?: InputMaybe<Scalars['Boolean']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  meta_description?: InputMaybe<Scalars['String']['input']>;
  meta_title?: InputMaybe<Scalars['String']['input']>;
  no_follow?: InputMaybe<Scalars['Boolean']['input']>;
  no_index?: InputMaybe<Scalars['Boolean']['input']>;
  oewa?: InputMaybe<Scalars['String']['input']>;
  og_description?: InputMaybe<Scalars['String']['input']>;
  og_image?: InputMaybe<Scalars['String']['input']>;
  og_title?: InputMaybe<Scalars['String']['input']>;
  outbrain_compliant?: InputMaybe<Scalars['Boolean']['input']>;
  outbrain_disabled?: InputMaybe<Scalars['Boolean']['input']>;
  portal: Scalars['String']['input'];
  published?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  teaser: Scalars['String']['input'];
  topics?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  twitter_description?: InputMaybe<Scalars['String']['input']>;
  twitter_title?: InputMaybe<Scalars['String']['input']>;
};

export type CreateArticleContent = {
  alt?: InputMaybe<Scalars['String']['input']>;
  anchor?: InputMaybe<Scalars['String']['input']>;
  caption?: InputMaybe<Scalars['String']['input']>;
  column_casting?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  content?: InputMaybe<Scalars['String']['input']>;
  copyright?: InputMaybe<Scalars['String']['input']>;
  /** CSV File url if the content is a csv file */
  csv_file?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Podcast id from podigee */
  episode_id?: InputMaybe<Scalars['String']['input']>;
  /** Faqs */
  faqs?: InputMaybe<Array<InputMaybe<CreateArticleContentFaq>>>;
  /** Files for download */
  files?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Define if the first column of the table is a header */
  first_column_header?: InputMaybe<Scalars['Boolean']['input']>;
  /** Define if the first row of the table is a header */
  first_row_header?: InputMaybe<Scalars['Boolean']['input']>;
  has_anchor?: InputMaybe<Scalars['Boolean']['input']>;
  has_headline?: InputMaybe<Scalars['Boolean']['input']>;
  headline?: InputMaybe<Scalars['String']['input']>;
  headline_level?: InputMaybe<Scalars['Int']['input']>;
  howto?: InputMaybe<CreateArticleHowTo>;
  /** Iframe url for iframes */
  iframe_url?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  image_alt?: InputMaybe<Scalars['String']['input']>;
  image_link?: InputMaybe<Scalars['String']['input']>;
  image_mode?: InputMaybe<Scalars['String']['input']>;
  image_no_resize?: InputMaybe<Scalars['Boolean']['input']>;
  image_title?: InputMaybe<Scalars['String']['input']>;
  /** Keyfacts */
  infobox_content?: InputMaybe<Array<InputMaybe<CreateArticleContentInfobox>>>;
  /** JW-Id for the video player */
  jw?: InputMaybe<Scalars['String']['input']>;
  /** Define if the last row is a header */
  last_row_header?: InputMaybe<Scalars['Boolean']['input']>;
  listitems?: InputMaybe<Array<InputMaybe<CreateArticleListItem>>>;
  /** Iframe min height */
  min_height?: InputMaybe<Scalars['Int']['input']>;
  /** Lists can have a style mode like bullet */
  mode?: InputMaybe<Scalars['String']['input']>;
  /** Socialmedia Network type */
  network?: InputMaybe<Scalars['String']['input']>;
  /** Socialmedia Network id */
  network_id?: InputMaybe<Scalars['String']['input']>;
  no_caption?: InputMaybe<Scalars['Boolean']['input']>;
  /** Affiliate ASIN Ids */
  products?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Quote text */
  quote?: InputMaybe<Scalars['String']['input']>;
  recipe?: InputMaybe<CreateArticleRecipe>;
  /** Define if the columns of are sortable */
  sortable_columns?: InputMaybe<Scalars['Boolean']['input']>;
  /** Source fo the download */
  source?: InputMaybe<Scalars['String']['input']>;
  /** Table source type */
  source_type?: InputMaybe<Scalars['String']['input']>;
  table_content?: InputMaybe<CreateArticleTable>;
  /** Table of content headline size */
  table_of_contents?: InputMaybe<Scalars['String']['input']>;
  /** Teaser for download */
  teaser?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  video_file?: InputMaybe<Scalars['String']['input']>;
  video_source?: InputMaybe<Scalars['String']['input']>;
  video_url?: InputMaybe<Scalars['String']['input']>;
  /** Widget ID */
  widget?: InputMaybe<Scalars['String']['input']>;
  youtube?: InputMaybe<Scalars['String']['input']>;
};

export type CreateArticleContentFaq = {
  answer?: InputMaybe<Scalars['String']['input']>;
  question?: InputMaybe<Scalars['String']['input']>;
};

export type CreateArticleContentInfobox = {
  content?: InputMaybe<Scalars['String']['input']>;
  headline?: InputMaybe<Scalars['String']['input']>;
};

export type CreateArticleGallery = {
  images?: InputMaybe<Array<InputMaybe<CreateArticleGalleryImage>>>;
};

export type CreateArticleGalleryImage = {
  alt?: InputMaybe<Scalars['String']['input']>;
  caption?: InputMaybe<Scalars['String']['input']>;
  copyright?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
};

export type CreateArticleHowTo = {
  steps?: InputMaybe<Array<CreateArticleHowToStep>>;
};

export type CreateArticleHowToStep = {
  description?: InputMaybe<Scalars['String']['input']>;
  headline?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  image_alt?: InputMaybe<Scalars['String']['input']>;
  image_copyright?: InputMaybe<Scalars['String']['input']>;
  time?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateArticleListItem = {
  description?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  headline?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type CreateArticleRecipe = {
  ingredients?: InputMaybe<Array<InputMaybe<CreateArticleRecipeIngridient>>>;
  recipe_level?: InputMaybe<Scalars['String']['input']>;
  recipe_time?: InputMaybe<Scalars['Int']['input']>;
  recipe_type?: InputMaybe<Scalars['String']['input']>;
  steps?: InputMaybe<Array<InputMaybe<CreateArticleRecipeStep>>>;
};

export type CreateArticleRecipeIngridient = {
  amount?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  ingredient?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type CreateArticleRecipeStep = {
  content?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  image_alt?: InputMaybe<Scalars['String']['input']>;
  image_caption?: InputMaybe<Scalars['String']['input']>;
  image_copyright?: InputMaybe<Scalars['String']['input']>;
  image_title?: InputMaybe<Scalars['String']['input']>;
};

export type CreateArticleTable = {
  rows?: InputMaybe<Array<CreateArticleTableRow>>;
  widths?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type CreateArticleTableColumn = {
  copyright?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type CreateArticleTableRow = {
  columns?: InputMaybe<Array<CreateArticleTableColumn>>;
};

export type CreateGustoCategory = {
  custom_open_graph_description?: InputMaybe<Scalars['String']['input']>;
  custom_open_graph_title?: InputMaybe<Scalars['String']['input']>;
  custom_twitter_description?: InputMaybe<Scalars['String']['input']>;
  custom_twitter_title?: InputMaybe<Scalars['String']['input']>;
  google_news_title?: InputMaybe<Scalars['String']['input']>;
  meta_description?: InputMaybe<Scalars['String']['input']>;
  meta_title?: InputMaybe<Scalars['String']['input']>;
  no_follow?: InputMaybe<Scalars['Boolean']['input']>;
  no_index?: InputMaybe<Scalars['Boolean']['input']>;
  open_graph_description?: InputMaybe<Scalars['String']['input']>;
  redirect?: InputMaybe<Scalars['String']['input']>;
  ressort_id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  twitter_description?: InputMaybe<Scalars['String']['input']>;
};

export type CreateGustoCountry = {
  custom_open_graph_description?: InputMaybe<Scalars['String']['input']>;
  custom_open_graph_title?: InputMaybe<Scalars['String']['input']>;
  custom_twitter_description?: InputMaybe<Scalars['String']['input']>;
  custom_twitter_title?: InputMaybe<Scalars['String']['input']>;
  google_news_title?: InputMaybe<Scalars['String']['input']>;
  meta_description?: InputMaybe<Scalars['String']['input']>;
  meta_title?: InputMaybe<Scalars['String']['input']>;
  no_follow?: InputMaybe<Scalars['Boolean']['input']>;
  no_index?: InputMaybe<Scalars['Boolean']['input']>;
  open_graph_description?: InputMaybe<Scalars['String']['input']>;
  redirect?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  twitter_description?: InputMaybe<Scalars['String']['input']>;
};

export type CreateGustoIngredient = {
  bread_units?: InputMaybe<Scalars['Float']['input']>;
  caffeine?: InputMaybe<Scalars['Float']['input']>;
  calories?: InputMaybe<Scalars['Float']['input']>;
  /** kJ value */
  calorific_value?: InputMaybe<Scalars['Float']['input']>;
  carbohydrates?: InputMaybe<Scalars['Float']['input']>;
  carbohydrates_sugar?: InputMaybe<Scalars['Float']['input']>;
  custom_open_graph_description?: InputMaybe<Scalars['String']['input']>;
  custom_open_graph_title?: InputMaybe<Scalars['String']['input']>;
  custom_twitter_description?: InputMaybe<Scalars['String']['input']>;
  custom_twitter_title?: InputMaybe<Scalars['String']['input']>;
  fat?: InputMaybe<Scalars['Float']['input']>;
  google_news_title?: InputMaybe<Scalars['String']['input']>;
  meta_description?: InputMaybe<Scalars['String']['input']>;
  meta_title?: InputMaybe<Scalars['String']['input']>;
  no_follow?: InputMaybe<Scalars['Boolean']['input']>;
  no_index?: InputMaybe<Scalars['Boolean']['input']>;
  open_graph_description?: InputMaybe<Scalars['String']['input']>;
  protein?: InputMaybe<Scalars['Float']['input']>;
  redirect?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  twitter_description?: InputMaybe<Scalars['String']['input']>;
  water?: InputMaybe<Scalars['Float']['input']>;
};

export type CreateGustoIssue = {
  cover_image_path?: InputMaybe<Scalars['String']['input']>;
  filename?: InputMaybe<Scalars['String']['input']>;
  issue_number?: InputMaybe<Scalars['Int']['input']>;
  month?: InputMaybe<Scalars['String']['input']>;
  origin_id?: InputMaybe<Scalars['String']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  recipes?: InputMaybe<Array<Scalars['ID']['input']>>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  year: Scalars['Int']['input'];
};

export type CreateGustoOccasion = {
  custom_open_graph_description?: InputMaybe<Scalars['String']['input']>;
  custom_open_graph_title?: InputMaybe<Scalars['String']['input']>;
  custom_twitter_description?: InputMaybe<Scalars['String']['input']>;
  custom_twitter_title?: InputMaybe<Scalars['String']['input']>;
  google_news_title?: InputMaybe<Scalars['String']['input']>;
  meta_description?: InputMaybe<Scalars['String']['input']>;
  meta_title?: InputMaybe<Scalars['String']['input']>;
  no_follow?: InputMaybe<Scalars['Boolean']['input']>;
  no_index?: InputMaybe<Scalars['Boolean']['input']>;
  open_graph_description?: InputMaybe<Scalars['String']['input']>;
  redirect?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  twitter_description?: InputMaybe<Scalars['String']['input']>;
};

export type CreateGustoProperty = {
  custom_open_graph_description?: InputMaybe<Scalars['String']['input']>;
  custom_open_graph_title?: InputMaybe<Scalars['String']['input']>;
  custom_twitter_description?: InputMaybe<Scalars['String']['input']>;
  custom_twitter_title?: InputMaybe<Scalars['String']['input']>;
  google_news_title?: InputMaybe<Scalars['String']['input']>;
  meta_description?: InputMaybe<Scalars['String']['input']>;
  meta_title?: InputMaybe<Scalars['String']['input']>;
  no_follow?: InputMaybe<Scalars['Boolean']['input']>;
  no_index?: InputMaybe<Scalars['Boolean']['input']>;
  open_graph_description?: InputMaybe<Scalars['String']['input']>;
  redirect?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  twitter_description?: InputMaybe<Scalars['String']['input']>;
};

export type CreateGustoRecipe = {
  bread_units?: InputMaybe<Scalars['Float']['input']>;
  caffeine?: InputMaybe<Scalars['Float']['input']>;
  calories?: InputMaybe<Scalars['Float']['input']>;
  /** kJ value */
  calorific_value?: InputMaybe<Scalars['Float']['input']>;
  carbohydrates?: InputMaybe<Scalars['Float']['input']>;
  carbohydrates_sugar?: InputMaybe<Scalars['Float']['input']>;
  categories?: InputMaybe<Array<Scalars['ID']['input']>>;
  category_id?: InputMaybe<Scalars['ID']['input']>;
  cholesterine?: InputMaybe<Scalars['Float']['input']>;
  countries?: InputMaybe<Array<Scalars['ID']['input']>>;
  cover_image_id?: InputMaybe<Scalars['ID']['input']>;
  cover_image_when_video_id?: InputMaybe<Scalars['ID']['input']>;
  custom_open_graph_description?: InputMaybe<Scalars['String']['input']>;
  custom_open_graph_title?: InputMaybe<Scalars['String']['input']>;
  custom_twitter_description?: InputMaybe<Scalars['String']['input']>;
  custom_twitter_title?: InputMaybe<Scalars['String']['input']>;
  fat?: InputMaybe<Scalars['Float']['input']>;
  google_news_title?: InputMaybe<Scalars['String']['input']>;
  images?: InputMaybe<Array<Scalars['ID']['input']>>;
  ingredient_groups?: InputMaybe<Array<InputGustoRecipeIngredientGroup>>;
  issue_id?: InputMaybe<Scalars['ID']['input']>;
  level?: InputMaybe<GustoRecipeLevel>;
  meta_description?: InputMaybe<Scalars['String']['input']>;
  meta_title?: InputMaybe<Scalars['String']['input']>;
  no_follow?: InputMaybe<Scalars['Boolean']['input']>;
  no_index?: InputMaybe<Scalars['Boolean']['input']>;
  occasions?: InputMaybe<Array<Scalars['ID']['input']>>;
  open_graph_description?: InputMaybe<Scalars['String']['input']>;
  portal?: InputMaybe<Scalars['String']['input']>;
  properties?: InputMaybe<Array<Scalars['ID']['input']>>;
  protein?: InputMaybe<Scalars['Float']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  redirect?: InputMaybe<Scalars['String']['input']>;
  servings?: InputMaybe<Scalars['Int']['input']>;
  servings_unit?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  steps?: InputMaybe<Array<InputGustoRecipeStep>>;
  teaser?: InputMaybe<Scalars['String']['input']>;
  teaser_short?: InputMaybe<Scalars['String']['input']>;
  time?: InputMaybe<Scalars['Int']['input']>;
  time_hint?: InputMaybe<Scalars['String']['input']>;
  tips?: InputMaybe<Array<Scalars['ID']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_short?: InputMaybe<Scalars['String']['input']>;
  twitter_description?: InputMaybe<Scalars['String']['input']>;
  users?: InputMaybe<Array<Scalars['ID']['input']>>;
  water?: InputMaybe<Scalars['Float']['input']>;
};

export type CreateGustoTip = {
  advertorial?: InputMaybe<Scalars['Boolean']['input']>;
  custom_open_graph_description?: InputMaybe<Scalars['String']['input']>;
  custom_open_graph_title?: InputMaybe<Scalars['String']['input']>;
  custom_twitter_description?: InputMaybe<Scalars['String']['input']>;
  custom_twitter_title?: InputMaybe<Scalars['String']['input']>;
  google_news_title?: InputMaybe<Scalars['String']['input']>;
  headline: Scalars['String']['input'];
  image_id?: InputMaybe<Scalars['ID']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  logo_id?: InputMaybe<Scalars['ID']['input']>;
  meta_description?: InputMaybe<Scalars['String']['input']>;
  meta_title?: InputMaybe<Scalars['String']['input']>;
  no_follow?: InputMaybe<Scalars['Boolean']['input']>;
  no_index?: InputMaybe<Scalars['Boolean']['input']>;
  open_graph_description?: InputMaybe<Scalars['String']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  redirect?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  twitter_description?: InputMaybe<Scalars['String']['input']>;
};

export type CreateMailRequestBodyElement = {
  headline_size?: InputMaybe<MailHeadlineSize>;
  /** Image source path */
  source?: InputMaybe<Scalars['String']['input']>;
  type: MailRequestBodyElementType;
  /** Link for link element */
  url?: InputMaybe<Scalars['String']['input']>;
  /** This is always the text interpretation */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type CreateMailRequestInput = {
  body: CreateMailRequestInputBody;
  email: Scalars['String']['input'];
  portal: Scalars['String']['input'];
  subject: Scalars['String']['input'];
  template?: InputMaybe<Scalars['String']['input']>;
  tracking?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateMailRequestInputBody = {
  rows?: InputMaybe<Array<CreateMailRequestInputRow>>;
};

export type CreateMailRequestInputColumn = {
  content?: InputMaybe<Array<CreateMailRequestBodyElement>>;
};

export type CreateMailRequestInputRow = {
  background?: InputMaybe<Scalars['String']['input']>;
  columns?: InputMaybe<Array<CreateMailRequestInputColumn>>;
  columns_per_row: MailColumns;
};

export type CreateUserAccountResult = {
  __typename?: 'CreateUserAccountResult';
  error_text?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateUserSettingEntry = {
  id?: InputMaybe<Scalars['ID']['input']>;
  key: Scalars['String']['input'];
  portal: UserSettingPortal;
  type: UserSettingEntryType;
  /** This will be casted to the correct format */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type CtaButton = {
  __typename?: 'CtaButton';
  link?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  variant?: Maybe<Scalars['String']['output']>;
};

export type CustomerAccounts = {
  __typename?: 'CustomerAccounts';
  paymentMean?: Maybe<CustomerPaymentMean>;
};

export type CustomerAddress = {
  __typename?: 'CustomerAddress';
  city?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  companyName2?: Maybe<Scalars['String']['output']>;
  country?: Maybe<CustomerStatus>;
  door?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  floor?: Maybe<Scalars['String']['output']>;
  houseNumber?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  name3?: Maybe<Scalars['String']['output']>;
  name4?: Maybe<Scalars['String']['output']>;
  otherTitle?: Maybe<Scalars['String']['output']>;
  postalDeliveryNotes?: Maybe<Scalars['String']['output']>;
  salutation?: Maybe<CustomerStatus>;
  street?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type CustomerAddressRedirects = {
  __typename?: 'CustomerAddressRedirects';
  address?: Maybe<CustomerAddress>;
  endDt: Scalars['String']['output'];
  redirectId: Scalars['String']['output'];
  startDt: Scalars['String']['output'];
};

/**
 * Result of an anonymous customer creation via vn-auth-service/user/create.
 * Atomically creates a UUser (with a generated noreply-* placeholder email
 * that no one ever logs in with) + auto-linked Customer record + returns a
 * customer-scoped Compax JWT. Frontend uses access_token as Bearer for
 * downstream Stripe/basket/contract calls — same auth model as the regular
 * checkout, just without prompting the user for email + password upfront.
 * The user's real email is attached to the customer record at the end of
 * the flow via customerChangeData.
 */
export type CustomerAnonymousResult = {
  __typename?: 'CustomerAnonymousResult';
  access_token?: Maybe<Scalars['String']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  error_code?: Maybe<Scalars['Int']['output']>;
  error_text?: Maybe<Scalars['String']['output']>;
  /**
   * True when the caller's real email was used as the UUser login
   * (i.e. it was free in Compax). False when we fell back to a
   * noreply-{uuid}@compax-temp.invalid placeholder because the email
   * was already taken. Lets the checkout client decide whether to fire
   * customerResetPassword post-contract so a brand-new user gets a
   * "set your password" email they can use to claim the account.
   */
  loginIsRealEmail?: Maybe<Scalars['Boolean']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CustomerBankAccount = {
  __typename?: 'CustomerBankAccount';
  accountHolder?: Maybe<Scalars['String']['output']>;
  bic?: Maybe<Scalars['String']['output']>;
  iban?: Maybe<Scalars['String']['output']>;
  /** Compax id; exceeds 32-bit Int, hence String. */
  id?: Maybe<Scalars['String']['output']>;
};

export type CustomerBasketResult = {
  __typename?: 'CustomerBasketResult';
  contractId: Scalars['String']['output'];
  customerId: Scalars['String']['output'];
  signUpId: Scalars['String']['output'];
  workflowId: Scalars['String']['output'];
};

export type CustomerBill = {
  __typename?: 'CustomerBill';
  documentName?: Maybe<Scalars['String']['output']>;
  file?: Maybe<Scalars['String']['output']>;
  mimeType?: Maybe<Scalars['String']['output']>;
};

export type CustomerBills = {
  __typename?: 'CustomerBills';
  amount?: Maybe<Scalars['Float']['output']>;
  billDocumentName?: Maybe<Scalars['String']['output']>;
  billNumber?: Maybe<Scalars['String']['output']>;
  billPeriode?: Maybe<Scalars['String']['output']>;
  billPeriodeFrom?: Maybe<Scalars['String']['output']>;
  billPeriodeTo?: Maybe<Scalars['String']['output']>;
  billType?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  invoiceDate?: Maybe<Scalars['String']['output']>;
  paymentMode?: Maybe<CustomerStatus>;
  status?: Maybe<Scalars['String']['output']>;
};

export type CustomerCompaxActiveServies = {
  __typename?: 'CustomerCompaxActiveServies';
  accountId?: Maybe<Scalars['String']['output']>;
  contractId?: Maybe<Scalars['String']['output']>;
  dserviceId?: Maybe<Scalars['String']['output']>;
  endDateRequested?: Maybe<Scalars['DateTime']['output']>;
  endDateService?: Maybe<Scalars['DateTime']['output']>;
  productId?: Maybe<Scalars['Int']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  startDateBilling?: Maybe<Scalars['DateTime']['output']>;
  startDateRequested?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<CustomerStatus>;
  subServices?: Maybe<Array<Maybe<CustomerCompaxActiveServies>>>;
};

export type CustomerContracts = {
  __typename?: 'CustomerContracts';
  activeServices?: Maybe<Array<Maybe<CustomerCompaxActiveServies>>>;
  customerFirstName?: Maybe<Scalars['String']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  customerLastName?: Maybe<Scalars['String']['output']>;
  /** True when Compax could not be asked and this is the last snapshot user-service holds for the session. */
  snapshot?: Maybe<Scalars['Boolean']['output']>;
  /** When that snapshot was taken (ISO 8601); null for a live answer. */
  snapshotAt?: Maybe<Scalars['String']['output']>;
};

export type CustomerCreditCard = {
  __typename?: 'CustomerCreditCard';
  cardType?: Maybe<Scalars['String']['output']>;
  holder?: Maybe<Scalars['String']['output']>;
  /** Compax id; exceeds 32-bit Int, hence String. */
  id?: Maybe<Scalars['String']['output']>;
  maskedCardNumber?: Maybe<Scalars['String']['output']>;
  validityMonth?: Maybe<Scalars['String']['output']>;
  validityYear?: Maybe<Scalars['String']['output']>;
};

export type CustomerData = {
  __typename?: 'CustomerData';
  birthday?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  companyName2?: Maybe<Scalars['String']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  customerType?: Maybe<CustomerStatus>;
  email?: Maybe<CustomerEmail>;
  firstName?: Maybe<Scalars['String']['output']>;
  hasActivatedUsers?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  language?: Maybe<CustomerStatus>;
  lastName?: Maybe<Scalars['String']['output']>;
  mainAddress?: Maybe<CustomerAddress>;
  permissions?: Maybe<Array<Maybe<CustomerPermission>>>;
  phone?: Maybe<CustomerPhone>;
  phone2?: Maybe<CustomerPhone>;
  preferredContactType?: Maybe<CustomerStatus>;
  salutation?: Maybe<CustomerStatus>;
  title?: Maybe<CustomerStatus>;
};

export type CustomerDeliveryComplaintsContractResult = {
  __typename?: 'CustomerDeliveryComplaintsContractResult';
  issues: Array<Maybe<CompaxIssue>>;
};

export type CustomerDeliveryExtendedValues = {
  __typename?: 'CustomerDeliveryExtendedValues';
  extendedValues: Array<Maybe<CustomerStatus>>;
};

export type CustomerDeliverySuspensionsActiveResult = {
  __typename?: 'CustomerDeliverySuspensionsActiveResult';
  endDt?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  reasonId?: Maybe<Scalars['Int']['output']>;
  startDt?: Maybe<Scalars['String']['output']>;
};

export type CustomerEmail = {
  __typename?: 'CustomerEmail';
  email?: Maybe<Scalars['String']['output']>;
  emailType?: Maybe<CustomerStatus>;
  id?: Maybe<Scalars['Int']['output']>;
};

export type CustomerEmailInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  emailType?: InputMaybe<CustomerStatusInput>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type CustomerPaymentMean = {
  __typename?: 'CustomerPaymentMean';
  bankAccount?: Maybe<CustomerBankAccount>;
  creditCard?: Maybe<CustomerCreditCard>;
  /** Compax id; exceeds 32-bit Int (e.g. 2176141203), hence String. */
  id?: Maybe<Scalars['String']['output']>;
  paymentMode?: Maybe<CustomerPaymentMode>;
  stripeAccount?: Maybe<CustomerStripeAccount>;
  tokenId?: Maybe<Scalars['String']['output']>;
  transactionId?: Maybe<Scalars['String']['output']>;
};

export type CustomerPaymentMode = {
  __typename?: 'CustomerPaymentMode';
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

export type CustomerPermission = {
  __typename?: 'CustomerPermission';
  accepted?: Maybe<Scalars['Boolean']['output']>;
  lastUser?: Maybe<Scalars['Int']['output']>;
  permissionType?: Maybe<Scalars['String']['output']>;
  referenz?: Maybe<Scalars['String']['output']>;
};

export type CustomerPhone = {
  __typename?: 'CustomerPhone';
  areaCode?: Maybe<Scalars['String']['output']>;
  cli?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  phoneType?: Maybe<CustomerStatus>;
};

export type CustomerPhoneInput = {
  areaCode?: InputMaybe<Scalars['String']['input']>;
  cli?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  phoneType?: InputMaybe<CustomerStatusInput>;
};

export type CustomerRegistrationResult = {
  __typename?: 'CustomerRegistrationResult';
  /** This code will only be present if an error occurs */
  error_code?: Maybe<Scalars['Int']['output']>;
  error_text?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export enum CustomerSalutation {
  An = 'AN',
  Firma = 'FIRMA',
  Frau = 'FRAU',
  Herr = 'HERR'
}

export type CustomerStatus = {
  __typename?: 'CustomerStatus';
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

export type CustomerStatusInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type CustomerStripeAccount = {
  __typename?: 'CustomerStripeAccount';
  /** Compax id; exceeds 32-bit Int, hence String. */
  id?: Maybe<Scalars['String']['output']>;
  paymentMethodId?: Maybe<Scalars['String']['output']>;
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
};

export type CustomerTokenResult = {
  __typename?: 'CustomerTokenResult';
  access_token?: Maybe<Scalars['String']['output']>;
  expires_in?: Maybe<Scalars['Int']['output']>;
  refresh_token?: Maybe<Scalars['String']['output']>;
  scope?: Maybe<Scalars['String']['output']>;
  token_type?: Maybe<Scalars['String']['output']>;
};

export type CustomerTokenResultWithError = {
  __typename?: 'CustomerTokenResultWithError';
  access_token?: Maybe<Scalars['String']['output']>;
  error_code?: Maybe<Scalars['Int']['output']>;
  error_text?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CustomerUser = {
  __typename?: 'CustomerUser';
  address?: Maybe<CustomerUserAddress>;
  compaxContracts?: Maybe<Array<Maybe<CustomerContracts>>>;
  compaxProducts?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  compaxToken?: Maybe<Scalars['String']['output']>;
  compax_id?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  email_verified?: Maybe<Scalars['Boolean']['output']>;
  firstName: Scalars['String']['output'];
  gender: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  locale?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  permissions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  refresh_token?: Maybe<Scalars['String']['output']>;
};

export type CustomerUserAddress = {
  __typename?: 'CustomerUserAddress';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  postal_code?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
};

export type CustomerUserResult = {
  __typename?: 'CustomerUserResult';
  status?: Maybe<Scalars['String']['output']>;
};

export type CustomerVacationAddressInput = {
  city: Scalars['String']['input'];
  companyName?: InputMaybe<Scalars['String']['input']>;
  companyName2?: InputMaybe<Scalars['String']['input']>;
  country: CustomerStatusInput;
  door: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  floor: Scalars['String']['input'];
  houseNumber: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  salutation: CustomerStatusInput;
  street: Scalars['String']['input'];
  zip: Scalars['String']['input'];
};

export type DataSubjectDocument = {
  __typename?: 'DataSubjectDocument';
  key: Scalars['String']['output'];
  mime?: Maybe<Scalars['String']['output']>;
  originalName?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
};

/** A single identity document, base64-encoded so it travels as a normal GraphQL String (no REST/multipart). */
export type DataSubjectDocumentInput = {
  contentBase64: Scalars['String']['input'];
  filename: Scalars['String']['input'];
};

export type DataSubjectDocumentUrl = {
  __typename?: 'DataSubjectDocumentUrl';
  error_text?: Maybe<Scalars['String']['output']>;
  expiresAt?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type DataSubjectRequestAdmin = {
  __typename?: 'DataSubjectRequestAdmin';
  additionalInfo?: Maybe<Scalars['String']['output']>;
  confirmedAt?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  documents?: Maybe<Array<DataSubjectDocument>>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  portal?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  submittedAt?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type DateRange = {
  from?: InputMaybe<Scalars['Date']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
};

export enum DateType {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

export type DefaultPaginator = {
  __typename?: 'DefaultPaginator';
  count?: Maybe<Scalars['Int']['output']>;
  currentPage?: Maybe<Scalars['Int']['output']>;
  firstItem?: Maybe<Scalars['Int']['output']>;
  hasMorePages?: Maybe<Scalars['Boolean']['output']>;
  lastItem?: Maybe<Scalars['Int']['output']>;
  lastPage?: Maybe<Scalars['Int']['output']>;
  perPage?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type DiscountCode = {
  __typename?: 'DiscountCode';
  code?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<FairuAsset>;
  link?: Maybe<Scalars['String']['output']>;
  portal?: Maybe<Scalars['String']['output']>;
  /** Linked subscription page ids (each carries Offering ID + Product ID via compax_id / compax_product_id). */
  subscription_page_ids?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  subscriptions?: Maybe<Array<Maybe<SubscriptionPage>>>;
  text?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};


export type DiscountCodeTextArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DummyResponse = {
  __typename?: 'DummyResponse';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type EnableUserAccountResult = {
  __typename?: 'EnableUserAccountResult';
  already_active?: Maybe<Scalars['Boolean']['output']>;
  redirect_url?: Maybe<Scalars['String']['output']>;
  resent?: Maybe<Scalars['Boolean']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Entity entry. */
export type Entity = {
  __typename?: 'Entity';
  /** Asset id backdrop image */
  asset_backdrop_id?: Maybe<Scalars['String']['output']>;
  /** Asset id cover image */
  asset_id?: Maybe<Scalars['String']['output']>;
  /** Backdrop image */
  backdrop_image?: Maybe<FairuAsset>;
  /** cover image */
  cover_image?: Maybe<FairuAsset>;
  full?: Maybe<TvmEntityEntry>;
  /** Unique primary key. */
  id?: Maybe<Scalars['String']['output']>;
  /** Slug */
  slug?: Maybe<Scalars['String']['output']>;
  /** Summary */
  summary?: Maybe<Scalars['String']['output']>;
  /** Title of the enitity */
  title?: Maybe<Scalars['String']['output']>;
  /** TMDB Id */
  tmdb_id?: Maybe<Scalars['String']['output']>;
  /** Tmdb Score */
  tmdb_score?: Maybe<Scalars['Float']['output']>;
  /** Type of the enitity */
  type?: Maybe<Scalars['String']['output']>;
  /** Year */
  year?: Maybe<Scalars['Int']['output']>;
};


/** Entity entry. */
export type EntitySummaryArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EntityEntry = Movie | Show | Vod;

export type EntityInterface = {
  /** Asset id cover image */
  asset_id?: Maybe<Scalars['String']['output']>;
  /** Created at */
  created_at?: Maybe<Scalars['DateTime']['output']>;
  /** Unique primary key. */
  id: Scalars['ID']['output'];
  /** IMDB Id */
  imdb_id?: Maybe<Scalars['String']['output']>;
  /** Published */
  published?: Maybe<Scalars['Boolean']['output']>;
  /** Run time */
  runtime?: Maybe<Scalars['Int']['output']>;
  /** Shorttitle of the enitity */
  short?: Maybe<Scalars['String']['output']>;
  /** Title of the enitity */
  title?: Maybe<Scalars['String']['output']>;
  /** TMDB Id */
  tmdb_id?: Maybe<Scalars['String']['output']>;
  /** Score */
  tmdb_score?: Maybe<Scalars['Float']['output']>;
  /** Updated at */
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  /** Year of release */
  year?: Maybe<Scalars['Int']['output']>;
};

export type EntityPaginationList = {
  __typename?: 'EntityPaginationList';
  data?: Maybe<Array<Maybe<EntityEntry>>>;
  paginatorInfo?: Maybe<DefaultPaginator>;
};

export type Entry = Article | Collage | Page | Product | Redirect | Ressort | SubscriptionOverview | SubscriptionPage | Topic | TvmTopicEntry;

/** Season episode entry. */
export type Episode = BaseInterface & {
  __typename?: 'Episode';
  actor_ids?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Article ids */
  article_ids?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Image for the episode */
  asset?: Maybe<FairuAsset>;
  /** The main image for this episode. */
  asset_id?: Maybe<Scalars['String']['output']>;
  /** Created at */
  created_at?: Maybe<Scalars['DateTime']['output']>;
  crew_ids?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** flat list of director ids for the episode */
  director_ids?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** directors for the episode */
  directors?: Maybe<PersonPaginationList>;
  /** Enriched data  */
  enriched?: Maybe<Scalars['Boolean']['output']>;
  /** Genre ids for the movie */
  genre_ids?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Genres for the movie */
  genres?: Maybe<Array<Maybe<Genre>>>;
  /** Unique primary key. */
  id?: Maybe<Scalars['String']['output']>;
  /** Imdb id */
  imdb_id?: Maybe<Scalars['String']['output']>;
  /** Id within the justwatch api */
  justwatch_id?: Maybe<Scalars['String']['output']>;
  /** Watch links */
  links?: Maybe<Array<Maybe<WatchLink>>>;
  /** Mediapress content id */
  mediapress_id?: Maybe<Scalars['String']['output']>;
  /** Meta data */
  metadata?: Maybe<Meta>;
  /** Episode number */
  nr?: Maybe<Scalars['Int']['output']>;
  /** persons for the show */
  persons?: Maybe<PersonPaginationList>;
  /** Pubslihed */
  published?: Maybe<Scalars['Boolean']['output']>;
  /** Release date */
  release_date?: Maybe<Scalars['String']['output']>;
  /** Review */
  review?: Maybe<Scalars['String']['output']>;
  /** Reviewed data  */
  reviewed?: Maybe<Scalars['Boolean']['output']>;
  /** Runtime of the single episode */
  runtime?: Maybe<Scalars['Int']['output']>;
  /** Season */
  season?: Maybe<Season>;
  /** Season */
  show?: Maybe<Season>;
  /** Id of the show */
  show_id?: Maybe<Scalars['String']['output']>;
  /** Name of the show */
  show_title?: Maybe<Scalars['String']['output']>;
  /** Showtimes identifier */
  showtimes_id?: Maybe<Scalars['String']['output']>;
  /** Pivot information will only be attached if the querys root is a person. */
  singlePersonMetaInformation?: Maybe<PersonMeta>;
  /** Summary */
  summary?: Maybe<Scalars['String']['output']>;
  /** Title of the enitity */
  title?: Maybe<Scalars['String']['output']>;
  /** Tmdb id */
  tmdb_id?: Maybe<Scalars['String']['output']>;
  /** Score of TVMedia */
  tvm_score?: Maybe<Scalars['Int']['output']>;
  /** Updated at */
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  /** Year */
  year?: Maybe<Scalars['String']['output']>;
};


/** Season episode entry. */
export type EpisodeDirectorsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


/** Season episode entry. */
export type EpisodeGenresArgs = {
  flat?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Season episode entry. */
export type EpisodePersonsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  withUnpublished?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Season episode entry. */
export type EpisodeReviewArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Season episode entry. */
export type EpisodeSummaryArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A paginated list of Episode items. */
export type EpisodePaginator = {
  __typename?: 'EpisodePaginator';
  /** A list of Episode items. */
  data: Array<Episode>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

/** Result type for fairuAllFilesFlat query - S3-compatible flat file listing */
export type FairuAllFilesFlatResult = {
  __typename?: 'FairuAllFilesFlatResult';
  /** List of entries (files and empty folders) */
  entries: Array<FairuFlatEntry>;
  /** True if there are more pages */
  hasMore: Scalars['Boolean']['output'];
  /** Cursor for next page (null if no more pages) */
  nextCursor?: Maybe<Scalars['String']['output']>;
};

export type FairuAsset = {
  __typename?: 'FairuAsset';
  /** Whether this asset was generated or manipulated by AI (EU AI Act labeling). */
  ai_generated?: Maybe<Scalars['Boolean']['output']>;
  /** The metadata value the AI detection matched on. */
  ai_provenance_detail?: Maybe<Scalars['String']['output']>;
  /** How the AI marker was determined: c2pa, iptc, credit, software, sd_parameters or manual. */
  ai_provenance_source?: Maybe<Scalars['String']['output']>;
  alt?: Maybe<Scalars['String']['output']>;
  archived?: Maybe<Scalars['Boolean']['output']>;
  blocked?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The blueprints that apply to this asset — inherited from its folders and
   * pinned to it — in the order a metadata panel should read them.
   */
  blueprints?: Maybe<Array<FairuAssetBlueprint>>;
  blurhash?: Maybe<Scalars['String']['output']>;
  caption?: Maybe<Scalars['String']['output']>;
  copyright_text?: Maybe<Scalars['String']['output']>;
  copyright_year?: Maybe<Scalars['Int']['output']>;
  copyrights?: Maybe<Array<FairuCopyright>>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** Whether the stored description was written by AI and not yet replaced by a person. */
  description_ai_generated?: Maybe<Scalars['Boolean']['output']>;
  /**
   * How long the media runs, in seconds, with millisecond precision.
   *
   * Null for anything that is not audio or video, for media uploaded before the
   * length was recorded, and for media whose length could not be read at all —
   * a player should fall back to what the browser measures rather than show a
   * zero.
   *
   * Not owner-only: the number is what a podcast client puts next to an episode
   * before anyone has agreed to download it.
   */
  duration?: Maybe<Scalars['Float']['output']>;
  /**
   * Whether the signed-in person keeps this asset at hand.
   *
   * A favourite belongs to a person, not to a workspace, so this answers `null`
   * when the request is authenticated by a workspace API key or a Raku
   * credential — a machine has no shortlist. `false` means a signed-in person
   * has not starred it.
   */
  favorite?: Maybe<Scalars['Boolean']['output']>;
  /**
   * SHA1 of the file's content, used for deduplication.
   *
   * Owner-only: a content hash identifies the bytes, so handing it to a caller
   * outside the workspace would let them confirm which files it holds.
   */
  fingerprint?: Maybe<Scalars['String']['output']>;
  focal_point?: Maybe<Scalars['String']['output']>;
  has_error?: Maybe<Scalars['Boolean']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  /**
   * What the file's own IPTC block says: creator, credit, copyright notice,
   * usage terms and the rest of the allow-list in `App\\Services\\IptcReader`.
   *
   * Owner-only, unlike `duration`. A credit line is meant to be shown and a
   * licence is meant to be read, but the same record carries `instructions` —
   * an editor's private note to the desk — and the city a picture was taken in.
   * Handing the block to every caller would publish the internal half to reach
   * the public one; a workspace that wants a credit line rendered can ask for it
   * and choose what to print.
   *
   * Null while the file has not been read, and for a workspace that has not
   * switched `use_iptc_metadata` on.
   */
  iptc?: Maybe<Scalars['JSON']['output']>;
  /** The state this asset is in, out of the set the workspace defined. */
  label?: Maybe<FairuLabel>;
  licenses?: Maybe<Array<FairuLicense>>;
  /**
   * Every field that applies to this asset, with the values it holds.
   *
   * Values recorded under a blueprint that has since been detached are left out
   * rather than deleted; ask with `includeUnassigned` to see them.
   *
   * On the open queries this answers for everyone, but a caller outside the
   * owning workspace sees only the fields of blueprints marked `public` —
   * and never the unassigned leftovers.
   */
  metadata?: Maybe<Array<FairuAssetMetadata>>;
  /** Whether every required field that applies to this asset has a value. */
  metadata_complete?: Maybe<Scalars['Boolean']['output']>;
  mime?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  original_height?: Maybe<Scalars['Int']['output']>;
  original_width?: Maybe<Scalars['Int']['output']>;
  /**
   * Whether the asset is withheld from anonymous access.
   *
   * A private asset resolves to null on the open URL queries and is only served
   * by the proxy against a valid access signature. This is what the S3 gateway
   * reports as the object ACL, and what `Storage::setVisibility()` writes.
   */
  private?: Maybe<Scalars['Boolean']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  tags?: Maybe<Array<FairuTag>>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  versions?: Maybe<Array<FairuAssetVideoVersions>>;
  width?: Maybe<Scalars['Int']['output']>;
};


export type FairuAssetCaptionArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};


export type FairuAssetDescriptionArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};


export type FairuAssetMetadataArgs = {
  includeUnassigned?: InputMaybe<Scalars['Boolean']['input']>;
};


export type FairuAssetUrlArgs = {
  focal_point?: InputMaybe<Scalars['String']['input']>;
  height?: InputMaybe<Scalars['Int']['input']>;
  quality?: InputMaybe<Scalars['Int']['input']>;
  sign?: InputMaybe<Scalars['Int']['input']>;
  version?: InputMaybe<FairuAssetVideoVersions>;
  width?: InputMaybe<Scalars['Int']['input']>;
  withStoredFocalPoint?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A blueprint that applies to an asset, and how it got there. */
export type FairuAssetBlueprint = {
  __typename?: 'FairuAssetBlueprint';
  blueprint: FairuBlueprint;
  /** The folder carrying the assignment. Null when the blueprint is pinned to the asset. */
  folder_id?: Maybe<Scalars['ID']['output']>;
  source: FairuBlueprintSource;
};

export type FairuAssetList = {
  __typename?: 'FairuAssetList';
  data?: Maybe<Array<FairuAsset>>;
  paginatorInfo?: Maybe<DefaultPaginator>;
};

/** One field that applies to an asset, together with what the asset holds for it. */
export type FairuAssetMetadata = {
  __typename?: 'FairuAssetMetadata';
  field: FairuField;
  folder_id?: Maybe<Scalars['ID']['output']>;
  source: FairuBlueprintSource;
  /** The value, for every field that holds one. Null for a multi-select. */
  value?: Maybe<Scalars['String']['output']>;
  /** Every value, in order. A single-value field answers with at most one entry. */
  values: Array<Scalars['String']['output']>;
};

export enum FairuAssetVideoVersions {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM',
  P720 = 'P720',
  P1080 = 'P1080'
}

/** A backup target: where this workspace's originals are copied to. */
export type FairuBackup = {
  __typename?: 'FairuBackup';
  active?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Bytes copied to this target so far, counted as workspace egress.
   *
   * Float rather than Int on purpose. GraphQL's Int is 32-bit, and graphql-php
   * raises a serialization error above 2147483647 rather than truncating — so a
   * target that has moved more than 2 GB, which is the ordinary case, would fail
   * the whole query. Float is a double and exact for integers up to 2^53.
   */
  bytes_transferred?: Maybe<Scalars['Float']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  /** Reuses the disk credential shapes: a backup target is the same remote, with the traffic going the other way. */
  credentials?: Maybe<FairuDiskCredentials>;
  /** The root of the mirrored subtree. Null means the whole workspace. */
  folder?: Maybe<FairuFolder>;
  healthy?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  last_completed_at?: Maybe<Scalars['DateTime']['output']>;
  last_run_at?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** Directory on the target that everything is written below. */
  path?: Maybe<Scalars['String']['output']>;
  /** Optional regular expression. Only files whose name matches it are backed up. */
  pattern?: Maybe<Scalars['String']['output']>;
  progress?: Maybe<FairuBackupProgress>;
  syncing?: Maybe<Scalars['Boolean']['output']>;
  type?: Maybe<FairuDiskType>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type FairuBackupDto = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  credentials?: InputMaybe<FairuDiskCredentialsDto>;
  /** The root of the subtree to mirror. Leave empty to back up the whole workspace. */
  folder_id?: InputMaybe<Scalars['ID']['input']>;
  /** Required when updating, ignored when creating. */
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  pattern?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<FairuDiskType>;
};

export type FairuBackupList = {
  __typename?: 'FairuBackupList';
  data?: Maybe<Array<FairuBackup>>;
  paginatorInfo?: Maybe<DefaultPaginator>;
};

/** How far a backup has got through the files it planned. */
export type FairuBackupProgress = {
  __typename?: 'FairuBackupProgress';
  /** See FairuBackup.bytes_transferred for why this is a Float. */
  bytes?: Maybe<Scalars['Float']['output']>;
  failed?: Maybe<Scalars['Int']['output']>;
  pending?: Maybe<Scalars['Int']['output']>;
  /** Whole percent of planned files already copied. */
  percent?: Maybe<Scalars['Int']['output']>;
  synced?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

/**
 * A named collection of fieldsets — the unit that is assigned to a folder, where
 * it inherits down the tree, or pinned to a single asset.
 *
 * A blueprint holds fieldsets and only fieldsets; a fieldset holds fields and only
 * fields. The hierarchy is exactly two levels deep and cannot be nested further.
 */
export type FairuBlueprint = {
  __typename?: 'FairuBlueprint';
  /** Which assets this blueprint governs. MANUAL unless somebody widened it. */
  applies_to?: Maybe<FairuBlueprintApplies>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  fieldsets?: Maybe<Array<FairuFieldset>>;
  /** The stable name to address this by. Display names change; handles do not. */
  handle: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /**
   * Whether this blueprint's fields and values are readable on the open asset
   * queries without owner authentication. Private (the default) keeps them
   * visible to the owning workspace only.
   */
  public?: Maybe<Scalars['Boolean']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

/**
 * How a blueprint finds the assets it governs.
 *
 * MANUAL is the default and reaches an asset only where the blueprint is attached
 * to one of its folders or pinned to the asset itself. ALL reaches every asset in
 * the workspace with nothing to attach — which also means that turning it on
 * re-evaluates the completeness flag of the entire library.
 */
export enum FairuBlueprintApplies {
  All = 'ALL',
  Manual = 'MANUAL'
}

export type FairuBlueprintDto = {
  /**
   * Widen the blueprint to every asset in the workspace, or narrow it back to
   * where it is attached. Changing this recomputes the completeness flag across
   * the whole library, so it is queued rather than done in the request.
   */
  appliesTo?: InputMaybe<FairuBlueprintApplies>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** The fieldsets this blueprint holds, in this order. Replaces the current list. */
  fieldsetIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Derived from the name when omitted. Lowercase, starting with a letter: a-z, 0-9 and _. */
  handle?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** Expose this blueprint's fields and values on the open asset queries. Off by default. */
  public?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FairuBlueprintList = {
  __typename?: 'FairuBlueprintList';
  data?: Maybe<Array<FairuBlueprint>>;
  paginatorInfo?: Maybe<DefaultPaginator>;
};

/**
 * How a blueprint reached the asset it applies to: pinned to the asset itself,
 * contributed by one of its folders, or applied across the whole workspace.
 */
export enum FairuBlueprintSource {
  Automatic = 'AUTOMATIC',
  Direct = 'DIRECT',
  Inherited = 'INHERITED'
}

/** One run of a delivery-cache purge. */
export type FairuCachePurgeResult = {
  __typename?: 'FairuCachePurgeResult';
  /** The ids nothing was queued for — unknown here, or owned by somebody else. */
  missing: Array<Scalars['ID']['output']>;
  /** The ids a purge was queued for. */
  queued: Array<Scalars['ID']['output']>;
};

export type FairuCaptionUpdateResult = {
  __typename?: 'FairuCaptionUpdateResult';
  /** The caption as Fairu stored it. Public pages pick it up ~1 minute later, once the delayed cache purge has run. */
  caption?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** A list of options that select fields choose from. */
export type FairuCatalog = {
  __typename?: 'FairuCatalog';
  created_at?: Maybe<Scalars['DateTime']['output']>;
  entries?: Maybe<Array<FairuCatalogEntry>>;
  handle: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  last_sync_count?: Maybe<Scalars['Int']['output']>;
  last_sync_message?: Maybe<Scalars['String']['output']>;
  last_sync_status?: Maybe<Scalars['String']['output']>;
  /** When the last sync ran, whether it worked, and what it said if it did not. */
  last_synced_at?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  /** See the note on FairuField.type. */
  scope: FairuCatalogScope;
  sort_mode?: Maybe<FairuCatalogSortMode>;
  /**
   * Where the options come from. MANUAL is maintained in the workspace; URL is
   * fetched from `source_url` whenever a sync runs.
   */
  source_type?: Maybe<FairuCatalogSourceType>;
  /** The address a URL-backed catalog reads. Any credentials it sends are never returned. */
  source_url?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type FairuCatalogDto = {
  entries?: InputMaybe<Array<FairuCatalogEntryInput>>;
  handle?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sort_mode?: InputMaybe<FairuCatalogSortMode>;
  /** Headers the fetch sends, usually an API key. Stored encrypted and never returned. */
  source_headers?: InputMaybe<Array<FairuCatalogHeaderInput>>;
  /** Set to URL together with sourceUrl to make this catalog a mirror of something else. */
  source_type?: InputMaybe<FairuCatalogSourceType>;
  source_url?: InputMaybe<Scalars['String']['input']>;
};

export type FairuCatalogEntry = {
  __typename?: 'FairuCatalogEntry';
  /**
   * Retired: cannot be chosen for a new value, and still resolves for every
   * asset that already carries it.
   */
  archived: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** What a person reads. Falls back to the value. */
  label?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  /** What is stored and filtered on. */
  value: Scalars['String']['output'];
};

export type FairuCatalogEntryDto = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  catalogId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type FairuCatalogEntryInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  value: Scalars['String']['input'];
};

export type FairuCatalogHeaderInput = {
  name: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type FairuCatalogList = {
  __typename?: 'FairuCatalogList';
  data?: Maybe<Array<FairuCatalog>>;
  paginatorInfo?: Maybe<DefaultPaginator>;
};

/**
 * Whether an option list is a workspace-wide catalog several fields may point at,
 * or the private list behind one field.
 */
export enum FairuCatalogScope {
  Field = 'FIELD',
  Shared = 'SHARED'
}

/** The order a catalog offers its options in. */
export enum FairuCatalogSortMode {
  Label = 'LABEL',
  Manual = 'MANUAL',
  Value = 'VALUE'
}

/** How a catalog's options are kept up to date. */
export enum FairuCatalogSourceType {
  Manual = 'MANUAL',
  Url = 'URL'
}

export type FairuCopyright = {
  __typename?: 'FairuCopyright';
  active?: Maybe<Scalars['Boolean']['output']>;
  blocked?: Maybe<Scalars['Boolean']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  reviewed?: Maybe<Scalars['Boolean']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

export type FairuCopyrightDto = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  blocked?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  reviewed?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type FairuCopyrightList = {
  __typename?: 'FairuCopyrightList';
  data?: Maybe<Array<FairuCopyright>>;
  paginatorInfo?: Maybe<DefaultPaginator>;
};

export enum FairuCustomDomainStatus {
  Checking = 'CHECKING',
  Failed = 'FAILED',
  None = 'NONE',
  Success = 'SUCCESS'
}

export type FairuDisk = {
  __typename?: 'FairuDisk';
  active?: Maybe<Scalars['Boolean']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  credentials?: Maybe<FairuDiskCredentials>;
  delete_at_origin?: Maybe<Scalars['Boolean']['output']>;
  folder?: Maybe<FairuFolder>;
  healthy?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  path?: Maybe<Scalars['String']['output']>;
  pattern?: Maybe<Scalars['String']['output']>;
  syncing?: Maybe<Scalars['Boolean']['output']>;
  type?: Maybe<FairuDiskType>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type FairuDiskCredentials = FairuDiskFtpCredentials | FairuDiskS3Credentials;

export type FairuDiskCredentialsDto = {
  /** For S3 */
  bucket?: InputMaybe<Scalars['String']['input']>;
  /** For S3 */
  endpoint?: InputMaybe<Scalars['String']['input']>;
  /** For FTP/SFTP */
  ftp_host?: InputMaybe<Scalars['String']['input']>;
  /** For FTP/SFTP */
  ftp_password?: InputMaybe<Scalars['String']['input']>;
  /** For FTP/SFTP */
  ftp_port?: InputMaybe<Scalars['Int']['input']>;
  /** For FTP/SFTP */
  ftp_username?: InputMaybe<Scalars['String']['input']>;
  /** For S3 */
  key?: InputMaybe<Scalars['String']['input']>;
  /** For S3 */
  region?: InputMaybe<Scalars['String']['input']>;
  /** For S3 */
  secret?: InputMaybe<Scalars['String']['input']>;
  /** For S3 */
  url?: InputMaybe<Scalars['String']['input']>;
};

export type FairuDiskDto = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  credentials?: InputMaybe<FairuDiskCredentialsDto>;
  delete_at_origin?: InputMaybe<Scalars['Boolean']['input']>;
  folder_id?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  pattern?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<FairuDiskType>;
};

export type FairuDiskFtpCredentials = {
  __typename?: 'FairuDiskFTPCredentials';
  ftp_host?: Maybe<Scalars['String']['output']>;
  ftp_password?: Maybe<Scalars['String']['output']>;
  ftp_port?: Maybe<Scalars['Int']['output']>;
  ftp_username?: Maybe<Scalars['String']['output']>;
};

export type FairuDiskList = {
  __typename?: 'FairuDiskList';
  data?: Maybe<Array<FairuDisk>>;
  paginatorInfo?: Maybe<DefaultPaginator>;
};

export type FairuDiskS3Credentials = {
  __typename?: 'FairuDiskS3Credentials';
  bucket?: Maybe<Scalars['String']['output']>;
  endpoint?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  secret?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type FairuDiskStatus = {
  __typename?: 'FairuDiskStatus';
  failed?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  open?: Maybe<Scalars['Int']['output']>;
  pending?: Maybe<Scalars['Int']['output']>;
  synced?: Maybe<Scalars['Int']['output']>;
  syncing?: Maybe<Scalars['Boolean']['output']>;
};

export enum FairuDiskType {
  Ftp = 'FTP',
  S3 = 'S3',
  Sftp = 'SFTP'
}

export type FairuDmca = {
  __typename?: 'FairuDmca';
  email?: Maybe<Scalars['String']['output']>;
  file?: Maybe<FairuAsset>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  reply?: Maybe<Scalars['String']['output']>;
  reply_send?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<FairuDmcaStatus>;
};

export type FairuDmcaComplainDto = {
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  text?: InputMaybe<Scalars['String']['input']>;
  url: Scalars['String']['input'];
};

export type FairuDmcaDto = {
  email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  reply?: InputMaybe<Scalars['String']['input']>;
  reply_send?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FairuDmcaList = {
  __typename?: 'FairuDmcaList';
  data?: Maybe<Array<FairuDmca>>;
  paginatorInfo?: Maybe<DefaultPaginator>;
};

export enum FairuDmcaStatus {
  Accepted = 'ACCEPTED',
  Denies = 'DENIES',
  Failed = 'FAILED',
  Open = 'OPEN'
}

export type FairuEntry = FairuAsset | FairuFolder;

/**
 * One custom metadata field. Handles are unique per workspace, so `market` names
 * the same field wherever it is reached from.
 */
export type FairuField = {
  __typename?: 'FairuField';
  /** The options a select field chooses from. Null for every other type. */
  catalog?: Maybe<FairuCatalog>;
  /**
   * Visibility conditions, all of which must hold for the field to be asked:
   * a list of {handle, operator, value} where operator is one of equals,
   * not_equals, filled, empty. A required field behind an unmet condition
   * does not count against completeness.
   */
  conditions?: Maybe<Scalars['JSON']['output']>;
  default_value?: Maybe<Scalars['String']['output']>;
  handle: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  instructions?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** Shown inside the empty input on the asset panel. */
  placeholder?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  /**
   * Whether the asset counts as complete without it. A required field never
   * refuses a write — it marks the asset, and `metadata_complete` is filterable.
   */
  required: Scalars['Boolean']['output'];
  /**
   * Laravel-style validation rules for the value, e.g. "min:3|max:120" or
   * "email". Unlike `required`, a violated rule refuses the write.
   */
  rules?: Maybe<Scalars['String']['output']>;
  /**
   * Read through `field_type` rather than the model's `type`, which is a native
   * PHP enum. graphql-php serialises one of those by its PHP case name
   * (`MultiSelect`), and this schema declares `MULTI_SELECT` — the accessor hands
   * over the backing string so the two cannot drift apart.
   */
  type: FairuFieldType;
};

export type FairuFieldDto = {
  /** Point a select field at an existing shared catalog. */
  catalogId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Visibility conditions as a list of {handle, operator, value}, operator one
   * of equals, not_equals, filled, empty. All must hold for the field to be
   * asked.
   */
  conditions?: InputMaybe<Scalars['JSON']['input']>;
  default_value?: InputMaybe<Scalars['String']['input']>;
  /** Required when creating. The fieldset the field belongs to; a field cannot be moved later. */
  fieldsetId?: InputMaybe<Scalars['ID']['input']>;
  handle?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  instructions?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /**
   * Or give it options inline, which creates a catalog private to this field.
   * Replaces the current list; an option still in use is archived, not removed.
   */
  options?: InputMaybe<Array<FairuCatalogEntryInput>>;
  /** Shown inside the empty input on the asset panel. */
  placeholder?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  /** Marks the asset as incomplete when empty. Never refuses the write. */
  required?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Laravel-style validation rules for the value, e.g. "min:3|max:120" or
   * "email". A violated rule refuses the write. Allowed rules are limited to
   * ones that judge the submitted string itself.
   */
  rules?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<FairuFieldType>;
};

/** The kind of value a custom metadata field holds. */
export enum FairuFieldType {
  Boolean = 'BOOLEAN',
  Date = 'DATE',
  MultiSelect = 'MULTI_SELECT',
  Number = 'NUMBER',
  Select = 'SELECT',
  Text = 'TEXT',
  Textarea = 'TEXTAREA',
  Url = 'URL'
}

/** A reusable group of fields. Cannot contain a blueprint or another fieldset. */
export type FairuFieldset = {
  __typename?: 'FairuFieldset';
  created_at?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  fields?: Maybe<Array<FairuField>>;
  handle: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type FairuFieldsetDto = {
  description?: InputMaybe<Scalars['String']['input']>;
  handle?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type FairuFieldsetList = {
  __typename?: 'FairuFieldsetList';
  data?: Maybe<Array<FairuFieldset>>;
  paginatorInfo?: Maybe<DefaultPaginator>;
};

export type FairuFileAccessSignature = {
  __typename?: 'FairuFileAccessSignature';
  expires_at: Scalars['String']['output'];
  file_id: Scalars['ID']['output'];
  signature: Scalars['String']['output'];
};

export type FairuFileComment = {
  __typename?: 'FairuFileComment';
  author?: Maybe<FairuFileCommentAuthor>;
  /** The comment text */
  body: Scalars['String']['output'];
  created_at?: Maybe<Scalars['DateTime']['output']>;
  /** ID of the file this comment belongs to */
  file_id: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** Array of mentioned user IDs */
  mentions?: Maybe<Scalars['JSON']['output']>;
  /** PDF page number (null for non-PDF assets) */
  page?: Maybe<Scalars['Int']['output']>;
  /** Relative pin position { x, y } in 0-1 range (null = unpinned) */
  position?: Maybe<Scalars['JSON']['output']>;
  resolved_at?: Maybe<Scalars['DateTime']['output']>;
  /** ID of the user who resolved this comment */
  resolved_by?: Maybe<Scalars['ID']['output']>;
  /** Timestamp in seconds (for video/audio) */
  timestamp?: Maybe<Scalars['Float']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type FairuFileCommentAuthor = {
  __typename?: 'FairuFileCommentAuthor';
  color?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  initials?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type FairuFileDto = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Mark the asset as AI-generated. The proxy then embeds a machine-readable IPTC marker in every rendition (EU AI Act labeling). */
  ai_generated?: InputMaybe<Scalars['Boolean']['input']>;
  /** Define an alternative text */
  alt?: InputMaybe<Scalars['String']['input']>;
  blocked?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Blueprints pinned to this file, on top of whatever its folders contribute.
   * Replaces the current list; it never removes an inherited blueprint.
   */
  blueprintIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** This text should be used for text below the asset - html supported */
  caption?: InputMaybe<Scalars['String']['input']>;
  /** Use the copyright ids to pass the list to the file */
  copyrightIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Add an internal description to the file - html supported */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Define an focal point in terms of y-x-zoom eg. 0-10-1 */
  focal_point?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /**
   * The state to put the asset in — a label id or its handle, `null` to clear it.
   *
   * Changing it writes an audit entry and fires the `label_changed` webhook.
   * Omit the field to leave the state alone; sending `null` is a change.
   */
  label?: InputMaybe<Scalars['ID']['input']>;
  /** Use the ids from license to define a license fo this file */
  licenseIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Custom metadata values. Partial — a field nobody names keeps what it had. */
  metadata?: InputMaybe<Array<FairuFileMetadataInput>>;
  /** Enter a name without the file extension - otherwise it will be part of the name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Use tag ids to assign tags to the file */
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

/**
 * One field's worth of change.
 *
 * Address the field by handle. Send `value` for a single-value field and `values`
 * for a multi-select — not both. Emptying a field is `clear: true`, an empty
 * `values` list, or an empty string; all three mean the same thing.
 */
export type FairuFileMetadataInput = {
  clear?: InputMaybe<Scalars['Boolean']['input']>;
  handle: Scalars['String']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
  values?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type FairuFilePdfSignatureRequest = {
  __typename?: 'FairuFilePdfSignatureRequest';
  config_url?: Maybe<Scalars['String']['output']>;
  emails?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  file?: Maybe<FairuAsset>;
  id: Scalars['ID']['output'];
  signature_id?: Maybe<Scalars['ID']['output']>;
  status?: Maybe<FairuPdfSignatureRequestStatus>;
};

export type FairuFilePdfSignatureRequestDto = {
  emails?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  file_id?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Single entry in flat file listing (file or empty folder) */
export type FairuFlatEntry = {
  __typename?: 'FairuFlatEntry';
  /** SHA1 of the file's content. Null for folders. Serves as the S3 ETag. */
  fingerprint?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** True if this is an empty folder (S3: 0-byte key with trailing /) */
  isFolder: Scalars['Boolean']['output'];
  /** MIME type (null for folders) */
  mime?: Maybe<Scalars['String']['output']>;
  /** File or folder name */
  name: Scalars['String']['output'];
  /** Full path including name (e.g., 'marketing/2024/hero.jpg' or 'archive/') */
  path: Scalars['String']['output'];
  /** Size in bytes (0 for folders) */
  size: Scalars['Int']['output'];
  /** Last update timestamp */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type FairuFolder = {
  __typename?: 'FairuFolder';
  /** Get all files recursively from this folder and all subfolders */
  allAssets?: Maybe<Array<FairuAsset>>;
  auto_assign_copyright?: Maybe<Scalars['Boolean']['output']>;
  content?: Maybe<FairuFolderList>;
  copyrights?: Maybe<Array<Maybe<FairuCopyright>>>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};


export type FairuFolderAllAssetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type FairuFolderContentArgs = {
  folder?: InputMaybe<Scalars['ID']['input']>;
  globalSearch?: InputMaybe<Scalars['Boolean']['input']>;
  onlyFolder?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  orderDirection?: InputMaybe<FairuSortingDirection>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type FairuFolderDto = {
  autoAssignCopyright?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Blueprints assigned to this folder. They apply to every asset below it.
   * Replaces the current list.
   */
  blueprintIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  copyrightIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Whether this folder also picks up the blueprints of its ancestors. Default
   * true; false keeps this folder's own assignments and stops the walk here.
   */
  inheritBlueprints?: InputMaybe<Scalars['Boolean']['input']>;
  inhertiCopyrightAssignment?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parent?: InputMaybe<Scalars['ID']['input']>;
};

export type FairuFolderFilter = {
  /** Only files marked AI-generated (true) or not AI-generated (false). Omit for no constraint. */
  aiGenerated?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Only what the signed-in person starred.
   *
   * A favourite belongs to a person, so this needs a session: sent with a
   * workspace API key or a Raku credential the query is refused rather than
   * answered without the constraint.
   */
  favorite?: InputMaybe<Scalars['Boolean']['input']>;
  /** Only assets in this state — the id of a label from fairuLabels. Folders are excluded while it is set. */
  label?: InputMaybe<Scalars['ID']['input']>;
  mimeFilter?: InputMaybe<Scalars['String']['input']>;
  onlyAudio?: InputMaybe<Scalars['Boolean']['input']>;
  onlyImage?: InputMaybe<Scalars['Boolean']['input']>;
  onlyVideo?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FairuFolderList = {
  __typename?: 'FairuFolderList';
  data?: Maybe<Array<FairuEntry>>;
  paginatorInfo?: Maybe<DefaultPaginator>;
};

export type FairuFolderUploadShareLink = {
  __typename?: 'FairuFolderUploadShareLink';
  /** When the link expires (null if never) */
  expires_at?: Maybe<Scalars['String']['output']>;
  /** The folder ID this link uploads to */
  folder_id: Scalars['ID']['output'];
  /** The ID of the upload share link */
  id: Scalars['ID']['output'];
  /** Optional name for the link */
  name?: Maybe<Scalars['String']['output']>;
  /** The shareable URL that can be used to upload files */
  url: Scalars['String']['output'];
};

export type FairuGallery = {
  __typename?: 'FairuGallery';
  active?: Maybe<Scalars['Boolean']['output']>;
  copyright_text?: Maybe<Scalars['String']['output']>;
  copyrights?: Maybe<Array<FairuCopyright>>;
  cover_image?: Maybe<FairuAsset>;
  date?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  exclude_from_list?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  /** Gallery items (loaded on-demand, default 50, max 100). Use itemsPaginated for more. */
  items?: Maybe<Array<FairuAsset>>;
  itemsPaginated?: Maybe<FairuGalleryItemList>;
  location?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  sorting_direction?: Maybe<Scalars['String']['output']>;
  sorting_field?: Maybe<Scalars['String']['output']>;
};


export type FairuGalleryDescriptionArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};


export type FairuGalleryItemsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type FairuGalleryItemsPaginatedArgs = {
  orderBy?: InputMaybe<Scalars['String']['input']>;
  orderDirection?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};

export type FairuGalleryDto = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  exclude_from_list?: InputMaybe<Scalars['Boolean']['input']>;
  folder_id?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sorting_direction?: InputMaybe<FairuSortingDirection>;
  sorting_field?: InputMaybe<FairuGallerySortingField>;
};

export type FairuGalleryItemList = {
  __typename?: 'FairuGalleryItemList';
  data?: Maybe<Array<FairuAsset>>;
  paginatorInfo?: Maybe<DefaultPaginator>;
};

export type FairuGalleryList = {
  __typename?: 'FairuGalleryList';
  data?: Maybe<Array<FairuGallery>>;
  paginatorInfo?: Maybe<DefaultPaginator>;
};

export enum FairuGallerySortingField {
  CreatedAt = 'CREATED_AT',
  Name = 'NAME'
}

export type FairuHealthStatus = {
  __typename?: 'FairuHealthStatus';
  /**
   * The commit the running image was built from.
   *
   * Null when the build did not record one, never a substitute: the underlying
   * setting falls back to a timestamp for cache-busting, and a timestamp shaped
   * like an answer is worse here than no answer.
   */
  commit?: Maybe<Scalars['String']['output']>;
  healthy?: Maybe<Scalars['Boolean']['output']>;
  /** The release this instance is running — APP_VERSION, from the release-please tag. */
  version?: Maybe<Scalars['String']['output']>;
};

/**
 * One state a workspace can put an asset in — approved, on hold, needs retouching.
 *
 * Unlike a tag, an asset wears exactly one, and the set is curated by the
 * workspace rather than typed per file. `handle` is the stable machine name to
 * filter on: renaming a label for the people reading it never changes it.
 */
export type FairuLabel = {
  __typename?: 'FairuLabel';
  /** Six-digit hex, as picked in the workspace settings. */
  color: Scalars['String']['output'];
  handle: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  position: Scalars['Int']['output'];
};

export type FairuLabelDto = {
  /** Six-digit hex, e.g. #00a99d. */
  color?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** Where it sits in the set. */
  position?: InputMaybe<Scalars['Int']['input']>;
};

export type FairuLicense = {
  __typename?: 'FairuLicense';
  active?: Maybe<Scalars['Boolean']['output']>;
  copyright?: Maybe<FairuCopyright>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  days?: Maybe<Scalars['Int']['output']>;
  default?: Maybe<Scalars['Boolean']['output']>;
  end?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  interval?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  replace_date?: Maybe<Scalars['DateTime']['output']>;
  replace_license?: Maybe<Scalars['Boolean']['output']>;
  replace_license_entry?: Maybe<FairuLicense>;
  replaced_by_license_entry?: Maybe<FairuLicense>;
  start?: Maybe<Scalars['DateTime']['output']>;
  type?: Maybe<FairuLicenseType>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type FairuLicenseDto = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  copyright_id?: InputMaybe<Scalars['ID']['input']>;
  days?: InputMaybe<Scalars['Int']['input']>;
  default?: InputMaybe<Scalars['Boolean']['input']>;
  end?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  interval?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  replace_date?: InputMaybe<Scalars['DateTime']['input']>;
  replace_license?: InputMaybe<Scalars['Boolean']['input']>;
  replace_license_id?: InputMaybe<Scalars['ID']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
  type?: InputMaybe<FairuLicenseType>;
};

export type FairuLicenseList = {
  __typename?: 'FairuLicenseList';
  data?: Maybe<Array<FairuLicense>>;
  paginatorInfo?: Maybe<DefaultPaginator>;
};

export enum FairuLicenseType {
  Period = 'PERIOD',
  Standard = 'STANDARD'
}

/** One field's options with how many assets each would still leave. */
export type FairuMetadataFacet = {
  __typename?: 'FairuMetadataFacet';
  handle: Scalars['String']['output'];
  name: Scalars['String']['output'];
  options: Array<FairuMetadataFacetOption>;
  type: FairuFieldType;
};

export type FairuMetadataFacetOption = {
  __typename?: 'FairuMetadataFacetOption';
  label?: Maybe<Scalars['String']['output']>;
  /**
   * Assets matching this option under every *other* condition currently set.
   * A field's own condition is excluded from its own counts, so the number
   * answers "what would I get if I ticked this" rather than "what did I get".
   * Options nothing matches are kept, at zero.
   */
  total: Scalars['Int']['output'];
  value: Scalars['String']['output'];
};

/**
 * One condition on a metadata field.
 *
 * Conditions on different fields are combined with AND; the values inside one
 * condition with OR. Ticking "DE" and "AT" under Market means either, ticking
 * "Vanilla" under Flavour as well means both.
 *
 * Values are written the same way for every field type: an option value for a
 * select, the text for a short text, `true`/`false` for a checkbox, `YYYY-MM-DD`
 * for a date.
 */
export type FairuMetadataFilterInput = {
  handle: Scalars['String']['input'];
  /**
   * Match on presence instead: false finds the assets holding nothing at all for
   * this field, which is how you find what still needs filling in.
   */
  present?: InputMaybe<Scalars['Boolean']['input']>;
  /** Match assets holding any of these. */
  values?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Presigned URL for uploading a single part */
export type FairuMultipartPart = {
  __typename?: 'FairuMultipartPart';
  /** Part number (1-indexed) */
  partNumber: Scalars['Int']['output'];
  /** Presigned URL for PUT request */
  uploadUrl: Scalars['String']['output'];
};

/** Input type for multipart upload part completion */
export type FairuMultipartPartInput = {
  /** ETag returned by S3 after uploading the part */
  etag: Scalars['String']['input'];
  /** Part number (1-indexed) */
  partNumber: Scalars['Int']['input'];
};

/** Response from initializing a multipart upload */
export type FairuMultipartUploadInit = {
  __typename?: 'FairuMultipartUploadInit';
  /** File ID */
  id: Scalars['ID']['output'];
  /** Size of each part in bytes (only if fileSize was provided) */
  partSize?: Maybe<Scalars['Int']['output']>;
  /** Presigned URLs for uploading each part (only if fileSize was provided) */
  parts?: Maybe<Array<FairuMultipartPart>>;
  /** URL to call after upload completion to sync metadata */
  sync_url: Scalars['String']['output'];
  /** Total number of parts (only if fileSize was provided) */
  totalParts?: Maybe<Scalars['Int']['output']>;
  /** S3 Upload ID - required for completing the upload */
  uploadId: Scalars['String']['output'];
};

export enum FairuPdfSignatureRequestStatus {
  Canceled = 'CANCELED',
  Created = 'CREATED',
  Done = 'DONE',
  Failed = 'FAILED',
  Started = 'STARTED'
}

/**
 * One run of a podcast import.
 *
 * The counters are separate because they answer separate questions: how big the
 * feed was, how much of it was taken on, what was declined, and what broke.
 * `episodes_skipped` is the ordinary, non-alarming one — a trailer item carrying
 * no audio has nothing to import.
 *
 * `status` reaching `success` means the feed was read and its episodes were queued,
 * not that every download has finished. The audio arrives afterwards, and an
 * episode that fails on the way in is counted on `episodes_failed`.
 */
export type FairuPodcastImport = {
  __typename?: 'FairuPodcastImport';
  /** The channel the feed maps to. Null until the feed has been read. */
  channel_id?: Maybe<Scalars['ID']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  episodes_failed?: Maybe<Scalars['Int']['output']>;
  episodes_queued?: Maybe<Scalars['Int']['output']>;
  /** Feed items with no audio attached. Nothing to import, so nothing was. */
  episodes_skipped?: Maybe<Scalars['Int']['output']>;
  episodes_total?: Maybe<Scalars['Int']['output']>;
  /** What that resolved to and what was actually fetched. */
  feed_url?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Why it failed, in a sentence. Null while it is going well. */
  message?: Maybe<Scalars['String']['output']>;
  /** The address the import was started with. */
  source_url?: Maybe<Scalars['String']['output']>;
  /** pending, importing, success or failed. */
  status: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type FairuRakuCredential = {
  __typename?: 'FairuRakuCredential';
  access_key_id: Scalars['String']['output'];
  active: Scalars['Boolean']['output'];
  bucket?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['DateTime']['output'];
  expires_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  last_used_at?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  permissions: Array<Scalars['String']['output']>;
};

export type FairuRakuCredentialWithSecret = {
  __typename?: 'FairuRakuCredentialWithSecret';
  access_key_id: Scalars['String']['output'];
  bucket?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  permissions: Array<Scalars['String']['output']>;
  secret_access_key: Scalars['String']['output'];
};

export type FairuRole = {
  __typename?: 'FairuRole';
  created_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  permissions?: Maybe<Array<Scalars['String']['output']>>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type FairuRoleDto = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type FairuRoleList = {
  __typename?: 'FairuRoleList';
  data?: Maybe<Array<FairuRole>>;
  paginatorInfo?: Maybe<DefaultPaginator>;
};

export enum FairuSortingDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type FairuTag = {
  __typename?: 'FairuTag';
  color?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type FairuTagDto = {
  color?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type FairuTagList = {
  __typename?: 'FairuTagList';
  data?: Maybe<Array<FairuTag>>;
  paginatorInfo?: Maybe<DefaultPaginator>;
};

export type FairuTenant = {
  __typename?: 'FairuTenant';
  ai_language?: Maybe<Scalars['String']['output']>;
  avatar?: Maybe<FairuAsset>;
  /** Block files with error - if true, files with errors will not have a URL (default: true) */
  block_files_with_error?: Maybe<Scalars['Boolean']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  /** Custom domain */
  custom_domain?: Maybe<Scalars['String']['output']>;
  /** Status of the custom domain creatoin process */
  custom_domain_status?: Maybe<FairuCustomDomainStatus>;
  /** If this flag is true we have identified a valid CNAME entry */
  custom_domain_verified?: Maybe<Scalars['Boolean']['output']>;
  /** Fallback image shown when a file is not found */
  fallback_image?: Maybe<FairuAsset>;
  /** Fallback image shown when a file is blocked (e.g. missing license) */
  fallback_image_blocked?: Maybe<FairuAsset>;
  /** File policy entry - should at least one copyright entry be enforced */
  force_filce_copyright?: Maybe<Scalars['Boolean']['output']>;
  /** File policy entry - should alternative text for files be enforced */
  force_file_alt?: Maybe<Scalars['Boolean']['output']>;
  /** File policy entry - should a caption text be enforced */
  force_file_caption?: Maybe<Scalars['Boolean']['output']>;
  /** File policy entry - should a description be enforced */
  force_file_description?: Maybe<Scalars['Boolean']['output']>;
  /** File policy active? */
  force_file_policy?: Maybe<Scalars['Boolean']['output']>;
  /** Will license use enforced - if this flag is set to true - files without a valid license will be blocked */
  force_license?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  /** Whether this tenant is a sub-tenant */
  is_sub_tenant?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** Parent tenant ID (null if standalone) */
  parent_id?: Maybe<Scalars['ID']['output']>;
  /** Sub-tenants of this tenant */
  sub_tenants?: Maybe<Array<FairuTenant>>;
  trial_ends_at?: Maybe<Scalars['DateTime']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  use_ai?: Maybe<Scalars['Boolean']['output']>;
  use_ai_onupload?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * Result of creating a new tenant via the createFairuTenant mutation.
 *
 * This type contains all the information needed to start using the new tenant,
 * including a full-access API key that is only shown once.
 */
export type FairuTenantCreationResult = {
  __typename?: 'FairuTenantCreationResult';
  /**
   * Full-access API key for the new tenant.
   *
   * IMPORTANT: This key is only shown once! Store it securely.
   * The key has all permissions and can be used immediately to:
   * - Upload and manage files
   * - Create folders
   * - Manage copyrights and licenses
   * - Configure tenant settings
   * - And more...
   *
   * If lost, generate a new key via the tenant settings or API.
   */
  api_key: Scalars['String']['output'];
  /** ISO 8601 timestamp when the tenant was created */
  created_at: Scalars['String']['output'];
  /** Unique identifier for the new tenant (UUID) */
  id: Scalars['ID']['output'];
  /** Name of the tenant */
  name: Scalars['String']['output'];
};

export type FairuUploadLink = {
  __typename?: 'FairuUploadLink';
  /** This will be the ID for the File after uploading */
  id: Scalars['ID']['output'];
  /** Mime type is returned to help you identify the file type */
  mime?: Maybe<Scalars['String']['output']>;
  /** Call this url via GET-Request after uploading. This step is required. */
  sync_url?: Maybe<Scalars['String']['output']>;
  /** Use this url to upload the file */
  upload_url: Scalars['String']['output'];
};

export enum FairuUploadShareLinkExpiration {
  Never = 'NEVER',
  OneDay = 'ONE_DAY',
  OneHour = 'ONE_HOUR',
  SevenDays = 'SEVEN_DAYS',
  SixHours = 'SIX_HOURS',
  ThirtyDays = 'THIRTY_DAYS'
}

export enum FairuUploadType {
  Download = 'DOWNLOAD',
  Standard = 'STANDARD'
}

export type FairuUser = {
  __typename?: 'FairuUser';
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  owner?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<FairuUserStatus>;
};

export type FairuUserList = {
  __typename?: 'FairuUserList';
  data?: Maybe<Array<FairuUser>>;
  paginatorInfo?: Maybe<DefaultPaginator>;
};

export enum FairuUserStatus {
  Accepted = 'ACCEPTED',
  Created = 'CREATED',
  Declined = 'DECLINED',
  Pending = 'PENDING'
}

/**
 * A series of videos, organised into seasons.
 *
 * Additive: no existing type or field changes shape. `videoChannels` is gated by
 * the `video_channels` feature — a workspace that has not switched it on gets an
 * empty list rather than an error, so a client can ask unconditionally.
 *
 * One type serves two callers. The workspace that owns the channel reaches it
 * through `fairuVideoChannel`; a stranger reaches a published one through
 * `fairuPublicVideoChannel`. Rather than a second type — which a federated gateway
 * would have to compose separately — the boundary is drawn per field with
 * `@ownerOnly`, exactly as it is on FairuAsset. Public by design, because a visitor
 * to the channel page already sees them: `name`, `slug`, `description`,
 * `cover_image`, `seasons`, `episodes`, `embed`. Everything else answers null
 * outside the workspace.
 */
export type FairuVideoChannel = {
  __typename?: 'FairuVideoChannel';
  /** Whether the channel is published. A publishing setting, not a visitor's business. */
  active?: Maybe<Scalars['Boolean']['output']>;
  /** Who made the show, the rights line, and 'episodic' or 'serial'. */
  author?: Maybe<Scalars['String']['output']>;
  copyright?: Maybe<Scalars['String']['output']>;
  /** The still shown before anything plays. Falls back to the first episode's poster. */
  cover_image?: Maybe<FairuAsset>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /**
   * A ready-made embed of the channel's public page.
   *
   * Null until the channel is published, for the same reason the channel screen
   * hides its public link before then: the page answers 404, so handing out its
   * address would be a promise the app cannot keep.
   */
  embed?: Maybe<FairuVideoEmbed>;
  /**
   * The aspect ratio this channel enforces at intake — '4:3', '16:9' or '9:16',
   * or null when anything goes. A video that does not fit is refused when an
   * episode is created; episodes that predate the setting stay and are hinted at.
   */
  enforced_format?: Maybe<Scalars['String']['output']>;
  /** The channel's saved episode order. */
  episode_order?: Maybe<FairuVideoChannelEpisodeOrder>;
  /**
   * Every episode of every season. Omit orderBy to use the channel's saved
   * order grouped by season. An explicit publication-date order sorts across
   * seasons; undated episodes come last in either direction.
   */
  episodes?: Maybe<Array<FairuVideoChannelEpisode>>;
  /** Whether the show declares explicit content. */
  explicit?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  /** The Apple Podcasts category and subcategory this show is submitted under. */
  itunes_category?: Maybe<Scalars['String']['output']>;
  itunes_subcategory?: Maybe<Scalars['String']['output']>;
  itunes_type?: Maybe<Scalars['String']['output']>;
  /**
   * What the channel is: `video` or `audio`.
   *
   * A podcast is heard rather than watched, and the difference is not cosmetic —
   * it decides which player renders. A client building its own surface has to be
   * able to make the same choice, which is why this is public.
   */
  kind?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  owner_email?: Maybe<Scalars['String']['output']>;
  /**
   * The ownership address, withheld outside the workspace.
   *
   * It is a real mailbox belonging to a real person, published in the feed
   * because Apple requires it there — that is a decision the workspace made,
   * not a reason to hand it to every caller of this API.
   */
  owner_name?: Maybe<Scalars['String']['output']>;
  /**
   * Plays per day across the whole channel, newest first.
   *
   * `days` counts back from today inclusive, so `days: 7` is a week. Capped at
   * 365, defaults to 30.
   */
  play_statistics?: Maybe<Array<FairuVideoPlayStatistic>>;
  /**
   * How the player behaves on this channel.
   *
   * Every field answers, whether or not the channel was ever configured — the
   * settings are normalised on the way out, so "never configured" arrives as the
   * defaults rather than as null. Public for the same reason `embed` is: a CMS
   * building its own player around the same video has to be able to build the
   * one the channel's own page shows.
   */
  player_settings?: Maybe<FairuVideoPlayerSettings>;
  /**
   * Total plays across every episode of the channel.
   *
   * Null outside the workspace rather than 0 — `@ownerOnly` comes first in the
   * directive list so it wraps the sum and the sum never runs, because 0 would
   * read as "nobody watched it" instead of "you may not ask".
   */
  plays?: Maybe<Scalars['Int']['output']>;
  seasons?: Maybe<Array<FairuVideoChannelSeason>>;
  /** URL-safe name, unique inside the workspace. */
  slug?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};


/**
 * A series of videos, organised into seasons.
 *
 * Additive: no existing type or field changes shape. `videoChannels` is gated by
 * the `video_channels` feature — a workspace that has not switched it on gets an
 * empty list rather than an error, so a client can ask unconditionally.
 *
 * One type serves two callers. The workspace that owns the channel reaches it
 * through `fairuVideoChannel`; a stranger reaches a published one through
 * `fairuPublicVideoChannel`. Rather than a second type — which a federated gateway
 * would have to compose separately — the boundary is drawn per field with
 * `@ownerOnly`, exactly as it is on FairuAsset. Public by design, because a visitor
 * to the channel page already sees them: `name`, `slug`, `description`,
 * `cover_image`, `seasons`, `episodes`, `embed`. Everything else answers null
 * outside the workspace.
 */
export type FairuVideoChannelEmbedArgs = {
  height?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * A series of videos, organised into seasons.
 *
 * Additive: no existing type or field changes shape. `videoChannels` is gated by
 * the `video_channels` feature — a workspace that has not switched it on gets an
 * empty list rather than an error, so a client can ask unconditionally.
 *
 * One type serves two callers. The workspace that owns the channel reaches it
 * through `fairuVideoChannel`; a stranger reaches a published one through
 * `fairuPublicVideoChannel`. Rather than a second type — which a federated gateway
 * would have to compose separately — the boundary is drawn per field with
 * `@ownerOnly`, exactly as it is on FairuAsset. Public by design, because a visitor
 * to the channel page already sees them: `name`, `slug`, `description`,
 * `cover_image`, `seasons`, `episodes`, `embed`. Everything else answers null
 * outside the workspace.
 */
export type FairuVideoChannelEpisodesArgs = {
  orderBy?: InputMaybe<FairuVideoChannelEpisodeOrder>;
};


/**
 * A series of videos, organised into seasons.
 *
 * Additive: no existing type or field changes shape. `videoChannels` is gated by
 * the `video_channels` feature — a workspace that has not switched it on gets an
 * empty list rather than an error, so a client can ask unconditionally.
 *
 * One type serves two callers. The workspace that owns the channel reaches it
 * through `fairuVideoChannel`; a stranger reaches a published one through
 * `fairuPublicVideoChannel`. Rather than a second type — which a federated gateway
 * would have to compose separately — the boundary is drawn per field with
 * `@ownerOnly`, exactly as it is on FairuAsset. Public by design, because a visitor
 * to the channel page already sees them: `name`, `slug`, `description`,
 * `cover_image`, `seasons`, `episodes`, `embed`. Everything else answers null
 * outside the workspace.
 */
export type FairuVideoChannelPlay_StatisticsArgs = {
  days?: InputMaybe<Scalars['Int']['input']>;
};

export type FairuVideoChannelEpisode = {
  __typename?: 'FairuVideoChannelEpisode';
  /** A publishing setting. Withheld outside the workspace — and an episode that is off is not listed to a visitor at all. */
  active?: Maybe<Scalars['Boolean']['output']>;
  /** Width divided by height, for a CSS aspect-ratio on the frame. */
  aspect_ratio?: Maybe<Scalars['Float']['output']>;
  /** The video itself. Null if it was deleted or moved out of the workspace. */
  asset?: Maybe<FairuAsset>;
  /**
   * The picture for this episode: its own cover, or the show's when it has none.
   *
   * Not the same as `asset`. That is the episode itself — the video or the
   * audio file — and for a podcast it has no picture in it at all, which is why
   * a client that drew rows from `asset` drew nothing. This resolves the
   * fallback once, here, instead of in every caller.
   *
   * Null only when neither the episode nor the channel has a cover.
   */
  cover_image?: Maybe<FairuAsset>;
  description?: Maybe<Scalars['String']['output']>;
  /**
   * A ready-made embed of the episode's video.
   *
   * Points at `/embed/{file}`, the player page the app already hands out for a
   * single video. Null when the video is gone, because there is nothing to play.
   */
  embed?: Maybe<FairuVideoEmbed>;
  /**
   * What this item is in the run of the show: `full`, `trailer` or `bonus`.
   *
   * A client is expected to keep the last two out of the numbered sequence — a
   * trailer for next season sitting in the list as episode 11 is the mistake the
   * tag exists to prevent.
   */
  episode_type?: Maybe<Scalars['String']['output']>;
  /**
   * Whether this one episode declares itself explicit.
   *
   * Raises the show's own declaration, never lowers it: the feed emits the tag
   * on an item only when the episode says yes, because at item level it
   * overrides the channel and a `false` would clear an explicit show's
   * declaration on every episode of it.
   */
  explicit?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  number?: Maybe<Scalars['Int']['output']>;
  /**
   * How the episode should be framed: landscape, portrait or square.
   *
   * A channel can hold both a 16:9 documentary and a vertical clip, and a player
   * sized for one letterboxes the other into a stripe. Carried on the episode so
   * a surface can size its frame before the video loads.
   */
  orientation?: Maybe<FairuVideoOrientation>;
  /**
   * Plays per day for this episode, newest first.
   *
   * `days` counts back from today inclusive, so `days: 7` is a week. Capped at
   * 365, defaults to 30.
   */
  play_statistics?: Maybe<Array<FairuVideoPlayStatistic>>;
  /**
   * How often the episode was played.
   *
   * The running total on the episode itself, so a list of thirty rows does not
   * cost thirty aggregates. Null outside the workspace rather than 0.
   */
  plays?: Maybe<Scalars['Int']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  /**
   * The release window, and both ends may be open.
   *
   * `publish_at` is the moment the episode starts answering on every public
   * surface — the channel page, its own address, the feed and its chapters file
   * — and `unpublish_at` the moment it stops. Null on either side means no bound
   * there. Nothing is flipped by a job: the window is read on every request, so
   * an episode is out the second it is due and never a queue's delay later.
   *
   * Not to be confused with `published_at`, which is the date the episode
   * carries — what the feed puts in `pubDate` and what the list is sorted by. A
   * back catalogue has thirty different `published_at` values and no
   * `publish_at` at all.
   *
   * Publishing settings, so withheld outside the workspace: to a visitor an
   * episode that is not out yet does not exist, which is a stronger answer than
   * telling them when it will.
   */
  publish_at?: Maybe<Scalars['DateTime']['output']>;
  /** The date the episode carries. Sorted on, and published as `pubDate`. */
  published_at?: Maybe<Scalars['DateTime']['output']>;
  /**
   * The notes under the episode, as markup.
   *
   * Where `description` is the blurb a list shows, this is the links, the
   * timestamps and the credits — the feed publishes it as `content:encoded`.
   * Sanitised on the way in: an allowlist of ordinary text markup and links,
   * because it is rendered into pages Fairu does not control.
   *
   * Answers the description for an episode that has no notes of its own, so a
   * caller rendering this never has to fall back for itself.
   */
  show_notes?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  unpublish_at?: Maybe<Scalars['DateTime']['output']>;
};


export type FairuVideoChannelEpisodeEmbedArgs = {
  height?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};


export type FairuVideoChannelEpisodePlay_StatisticsArgs = {
  days?: InputMaybe<Scalars['Int']['input']>;
};

export type FairuVideoChannelEpisodeInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** `full`, `trailer` or `bonus`. Anything else is refused rather than corrected. */
  episode_type?: InputMaybe<Scalars['String']['input']>;
  /** Whether this episode declares itself explicit. Raises the show's declaration, never lowers it. */
  explicit?: InputMaybe<Scalars['Boolean']['input']>;
  /** The video. Has to be an active video file in the same workspace. */
  file_id: Scalars['ID']['input'];
  /**
   * The whole timeline, replaced wholesale.
   *
   * The complete list every time — a marker left out of the list is a marker
   * deleted, because there is no way to tell the two apart. Up to 100 of them,
   * and each has to sit inside the episode's own running time.
   */
  markers?: InputMaybe<Array<FairuVideoMarkerInput>>;
  number?: InputMaybe<Scalars['Int']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  /**
   * When the episode becomes visible, and when it stops being.
   *
   * Both optional and independent of `active`, which still has the last word: an
   * episode that is switched off stays off whatever the dates say. Leave both out
   * and it is public as soon as it is active, which is how every episode behaved
   * before this existed.
   *
   * Read on every request rather than applied by a job, so a release is accurate
   * to the second — and `unpublish_at` has to come after `publish_at`.
   */
  publish_at?: InputMaybe<Scalars['DateTime']['input']>;
  /** The date the episode carries — `pubDate` in the feed, and what the list is sorted by. Defaults to now. */
  published_at?: InputMaybe<Scalars['DateTime']['input']>;
  /**
   * The notes under the episode, as markup, published as `content:encoded`.
   *
   * Sanitised on the way in rather than trusted: paragraphs, lists, emphasis and
   * links survive, everything else is unwrapped and scripts are dropped whole.
   * Leave it out and the feed falls back to `description`.
   */
  show_notes?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  unpublish_at?: InputMaybe<Scalars['DateTime']['input']>;
};

export enum FairuVideoChannelEpisodeOrder {
  Manual = 'MANUAL',
  PublishedAtAsc = 'PUBLISHED_AT_ASC',
  PublishedAtDesc = 'PUBLISHED_AT_DESC'
}

export type FairuVideoChannelInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Who made the show, and the rights line under it. */
  author?: InputMaybe<Scalars['String']['input']>;
  copyright?: InputMaybe<Scalars['String']['input']>;
  cover_file_id?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** '4:3', '16:9' or '9:16' to enforce that ratio at intake; null enforces nothing. */
  enforced_format?: InputMaybe<Scalars['String']['input']>;
  episode_order?: InputMaybe<FairuVideoChannelEpisodeOrder>;
  exclude_from_list?: InputMaybe<Scalars['Boolean']['input']>;
  /** The show's own declaration. Each episode may raise it, never lower it. */
  explicit?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * The Apple Podcasts category, e.g. "Technology". Required by their
   * submission form and by nothing else — a show without one can be subscribed
   * to by hand and listed nowhere.
   */
  itunes_category?: InputMaybe<Scalars['String']['input']>;
  /** A subcategory of the above, e.g. "Software How-To". Rendered nested inside it. */
  itunes_subcategory?: InputMaybe<Scalars['String']['input']>;
  /**
   * 'episodic' or 'serial' — whether the newest episode belongs at the top or
   * the first one does. Anything else is read as 'episodic'.
   */
  itunes_type?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner_email?: InputMaybe<Scalars['String']['input']>;
  /** The address Apple sends the ownership mail to. Without it the show cannot be claimed. */
  owner_name?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type FairuVideoChannelList = {
  __typename?: 'FairuVideoChannelList';
  data?: Maybe<Array<FairuVideoChannel>>;
  paginatorInfo?: Maybe<DefaultPaginator>;
};

/**
 * One episode moving in or out of view, for a workspace's release calendar.
 *
 * A flat row rather than a nested episode, because a calendar draws a line per
 * event and needs the channel's name beside the title — the show is what tells two
 * rows on the same afternoon apart. It is not `FairuVideoChannelEpisode`: that type
 * answers for one channel a caller already has, while this crosses all of them.
 */
export type FairuVideoChannelScheduleEntry = {
  __typename?: 'FairuVideoChannelScheduleEntry';
  /** Whether the episode is switched on at all. A draft with a date is still a plan. */
  active: Scalars['Boolean']['output'];
  channel: FairuVideoChannelSummary;
  /** The episode this row is about. Ask `fairuVideoChannel` for the rest of it. */
  id: Scalars['ID']['output'];
  /** The two ends of the release window. At least one of them falls in the range. */
  publish_at?: Maybe<Scalars['DateTime']['output']>;
  /** The date the episode carries, which is not when it goes live. See the episode type. */
  published_at?: Maybe<Scalars['DateTime']['output']>;
  /** Optional: a season may be called Specials and have no number. */
  season_number?: Maybe<Scalars['Int']['output']>;
  state: FairuVideoReleaseState;
  title: Scalars['String']['output'];
  unpublish_at?: Maybe<Scalars['DateTime']['output']>;
};

export type FairuVideoChannelSeason = {
  __typename?: 'FairuVideoChannelSeason';
  /** A publishing setting. Withheld outside the workspace — and a season that is off is not listed to a visitor at all. */
  active?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** Override the saved episode order for this season. Undated episodes come last. */
  episodes?: Maybe<Array<FairuVideoChannelEpisode>>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  /** Optional: a season may be called Specials and have no number. */
  number?: Maybe<Scalars['Int']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
};


export type FairuVideoChannelSeasonEpisodesArgs = {
  orderBy?: InputMaybe<FairuVideoChannelEpisodeOrder>;
};

export type FairuVideoChannelSeasonInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  number?: InputMaybe<Scalars['Int']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
};

/** Just enough of a channel to name it in a list that crosses several. */
export type FairuVideoChannelSummary = {
  __typename?: 'FairuVideoChannelSummary';
  id: Scalars['ID']['output'];
  /** `video` or `audio` — what the player does with it. */
  kind: Scalars['String']['output'];
  name: Scalars['String']['output'];
  slug?: Maybe<Scalars['String']['output']>;
};

/**
 * One embed, ready to paste.
 *
 * The same two surfaces the UI has and no third one invented for the API: a
 * channel embeds its public page, an episode embeds the player page for its video.
 */
export type FairuVideoEmbed = {
  __typename?: 'FairuVideoEmbed';
  /** Width over height, for a container that reserves the space before the frame loads. */
  aspect_ratio?: Maybe<Scalars['Float']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  /**
   * The snippet to paste: a placeholder and Fairu's loader script.
   *
   * The loader mounts the frame and then keeps it at the height the frame
   * reports, which is the part a plain iframe cannot do — a height written into a
   * snippet is a guess made once, and it is still there when the channel turns
   * out to be audio, grows a playlist, or is read on a phone.
   */
  html?: Maybe<Scalars['String']['output']>;
  /**
   * The same embed as a bare iframe, sized and titled.
   *
   * For hosts where a script cannot run — an editor that strips `<script>`, a
   * newsletter, a sandbox. Same frame, same player settings; only the height
   * stops following the content.
   */
  iframe?: Maybe<Scalars['String']['output']>;
  /** What goes in an iframe's `src`. */
  url?: Maybe<Scalars['String']['output']>;
  /** The size written into the iframe. Height is derived from the width unless it is given. */
  width?: Maybe<Scalars['Int']['output']>;
};

/**
 * One mark on an episode's timeline.
 *
 * Four kinds share one list because they are one thing to the person setting them:
 * a time on a line, marked while watching. What the kind decides is who sees it —
 * `chapter` is the only one that reaches the public chapters file, and `ad` is
 * deliberately not in it: publishing an ad break as a chapter would hand a podcast
 * client the timings of the adverts and invite it to jump straight past them.
 */
export type FairuVideoMarkerInput = {
  /** A plain `#rrggbb` for the timeline, or nothing. */
  color?: InputMaybe<Scalars['String']['input']>;
  /**
   * Kept when it is given, minted when it is not.
   *
   * The player tells markers apart by it between renders, so an id that changed
   * on every save would make the active chapter jump while somebody is watching.
   */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** `chapter`, `ad`, `infocard` or `overlay`. Defaults to `chapter`. */
  kind?: InputMaybe<Scalars['String']['input']>;
  /** An ad marker's own VAST tag. Empty means the episode's, then the channel's. */
  tag_url?: InputMaybe<Scalars['String']['input']>;
  /** Seconds from the start of the episode. Has to be inside it. */
  time: Scalars['Float']['input'];
  /** What the mark is called. Optional — a chapter with no name is a jump point. */
  title?: InputMaybe<Scalars['String']['input']>;
};

export enum FairuVideoOrientation {
  Landscape = 'landscape',
  Portrait = 'portrait',
  Square = 'square'
}

/** Plays on one day. */
export type FairuVideoPlayStatistic = {
  __typename?: 'FairuVideoPlayStatistic';
  date?: Maybe<Scalars['Date']['output']>;
  plays?: Maybe<Scalars['Int']['output']>;
};

/**
 * How the player behaves on a channel.
 *
 * Every option maps to a prop `@fairu/player` actually reads, and the names are
 * the server's own — `App\\Support\\VideoPlayerSettings` is the list, and the
 * mapping onto player props lives in one place on the client. A field here that
 * the player has no prop for would be a setting nobody could obey.
 *
 * Note `allow_seeking`: it is named for what it grants, while the player names it
 * `seekingDisabled`. Every switch in this type reads "true means the viewer has
 * it", which is worth one inversion in one place rather than one member of the set
 * that reads backwards.
 */
export type FairuVideoPlayerSettings = {
  __typename?: 'FairuVideoPlayerSettings';
  /**
   * The player's accent as `#rrggbb`, or empty for the one its own stylesheet
   * carries.
   *
   * Empty rather than the default spelled out, so a channel that never chose a
   * colour still follows the default if it ever moves.
   */
  accent_color?: Maybe<Scalars['String']['output']>;
  /** True means the viewer may scrub. False is for material that has to be watched through. */
  allow_seeking?: Maybe<Scalars['Boolean']['output']>;
  auto_hide_controls?: Maybe<Scalars['Boolean']['output']>;
  /** Start playing on its own. Most browsers only allow this while muted. */
  autoplay?: Maybe<Scalars['Boolean']['output']>;
  /** When one episode ends, the next one starts. */
  autoplay_next?: Maybe<Scalars['Boolean']['output']>;
  cast?: Maybe<Scalars['Boolean']['output']>;
  /** Milliseconds, between 500 and 15000. */
  controls_hide_delay?: Maybe<Scalars['Int']['output']>;
  fullscreen?: Maybe<Scalars['Boolean']['output']>;
  muted?: Maybe<Scalars['Boolean']['output']>;
  /** Pause while the viewer is looking at another tab. */
  pause_on_hidden?: Maybe<Scalars['Boolean']['output']>;
  picture_in_picture?: Maybe<Scalars['Boolean']['output']>;
  playback_speed?: Maybe<Scalars['Boolean']['output']>;
  quality_selector?: Maybe<Scalars['Boolean']['output']>;
  /** One of `none`, `one`, `all`. */
  repeat?: Maybe<Scalars['String']['output']>;
  /** Only ever true alongside `pause_on_hidden` — the player cannot resume what it never paused. */
  resume_on_visible?: Maybe<Scalars['Boolean']['output']>;
  show_chapters?: Maybe<Scalars['Boolean']['output']>;
  /** The other episodes, drawn inside the player's own frame. */
  show_playlist?: Maybe<Scalars['Boolean']['output']>;
  skip_backward_seconds?: Maybe<Scalars['Int']['output']>;
  skip_buttons?: Maybe<Scalars['Boolean']['output']>;
  /** Seconds, between 1 and 300. */
  skip_forward_seconds?: Maybe<Scalars['Int']['output']>;
  subtitles?: Maybe<Scalars['Boolean']['output']>;
  volume_control?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * Where an episode stands right now.
 *
 * Worked out by the same predicate the public surfaces read, never by the caller:
 * an episode that says `live` here is one a visitor can open, and a calendar that
 * derived that for itself would eventually disagree with the feed.
 *
 * `draft` is switched off, whatever its dates say — the switch beats the schedule,
 * so an episode nobody has turned on is not merely waiting. `scheduled` is on and
 * due, `live` is out now, `ended` has come back down.
 */
export enum FairuVideoReleaseState {
  Draft = 'draft',
  Ended = 'ended',
  Live = 'live',
  Scheduled = 'scheduled'
}

export type FairuWebhook = {
  __typename?: 'FairuWebhook';
  active: Scalars['Boolean']['output'];
  auth_type: FairuWebhookAuthType;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  has_auth: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  subscriptions: Scalars['JSON']['output'];
  tenant_id: Scalars['ID']['output'];
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  url: Scalars['String']['output'];
};

export enum FairuWebhookAuthType {
  Basic = 'BASIC',
  Bearer = 'BEARER',
  None = 'NONE'
}

export type FairuWebhookDto = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  auth_type?: InputMaybe<FairuWebhookAuthType>;
  auth_value?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  subscriptions?: InputMaybe<Scalars['JSON']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type FairuWebhookList = {
  __typename?: 'FairuWebhookList';
  data?: Maybe<Array<FairuWebhook>>;
  paginatorInfo?: Maybe<DefaultPaginator>;
};

export type FairuWorkflow = {
  __typename?: 'FairuWorkflow';
  active?: Maybe<Scalars['Boolean']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  has_error?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  last_at?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  status: FairuWorkflowStatus;
  type: FairuWorkflowType;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type FairuWorkflowDto = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  structure?: InputMaybe<Scalars['WorkflowStructure']['input']>;
  type?: InputMaybe<FairuWorkflowType>;
};

export type FairuWorkflowList = {
  __typename?: 'FairuWorkflowList';
  data?: Maybe<Array<FairuWorkflow>>;
  paginatorInfo?: Maybe<DefaultPaginator>;
};

export enum FairuWorkflowStatus {
  Failed = 'FAILED',
  None = 'NONE',
  Processing = 'PROCESSING',
  Success = 'SUCCESS',
  Triggered = 'TRIGGERED'
}

export enum FairuWorkflowType {
  CopyrightReplacing = 'COPYRIGHT_REPLACING',
  CopyrightReplacingSearch = 'COPYRIGHT_REPLACING_SEARCH',
  CopyrightSplitting = 'COPYRIGHT_SPLITTING',
  CopyrightSplittingSearch = 'COPYRIGHT_SPLITTING_SEARCH'
}

export type Faq = {
  __typename?: 'Faq';
  /** Answer */
  answer?: Maybe<Scalars['String']['output']>;
  /** Question */
  question?: Maybe<Scalars['String']['output']>;
};


export type FaqAnswerArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};


export type FaqQuestionArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FavoriteStatus = {
  __typename?: 'FavoriteStatus';
  groups?: Maybe<Array<Scalars['ID']['output']>>;
  id: Scalars['ID']['output'];
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type FeatureColumnBlock = {
  __typename?: 'FeatureColumnBlock';
  exclusion?: Maybe<Scalars['String']['output']>;
  headline?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Array<Maybe<FeatureColumnItem>>>;
};

export type FeatureColumnItem = {
  __typename?: 'FeatureColumnItem';
  description?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
};

export type Form = {
  __typename?: 'Form';
  id: Scalars['ID']['output'];
};

/** Gallery  */
export type Gallery = {
  __typename?: 'Gallery';
  fairuGallery?: Maybe<FairuGallery>;
  /** ID */
  id?: Maybe<Scalars['String']['output']>;
  /** Description for internal purpose. */
  instructions?: Maybe<Scalars['String']['output']>;
  /** Gallery items */
  items?: Maybe<Array<Maybe<GalleryItem>>>;
  /** Title */
  title?: Maybe<Scalars['String']['output']>;
  use_fairu?: Maybe<Scalars['Boolean']['output']>;
};

/** Gallery asset */
export type GalleryElementAsset = {
  __typename?: 'GalleryElementAsset';
  asset?: Maybe<FairuAsset>;
  caption?: Maybe<Scalars['String']['output']>;
  image_mode?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  use_as_cover?: Maybe<Scalars['Boolean']['output']>;
};


/** Gallery asset */
export type GalleryElementAssetCaptionArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GalleryElementGusto = {
  __typename?: 'GalleryElementGusto';
  recipe?: Maybe<GustoRecipe>;
};

export type GalleryElementRecipe = {
  __typename?: 'GalleryElementRecipe';
  recipe?: Maybe<GustoRecipe>;
};

export type GalleryElementSocialMediaEmbed = {
  __typename?: 'GalleryElementSocialMediaEmbed';
  /** The unique identifier to embed the element */
  id?: Maybe<Scalars['String']['output']>;
  /** Type of social embed */
  network?: Maybe<Scalars['String']['output']>;
};

export type GalleryItem = GalleryElementAsset | GalleryElementGusto | GalleryElementSocialMediaEmbed;

export type Genre = {
  __typename?: 'Genre';
  /** Created at */
  created_at?: Maybe<Scalars['DateTime']['output']>;
  /** Id of the Genre */
  id: Scalars['ID']['output'];
  /** Mediapress  id */
  mediapress_id?: Maybe<Scalars['String']['output']>;
  /** Meta data */
  metadata?: Maybe<Meta>;
  /** Movies for the person */
  movies?: Maybe<Array<Maybe<Movie>>>;
  /** Shows for the person */
  shows?: Maybe<Array<Maybe<Show>>>;
  /** Slug */
  slug?: Maybe<Scalars['String']['output']>;
  /** Sorting */
  sort?: Maybe<Scalars['Int']['output']>;
  /** Title */
  title?: Maybe<Scalars['String']['output']>;
  /** Tmdb id */
  tmdb_id?: Maybe<Scalars['String']['output']>;
  /** Updated at */
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};


export type GenreMoviesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type GenreShowsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

/** A paginated list of Genre items. */
export type GenrePaginator = {
  __typename?: 'GenrePaginator';
  /** A list of Genre items. */
  data: Array<Genre>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type GlideData = {
  __typename?: 'GlideData';
  height?: Maybe<Scalars['Int']['output']>;
  path?: Maybe<Scalars['String']['output']>;
  path_origin?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

export type Global = GlobalAutorevue | GlobalGusto | GlobalNews | GlobalTrend | GlobalTvmedia | GlobalWoman | GlobalYachtrevue;

export type GlobalAutorevue = {
  __typename?: 'GlobalAutorevue';
  /** Author overview page */
  author_page?: Maybe<Page>;
  /** Newsletter */
  newsletter?: Maybe<Newsletter>;
  /** Subscription ad */
  subscription_ad?: Maybe<SubscriptionAd>;
  /** Subscription ad in articles */
  subscription_ad_article?: Maybe<ArticleSubscriptionAd>;
};

export type GlobalGusto = {
  __typename?: 'GlobalGusto';
  /** Author overview page */
  author_page?: Maybe<Page>;
  login_recipe?: Maybe<GustoRecipe>;
  /** Newsletter */
  newsletter?: Maybe<Newsletter>;
  /** Subscription ad */
  subscription_ad?: Maybe<SubscriptionAd>;
  /** Subscription ad in articles */
  subscription_ad_article?: Maybe<ArticleSubscriptionAd>;
};

export type GlobalNews = {
  __typename?: 'GlobalNews';
  /** Author overview page */
  author_page?: Maybe<Page>;
  /** Newsletter */
  newsletter?: Maybe<Newsletter>;
  /** Subscription ad */
  subscription_ad?: Maybe<SubscriptionAd>;
  /** Subscription ad in articles */
  subscription_ad_article?: Maybe<ArticleSubscriptionAd>;
};

export type GlobalSet = {
  __typename?: 'GlobalSet';
  settings?: Maybe<Global>;
};

export type GlobalTrend = {
  __typename?: 'GlobalTrend';
  /** Author overview page */
  author_page?: Maybe<Page>;
  /** Newsletter */
  newsletter?: Maybe<Newsletter>;
  /** Subscription ad */
  subscription_ad?: Maybe<SubscriptionAd>;
  /** Subscription ad in articles */
  subscription_ad_article?: Maybe<ArticleSubscriptionAd>;
};

export type GlobalTvmedia = {
  __typename?: 'GlobalTvmedia';
  /** Author overview page */
  author_page?: Maybe<Page>;
  /** Newsletter */
  newsletter?: Maybe<Newsletter>;
  /** Subscription ad */
  subscription_ad?: Maybe<SubscriptionAd>;
  /** Subscription ad in articles */
  subscription_ad_article?: Maybe<ArticleSubscriptionAd>;
};

export type GlobalWoman = {
  __typename?: 'GlobalWoman';
  /** Author overview page */
  author_page?: Maybe<Page>;
  /** Newsletter */
  newsletter?: Maybe<Newsletter>;
  /** Subscription ad */
  subscription_ad?: Maybe<SubscriptionAd>;
  /** Subscription ad in articles */
  subscription_ad_article?: Maybe<ArticleSubscriptionAd>;
};

export type GlobalYachtrevue = {
  __typename?: 'GlobalYachtrevue';
  /** Author overview page */
  author_page?: Maybe<Page>;
  /** Newsletter */
  newsletter?: Maybe<Newsletter>;
  /** Subscription ad */
  subscription_ad?: Maybe<SubscriptionAd>;
  /** Subscription ad in articles */
  subscription_ad_article?: Maybe<ArticleSubscriptionAd>;
};

export type GustoAmountTypeEnumMapping = {
  __typename?: 'GustoAmountTypeEnumMapping';
  enumName: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type GustoArticle = Article | GustoRecipe;

export type GustoAsset = {
  __typename?: 'GustoAsset';
  caption?: Maybe<Scalars['String']['output']>;
  copyright?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  path?: Maybe<Scalars['String']['output']>;
  /** Can be image of video */
  type?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

export type GustoAuthor = {
  __typename?: 'GustoAuthor';
  firstname?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastname?: Maybe<Scalars['String']['output']>;
  recipes?: Maybe<Array<Maybe<GustoRecipe>>>;
  slug?: Maybe<Scalars['String']['output']>;
};

export type GustoAuthorPagination = {
  __typename?: 'GustoAuthorPagination';
  data?: Maybe<Array<GustoAuthor>>;
  paginatorInfo?: Maybe<DefaultPaginator>;
};

export type GustoAuthorRequest = {
  __typename?: 'GustoAuthorRequest';
  id: Scalars['ID']['output'];
  recipes?: Maybe<GustoRecipeItemPaginator>;
};

export type GustoCountry = {
  __typename?: 'GustoCountry';
  custom_open_graph_description?: Maybe<Scalars['String']['output']>;
  custom_open_graph_title?: Maybe<Scalars['String']['output']>;
  custom_twitter_description?: Maybe<Scalars['String']['output']>;
  custom_twitter_title?: Maybe<Scalars['String']['output']>;
  google_news_title?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  meta_description?: Maybe<Scalars['String']['output']>;
  meta_title?: Maybe<Scalars['String']['output']>;
  no_follow?: Maybe<Scalars['Boolean']['output']>;
  no_index?: Maybe<Scalars['Boolean']['output']>;
  open_graph_description?: Maybe<Scalars['String']['output']>;
  redirect?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  twitter_description?: Maybe<Scalars['String']['output']>;
};

export type GustoCountryPagination = {
  __typename?: 'GustoCountryPagination';
  data?: Maybe<Array<GustoCountry>>;
  paginatorInfo?: Maybe<DefaultPaginator>;
};

export type GustoEntry = GustoRecipe;

export type GustoGallery = {
  __typename?: 'GustoGallery';
  id: Scalars['ID']['output'];
  recipes?: Maybe<Array<Maybe<GustoRecipe>>>;
  slug?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type GustoGalleryPagination = {
  __typename?: 'GustoGalleryPagination';
  data?: Maybe<Array<GustoGallery>>;
  paginatorInfo?: Maybe<DefaultPaginator>;
};

export type GustoIngredient = {
  __typename?: 'GustoIngredient';
  bread_units?: Maybe<Scalars['Float']['output']>;
  caffeine?: Maybe<Scalars['Float']['output']>;
  calories?: Maybe<Scalars['Float']['output']>;
  /** kJ value */
  calorific_value?: Maybe<Scalars['Float']['output']>;
  carbohydrates?: Maybe<Scalars['Float']['output']>;
  carbohydrates_sugar?: Maybe<Scalars['Float']['output']>;
  custom_open_graph_description?: Maybe<Scalars['String']['output']>;
  custom_open_graph_title?: Maybe<Scalars['String']['output']>;
  custom_twitter_description?: Maybe<Scalars['String']['output']>;
  custom_twitter_title?: Maybe<Scalars['String']['output']>;
  fat?: Maybe<Scalars['Float']['output']>;
  google_news_title?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isUmbrella?: Maybe<Scalars['Boolean']['output']>;
  meta_description?: Maybe<Scalars['String']['output']>;
  meta_title?: Maybe<Scalars['String']['output']>;
  no_follow?: Maybe<Scalars['Boolean']['output']>;
  no_index?: Maybe<Scalars['Boolean']['output']>;
  open_graph_description?: Maybe<Scalars['String']['output']>;
  origin: GustoIngredientOrigin;
  origin_id?: Maybe<Scalars['String']['output']>;
  protein?: Maybe<Scalars['Float']['output']>;
  redirect?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  twitter_description?: Maybe<Scalars['String']['output']>;
  umbrellaContains?: Maybe<Array<Scalars['String']['output']>>;
  water?: Maybe<Scalars['Float']['output']>;
};

export enum GustoIngredientOrigin {
  Censhare = 'CENSHARE',
  None = 'NONE'
}

export type GustoIngredientPagination = {
  __typename?: 'GustoIngredientPagination';
  data?: Maybe<Array<GustoIngredient>>;
  paginatorInfo?: Maybe<DefaultPaginator>;
};

export type GustoIngredientsGrouped = {
  __typename?: 'GustoIngredientsGrouped';
  headline: Scalars['String']['output'];
  ingredients?: Maybe<Array<Maybe<GustoRecipeIngredientNoRelation>>>;
  servings?: Maybe<Scalars['Int']['output']>;
  servings_units?: Maybe<Scalars['String']['output']>;
  time?: Maybe<Scalars['Float']['output']>;
};

export type GustoIssue = {
  __typename?: 'GustoIssue';
  cover_image?: Maybe<FairuAsset>;
  cover_image_path?: Maybe<Scalars['ID']['output']>;
  created_at?: Maybe<Scalars['String']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  issue_number?: Maybe<Scalars['Int']['output']>;
  month?: Maybe<Scalars['String']['output']>;
  origin_id?: Maybe<Scalars['String']['output']>;
  published?: Maybe<Scalars['Boolean']['output']>;
  recipes?: Maybe<Array<GustoRecipe>>;
  slug?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['String']['output']>;
  year?: Maybe<Scalars['Int']['output']>;
};

export type GustoIssuePagination = {
  __typename?: 'GustoIssuePagination';
  data?: Maybe<Array<GustoIssue>>;
  paginatorInfo?: Maybe<DefaultPaginator>;
};

export type GustoIssueYear = {
  __typename?: 'GustoIssueYear';
  first_cover?: Maybe<FairuAsset>;
  issues_count: Scalars['Int']['output'];
  year: Scalars['Int']['output'];
};

export type GustoIssueYearsPagination = {
  __typename?: 'GustoIssueYearsPagination';
  data?: Maybe<Array<GustoIssueYear>>;
  paginatorInfo?: Maybe<DefaultPaginator>;
};

export type GustoNutriationTable = {
  __typename?: 'GustoNutriationTable';
  bread_units?: Maybe<Scalars['Float']['output']>;
  caffeine?: Maybe<Scalars['Float']['output']>;
  calories?: Maybe<Scalars['Float']['output']>;
  /** kJ value */
  calorific_value?: Maybe<Scalars['Float']['output']>;
  carbohydrates?: Maybe<Scalars['Float']['output']>;
  carbohydrates_sugar?: Maybe<Scalars['Float']['output']>;
  fat?: Maybe<Scalars['Float']['output']>;
  protein?: Maybe<Scalars['Float']['output']>;
  water?: Maybe<Scalars['Float']['output']>;
};

export type GustoOccasion = {
  __typename?: 'GustoOccasion';
  custom_open_graph_description?: Maybe<Scalars['String']['output']>;
  custom_open_graph_title?: Maybe<Scalars['String']['output']>;
  custom_twitter_description?: Maybe<Scalars['String']['output']>;
  custom_twitter_title?: Maybe<Scalars['String']['output']>;
  google_news_title?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  meta_description?: Maybe<Scalars['String']['output']>;
  meta_title?: Maybe<Scalars['String']['output']>;
  no_follow?: Maybe<Scalars['Boolean']['output']>;
  no_index?: Maybe<Scalars['Boolean']['output']>;
  open_graph_description?: Maybe<Scalars['String']['output']>;
  redirect?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  twitter_description?: Maybe<Scalars['String']['output']>;
};

export type GustoOccasionPagination = {
  __typename?: 'GustoOccasionPagination';
  data?: Maybe<Array<GustoOccasion>>;
  paginatorInfo?: Maybe<DefaultPaginator>;
};

export type GustoPreparationsGrouped = {
  __typename?: 'GustoPreparationsGrouped';
  descriptions: Array<Scalars['String']['output']>;
  headline: Scalars['String']['output'];
};

export type GustoRecipe = {
  __typename?: 'GustoRecipe';
  bread_units?: Maybe<Scalars['Float']['output']>;
  calories?: Maybe<Scalars['Float']['output']>;
  carbohydrates?: Maybe<Scalars['Float']['output']>;
  categories?: Maybe<Array<GustoRecipeCategory>>;
  category?: Maybe<GustoRecipeCategory>;
  cholesterine?: Maybe<Scalars['Float']['output']>;
  countries?: Maybe<Array<GustoCountry>>;
  cover_image?: Maybe<FairuAsset>;
  cover_image_id?: Maybe<Scalars['ID']['output']>;
  /** Poster image to show when cover_image is a video (Bild wenn Video) */
  cover_image_when_video?: Maybe<FairuAsset>;
  cover_image_when_video_id?: Maybe<Scalars['ID']['output']>;
  created_at?: Maybe<Scalars['String']['output']>;
  custom_open_graph_description?: Maybe<Scalars['String']['output']>;
  custom_open_graph_title?: Maybe<Scalars['String']['output']>;
  custom_twitter_description?: Maybe<Scalars['String']['output']>;
  custom_twitter_title?: Maybe<Scalars['String']['output']>;
  fat?: Maybe<Scalars['Float']['output']>;
  favorite?: Maybe<FavoriteStatus>;
  galleries?: Maybe<Array<GustoGallery>>;
  google_news_title?: Maybe<Scalars['String']['output']>;
  /** Unique primary key. */
  id: Scalars['ID']['output'];
  images?: Maybe<Array<Maybe<FairuAsset>>>;
  ingredient_groups?: Maybe<Array<GustoRecipeIngredientGroup>>;
  ingredients?: Maybe<Array<GustoIngredient>>;
  /** @deprecated Moves in favor of ingridient_groups -> please use ingredients_groups */
  ingredients_grouped?: Maybe<Array<GustoIngredientsGrouped>>;
  ingredients_with_amounts?: Maybe<Array<GustoRecipeIngredient>>;
  issue?: Maybe<GustoIssue>;
  level?: Maybe<GustoRecipeLevel>;
  meta_description?: Maybe<Scalars['String']['output']>;
  meta_title?: Maybe<Scalars['String']['output']>;
  my_rating?: Maybe<Scalars['Int']['output']>;
  no_follow?: Maybe<Scalars['Boolean']['output']>;
  no_index?: Maybe<Scalars['Boolean']['output']>;
  nuration_table?: Maybe<GustoNutriationTable>;
  occasions?: Maybe<Array<GustoOccasion>>;
  open_graph_description?: Maybe<Scalars['String']['output']>;
  portal?: Maybe<Scalars['String']['output']>;
  /** @deprecated Legacy implementation */
  preparations_grouped?: Maybe<Array<GustoPreparationsGrouped>>;
  properties?: Maybe<Array<GustoRecipeProperty>>;
  protein?: Maybe<Scalars['Float']['output']>;
  published?: Maybe<Scalars['Boolean']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
  rating_count?: Maybe<Scalars['Int']['output']>;
  redirect?: Maybe<Scalars['String']['output']>;
  servings?: Maybe<Scalars['Int']['output']>;
  servings_unit?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  specialRessort?: Maybe<GustoSpecialRessortRequest>;
  steps?: Maybe<Array<GustoRecipeStep>>;
  teaser?: Maybe<Scalars['String']['output']>;
  teaser_short?: Maybe<Scalars['String']['output']>;
  time?: Maybe<Scalars['Int']['output']>;
  time_hint?: Maybe<Scalars['String']['output']>;
  tips?: Maybe<Array<GustoTip>>;
  title?: Maybe<Scalars['String']['output']>;
  title_short?: Maybe<Scalars['String']['output']>;
  twitter_description?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['String']['output']>;
  uri?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  users?: Maybe<Array<User>>;
};


export type GustoRecipeTeaserArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};


export type GustoRecipeTeaser_ShortArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GustoRecipeCategory = {
  __typename?: 'GustoRecipeCategory';
  custom_open_graph_description?: Maybe<Scalars['String']['output']>;
  custom_open_graph_title?: Maybe<Scalars['String']['output']>;
  custom_twitter_description?: Maybe<Scalars['String']['output']>;
  custom_twitter_title?: Maybe<Scalars['String']['output']>;
  google_news_title?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  meta_description?: Maybe<Scalars['String']['output']>;
  meta_title?: Maybe<Scalars['String']['output']>;
  no_follow?: Maybe<Scalars['Boolean']['output']>;
  no_index?: Maybe<Scalars['Boolean']['output']>;
  open_graph_description?: Maybe<Scalars['String']['output']>;
  redirect?: Maybe<Scalars['String']['output']>;
  ressort?: Maybe<Ressort>;
  ressort_id?: Maybe<Scalars['ID']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  twitter_description?: Maybe<Scalars['String']['output']>;
};

export type GustoRecipeCategoryPagination = {
  __typename?: 'GustoRecipeCategoryPagination';
  data?: Maybe<Array<GustoRecipeCategory>>;
  paginatorInfo?: Maybe<DefaultPaginator>;
};

export type GustoRecipeCoverImage = {
  __typename?: 'GustoRecipeCoverImage';
  cover_image?: Maybe<FairuAsset>;
  recipe: Scalars['ID']['output'];
};

export type GustoRecipeExtendedSearch = {
  categories?: InputMaybe<Array<Scalars['ID']['input']>>;
  countries?: InputMaybe<Array<Scalars['ID']['input']>>;
  hasImages?: InputMaybe<Scalars['Boolean']['input']>;
  ingredients?: InputMaybe<Array<Scalars['ID']['input']>>;
  level?: InputMaybe<GustoRecipeLevel>;
  occasions?: InputMaybe<Array<Scalars['ID']['input']>>;
  properties?: InputMaybe<Array<Scalars['ID']['input']>>;
  time_from?: InputMaybe<Scalars['Int']['input']>;
  time_until?: InputMaybe<Scalars['Int']['input']>;
};

export type GustoRecipeFavoritesRequest = {
  __typename?: 'GustoRecipeFavoritesRequest';
  categories?: Maybe<Array<GustoRecipeCategory>>;
  data?: Maybe<Array<GustoRecipe>>;
  id: Scalars['ID']['output'];
  paginatorInfo?: Maybe<DefaultPaginator>;
};

export type GustoRecipeIngredient = {
  __typename?: 'GustoRecipeIngredient';
  amount?: Maybe<Scalars['Float']['output']>;
  amount_type?: Maybe<GustoRecipeUnit>;
  custom_open_graph_description?: Maybe<Scalars['String']['output']>;
  custom_open_graph_title?: Maybe<Scalars['String']['output']>;
  custom_twitter_description?: Maybe<Scalars['String']['output']>;
  custom_twitter_title?: Maybe<Scalars['String']['output']>;
  google_news_title?: Maybe<Scalars['String']['output']>;
  ingredient?: Maybe<GustoIngredient>;
  ingredient_id?: Maybe<Scalars['ID']['output']>;
  meta_description?: Maybe<Scalars['String']['output']>;
  meta_title?: Maybe<Scalars['String']['output']>;
  no_follow?: Maybe<Scalars['Boolean']['output']>;
  no_index?: Maybe<Scalars['Boolean']['output']>;
  open_graph_description?: Maybe<Scalars['String']['output']>;
  redirect?: Maybe<Scalars['String']['output']>;
  suffix?: Maybe<Scalars['String']['output']>;
  twitter_description?: Maybe<Scalars['String']['output']>;
};

export type GustoRecipeIngredientGroup = {
  __typename?: 'GustoRecipeIngredientGroup';
  headline?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  ingredients?: Maybe<Array<GustoRecipeIngredient>>;
  sorting?: Maybe<Scalars['Int']['output']>;
};

export type GustoRecipeIngredientNoRelation = {
  __typename?: 'GustoRecipeIngredientNoRelation';
  amount?: Maybe<Scalars['Float']['output']>;
  amount_type?: Maybe<GustoRecipeUnit>;
  ingredient?: Maybe<GustoIngredient>;
  suffix?: Maybe<Scalars['String']['output']>;
};

export type GustoRecipeItemPaginator = {
  __typename?: 'GustoRecipeItemPaginator';
  data?: Maybe<Array<GustoRecipe>>;
  paginatorInfo?: Maybe<DefaultPaginator>;
};

export enum GustoRecipeLevel {
  Easy = 'EASY',
  Hard = 'HARD',
  Medium = 'MEDIUM'
}

export type GustoRecipePagination = {
  __typename?: 'GustoRecipePagination';
  data?: Maybe<Array<GustoRecipe>>;
  paginatorInfo?: Maybe<DefaultPaginator>;
};

export type GustoRecipePropertiesPagination = {
  __typename?: 'GustoRecipePropertiesPagination';
  data?: Maybe<Array<GustoRecipeProperty>>;
  paginatorInfo?: Maybe<DefaultPaginator>;
};

export type GustoRecipeProperty = {
  __typename?: 'GustoRecipeProperty';
  custom_open_graph_description?: Maybe<Scalars['String']['output']>;
  custom_open_graph_title?: Maybe<Scalars['String']['output']>;
  custom_twitter_description?: Maybe<Scalars['String']['output']>;
  custom_twitter_title?: Maybe<Scalars['String']['output']>;
  google_news_title?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  meta_description?: Maybe<Scalars['String']['output']>;
  meta_title?: Maybe<Scalars['String']['output']>;
  no_follow?: Maybe<Scalars['Boolean']['output']>;
  no_index?: Maybe<Scalars['Boolean']['output']>;
  open_graph_description?: Maybe<Scalars['String']['output']>;
  recipes?: Maybe<Array<Maybe<GustoRecipe>>>;
  redirect?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  twitter_description?: Maybe<Scalars['String']['output']>;
};

export type GustoRecipeStep = {
  __typename?: 'GustoRecipeStep';
  asset?: Maybe<FairuAsset>;
  description?: Maybe<Scalars['String']['output']>;
  headline?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  ingredients?: Maybe<Array<GustoRecipeIngredient>>;
  /** Legacy preperation text */
  preperation?: Maybe<GustoPreparationsGrouped>;
  recipe?: Maybe<GustoRecipe>;
  sorting?: Maybe<Scalars['Int']['output']>;
  /** Time in minutes */
  time?: Maybe<Scalars['Int']['output']>;
  used_recipe_id?: Maybe<Scalars['ID']['output']>;
};


export type GustoRecipeStepDescriptionArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GustoRecipeStepAsset = {
  __typename?: 'GustoRecipeStepAsset';
  asset?: Maybe<GustoAsset>;
  sort?: Maybe<Scalars['Int']['output']>;
};

export enum GustoRecipeUnit {
  AFewDrops = 'A_FEW_DROPS',
  Bag = 'BAG',
  Ball = 'BALL',
  Balls = 'BALLS',
  Bottles = 'BOTTLES',
  Bulb = 'BULB',
  Bulbs = 'BULBS',
  Bunch = 'BUNCH',
  Can = 'CAN',
  Cans = 'CANS',
  CansParentheses = 'CANS_PARENTHESES',
  Centilitre = 'CENTILITRE',
  Centimetre = 'CENTIMETRE',
  Clove = 'CLOVE',
  Cloves = 'CLOVES',
  Cube = 'CUBE',
  Cup = 'CUP',
  Cups = 'CUPS',
  CupsPlural = 'CUPS_PLURAL',
  Dash = 'DASH',
  Drop = 'DROP',
  Drops = 'DROPS',
  FilletsOf = 'FILLETS_OF',
  Glass = 'GLASS',
  Glasses = 'GLASSES',
  Gram = 'GRAM',
  Handful = 'HANDFUL',
  Head = 'HEAD',
  Kilogram = 'KILOGRAM',
  Leaf = 'LEAF',
  Leaves = 'LEAVES',
  LevelTablespoon = 'LEVEL_TABLESPOON',
  Litre = 'LITRE',
  Loaf = 'LOAF',
  MeasuringSpoon = 'MEASURING_SPOON',
  MeasuringSpoonMs = 'MEASURING_SPOON_MS',
  Milligram = 'MILLIGRAM',
  Millilitre = 'MILLILITRE',
  MochaSpoon = 'MOCHA_SPOON',
  Nibbles = 'NIBBLES',
  None = 'NONE',
  Package = 'PACKAGE',
  PackageOld = 'PACKAGE_OLD',
  Pair = 'PAIR',
  Piece = 'PIECE',
  Pieces = 'PIECES',
  Pinch = 'PINCH',
  Pinches = 'PINCHES',
  PinchEs = 'PINCH_ES',
  Roll = 'ROLL',
  Rolls = 'ROLLS',
  RollsPlural = 'ROLLS_PLURAL',
  RosesFrom = 'ROSES_FROM',
  Shot = 'SHOT',
  Slice = 'SLICE',
  Slices = 'SLICES',
  SmallBag = 'SMALL_BAG',
  SmallCan = 'SMALL_CAN',
  SmallPackage = 'SMALL_PACKAGE',
  SmallPacket = 'SMALL_PACKET',
  SmallSpoon = 'SMALL_SPOON',
  SmallTwig = 'SMALL_TWIG',
  SmallTwigs = 'SMALL_TWIGS',
  Some = 'SOME',
  Spritz = 'SPRITZ',
  Stalk = 'STALK',
  Stalks = 'STALKS',
  StalksPlural = 'STALKS_PLURAL',
  Steak = 'STEAK',
  Steaks = 'STEAKS',
  Tablespoon = 'TABLESPOON',
  Teaspoon = 'TEASPOON',
  ThinSlices = 'THIN_SLICES',
  Times = 'TIMES',
  Tube = 'TUBE',
  Tubes = 'TUBES',
  Twig = 'TWIG',
  Twigs = 'TWIGS',
  TwigParentheses = 'TWIG_PARENTHESES'
}

export type GustoRessortQuery = {
  __typename?: 'GustoRessortQuery';
  id: Scalars['ID']['output'];
  recipes?: Maybe<GustoRecipeItemPaginator>;
};

export type GustoSpecialRessortRequest = {
  __typename?: 'GustoSpecialRessortRequest';
  id: Scalars['ID']['output'];
  ressort?: Maybe<Ressort>;
};

export type GustoTip = {
  __typename?: 'GustoTip';
  advertorial?: Maybe<Scalars['Boolean']['output']>;
  custom_open_graph_description?: Maybe<Scalars['String']['output']>;
  custom_open_graph_title?: Maybe<Scalars['String']['output']>;
  custom_twitter_description?: Maybe<Scalars['String']['output']>;
  custom_twitter_title?: Maybe<Scalars['String']['output']>;
  google_news_title?: Maybe<Scalars['String']['output']>;
  headline?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<FairuAsset>;
  image_id?: Maybe<Scalars['ID']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<FairuAsset>;
  logo_id?: Maybe<Scalars['ID']['output']>;
  meta_description?: Maybe<Scalars['String']['output']>;
  meta_title?: Maybe<Scalars['String']['output']>;
  no_follow?: Maybe<Scalars['Boolean']['output']>;
  no_index?: Maybe<Scalars['Boolean']['output']>;
  open_graph_description?: Maybe<Scalars['String']['output']>;
  published?: Maybe<Scalars['Boolean']['output']>;
  redirect?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  twitter_description?: Maybe<Scalars['String']['output']>;
};

export type GustoTipPagination = {
  __typename?: 'GustoTipPagination';
  data?: Maybe<Array<GustoTip>>;
  paginatorInfo?: Maybe<DefaultPaginator>;
};

export type GustoUploadRequest = {
  __typename?: 'GustoUploadRequest';
  get?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  mime?: Maybe<Scalars['String']['output']>;
  path?: Maybe<Scalars['String']['output']>;
  upload?: Maybe<Scalars['String']['output']>;
};

export type Headline = {
  /** Anchor. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** Headline. */
  headline?: Maybe<Scalars['String']['output']>;
  /** Headline size */
  headline_level?: Maybe<Scalars['Int']['output']>;
};

export type Health = {
  __typename?: 'Health';
  checkId?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type HeroCleanNavAnchor = {
  __typename?: 'HeroCleanNavAnchor';
  anchor?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
};

export type HeroCleanStat = {
  __typename?: 'HeroCleanStat';
  label?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
};

export type HeroSlide = HeroSlideEntity | HeroSlideServices;

export type HeroSlideEntity = {
  __typename?: 'HeroSlideEntity';
  /** Button text */
  button_text?: Maybe<Scalars['String']['output']>;
  /** Entity entry */
  entity?: Maybe<TvmEntity>;
  /** Text */
  text?: Maybe<Scalars['String']['output']>;
  /** Title */
  title?: Maybe<Scalars['String']['output']>;
};


export type HeroSlideEntityTextArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HeroSlideServices = {
  __typename?: 'HeroSlideServices';
  /** Button link */
  button_link?: Maybe<Scalars['String']['output']>;
  /** Button text */
  button_text?: Maybe<Scalars['String']['output']>;
  /** Red label */
  red_label?: Maybe<Scalars['String']['output']>;
  /** Services ids */
  services?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Tag line */
  tagline?: Maybe<Scalars['String']['output']>;
  /** Text */
  text?: Maybe<Scalars['String']['output']>;
  /** Title */
  title?: Maybe<Scalars['String']['output']>;
};


export type HeroSlideServicesTextArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum HeroType {
  LandingPage = 'landing_page',
  Slider = 'slider'
}

export type Horoskop = {
  __typename?: 'Horoskop';
  date?: Maybe<Scalars['Date']['output']>;
  headline?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  text?: Maybe<Scalars['String']['output']>;
  zodiac?: Maybe<HoroskopZodiac>;
};

export type HoroskopBirthday = {
  __typename?: 'HoroskopBirthday';
  headline1?: Maybe<Scalars['String']['output']>;
  headline2?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  text1?: Maybe<Scalars['String']['output']>;
  text2?: Maybe<Scalars['String']['output']>;
  zodiac?: Maybe<HoroskopZodiac>;
};

export type HoroskopZodiac = {
  __typename?: 'HoroskopZodiac';
  from?: Maybe<Scalars['Date']['output']>;
  horoskop?: Maybe<Horoskop>;
  horoskop_birthday?: Maybe<HoroskopBirthday>;
  label?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  until?: Maybe<Scalars['Date']['output']>;
};


export type HoroskopZodiacHoroskopArgs = {
  date?: InputMaybe<Scalars['Date']['input']>;
};


export type HoroskopZodiacHoroskop_BirthdayArgs = {
  birthday: Scalars['Date']['input'];
  date?: InputMaybe<Scalars['Date']['input']>;
};

export enum HoroskopZodiacType {
  Aquarius = 'AQUARIUS',
  Aries = 'ARIES',
  Cancer = 'CANCER',
  Capricorn = 'CAPRICORN',
  Gemini = 'GEMINI',
  Leo = 'LEO',
  Libra = 'LIBRA',
  Pisces = 'PISCES',
  Sagittarius = 'SAGITTARIUS',
  Scorpio = 'SCORPIO',
  Taurus = 'TAURUS',
  Virgo = 'VIRGO'
}

/** Image asset */
export type Image = {
  __typename?: 'Image';
  /** Caption */
  caption?: Maybe<Scalars['String']['output']>;
  /** Copyright */
  copyright?: Maybe<Scalars['String']['output']>;
  /** Height */
  height?: Maybe<Scalars['Int']['output']>;
  /** Path to asset */
  path?: Maybe<Scalars['String']['output']>;
  /** Width */
  width?: Maybe<Scalars['Int']['output']>;
};


/** Image asset */
export type ImageCaptionArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A single listing from the Immo United real-estate feed */
export type ImmoUnitedListing = {
  __typename?: 'ImmoUnitedListing';
  /** Formatted area (e.g. '105,24 m²') */
  area_formatted?: Maybe<Scalars['String']['output']>;
  /** City */
  city?: Maybe<Scalars['String']['output']>;
  /** Listing id */
  id?: Maybe<Scalars['ID']['output']>;
  /** First listing image */
  image?: Maybe<Scalars['String']['output']>;
  /** Formatted price (e.g. '€ 389.000') */
  price_formatted?: Maybe<Scalars['String']['output']>;
  /** Number of rooms */
  rooms?: Maybe<Scalars['Float']['output']>;
  /** Listing title */
  title?: Maybe<Scalars['String']['output']>;
  /** Link to the listing on immounited.com */
  url?: Maybe<Scalars['String']['output']>;
};

export type InputChannel = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  article_id?: InputMaybe<Scalars['String']['input']>;
  asset_id?: InputMaybe<Scalars['String']['input']>;
  asset_white_id?: InputMaybe<Scalars['String']['input']>;
  custom_open_graph_description?: InputMaybe<Scalars['String']['input']>;
  custom_open_graph_title?: InputMaybe<Scalars['String']['input']>;
  custom_twitter_description?: InputMaybe<Scalars['String']['input']>;
  custom_twitter_title?: InputMaybe<Scalars['String']['input']>;
  google_news_title?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  joyn_id?: InputMaybe<Scalars['String']['input']>;
  joyn_livestream?: InputMaybe<Scalars['String']['input']>;
  mediapress_id?: InputMaybe<Scalars['String']['input']>;
  meta_description?: InputMaybe<Scalars['String']['input']>;
  meta_title?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  no_follow?: InputMaybe<Scalars['Boolean']['input']>;
  no_index?: InputMaybe<Scalars['Boolean']['input']>;
  open_graph_description?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  redirect?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['Int']['input']>;
  sponsoring?: InputMaybe<Scalars['Boolean']['input']>;
  twitter_description?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type InputCinema = {
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type InputEpisode = {
  actor_ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  article_ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  asset_id?: InputMaybe<Scalars['String']['input']>;
  crew_ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  custom_open_graph_description?: InputMaybe<Scalars['String']['input']>;
  custom_open_graph_title?: InputMaybe<Scalars['String']['input']>;
  custom_twitter_description?: InputMaybe<Scalars['String']['input']>;
  custom_twitter_title?: InputMaybe<Scalars['String']['input']>;
  director_ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  enriched?: InputMaybe<Scalars['Boolean']['input']>;
  genres?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  google_news_title?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  imdb_id?: InputMaybe<Scalars['String']['input']>;
  justwatch_id?: InputMaybe<Scalars['String']['input']>;
  mediapress_id?: InputMaybe<Scalars['String']['input']>;
  meta_description?: InputMaybe<Scalars['String']['input']>;
  meta_title?: InputMaybe<Scalars['String']['input']>;
  no_follow?: InputMaybe<Scalars['Boolean']['input']>;
  no_index?: InputMaybe<Scalars['Boolean']['input']>;
  open_graph_description?: InputMaybe<Scalars['String']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  redirect?: InputMaybe<Scalars['String']['input']>;
  review?: InputMaybe<Scalars['String']['input']>;
  reviewed?: InputMaybe<Scalars['Boolean']['input']>;
  showtimes_id?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  tmdb_id?: InputMaybe<Scalars['String']['input']>;
  tmdb_score?: InputMaybe<Scalars['Float']['input']>;
  tvm_score?: InputMaybe<Scalars['Int']['input']>;
  twitter_description?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type InputGenre = {
  custom_open_graph_description?: InputMaybe<Scalars['String']['input']>;
  custom_open_graph_title?: InputMaybe<Scalars['String']['input']>;
  custom_twitter_description?: InputMaybe<Scalars['String']['input']>;
  custom_twitter_title?: InputMaybe<Scalars['String']['input']>;
  google_news_title?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  mediapress_id?: InputMaybe<Scalars['String']['input']>;
  meta_description?: InputMaybe<Scalars['String']['input']>;
  meta_title?: InputMaybe<Scalars['String']['input']>;
  no_follow?: InputMaybe<Scalars['Boolean']['input']>;
  no_index?: InputMaybe<Scalars['Boolean']['input']>;
  open_graph_description?: InputMaybe<Scalars['String']['input']>;
  redirect?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  tmdb_id?: InputMaybe<Scalars['String']['input']>;
  twitter_description?: InputMaybe<Scalars['String']['input']>;
};

export type InputGustoRecipeIngredientGroup = {
  headline?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  ingredients?: InputMaybe<Array<InputGustoRecipeIngredientGroupIngredient>>;
};

export type InputGustoRecipeIngredientGroupIngredient = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  amount_type?: InputMaybe<GustoRecipeUnit>;
  ingredient: Scalars['ID']['input'];
  suffix?: InputMaybe<Scalars['String']['input']>;
};

export type InputGustoRecipeStep = {
  asset?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  headline?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  ingredients?: InputMaybe<Array<InputGustoRecipeStepIngredient>>;
  time?: InputMaybe<Scalars['Int']['input']>;
  used_recipe_id?: InputMaybe<Scalars['ID']['input']>;
};

export type InputGustoRecipeStepIngredient = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  amount_type?: InputMaybe<GustoRecipeUnit>;
  ingredient: Scalars['ID']['input'];
  suffix?: InputMaybe<Scalars['String']['input']>;
};

export type InputMovie = {
  actor_ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  article_ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  asset_backdrop_id?: InputMaybe<Scalars['String']['input']>;
  asset_id?: InputMaybe<Scalars['String']['input']>;
  crew_ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  custom_open_graph_description?: InputMaybe<Scalars['String']['input']>;
  custom_open_graph_title?: InputMaybe<Scalars['String']['input']>;
  custom_twitter_description?: InputMaybe<Scalars['String']['input']>;
  custom_twitter_title?: InputMaybe<Scalars['String']['input']>;
  director_ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  enriched?: InputMaybe<Scalars['Boolean']['input']>;
  genres?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  google_news_title?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  imdb_id?: InputMaybe<Scalars['String']['input']>;
  justwatch_id?: InputMaybe<Scalars['String']['input']>;
  mediapress_id?: InputMaybe<Scalars['String']['input']>;
  meta_description?: InputMaybe<Scalars['String']['input']>;
  meta_title?: InputMaybe<Scalars['String']['input']>;
  no_follow?: InputMaybe<Scalars['Boolean']['input']>;
  no_index?: InputMaybe<Scalars['Boolean']['input']>;
  open_graph_description?: InputMaybe<Scalars['String']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  redirect?: InputMaybe<Scalars['String']['input']>;
  release_date?: InputMaybe<Scalars['String']['input']>;
  review?: InputMaybe<Scalars['String']['input']>;
  reviewed?: InputMaybe<Scalars['Boolean']['input']>;
  showtimes_id?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  text_lg?: InputMaybe<Scalars['String']['input']>;
  text_md?: InputMaybe<Scalars['String']['input']>;
  text_sm?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  tmdb_id?: InputMaybe<Scalars['String']['input']>;
  tmdb_score?: InputMaybe<Scalars['Float']['input']>;
  tvm_score?: InputMaybe<Scalars['Int']['input']>;
  twitter_description?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
  youtube?: InputMaybe<Scalars['String']['input']>;
};

export type InputPerson = {
  article_id?: InputMaybe<Scalars['String']['input']>;
  article_ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  asset_backdrop_id?: InputMaybe<Scalars['String']['input']>;
  asset_id?: InputMaybe<Scalars['String']['input']>;
  birth_place?: InputMaybe<Scalars['String']['input']>;
  born_at?: InputMaybe<Scalars['Date']['input']>;
  custom_open_graph_description?: InputMaybe<Scalars['String']['input']>;
  custom_open_graph_title?: InputMaybe<Scalars['String']['input']>;
  custom_twitter_description?: InputMaybe<Scalars['String']['input']>;
  custom_twitter_title?: InputMaybe<Scalars['String']['input']>;
  died_at?: InputMaybe<Scalars['Date']['input']>;
  enriched?: InputMaybe<Scalars['Boolean']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  google_news_title?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  imdb_id?: InputMaybe<Scalars['String']['input']>;
  meta_description?: InputMaybe<Scalars['String']['input']>;
  meta_title?: InputMaybe<Scalars['String']['input']>;
  movie_ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  no_follow?: InputMaybe<Scalars['Boolean']['input']>;
  no_index?: InputMaybe<Scalars['Boolean']['input']>;
  open_graph_description?: InputMaybe<Scalars['String']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  quotes_ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  redirect?: InputMaybe<Scalars['String']['input']>;
  reviewed?: InputMaybe<Scalars['Boolean']['input']>;
  show_ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug?: InputMaybe<Scalars['String']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  text_lg?: InputMaybe<Scalars['String']['input']>;
  text_md?: InputMaybe<Scalars['String']['input']>;
  text_sm?: InputMaybe<Scalars['String']['input']>;
  tmdb_id?: InputMaybe<Scalars['String']['input']>;
  tmdb_score?: InputMaybe<Scalars['Float']['input']>;
  twitter_description?: InputMaybe<Scalars['String']['input']>;
};

export type InputPersonable = {
  entries?: InputMaybe<Array<InputMaybe<InputPersonableEntries>>>;
  person_id?: InputMaybe<Scalars['String']['input']>;
  personable_id?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type InputPersonableEntries = {
  position?: InputMaybe<Scalars['String']['input']>;
  rolename?: InputMaybe<Scalars['String']['input']>;
};

export type InputProvider = {
  article_id?: InputMaybe<Scalars['String']['input']>;
  asset_id?: InputMaybe<Scalars['String']['input']>;
  asset_white_id?: InputMaybe<Scalars['String']['input']>;
  custom_open_graph_description?: InputMaybe<Scalars['String']['input']>;
  custom_open_graph_title?: InputMaybe<Scalars['String']['input']>;
  custom_twitter_description?: InputMaybe<Scalars['String']['input']>;
  custom_twitter_title?: InputMaybe<Scalars['String']['input']>;
  google_news_title?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  meta_description?: InputMaybe<Scalars['String']['input']>;
  meta_title?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  no_follow?: InputMaybe<Scalars['Boolean']['input']>;
  no_index?: InputMaybe<Scalars['Boolean']['input']>;
  open_graph_description?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  redirect?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['Int']['input']>;
  sponsoring?: InputMaybe<Scalars['Boolean']['input']>;
  twitter_description?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  youtube_channel_id?: InputMaybe<Scalars['String']['input']>;
  youtube_fetching?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InputQuote = {
  person_id?: InputMaybe<Scalars['String']['input']>;
  quote_id?: InputMaybe<Scalars['String']['input']>;
};

export type InputShow = {
  actor_ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  article_ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  asset_backdrop_id?: InputMaybe<Scalars['String']['input']>;
  asset_id?: InputMaybe<Scalars['String']['input']>;
  crew_ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  custom_open_graph_description?: InputMaybe<Scalars['String']['input']>;
  custom_open_graph_title?: InputMaybe<Scalars['String']['input']>;
  custom_twitter_description?: InputMaybe<Scalars['String']['input']>;
  custom_twitter_title?: InputMaybe<Scalars['String']['input']>;
  director_ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  enriched?: InputMaybe<Scalars['Boolean']['input']>;
  genres?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  google_news_title?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  imdb_id?: InputMaybe<Scalars['String']['input']>;
  justwatch_id?: InputMaybe<Scalars['String']['input']>;
  mediapress_id?: InputMaybe<Scalars['String']['input']>;
  meta_description?: InputMaybe<Scalars['String']['input']>;
  meta_title?: InputMaybe<Scalars['String']['input']>;
  no_follow?: InputMaybe<Scalars['Boolean']['input']>;
  no_index?: InputMaybe<Scalars['Boolean']['input']>;
  open_graph_description?: InputMaybe<Scalars['String']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  redirect?: InputMaybe<Scalars['String']['input']>;
  review?: InputMaybe<Scalars['String']['input']>;
  reviewed?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  text_lg?: InputMaybe<Scalars['String']['input']>;
  text_md?: InputMaybe<Scalars['String']['input']>;
  text_sm?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  tmdb_id?: InputMaybe<Scalars['String']['input']>;
  tmdb_score?: InputMaybe<Scalars['Float']['input']>;
  tvm_score?: InputMaybe<Scalars['Int']['input']>;
  twitter_description?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
  youtube?: InputMaybe<Scalars['String']['input']>;
};

export type InputVod = {
  asset_id?: InputMaybe<Scalars['String']['input']>;
  asset_url?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  imdb_id?: InputMaybe<Scalars['String']['input']>;
  provider_id?: InputMaybe<Scalars['ID']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  runtime?: InputMaybe<Scalars['Int']['input']>;
  short?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  tmdb_score?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<VodType>;
  url?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type InterviewPart = {
  __typename?: 'InterviewPart';
  person?: Maybe<Person>;
  text?: Maybe<Scalars['String']['output']>;
};


export type InterviewPartTextArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};

export type JwtToken = {
  __typename?: 'JWTToken';
  error_code?: Maybe<Scalars['Int']['output']>;
  refresh_token?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
};

export type KeyfactGroupItem = CompanyKeyFact | CompanyKeyFactHeadline;

export type LawAdminInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type LawCategory = {
  __typename?: 'LawCategory';
  active: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  sort_order: Scalars['Int']['output'];
  type: LawCategoryType;
};

export enum LawCategoryType {
  Bundesland = 'BUNDESLAND',
  Duo = 'DUO',
  Standard = 'STANDARD'
}

export type LawCompany = {
  __typename?: 'LawCompany';
  email: Scalars['String']['output'];
  employees?: Maybe<Scalars['Int']['output']>;
  entries: Array<LawSurveyEntry>;
  finished: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  saved_category_ids?: Maybe<Array<Scalars['String']['output']>>;
  slug: Scalars['String']['output'];
  year: Scalars['Int']['output'];
};

export type LawCompanyListItem = {
  __typename?: 'LawCompanyListItem';
  email: Scalars['String']['output'];
  finished: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  tab1_updated?: Maybe<Scalars['String']['output']>;
  tab2_updated?: Maybe<Scalars['String']['output']>;
  tab3_updated?: Maybe<Scalars['String']['output']>;
  tab4_updated?: Maybe<Scalars['String']['output']>;
  tab5_updated?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['String']['output']>;
  year: Scalars['Int']['output'];
};

export type LawFinalInput = {
  employees: Scalars['Int']['input'];
};

export type LawSurveyEntry = {
  __typename?: 'LawSurveyEntry';
  city?: Maybe<Scalars['String']['output']>;
  company_name: Scalars['String']['output'];
  firstname?: Maybe<Scalars['String']['output']>;
  firstname_2?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  lastname?: Maybe<Scalars['String']['output']>;
  lastname_2?: Maybe<Scalars['String']['output']>;
  law_category_id: Scalars['String']['output'];
  law_company_id: Scalars['String']['output'];
  sort_order: Scalars['Int']['output'];
};

export type LawSurveyEntryInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  company_name: Scalars['String']['input'];
  firstname?: InputMaybe<Scalars['String']['input']>;
  firstname_2?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  lastname?: InputMaybe<Scalars['String']['input']>;
  lastname_2?: InputMaybe<Scalars['String']['input']>;
  law_category_id: Scalars['String']['input'];
  sort_order: Scalars['Int']['input'];
};

export enum LawUpdateKindType {
  Admin = 'ADMIN',
  Category = 'CATEGORY',
  Final = 'FINAL'
}

export type Link = {
  __typename?: 'Link';
  /** ID */
  id?: Maybe<Scalars['String']['output']>;
  /** Should the element be opened in a seperat window/tab? */
  target_blank?: Maybe<Scalars['Boolean']['output']>;
  /** Title */
  title?: Maybe<Scalars['String']['output']>;
  /** Url */
  url?: Maybe<Scalars['String']['output']>;
};

export type LinkCollection = {
  __typename?: 'LinkCollection';
  /** ID */
  id: Scalars['ID']['output'];
  /** Links */
  links?: Maybe<Array<Maybe<Link>>>;
  /** Title */
  title?: Maybe<Scalars['String']['output']>;
};

export enum ListicleType {
  Channel = 'CHANNEL',
  Cinema = 'CINEMA',
  CollectionEntry = 'COLLECTION_ENTRY',
  Episode = 'EPISODE',
  Genre = 'GENRE',
  ListicleType = 'ListicleType',
  Manual = 'MANUAL',
  Movie = 'MOVIE',
  Person = 'PERSON',
  Provider = 'PROVIDER',
  Series = 'SERIES',
  Show = 'SHOW',
  Vod = 'VOD'
}

/** Magazine */
export type Magazine = {
  __typename?: 'Magazine';
  /** Image path */
  cover_image?: Maybe<Scalars['String']['output']>;
  /** Id for magazine */
  id: Scalars['ID']['output'];
  /** Url for further redirects */
  path?: Maybe<Scalars['String']['output']>;
  /** Shorthand of the magazine on the server */
  shorthand?: Maybe<Scalars['String']['output']>;
  /** Title */
  title?: Maybe<Scalars['String']['output']>;
};

export enum MailColumns {
  One = 'ONE',
  Three = 'THREE',
  Two = 'TWO'
}

export type MailElementHeadline = {
  __typename?: 'MailElementHeadline';
  headline?: Maybe<Scalars['String']['output']>;
  headline_size?: Maybe<MailHeadlineSize>;
};

export type MailElementHtml = {
  __typename?: 'MailElementHtml';
  html?: Maybe<Scalars['String']['output']>;
};

export type MailElementText = {
  __typename?: 'MailElementText';
  text?: Maybe<Scalars['String']['output']>;
};

export enum MailHeadlineSize {
  H1 = 'H1',
  H2 = 'H2',
  H3 = 'H3',
  H4 = 'H4'
}

export type MailRequest = {
  __typename?: 'MailRequest';
  body?: Maybe<MailRequestBody>;
  created_at?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  failed_at?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  portal: Scalars['String']['output'];
  sent_at?: Maybe<Scalars['String']['output']>;
  start_at?: Maybe<Scalars['String']['output']>;
  status?: Maybe<MailRequestStatus>;
  subject?: Maybe<Scalars['String']['output']>;
  /** Template settings. Please be aware that the mail will be sent from default if template cannot be found */
  template?: Maybe<Scalars['String']['output']>;
  /** If activated the service will automatically create replacement links */
  tracking?: Maybe<Scalars['Boolean']['output']>;
  updated_at?: Maybe<Scalars['String']['output']>;
};

export type MailRequestBody = {
  __typename?: 'MailRequestBody';
  rows?: Maybe<Array<MailRequestBodyRow>>;
};

export type MailRequestBodyElement = MailElementHeadline | MailElementHtml | MailElementText;

export enum MailRequestBodyElementType {
  Divider = 'DIVIDER',
  Headline = 'HEADLINE',
  Html = 'HTML',
  Image = 'IMAGE',
  Link = 'LINK',
  Spacer = 'SPACER',
  Text = 'TEXT'
}

export type MailRequestBodyRow = {
  __typename?: 'MailRequestBodyRow';
  background?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Array<MailRequestBodyElement>>;
};

export type MailRequestPaginationList = {
  __typename?: 'MailRequestPaginationList';
  data?: Maybe<Array<Maybe<MailRequest>>>;
  paginatorInfo?: Maybe<DefaultPaginator>;
};

export enum MailRequestStatus {
  Created = 'CREATED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Ready = 'READY',
  Sent = 'SENT'
}

export type MarketplaceEditorialSelection = {
  __typename?: 'MarketplaceEditorialSelection';
  createdAt: Scalars['DateTime']['output'];
  editorUserId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  listingId: Scalars['String']['output'];
  /** JSON-encoded snapshot of the AutoScout24 listing taken at selection time. */
  listingSnapshot?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  position: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type McStreamy = {
  __typename?: 'McStreamy';
  /** @deprecated The shorts import was removed — this data is frozen and no longer maintained. */
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** @deprecated The shorts import was removed — this data is frozen and no longer maintained. */
  speaker?: Maybe<Scalars['String']['output']>;
  /**
   * Tags for the mcstreamy
   * @deprecated The shorts import was removed — this data is frozen and no longer maintained.
   */
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** @deprecated The shorts import was removed — this data is frozen and no longer maintained. */
  thumbnail?: Maybe<Scalars['String']['output']>;
  /** @deprecated The shorts import was removed — this data is frozen and no longer maintained. */
  title?: Maybe<Scalars['String']['output']>;
  /** @deprecated The shorts import was removed — the stream URL may already be dead. */
  url?: Maybe<Scalars['String']['output']>;
};

export type McStreamyPaginationList = {
  __typename?: 'McStreamyPaginationList';
  /** @deprecated The shorts import was removed — this data is frozen and no longer maintained. */
  data?: Maybe<Array<McStreamy>>;
  /** @deprecated The shorts import was removed — this data is frozen and no longer maintained. */
  paginatorInfo?: Maybe<DefaultPaginator>;
};

export type Meta = SeoInterface & {
  __typename?: 'Meta';
  /** Custom open graph description */
  custom_open_graph_description?: Maybe<Scalars['String']['output']>;
  /** Open graph title */
  custom_open_graph_title?: Maybe<Scalars['String']['output']>;
  /** Twitter custom description */
  custom_twitter_description?: Maybe<Scalars['String']['output']>;
  /** Custom twitter title */
  custom_twitter_title?: Maybe<Scalars['String']['output']>;
  /** Google news title */
  google_news_title?: Maybe<Scalars['String']['output']>;
  /** Meta meta_description */
  meta_description?: Maybe<Scalars['String']['output']>;
  /** Meta title */
  meta_title?: Maybe<Scalars['String']['output']>;
  /** No follow */
  no_follow?: Maybe<Scalars['Boolean']['output']>;
  /** Should that entry be index */
  no_index?: Maybe<Scalars['Boolean']['output']>;
  /** Open graph description */
  open_graph_description?: Maybe<Scalars['String']['output']>;
  /** Open Graph Image */
  open_graph_image?: Maybe<FairuAsset>;
  /** Redirect url */
  redirect?: Maybe<Scalars['String']['output']>;
  /** Twitter description mode */
  twitter_description?: Maybe<Scalars['String']['output']>;
  /** Twitter Image */
  twitter_image?: Maybe<FairuAsset>;
};


export type MetaRedirectArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MoonCalendarDay = {
  __typename?: 'MoonCalendarDay';
  ascendent?: Maybe<HoroskopZodiac>;
  bad_bodycare?: Maybe<Scalars['Boolean']['output']>;
  bad_cleaning?: Maybe<Scalars['Boolean']['output']>;
  bad_cleaning_windows?: Maybe<Scalars['Boolean']['output']>;
  bad_cuthair?: Maybe<Scalars['Boolean']['output']>;
  bad_facecare?: Maybe<Scalars['Boolean']['output']>;
  bad_laundry?: Maybe<Scalars['Boolean']['output']>;
  bad_love?: Maybe<Scalars['Boolean']['output']>;
  bad_nails?: Maybe<Scalars['Boolean']['output']>;
  bad_party?: Maybe<Scalars['Boolean']['output']>;
  bad_planting?: Maybe<Scalars['Boolean']['output']>;
  bad_traveling?: Maybe<Scalars['Boolean']['output']>;
  bad_waterplants?: Maybe<Scalars['Boolean']['output']>;
  date?: Maybe<Scalars['Date']['output']>;
  good_bodycare?: Maybe<Scalars['Boolean']['output']>;
  good_cleaning?: Maybe<Scalars['Boolean']['output']>;
  good_cleaning_windows?: Maybe<Scalars['Boolean']['output']>;
  good_cuthair?: Maybe<Scalars['Boolean']['output']>;
  good_facecare?: Maybe<Scalars['Boolean']['output']>;
  good_laundry?: Maybe<Scalars['Boolean']['output']>;
  good_love?: Maybe<Scalars['Boolean']['output']>;
  good_nails?: Maybe<Scalars['Boolean']['output']>;
  good_party?: Maybe<Scalars['Boolean']['output']>;
  good_planting?: Maybe<Scalars['Boolean']['output']>;
  good_traveling?: Maybe<Scalars['Boolean']['output']>;
  good_waterplants?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  moonphase?: Maybe<Scalars['Float']['output']>;
  moonphase_type?: Maybe<Scalars['String']['output']>;
  moonrise?: Maybe<Scalars['String']['output']>;
  moonset?: Maybe<Scalars['String']['output']>;
  sunrise?: Maybe<Scalars['String']['output']>;
  sunset?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  zodiac?: Maybe<HoroskopZodiac>;
  zodiac_time?: Maybe<Scalars['String']['output']>;
};

export type MooncalendarDayPaginationList = {
  __typename?: 'MooncalendarDayPaginationList';
  data?: Maybe<Array<Maybe<MoonCalendarDay>>>;
  paginatorInfo?: Maybe<DefaultPaginator>;
};

export enum MooncalendarOptions {
  BadBodycare = 'bad_bodycare',
  BadCleaning = 'bad_cleaning',
  BadCleaningWindows = 'bad_cleaning_windows',
  BadCuthair = 'bad_cuthair',
  BadFacecare = 'bad_facecare',
  BadLaundry = 'bad_laundry',
  BadLove = 'bad_love',
  BadNails = 'bad_nails',
  BadParty = 'bad_party',
  BadPlanting = 'bad_planting',
  BadTraveling = 'bad_traveling',
  BadWaterplants = 'bad_waterplants',
  GoodBodycare = 'good_bodycare',
  GoodCleaning = 'good_cleaning',
  GoodCleaningWindows = 'good_cleaning_windows',
  GoodCuthair = 'good_cuthair',
  GoodFacecare = 'good_facecare',
  GoodLaundry = 'good_laundry',
  GoodLove = 'good_love',
  GoodNails = 'good_nails',
  GoodParty = 'good_party',
  GoodPlanting = 'good_planting',
  GoodTraveling = 'good_traveling',
  GoodWaterplants = 'good_waterplants'
}

/** Movie entry. */
export type Movie = EntityInterface & {
  __typename?: 'Movie';
  actor_ids?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Age rating */
  age_rating?: Maybe<Scalars['String']['output']>;
  /** Article ids */
  article_ids?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Asset id backdrop image */
  asset_backdrop_id?: Maybe<Scalars['String']['output']>;
  /** Asset id cover image */
  asset_id?: Maybe<Scalars['String']['output']>;
  /** Backdrop image */
  backdrop_image?: Maybe<FairuAsset>;
  /** Cinemas */
  cinemas: CinemaPaginator;
  /** cover image */
  cover_image?: Maybe<FairuAsset>;
  /** Created at */
  created_at?: Maybe<Scalars['DateTime']['output']>;
  crew_ids?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** flat list of director ids for the movie */
  director_ids?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** directors for the movie */
  directors?: Maybe<PersonPaginationList>;
  /** Enriched data  */
  enriched?: Maybe<Scalars['Boolean']['output']>;
  favorite?: Maybe<TvmFavorite>;
  /** Genre ids for the movie */
  genre_ids?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Genres for the movie */
  genres?: Maybe<Array<Maybe<Genre>>>;
  /** Unique primary key. */
  id: Scalars['ID']['output'];
  /** Imdb id */
  imdb_id?: Maybe<Scalars['String']['output']>;
  /** Id within the justwatch api */
  justwatch_id?: Maybe<Scalars['String']['output']>;
  /** Watch links */
  links?: Maybe<Array<Maybe<WatchLink>>>;
  /** Mediapress content id */
  mediapress_id?: Maybe<Scalars['String']['output']>;
  /** Meta data */
  metadata?: Maybe<Meta>;
  /** Original id is set if the the entry has been transformed */
  original_id?: Maybe<Scalars['String']['output']>;
  /** Original Title of the enitity */
  original_title?: Maybe<Scalars['String']['output']>;
  /** flat list of person ids for the movie */
  person_ids?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** persons for the movie */
  persons?: Maybe<PersonPaginationList>;
  /** Provider */
  provider?: Maybe<Array<Maybe<Provider>>>;
  /** Pubslihed */
  published?: Maybe<Scalars['Boolean']['output']>;
  /** Release Date */
  release_date?: Maybe<Scalars['String']['output']>;
  /** Review */
  review?: Maybe<Scalars['String']['output']>;
  /** Reviewed data  */
  reviewed?: Maybe<Scalars['Boolean']['output']>;
  /** Run time in minutes */
  runtime?: Maybe<Scalars['Int']['output']>;
  /** Shorttitle of the enitity */
  short?: Maybe<Scalars['String']['output']>;
  /** cinema showtimes */
  showtimes: CinemaShowtimePaginator;
  showtimesAmount?: Maybe<Scalars['Int']['output']>;
  /** Showtimes for today */
  showtimesToday: CinemaShowtimePaginator;
  /** Showtimes today but only upcoming */
  showtimesUpcoming: CinemaShowtimePaginator;
  /** Showtimes identifier */
  showtimes_id?: Maybe<Scalars['String']['output']>;
  /** Pivot information will only be attached if the querys root is a person. */
  singlePersonMetaInformation?: Maybe<PersonMeta>;
  /** Url-Slug */
  slug?: Maybe<Scalars['String']['output']>;
  /** Summary */
  summary?: Maybe<Scalars['String']['output']>;
  /** Tags for the show */
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Summary Long */
  text_lg?: Maybe<Scalars['String']['output']>;
  /** Summary Medium */
  text_md?: Maybe<Scalars['String']['output']>;
  /** Summary Small */
  text_sm?: Maybe<Scalars['String']['output']>;
  /** Title of the enitity */
  title?: Maybe<Scalars['String']['output']>;
  /** Tmdb id */
  tmdb_id?: Maybe<Scalars['String']['output']>;
  /** Score */
  tmdb_score?: Maybe<Scalars['Float']['output']>;
  /** Trailer for the movie */
  trailer?: Maybe<Array<Maybe<Trailer>>>;
  /** TV airings from the programme, matched by entity, Mediapress or typed TMDB ID. */
  tvShowtimes: TvChannelShowtimePaginator;
  /** Airings running now on active channels with a Joyn livestream. Use channel.joyn_livestream for the live-TV button; stop is exclusive. */
  tvShowtimesNow: TvChannelShowtimePaginator;
  /** TV airings starting today. */
  tvShowtimesToday: TvChannelShowtimePaginator;
  /** Upcoming TV airings. Defaults to now through the end of the day seven days ahead. */
  tvShowtimesUpcoming: TvChannelShowtimePaginator;
  /** Score of TVMedia */
  tvm_score?: Maybe<Scalars['Int']['output']>;
  /** Upcoming streaming releases (synced daily) */
  upcoming_offers?: Maybe<Array<Maybe<UpcomingOffer>>>;
  /** Updated at */
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  /** Year of release */
  year?: Maybe<Scalars['Int']['output']>;
  /** Youtube id */
  youtube?: Maybe<Scalars['String']['output']>;
};


/** Movie entry. */
export type MovieCinemasArgs = {
  first: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};


/** Movie entry. */
export type MovieDirectorsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


/** Movie entry. */
export type MovieGenresArgs = {
  flat?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Movie entry. */
export type MoviePersonsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


/** Movie entry. */
export type MovieReviewArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Movie entry. */
export type MovieShowtimesArgs = {
  first: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<DateRange>;
};


/** Movie entry. */
export type MovieShowtimesTodayArgs = {
  first: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};


/** Movie entry. */
export type MovieShowtimesUpcomingArgs = {
  cinema?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  first?: Scalars['Int']['input'];
  from?: InputMaybe<Scalars['DateTime']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  until?: InputMaybe<Scalars['DateTime']['input']>;
};


/** Movie entry. */
export type MovieSummaryArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Movie entry. */
export type MovieText_LgArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Movie entry. */
export type MovieText_MdArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Movie entry. */
export type MovieText_SmArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Movie entry. */
export type MovieTvShowtimesArgs = {
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<DateRange>;
};


/** Movie entry. */
export type MovieTvShowtimesNowArgs = {
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};


/** Movie entry. */
export type MovieTvShowtimesTodayArgs = {
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};


/** Movie entry. */
export type MovieTvShowtimesUpcomingArgs = {
  first?: Scalars['Int']['input'];
  from?: InputMaybe<Scalars['DateTime']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  until?: InputMaybe<Scalars['DateTime']['input']>;
};

export type MoviePaginationList = {
  __typename?: 'MoviePaginationList';
  data?: Maybe<Array<Maybe<Movie>>>;
  paginatorInfo?: Maybe<DefaultPaginator>;
};

/** A paginated list of Movie items. */
export type MoviePaginator = {
  __typename?: 'MoviePaginator';
  /** A list of Movie items. */
  data: Array<Movie>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type MoviesPaginationList = {
  __typename?: 'MoviesPaginationList';
  data?: Maybe<Array<Maybe<Movie>>>;
  paginatorInfo?: Maybe<DefaultPaginator>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Abort a multipart upload and clean up */
  abortFairuMultipartUpload: Scalars['Boolean']['output'];
  /**
   * Confirm that a broadcast arrived. Send this for events that carry a state
   * change — session.state.changed and match.found — using the `seq` from the
   * payload. Without a receipt the server repeats the broadcast once; the
   * repeat carries the same `seq`, so a client that did get it can ignore it.
   */
  ackTvmMatchEvent: TvmMatchAck;
  /** Add a listing to the editorial selection. Requires autorevue:marketplace-editor permission. */
  addMarketplaceSelection?: Maybe<MarketplaceEditorialSelection>;
  addReportToTT500Company?: Maybe<Tt500FinanceReport>;
  /** Internal (archives): announce a newly delivered e-paper issue to the portal app. The CMS confirms the issue with archives and writes the message itself; each issue at most once. */
  announceEpaperIssue: AppPushAnnouncement;
  /** Archive a file (permanent, cannot be undone). Archived files cannot be renamed or deleted. */
  archiveFairuFile?: Maybe<FairuAsset>;
  articleCreate?: Maybe<Article>;
  /** Hard-deletes any article entry matching the given identifier(s) AND any redirect entry occupying its URI. No 410/404 redirect is created. Intended for import-tool reset flows only — do NOT use as a general delete mutation. */
  articleReset?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Authorise this client for the session's private channel `tvinder.{id}`.
   *
   * Exists because clients reach this service through the federation gateway,
   * which forwards /graphql only — Laravel's /broadcasting/auth endpoint works
   * too, but is not reachable that way. Use it as Echo's custom authorizer.
   */
  authorizeTvmMatchChannel: TvmMatchChannelAuth;
  /** Block a file */
  blockFairuFile?: Maybe<Scalars['Boolean']['output']>;
  bookVgnEvent?: Maybe<VgnEvent>;
  /** Cancel a pdf signatur request */
  cancelFairuPdfSignatureRequest?: Maybe<Scalars['Boolean']['output']>;
  checkValidProduct?: Maybe<Scalars['Boolean']['output']>;
  clearCache?: Maybe<CacheClearResult>;
  /** Host only — stop accepting new participants. */
  closeTvmMatchLobby: TvmMatchSession;
  compaxLogin?: Maybe<CompaxLoginResult>;
  compaxLogout?: Maybe<CompaxAuthResult>;
  compaxRefreshSession?: Maybe<CompaxAuthResult>;
  /** Complete a multipart upload after all parts have been uploaded */
  completeFairuMultipartUpload: FairuUploadLink;
  confirmDataSubjectRequest?: Maybe<CreateUserAccountResult>;
  confirmRevocation?: Maybe<CreateUserAccountResult>;
  createArchiveIssue?: Maybe<ArchiveIssue>;
  createCarBrand?: Maybe<VgnCarBrand>;
  createCarModel?: Maybe<VgnCarModel>;
  /** Create a backup target. The credentials are checked against the remote before the entry is stored. */
  createFairuBackup?: Maybe<FairuBackup>;
  /** Create a metadata blueprint */
  createFairuBlueprint?: Maybe<FairuBlueprint>;
  /** Create a shared option catalog */
  createFairuCatalog?: Maybe<FairuCatalog>;
  /** Add an option to a catalog */
  createFairuCatalogEntry?: Maybe<FairuCatalogEntry>;
  /** Create a copyright */
  createFairuCopyright?: Maybe<FairuCopyright>;
  /** Create a sync disk entry */
  createFairuDisk?: Maybe<FairuDisk>;
  /** Create a dcma complain */
  createFairuDmcaComplain?: Maybe<Scalars['Boolean']['output']>;
  /** Add a field to a fieldset */
  createFairuField?: Maybe<FairuField>;
  /** Create a fieldset */
  createFairuFieldset?: Maybe<FairuFieldset>;
  /** Generate HMAC access signatures for private files */
  createFairuFileAccessSignature: Array<FairuFileAccessSignature>;
  /** Create a folder */
  createFairuFolder?: Maybe<FairuFolder>;
  /** Create a ftp connectoin to the folder */
  createFairuFolderFTP?: Maybe<FairuDisk>;
  /** Create an upload share link for a folder - anyone with this link can upload files to the folder */
  createFairuFolderUploadShareLink?: Maybe<FairuFolderUploadShareLink>;
  /** Create a gallery */
  createFairuGallery?: Maybe<FairuGallery>;
  /** Create shareable gallery link */
  createFairuGalleryShareLink?: Maybe<Scalars['String']['output']>;
  /** Add a state to the workspace label set */
  createFairuLabel?: Maybe<FairuLabel>;
  /** Create a license */
  createFairuLicense?: Maybe<FairuLicense>;
  /** Create a pdf signatur request */
  createFairuPdfSignatureRequest?: Maybe<FairuFilePdfSignatureRequest>;
  /** Create Raku credentials (S3-compatible storage) for the tenant */
  createFairuRakuCredential: FairuRakuCredentialWithSecret;
  /** Create a role */
  createFairuRole?: Maybe<FairuRole>;
  /**
   * Create a sub-tenant under the current tenant.
   * The current tenant must not be a sub-tenant itself (no nesting).
   * Requires an active subscription or trial.
   */
  createFairuSubTenant: FairuTenantCreationResult;
  /** Create a tag */
  createFairuTag?: Maybe<FairuTag>;
  /**
   * Create a new tenant (workspace) via API.
   *
   * This mutation is designed for programmatic tenant provisioning, typically used by:
   * - Partner integrations that need to create workspaces for their customers
   * - Automated onboarding systems
   * - White-label deployments
   *
   * ## Authentication
   *
   * Requires a special "provisioning token" with the `tenant::create` ability.
   * This is a global permission (not tied to any existing tenant).
   *
   * To obtain a provisioning token, contact your administrator or use the
   * admin panel to generate one for your user account.
   *
   * ## What happens on creation
   *
   * 1. A new tenant (workspace) is created with the given name
   * 2. The authenticated user becomes the owner with full admin rights
   * 3. A full-access API key is generated for the new tenant
   * 4. The API key is returned in the response (store it securely!)
   *
   * ## Response
   *
   * The mutation returns:
   * - `id`: The unique tenant ID (UUID)
   * - `name`: The tenant name
   * - `api_key`: A full-access API key for the new tenant (shown only once!)
   * - `created_at`: ISO 8601 timestamp
   *
   * ## Example
   *
   * ```graphql
   * mutation {
   *   createFairuTenant(name: "My New Workspace") {
   *     id
   *     name
   *     api_key
   *     created_at
   *   }
   * }
   * ```
   *
   * ## Important
   *
   * The `api_key` is only shown once in this response. Store it securely!
   * If lost, you'll need to generate a new one via the tenant settings.
   */
  createFairuTenant: FairuTenantCreationResult;
  createFairuUploadLink?: Maybe<FairuUploadLink>;
  createFairuVideoChannel?: Maybe<FairuVideoChannel>;
  createFairuVideoChannelEpisode?: Maybe<FairuVideoChannelEpisode>;
  createFairuVideoChannelSeason?: Maybe<FairuVideoChannelSeason>;
  /** Create a webhook */
  createFairuWebhook?: Maybe<FairuWebhook>;
  /** Create a workflow */
  createFairuWorkflow?: Maybe<FairuWorkflow>;
  createGenre?: Maybe<Genre>;
  createGustoCategory?: Maybe<GustoRecipeCategory>;
  createGustoCountry?: Maybe<GustoCountry>;
  createGustoIngredient?: Maybe<GustoIngredient>;
  createGustoIssue?: Maybe<GustoIssue>;
  createGustoOccasion?: Maybe<GustoOccasion>;
  createGustoRecipe?: Maybe<GustoRecipe>;
  createGustoRecipeProperty?: Maybe<GustoRecipeProperty>;
  createGustoTip?: Maybe<GustoTip>;
  createMailRequest?: Maybe<MailRequest>;
  createMergeUserNotification?: Maybe<Scalars['Boolean']['output']>;
  createMooncalendar?: Maybe<MoonCalendarDay>;
  createMovie?: Maybe<Movie>;
  createProvider?: Maybe<Provider>;
  createShow?: Maybe<Show>;
  createStripeCustomer?: Maybe<StripeCustomerResult>;
  createTT500Company?: Maybe<Tt500Company>;
  createTT500Person?: Maybe<Tt500Person>;
  createTokenNotification?: Maybe<Scalars['Boolean']['output']>;
  /** Will add the entry to favorites table */
  createTvmFavorite?: Maybe<TvmFavorite>;
  createTvmFavoriteMultiple?: Maybe<Array<Maybe<TvmFavorite>>>;
  /** Open a session and become its host. */
  createTvmMatchSession: TvmMatchSession;
  createUserAccount?: Maybe<CreateUserAccountResult>;
  createUserFavoriteGroup?: Maybe<UserFavoriteGroup>;
  createUserFeedback?: Maybe<CreateUserAccountResult>;
  createVgnCarAd?: Maybe<VgnCarAd>;
  createVgnEvent?: Maybe<VgnEvent>;
  createVgnEventCategory?: Maybe<VgnEventCategory>;
  createVgnEventSection?: Maybe<VgnEventSection>;
  createVgnSheet?: Maybe<VgnSheet>;
  createVod?: Maybe<Vod>;
  customerBasket?: Maybe<CustomerBasketResult>;
  customerChangeData?: Maybe<CustomerRegistrationResult>;
  customerChangePassword?: Maybe<CustomerRegistrationResult>;
  customerCheckEmailExists?: Maybe<Scalars['Boolean']['output']>;
  customerConfirm?: Maybe<CustomerRegistrationResult>;
  /**
   * Server-to-server anonymous customer creation. Calls Compax POST /customers
   * with the api-compax service-account oauth token (no end-user JWT, no UUser
   * created) — used as the first step of the simple-checkout flow when the
   * caller has no email yet (or wants to bypass the email-uniqueness gate of
   * customerRegisterUnconfirmed). Email is attached later via contactPersons[0]
   * in customerSubmitContract.
   */
  customerCreateAnonymous?: Maybe<CustomerAnonymousResult>;
  customerDeliveryAddressChange?: Maybe<CustomerRegistrationResult>;
  customerDeliveryComplaintsContractAdd?: Maybe<CustomerRegistrationResult>;
  customerDeliverySuspensionsContractAdd?: Maybe<CustomerRegistrationResult>;
  customerDeliverySuspensionsContractChange?: Maybe<CustomerRegistrationResult>;
  customerLogin?: Maybe<JwtToken>;
  customerLoginPre?: Maybe<JwtToken>;
  customerLogout?: Maybe<Scalars['Boolean']['output']>;
  customerRefreshToken?: Maybe<JwtToken>;
  customerRegisterFromCustomer?: Maybe<CustomerRegistrationResult>;
  customerRegisterUnconfirmed?: Maybe<CustomerTokenResultWithError>;
  customerResetPassword?: Maybe<CustomerUserResult>;
  customerSetPassword?: Maybe<CustomerRegistrationResult>;
  /**
   * Update the customer record's basic data via PUT /customers/{customerId}
   * (the non-selfService variant). Accepts email updates even when the email
   * is already in use by another Compax customer — Compax queues a
   * Dublettenprüfung workflow in the background instead of rejecting. Used
   * by the anonymous-checkout flow to swap the placeholder email with the
   * user's real one at the end of the order. customerId is derived from the
   * caller's customer-scoped JWT.
   */
  customerUpdateBasic?: Maybe<CustomerRegistrationResult>;
  /**
   * Record the buyer's marketing consent (MARKETING, EMAIL, SMS, PHONE) on the
   * Compax customer behind the caller's token, with referenz "Kauf auf <portal>
   * <timestamp>". Call it only when the box was ticked: Compax merges the entries,
   * and an unticked box must leave earlier consent untouched. Post (LETTER) cannot
   * be stored through the Compax update API yet.
   */
  customerUpdateMarketingConsent?: Maybe<CustomerRegistrationResult>;
  /**
   * Update a Stripe customer's email + name directly via Stripe's API
   * (POST /v1/customers/{id}), using STRIPE_SECRET_KEY in api-compax. Used at
   * the end of the anonymous-checkout flow to overwrite the noreply-*
   * placeholder Stripe stored when the customer record only had the
   * placeholder email — so charge receipts route to the real address and the
   * customer is findable in Stripe by their real email. Compax's /stripe/*
   * wrapper doesn't expose customer-update, hence the direct call.
   */
  customerUpdateStripeEmail?: Maybe<CustomerRegistrationResult>;
  customerVacationAddressAdd?: Maybe<CustomerRegistrationResult>;
  customerVacationAddressRedirect?: Maybe<CustomerRegistrationResult>;
  deleteArchiveIssue?: Maybe<Scalars['Boolean']['output']>;
  deleteCarBrand?: Maybe<Scalars['Boolean']['output']>;
  deleteCarModel?: Maybe<Scalars['Boolean']['output']>;
  deleteChannel?: Maybe<TvChannel>;
  deleteCinema?: Maybe<Scalars['Boolean']['output']>;
  deleteEpisode?: Maybe<Scalars['Boolean']['output']>;
  /** Delete a backup target. Only the configuration goes — the files already copied stay on the target. */
  deleteFairuBackup?: Maybe<Scalars['Boolean']['output']>;
  /** Delete a metadata blueprint. The values collected under it are kept, not destroyed. */
  deleteFairuBlueprint?: Maybe<Scalars['Boolean']['output']>;
  /** Delete a catalog. Refused while any of its options are in use. */
  deleteFairuCatalog?: Maybe<Scalars['Boolean']['output']>;
  /** Delete an option. Refused while in use unless force is given, which detaches the values first. */
  deleteFairuCatalogEntry?: Maybe<Scalars['Boolean']['output']>;
  /** Delete a copyright entry */
  deleteFairuCopyright?: Maybe<Scalars['Boolean']['output']>;
  /** Delete a disk */
  deleteFairuDisk?: Maybe<Scalars['Boolean']['output']>;
  /** Remove a field from its fieldset. The values recorded under it are kept and restorable. */
  deleteFairuField?: Maybe<Scalars['Boolean']['output']>;
  /** Delete a fieldset and its fields. The values are kept. */
  deleteFairuFieldset?: Maybe<Scalars['Boolean']['output']>;
  /** Delete a single file */
  deleteFairuFile?: Maybe<Scalars['Boolean']['output']>;
  /** Delete a single folder */
  deleteFairuFolder?: Maybe<Scalars['Boolean']['output']>;
  /** Delete a gallery */
  deleteFairuGallery?: Maybe<Scalars['Boolean']['output']>;
  /** Remove a label from the set. Assets that wore it keep existing and lose the state. */
  deleteFairuLabel?: Maybe<Scalars['Boolean']['output']>;
  /** Delete a license entry */
  deleteFairuLicense?: Maybe<Scalars['Boolean']['output']>;
  /** Delete Raku credentials permanently */
  deleteFairuRakuCredential: Scalars['Boolean']['output'];
  /** Delete a role */
  deleteFairuRole?: Maybe<Scalars['Boolean']['output']>;
  /** Delete a tag entry */
  deleteFairuTag?: Maybe<Scalars['Boolean']['output']>;
  /** Delete an user from the tenant - user will not be deleted by itself */
  deleteFairuUser?: Maybe<Scalars['Boolean']['output']>;
  deleteFairuVideoChannel?: Maybe<Scalars['Boolean']['output']>;
  /** Delete webhooks */
  deleteFairuWebhooks?: Maybe<Scalars['Boolean']['output']>;
  /** Delete a workflow */
  deleteFairuWorkflow?: Maybe<Scalars['Boolean']['output']>;
  deleteGenre?: Maybe<Scalars['Boolean']['output']>;
  deleteGustoCategory?: Maybe<Scalars['Boolean']['output']>;
  deleteGustoCountry?: Maybe<Scalars['Boolean']['output']>;
  deleteGustoIngredient?: Maybe<Scalars['Boolean']['output']>;
  deleteGustoIssue?: Maybe<Scalars['Boolean']['output']>;
  deleteGustoOccasion?: Maybe<Scalars['Boolean']['output']>;
  deleteGustoRecipe?: Maybe<Scalars['Boolean']['output']>;
  deleteGustoRecipeProperty?: Maybe<Scalars['Boolean']['output']>;
  deleteGustoTip?: Maybe<Scalars['Boolean']['output']>;
  deleteMailRequest?: Maybe<Scalars['Boolean']['output']>;
  deleteMovie?: Maybe<Scalars['Boolean']['output']>;
  deletePerson?: Maybe<Scalars['Boolean']['output']>;
  deleteProvider?: Maybe<Scalars['Boolean']['output']>;
  deleteQuote?: Maybe<Scalars['Boolean']['output']>;
  deleteShow?: Maybe<Scalars['Boolean']['output']>;
  deleteTT500Company?: Maybe<Scalars['Boolean']['output']>;
  deleteTT500Person?: Maybe<Scalars['Boolean']['output']>;
  /** Remove only the caller's association for this token; safe to repeat. */
  deleteTvmPushToken: Scalars['Boolean']['output'];
  deleteUserFavoriteGroup?: Maybe<Scalars['Boolean']['output']>;
  deleteVgnArchiveArticle?: Maybe<Scalars['Boolean']['output']>;
  deleteVgnCarAd?: Maybe<Scalars['Boolean']['output']>;
  deleteVgnEvent?: Maybe<Scalars['Boolean']['output']>;
  deleteVgnEventCategory?: Maybe<Scalars['Boolean']['output']>;
  deleteVgnEventSection?: Maybe<Scalars['Boolean']['output']>;
  deleteVgnSheet?: Maybe<Scalars['Boolean']['output']>;
  deleteVod?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Detach a sub-tenant, making it a fully independent tenant.
   * The sub-tenant gets a trial period to set up its own subscription.
   */
  detachFairuSubTenant: FairuTenant;
  /** Duplicate a file */
  duplicateFairuFile?: Maybe<Scalars['Boolean']['output']>;
  enableUserAccount?: Maybe<EnableUserAccountResult>;
  /**
   * Get the proxy URL for a file by its path (no authentication required).
   *
   * Returns null if:
   * - The tenant or file doesn't exist
   * - The file is private
   * - The file has errors (if block_files_with_error is enabled)
   *
   * ## Example
   *
   * ```graphql
   * mutation {
   *   fairuFileUrlByPath(
   *     tenant: "550e8400-e29b-41d4-a716-446655440000"
   *     path: "/marketing/hero.jpg"
   *     width: 800
   *     quality: 80
   *   )
   * }
   * ```
   */
  fairuFileUrlByPath?: Maybe<Scalars['String']['output']>;
  /** Host only — end the session and freeze the results. */
  finishTvmMatchSession: TvmMatchSession;
  /** Get a presigned URL for uploading a specific part (for S3 Gateway use) */
  getFairuMultipartPartUrl: FairuMultipartPart;
  ignoreChannelShowtime?: Maybe<Scalars['ID']['output']>;
  /**
   * Import a podcast from its RSS feed as an audio channel with episodes.
   *
   * `url` is the feed, or a podigee.io podcast address — those resolve to their
   * feed and import identically. Running it again on the same feed updates the
   * channel it already made instead of creating a second one: episodes are
   * matched on the feed's own `<guid>`.
   *
   * Answers with the import, not with the channel. The feed belongs to somebody
   * else's server, so the work is queued and this returns as soon as it is —
   * read the import again for `status`, and for `message` when that is `failed`.
   */
  importFairuPodcast?: Maybe<FairuPodcastImport>;
  /** Initialize a multipart upload for large files (>5MB) */
  initFairuMultipartUpload: FairuMultipartUploadInit;
  /** Invite an user to the tenant */
  inviteFairuUser?: Maybe<Scalars['Boolean']['output']>;
  /** Join an open session with its short code. */
  joinTvmMatchSession: TvmMatchSession;
  leaveTvmMatchSession: TvmMatchSession;
  linkArticleToIssue?: Maybe<ArchiveIssue>;
  markImagesUploaded?: Maybe<VgnEvent>;
  /** Mark one of the caller's notifications read — or unread again. */
  markTvmNotificationRead: TvmNotification;
  /** Move a file */
  moveFairuFile?: Maybe<Scalars['Boolean']['output']>;
  /** Move a folder */
  moveFairuFolder?: Maybe<Scalars['Boolean']['output']>;
  moveUserFavorite?: Maybe<Array<Maybe<UserFavorite>>>;
  /** Queue the fan-out for one published article — once per user and article, however often it is called. */
  notifyTvmArticle: Scalars['Boolean']['output'];
  ping?: Maybe<Scalars['String']['output']>;
  pingAuthenticated?: Maybe<Scalars['String']['output']>;
  productsOffering?: Maybe<ProductsOfferingResult>;
  productsToPermissions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Make a field's private option list available to every other field */
  promoteFairuCatalog?: Maybe<FairuCatalog>;
  /**
   * Purge the delivery cache for files of this workspace.
   *
   * The API half of the /cache page, for the caller that needs it most: a CMS
   * that has just replaced the bytes behind an id knows exactly which files went
   * stale, and until now could do nothing with that.
   *
   * Answers as soon as the purges are queued, not when the edges are cold — the
   * work is a job per file. `queued` is what was found and dispatched, `missing`
   * is everything else: an id that does not exist, and an id belonging to another
   * workspace, which read the same on purpose.
   *
   * Rotates each file's etag along the way, so a CDN that kept the response
   * revalidates into a miss rather than being told its copy is still good.
   *
   * Up to 50 ids, refused rather than truncated above that. Requires
   * `cache::purge` — its own permission because a purge is cheap to ask for and
   * expensive to serve.
   */
  purgeFairuCache?: Maybe<FairuCachePurgeResult>;
  rateGustoRecipe?: Maybe<GustoRecipe>;
  /** Admin action — hand an already-booked event to a different photographer. */
  reassignVgnEvent?: Maybe<VgnEvent>;
  /** Trigger file download process */
  redownloadFairuFile?: Maybe<Scalars['Boolean']['output']>;
  /** Register an app install for push notifications, or replace what it follows. Idempotent per token. Public. */
  registerAppDevice: AppDeviceResult;
  /** Register or replace this installation's FCM token for the authenticated user. */
  registerTvmPushToken: Scalars['Boolean']['output'];
  /** Remove a listing from the editorial selection. Requires autorevue:marketplace-editor permission. */
  removeMarketplaceSelection?: Maybe<Scalars['Boolean']['output']>;
  /** Will remove the entry from favorites table */
  removeTvmFavorite?: Maybe<Scalars['Boolean']['output']>;
  removeTvmFavoriteMultiple?: Maybe<Scalars['Boolean']['output']>;
  removeUserFavorite?: Maybe<Scalars['Boolean']['output']>;
  removeUserFavoriteFromGroup?: Maybe<Scalars['Boolean']['output']>;
  /** Rename a file */
  renameFairuFile?: Maybe<FairuAsset>;
  /** Rename a folder */
  renameFairuFolder?: Maybe<FairuFolder>;
  /** Create an upload link to replace an existing file's content in S3 */
  replaceFairuFile?: Maybe<FairuUploadLink>;
  /** Logged-in user requests deletion of their login. Identity (email, name, Kundennummer) is read from the JWT, never from arguments, so no double-opt-in or ID upload is needed. Notifies Abo support; no data is deleted automatically. */
  requestAccountDeletion?: Maybe<CreateUserAccountResult>;
  requestVgnCarAdUploadUrl?: Maybe<VgnCarAdUpload>;
  resendActivationLink?: Maybe<CreateUserAccountResult>;
  resetUserPassword?: Maybe<ResetPasswordResult>;
  resolveHtml?: Maybe<Scalars['String']['output']>;
  /** Will trigger the resync for a movie */
  resyncMovie?: Maybe<Scalars['Boolean']['output']>;
  /** Will trigger the resync for a person */
  resyncPerson?: Maybe<Scalars['Boolean']['output']>;
  /** Will trigger the resync for a show */
  resyncShow?: Maybe<Scalars['Boolean']['output']>;
  /** Revoke Raku credentials (deactivate but keep for audit) */
  revokeFairuRakuCredential: Scalars['Boolean']['output'];
  /** Send app feedback to the fixed support mailbox; available to guests, rate-limited by IP. */
  sendTvmAppFeedback: Scalars['Boolean']['output'];
  /** Put one notification into one user's inbox. Requires notifications:send. */
  sendTvmNotification: TvmNotification;
  /**
   * Make a single asset public or private.
   *
   * The write half of the S3 gateway's ACL support: `Storage::setVisibility()`
   * reaches this through PutObjectAcl. Requires the `file::update` permission.
   *
   * Turning an asset private evicts it from the proxy cache, so the change takes
   * effect immediately rather than after the cached copy expires.
   */
  setFairuFileVisibility?: Maybe<FairuAsset>;
  /** Sets the password with the code from the reset mail and confirms the account */
  setPasswordWithCode?: Maybe<CreateUserAccountResult>;
  /** Sets the password from the reset link and confirms the account. Use this rather than Compax's customerSetPassword: only this service can resolve the address behind the user id, so only here can the account be confirmed. */
  setPasswordWithToken?: Maybe<CreateUserAccountResult>;
  setPromotionalCode?: Maybe<PromotionalCodeResult>;
  /** Ticks a movie or show on the watchlist off as seen (true) or takes the tick back (false). Answers null when the entity is not on the viewer's watchlist or is not a movie or show. */
  setTvmFavoriteSeen?: Maybe<TvmFavorite>;
  /** Will set the sorting for the favorite entries */
  setTvmFavoriteSorting?: Maybe<Array<Maybe<TvmFavorite>>>;
  /** Flag yourself ready in the lobby. */
  setTvmMatchReady: TvmMatchSession;
  setUserFavorite?: Maybe<UserFavorite>;
  setUserSetting?: Maybe<UserSetting>;
  sheetsRequestSetUpload?: Maybe<VgnSheetUpload>;
  sheetsRequestUploadPath?: Maybe<SheetsUploadRequest>;
  /** Start a pdf signatur request */
  startFairuPdfSignatureRequest?: Maybe<FairuFilePdfSignatureRequest>;
  /** Host only — freeze the deck and begin swiping. */
  startTvmMatchSession: TvmMatchSession;
  submitContact?: Maybe<Scalars['Boolean']['output']>;
  /** GDPR data-subject request (Betroffenenrechte). Double-opt-in; upload follows after confirmation. */
  submitDataSubjectRequest?: Maybe<CreateUserAccountResult>;
  submitRevocation?: Maybe<CreateUserAccountResult>;
  submitRevocationAuthenticated?: Maybe<CreateUserAccountResult>;
  /** Persist a completed survey/calculator submission for the authenticated user (append-only). */
  submitSurveyResponse?: Maybe<SubmitSurveyResponseResult>;
  subscribeToNewsletter?: Maybe<NewsletterSubscriptionResult>;
  subscribeToNewsletterBrevo?: Maybe<NewsletterSubscriptionResult>;
  subscribeToNewsletterCustomerIo?: Maybe<NewsletterSubscriptionResult>;
  subscribeToNewsletters?: Maybe<Array<NewsletterSubscriptionResult>>;
  subscribeToNewslettersBrevo?: Maybe<Array<NewsletterSubscriptionResult>>;
  subscribeToNewslettersCustomerIo?: Maybe<Array<NewsletterSubscriptionResult>>;
  /** Swipe one card. Re-swiping the same card replaces the session vote and appends a new decision. */
  swipeTvmMatch: TvmMatchSwipeResult;
  /**
   * Refresh a catalog from the URL it points at.
   *
   * Answers as soon as the work is queued — the fetch is somebody else's server.
   * Read `last_sync_status` on the catalog for the result: `running`, `ok`, or
   * `failed` with `last_sync_message` saying why.
   *
   * The source has to answer with a list of options, as JSON or CSV:
   *
   * ```json
   * {"entries": [{"value": "de", "label": "Germany", "position": 0}]}
   * ```
   *
   * A bare array works, as does a bare list of strings, and `data`/`items`/
   * `results` are accepted as wrappers. In CSV the columns are found by header
   * name, or taken as value,label,position when there is no header. Only `value`
   * is required. A source that answers with nothing usable is refused rather
   * than emptying the catalog.
   */
  syncFairuCatalog?: Maybe<FairuCatalog>;
  /** Record a user activity for the points/bonus system (logged-in only). */
  trackActivity?: Maybe<Scalars['Boolean']['output']>;
  transformChannelShowtime?: Maybe<Scalars['ID']['output']>;
  /** Remove block a file */
  unblockFairuFile?: Maybe<Scalars['Boolean']['output']>;
  unbookVgnEvent?: Maybe<VgnEvent>;
  /** Forget an app install. Always answers true. Public. */
  unregisterAppDevice: Scalars['Boolean']['output'];
  unsubscribeFromNewsletter?: Maybe<Scalars['Boolean']['output']>;
  unsubscribeFromNewsletterBrevo?: Maybe<Scalars['Boolean']['output']>;
  updateArchiveIssue?: Maybe<ArchiveIssue>;
  updateBasketAddresses?: Maybe<UpdateBasketAddressesResult>;
  updateCarBrand?: Maybe<VgnCarBrand>;
  updateCarModel?: Maybe<VgnCarModel>;
  updateChannel?: Maybe<TvChannel>;
  updateCinema?: Maybe<Cinema>;
  updateEpisode?: Maybe<Episode>;
  /** Update a backup target. Changing its folder or path re-plans the mirror from scratch; what is already at the old target is left alone. */
  updateFairuBackup?: Maybe<FairuBackup>;
  /** Update a metadata blueprint. Changing its fieldsets changes which fields every asset below it has. */
  updateFairuBlueprint?: Maybe<FairuBlueprint>;
  /** Update a catalog */
  updateFairuCatalog?: Maybe<FairuCatalog>;
  /** Update an option. Archiving retires it without touching the assets that carry it. */
  updateFairuCatalogEntry?: Maybe<FairuCatalogEntry>;
  /** Update a copyright */
  updateFairuCopyright?: Maybe<FairuCopyright>;
  /** Update a sync disk and it's meta data */
  updateFairuDisk?: Maybe<FairuDisk>;
  /** Create a dcma complain */
  updateFairuDmcaComplain?: Maybe<FairuDmca>;
  /** Update a field. A type may only change where the stored values survive it. */
  updateFairuField?: Maybe<FairuField>;
  /** Update a fieldset */
  updateFairuFieldset?: Maybe<FairuFieldset>;
  /** Update meta data for a file */
  updateFairuFile?: Maybe<FairuAsset>;
  /**
   * Write the same metadata to many assets at once.
   *
   * Returns the number of assets updated. Refused as a whole if any value is
   * invalid for its field, so a bad option cannot leave half a selection written.
   */
  updateFairuFilesMetadata?: Maybe<Scalars['Int']['output']>;
  /** Update a folder and it's meta data */
  updateFairuFolder?: Maybe<FairuFolder>;
  /** Update a gallery and it's meta data */
  updateFairuGallery?: Maybe<FairuGallery>;
  /** Change one gallery image's caption in Fairu. Requires the portal_{portal} permission; the image must belong to a gallery of that portal's Fairu tenant. Currently enabled for portal news only. */
  updateFairuImageCaption?: Maybe<FairuCaptionUpdateResult>;
  /** Rename, recolour or reorder a label. Its handle never changes — integrations filter on it. */
  updateFairuLabel?: Maybe<FairuLabel>;
  /** Update a license */
  updateFairuLicense?: Maybe<FairuLicense>;
  /** Update a role */
  updateFairuRole?: Maybe<FairuRole>;
  /** Update a tag */
  updateFairuTag?: Maybe<FairuTag>;
  /**
   * Update the current tenant's settings.
   *
   * Requires the `tenant::update` permission on the current tenant.
   * All fields are optional - only provided fields will be updated.
   *
   * ## Example
   *
   * ```graphql
   * mutation {
   *   updateFairuTenant(
   *     name: "My Renamed Workspace"
   *     use_ai: true
   *     force_file_alt: true
   *   ) {
   *     id
   *     name
   *     use_ai
   *   }
   * }
   * ```
   */
  updateFairuTenant?: Maybe<FairuTenant>;
  updateFairuVideoChannel?: Maybe<FairuVideoChannel>;
  /** Update a webhook */
  updateFairuWebhook?: Maybe<FairuWebhook>;
  /** Update a workflow and it's meta data */
  updateFairuWorkflow?: Maybe<FairuWorkflow>;
  updateGenre?: Maybe<Genre>;
  updateGustoCategory?: Maybe<GustoRecipeCategory>;
  updateGustoCountry?: Maybe<GustoCountry>;
  updateGustoIngredient?: Maybe<GustoIngredient>;
  updateGustoIssue?: Maybe<GustoIssue>;
  updateGustoOccasion?: Maybe<GustoOccasion>;
  updateGustoRecipe?: Maybe<GustoRecipe>;
  updateGustoRecipeProperty?: Maybe<GustoRecipeProperty>;
  updateGustoTip?: Maybe<GustoTip>;
  updateLawSurvey?: Maybe<LawCompany>;
  /** Update position or notes for an existing editorial selection. Requires autorevue:marketplace-editor permission. */
  updateMarketplaceSelection?: Maybe<MarketplaceEditorialSelection>;
  updateMooncalendar?: Maybe<MoonCalendarDay>;
  updateMovie?: Maybe<Movie>;
  /** Update topic preferences using only the authenticated user's email. Does not change global unsubscribe or marketing consent. */
  updateMyNewsletterPreferencesCustomerIo: NewsletterPreferencesUpdateResult;
  updatePerson?: Maybe<Person>;
  updatePersonables?: Maybe<Scalars['Boolean']['output']>;
  updateProvider?: Maybe<Provider>;
  updateQuote?: Maybe<Scalars['String']['output']>;
  updateShow?: Maybe<Show>;
  updateTT500BankFinancialsBackend?: Maybe<Tt500BankBackend>;
  updateTT500Company?: Maybe<Tt500Company>;
  updateTT500CompanyBackend?: Maybe<Tt500CompanyBackend>;
  updateTT500CompanyFinancialsBackend?: Maybe<Tt500CompanyBackend>;
  updateTT500InsuranceFinancialsBackend?: Maybe<Tt500InsuranceBackend>;
  updateTT500Person?: Maybe<Tt500Person>;
  updateTvmPushPreferences: TvmPushPreferences;
  updateUserFavoriteGroup?: Maybe<UserFavoriteGroup>;
  updateVgnArchiveArticle?: Maybe<VgnArchiveArticle>;
  updateVgnCarAd?: Maybe<VgnCarAd>;
  updateVgnEvent?: Maybe<VgnEvent>;
  updateVgnEventCategory?: Maybe<VgnEventCategory>;
  updateVgnEventSection?: Maybe<VgnEventSection>;
  updateVgnSheet?: Maybe<VgnSheet>;
  updateVod?: Maybe<Vod>;
  /** Upload identity documents (base64) for a confirmed request. Token-gated; at least one document required. */
  uploadDataSubjectDocuments?: Maybe<CreateUserAccountResult>;
  /** Checks the code from the reset mail (template code); a wrong code costs one of 5 tries */
  verifyPasswordResetCode?: Maybe<CreateUserAccountResult>;
  vgnChangePassword?: Maybe<VgnAuthResult>;
  vgnConfirm?: Maybe<VgnAuthResult>;
  vgnCreateUser?: Maybe<VgnAuthResult>;
  vgnLogin?: Maybe<VgnLoginResult>;
  vgnRefreshToken?: Maybe<VgnLoginResult>;
  vgnRegister?: Maybe<VgnAuthResult>;
  vgnRequestPasswordReset?: Maybe<VgnAuthResult>;
  vgnResendActivation?: Maybe<VgnAuthResult>;
  vgnResetPassword?: Maybe<VgnAuthResult>;
  vgnUpdateUser?: Maybe<VgnAuthResult>;
};


export type MutationAbortFairuMultipartUploadArgs = {
  fileId: Scalars['ID']['input'];
  uploadId: Scalars['String']['input'];
};


export type MutationAckTvmMatchEventArgs = {
  seq: Scalars['Int']['input'];
  sessionId: Scalars['ID']['input'];
};


export type MutationAddMarketplaceSelectionArgs = {
  listingId: Scalars['String']['input'];
  listingSnapshot?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationAddReportToTt500CompanyArgs = {
  company?: InputMaybe<Scalars['String']['input']>;
  data?: InputMaybe<Tt500CompanyReport>;
};


export type MutationAnnounceEpaperIssueArgs = {
  issue: Scalars['String']['input'];
  portal: Scalars['String']['input'];
};


export type MutationArchiveFairuFileArgs = {
  id: Scalars['ID']['input'];
};


export type MutationArticleCreateArgs = {
  data?: InputMaybe<CreateArticle>;
};


export type MutationArticleResetArgs = {
  apa_id?: InputMaybe<Scalars['String']['input']>;
  import_id?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAuthorizeTvmMatchChannelArgs = {
  channel: Scalars['String']['input'];
  socketId: Scalars['String']['input'];
};


export type MutationBlockFairuFileArgs = {
  id: Scalars['ID']['input'];
};


export type MutationBookVgnEventArgs = {
  eventId: Scalars['ID']['input'];
};


export type MutationCancelFairuPdfSignatureRequestArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCheckValidProductArgs = {
  product?: InputMaybe<Scalars['String']['input']>;
};


export type MutationClearCacheArgs = {
  portal: Scalars['String']['input'];
  url?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCloseTvmMatchLobbyArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCompaxLoginArgs = {
  password: Scalars['String']['input'];
  portal: Scalars['String']['input'];
  username: Scalars['String']['input'];
};


export type MutationCompleteFairuMultipartUploadArgs = {
  fileId: Scalars['ID']['input'];
  parts: Array<FairuMultipartPartInput>;
  uploadId: Scalars['String']['input'];
};


export type MutationConfirmDataSubjectRequestArgs = {
  token: Scalars['String']['input'];
};


export type MutationConfirmRevocationArgs = {
  token: Scalars['String']['input'];
};


export type MutationCreateArchiveIssueArgs = {
  data: CreateArchiveIssue;
};


export type MutationCreateCarBrandArgs = {
  data: VgnCreateCarBrand;
};


export type MutationCreateCarModelArgs = {
  data: VgnCreateCarModel;
};


export type MutationCreateFairuBackupArgs = {
  data: FairuBackupDto;
};


export type MutationCreateFairuBlueprintArgs = {
  data: FairuBlueprintDto;
};


export type MutationCreateFairuCatalogArgs = {
  data: FairuCatalogDto;
};


export type MutationCreateFairuCatalogEntryArgs = {
  data: FairuCatalogEntryDto;
};


export type MutationCreateFairuCopyrightArgs = {
  data: FairuCopyrightDto;
};


export type MutationCreateFairuDiskArgs = {
  data: FairuDiskDto;
};


export type MutationCreateFairuDmcaComplainArgs = {
  data: FairuDmcaComplainDto;
};


export type MutationCreateFairuFieldArgs = {
  data: FairuFieldDto;
};


export type MutationCreateFairuFieldsetArgs = {
  data: FairuFieldsetDto;
};


export type MutationCreateFairuFileAccessSignatureArgs = {
  ids: Array<Scalars['ID']['input']>;
  valid_for_minutes?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationCreateFairuFolderArgs = {
  data: FairuFolderDto;
};


export type MutationCreateFairuFolderFtpArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCreateFairuFolderUploadShareLinkArgs = {
  expires_in?: InputMaybe<FairuUploadShareLinkExpiration>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateFairuGalleryArgs = {
  data: FairuGalleryDto;
};


export type MutationCreateFairuGalleryShareLinkArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCreateFairuLabelArgs = {
  data: FairuLabelDto;
};


export type MutationCreateFairuLicenseArgs = {
  data: FairuLicenseDto;
};


export type MutationCreateFairuPdfSignatureRequestArgs = {
  data: FairuFilePdfSignatureRequestDto;
};


export type MutationCreateFairuRakuCredentialArgs = {
  bucket?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  permissions: Array<Scalars['String']['input']>;
};


export type MutationCreateFairuRoleArgs = {
  data: FairuRoleDto;
};


export type MutationCreateFairuSubTenantArgs = {
  name: Scalars['String']['input'];
};


export type MutationCreateFairuTagArgs = {
  data: FairuTagDto;
};


export type MutationCreateFairuTenantArgs = {
  name: Scalars['String']['input'];
};


export type MutationCreateFairuUploadLinkArgs = {
  alt?: InputMaybe<Scalars['String']['input']>;
  caption?: InputMaybe<Scalars['String']['input']>;
  copyright?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  download_url?: InputMaybe<Scalars['String']['input']>;
  fileSize?: InputMaybe<Scalars['Int']['input']>;
  filename: Scalars['String']['input'];
  focal_point?: InputMaybe<Scalars['String']['input']>;
  folder?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<FairuUploadType>;
};


export type MutationCreateFairuVideoChannelArgs = {
  input: FairuVideoChannelInput;
};


export type MutationCreateFairuVideoChannelEpisodeArgs = {
  input: FairuVideoChannelEpisodeInput;
  season: Scalars['ID']['input'];
};


export type MutationCreateFairuVideoChannelSeasonArgs = {
  channel: Scalars['ID']['input'];
  input: FairuVideoChannelSeasonInput;
};


export type MutationCreateFairuWebhookArgs = {
  data: FairuWebhookDto;
};


export type MutationCreateFairuWorkflowArgs = {
  data: FairuWorkflowDto;
};


export type MutationCreateGenreArgs = {
  data?: InputMaybe<InputGenre>;
};


export type MutationCreateGustoCategoryArgs = {
  data: CreateGustoCategory;
};


export type MutationCreateGustoCountryArgs = {
  data: CreateGustoCountry;
};


export type MutationCreateGustoIngredientArgs = {
  data: CreateGustoIngredient;
};


export type MutationCreateGustoIssueArgs = {
  data: CreateGustoIssue;
};


export type MutationCreateGustoOccasionArgs = {
  data: CreateGustoOccasion;
};


export type MutationCreateGustoRecipeArgs = {
  data: CreateGustoRecipe;
};


export type MutationCreateGustoRecipePropertyArgs = {
  data: CreateGustoProperty;
};


export type MutationCreateGustoTipArgs = {
  data: CreateGustoTip;
};


export type MutationCreateMailRequestArgs = {
  data?: InputMaybe<CreateMailRequestInput>;
};


export type MutationCreateMergeUserNotificationArgs = {
  id: Scalars['Int']['input'];
  prev_id: Scalars['Int']['input'];
};


export type MutationCreateMooncalendarArgs = {
  data?: InputMaybe<CreateMooncalendarInput>;
};


export type MutationCreateMovieArgs = {
  data?: InputMaybe<InputMovie>;
};


export type MutationCreateProviderArgs = {
  data?: InputMaybe<InputProvider>;
};


export type MutationCreateShowArgs = {
  data?: InputMaybe<InputShow>;
};


export type MutationCreateTt500CompanyArgs = {
  data?: InputMaybe<Tt500CreateCompany>;
};


export type MutationCreateTt500PersonArgs = {
  data?: InputMaybe<Tt500CreatePerson>;
};


export type MutationCreateTvmFavoriteArgs = {
  entity?: InputMaybe<Scalars['ID']['input']>;
  showtime?: InputMaybe<Scalars['ID']['input']>;
  type: TvmFavoriteType;
};


export type MutationCreateTvmFavoriteMultipleArgs = {
  data?: InputMaybe<Array<TvmFavoriteData>>;
};


export type MutationCreateTvmMatchSessionArgs = {
  deckOrder?: InputMaybe<TvmMatchDeckOrder>;
  entityIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  entityTypes?: InputMaybe<Array<TvmMatchEntityType>>;
  genres?: InputMaybe<Array<Scalars['ID']['input']>>;
  matchThreshold?: InputMaybe<Scalars['Int']['input']>;
  maxParticipants?: InputMaybe<Scalars['Int']['input']>;
  mode?: TvmMatchSourceMode;
  name?: InputMaybe<Scalars['String']['input']>;
  onlyWithAsset?: InputMaybe<Scalars['Boolean']['input']>;
  providers?: InputMaybe<Array<Scalars['String']['input']>>;
  revealSwipes?: InputMaybe<Scalars['Boolean']['input']>;
  sourceRef?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateUserAccountArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  portal?: InputMaybe<UserSettingPortal>;
  salutation: CustomerSalutation;
  sendMail?: InputMaybe<Scalars['Boolean']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateUserFavoriteGroupArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
  parent?: InputMaybe<Scalars['ID']['input']>;
  portal: UserSettingPortal;
  sort?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationCreateUserFeedbackArgs = {
  body: Scalars['String']['input'];
  customerId: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  portal?: InputMaybe<UserSettingPortal>;
  subject: Scalars['String']['input'];
};


export type MutationCreateVgnCarAdArgs = {
  data?: InputMaybe<VgnCreateCarAd>;
};


export type MutationCreateVgnEventArgs = {
  data?: InputMaybe<VgnCreateEvent>;
};


export type MutationCreateVgnEventCategoryArgs = {
  data?: InputMaybe<VgnCreateEventCategory>;
};


export type MutationCreateVgnEventSectionArgs = {
  data?: InputMaybe<VgnCreateEventSection>;
};


export type MutationCreateVgnSheetArgs = {
  data?: InputMaybe<VgnSheetInput>;
};


export type MutationCreateVodArgs = {
  data?: InputMaybe<InputVod>;
};


export type MutationCustomerBasketArgs = {
  basketId: Scalars['String']['input'];
  basketUuid: Scalars['String']['input'];
  paymentMethod?: InputMaybe<PaymentMethodInput>;
  suppressBillSending?: InputMaybe<Scalars['Boolean']['input']>;
  vatIdNumber?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCustomerChangeDataArgs = {
  birthday?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  companyName2?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<CustomerEmailInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<CustomerPhoneInput>;
  preferredContactType?: InputMaybe<CustomerStatusInput>;
  salutation?: InputMaybe<CustomerStatusInput>;
};


export type MutationCustomerChangePasswordArgs = {
  newPassword: Scalars['String']['input'];
  newPasswordConfirm: Scalars['String']['input'];
  oldPassword: Scalars['String']['input'];
};


export type MutationCustomerCheckEmailExistsArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCustomerConfirmArgs = {
  username: Scalars['String']['input'];
};


export type MutationCustomerCreateAnonymousArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  portal: Scalars['String']['input'];
  salutation: CustomerSalutation;
  terms?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCustomerDeliveryAddressChangeArgs = {
  address?: InputMaybe<CustomerVacationAddressInput>;
  contractId: Scalars['String']['input'];
  existingAddressId?: InputMaybe<Scalars['String']['input']>;
  from: Scalars['String']['input'];
};


export type MutationCustomerDeliveryComplaintsContractAddArgs = {
  contractId: Scalars['String']['input'];
  issueIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  reasonId: Scalars['Int']['input'];
};


export type MutationCustomerDeliverySuspensionsContractAddArgs = {
  contractId: Scalars['String']['input'];
  from: Scalars['String']['input'];
  reasonId: Scalars['Int']['input'];
  to: Scalars['String']['input'];
};


export type MutationCustomerDeliverySuspensionsContractChangeArgs = {
  from: Scalars['String']['input'];
  suspensionId: Scalars['String']['input'];
  to: Scalars['String']['input'];
};


export type MutationCustomerLoginArgs = {
  password: Scalars['String']['input'];
  portal?: InputMaybe<Scalars['String']['input']>;
  username: Scalars['String']['input'];
};


export type MutationCustomerLoginPreArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  portal?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCustomerRefreshTokenArgs = {
  token: Scalars['String']['input'];
};


export type MutationCustomerRegisterFromCustomerArgs = {
  customerId: Scalars['String']['input'];
  email: Scalars['String']['input'];
  gdpr?: InputMaybe<Scalars['Boolean']['input']>;
  lastName: Scalars['String']['input'];
  password: Scalars['String']['input'];
  passwordConfirmation?: InputMaybe<Scalars['String']['input']>;
  postalCode: Scalars['String']['input'];
  terms?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCustomerRegisterUnconfirmedArgs = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  password: Scalars['String']['input'];
  passwordConfirmation: Scalars['String']['input'];
  portal: Scalars['String']['input'];
  salutation: CustomerSalutation;
  terms: Scalars['Boolean']['input'];
  unconfirmed?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCustomerResetPasswordArgs = {
  email: Scalars['String']['input'];
};


export type MutationCustomerSetPasswordArgs = {
  password: Scalars['String']['input'];
  passwordConfirmation: Scalars['String']['input'];
  token: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationCustomerUpdateBasicArgs = {
  birthday?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<CustomerEmailInput>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  salutation: CustomerStatusInput;
};


export type MutationCustomerUpdateMarketingConsentArgs = {
  portal: Scalars['String']['input'];
};


export type MutationCustomerUpdateStripeEmailArgs = {
  email: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  stripeCustomerId: Scalars['String']['input'];
};


export type MutationCustomerVacationAddressAddArgs = {
  address?: InputMaybe<CustomerVacationAddressInput>;
  contractId: Scalars['String']['input'];
  existingAddressId?: InputMaybe<Scalars['String']['input']>;
  from: Scalars['String']['input'];
  to: Scalars['String']['input'];
};


export type MutationCustomerVacationAddressRedirectArgs = {
  from: Scalars['String']['input'];
  redirectId: Scalars['String']['input'];
  to: Scalars['String']['input'];
};


export type MutationDeleteArchiveIssueArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCarBrandArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCarModelArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteChannelArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCinemaArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteEpisodeArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteFairuBackupArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteFairuBlueprintArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteFairuCatalogArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteFairuCatalogEntryArgs = {
  force?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationDeleteFairuCopyrightArgs = {
  deleteAssets?: InputMaybe<Scalars['Boolean']['input']>;
  deleteLicenses?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationDeleteFairuDiskArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteFairuFieldArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteFairuFieldsetArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteFairuFileArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteFairuFolderArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteFairuGalleryArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteFairuLabelArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteFairuLicenseArgs = {
  deleteAssets?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationDeleteFairuRakuCredentialArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteFairuRoleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteFairuTagArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteFairuUserArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteFairuVideoChannelArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteFairuWebhooksArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteFairuWorkflowArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteGenreArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteGustoCategoryArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteGustoCountryArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteGustoIngredientArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteGustoIssueArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteGustoOccasionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteGustoRecipeArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteGustoRecipePropertyArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteGustoTipArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteMailRequestArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteMovieArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePersonArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationDeleteProviderArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteQuoteArgs = {
  data?: InputMaybe<InputQuote>;
};


export type MutationDeleteShowArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTt500CompanyArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeleteTt500PersonArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeleteTvmPushTokenArgs = {
  token: Scalars['String']['input'];
};


export type MutationDeleteUserFavoriteGroupArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteVgnArchiveArticleArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeleteVgnCarAdArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteVgnEventArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteVgnEventCategoryArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteVgnEventSectionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteVgnSheetArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeleteVodArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDetachFairuSubTenantArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDuplicateFairuFileArgs = {
  id: Scalars['ID']['input'];
  parent?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationEnableUserAccountArgs = {
  token: Scalars['String']['input'];
};


export type MutationFairuFileUrlByPathArgs = {
  focal_point?: InputMaybe<Scalars['String']['input']>;
  height?: InputMaybe<Scalars['Int']['input']>;
  path: Scalars['String']['input'];
  quality?: InputMaybe<Scalars['Int']['input']>;
  tenant: Scalars['ID']['input'];
  version?: InputMaybe<FairuAssetVideoVersions>;
  width?: InputMaybe<Scalars['Int']['input']>;
  withStoredFocalPoint?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationFinishTvmMatchSessionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationGetFairuMultipartPartUrlArgs = {
  fileId: Scalars['ID']['input'];
  partNumber: Scalars['Int']['input'];
  uploadId: Scalars['String']['input'];
};


export type MutationIgnoreChannelShowtimeArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationImportFairuPodcastArgs = {
  url: Scalars['String']['input'];
};


export type MutationInitFairuMultipartUploadArgs = {
  alt?: InputMaybe<Scalars['String']['input']>;
  caption?: InputMaybe<Scalars['String']['input']>;
  contentType?: InputMaybe<Scalars['String']['input']>;
  copyright?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fileSize?: InputMaybe<Scalars['Int']['input']>;
  filename: Scalars['String']['input'];
  folder?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationInviteFairuUserArgs = {
  email: Scalars['String']['input'];
  role: Scalars['ID']['input'];
};


export type MutationJoinTvmMatchSessionArgs = {
  code: Scalars['String']['input'];
};


export type MutationLeaveTvmMatchSessionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationLinkArticleToIssueArgs = {
  articleId: Scalars['String']['input'];
  issueOriginId: Scalars['String']['input'];
  migrationToken: Scalars['String']['input'];
};


export type MutationMarkImagesUploadedArgs = {
  eventId: Scalars['ID']['input'];
};


export type MutationMarkTvmNotificationReadArgs = {
  id: Scalars['ID']['input'];
  read?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationMoveFairuFileArgs = {
  id: Scalars['ID']['input'];
  parent?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationMoveFairuFolderArgs = {
  id: Scalars['ID']['input'];
  parent?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationMoveUserFavoriteArgs = {
  entity_id: Scalars['ID']['input'];
  group_id?: InputMaybe<Scalars['ID']['input']>;
  portal?: InputMaybe<UserSettingPortal>;
};


export type MutationNotifyTvmArticleArgs = {
  articleId: Scalars['ID']['input'];
  path: Scalars['String']['input'];
  title: Scalars['String']['input'];
  userIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type MutationPingArgs = {
  value?: InputMaybe<Scalars['String']['input']>;
};


export type MutationPingAuthenticatedArgs = {
  value?: InputMaybe<Scalars['String']['input']>;
};


export type MutationProductsOfferingArgs = {
  marketingCode: Scalars['String']['input'];
  offeringId: Scalars['String']['input'];
};


export type MutationProductsToPermissionsArgs = {
  products?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationPromoteFairuCatalogArgs = {
  id: Scalars['ID']['input'];
};


export type MutationPurgeFairuCacheArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationRateGustoRecipeArgs = {
  nonce: Scalars['String']['input'];
  rating: Scalars['Int']['input'];
  recipe: Scalars['ID']['input'];
  turnstileToken?: InputMaybe<Scalars['String']['input']>;
};


export type MutationReassignVgnEventArgs = {
  eventId: Scalars['ID']['input'];
  newPhotographerEmail: Scalars['String']['input'];
};


export type MutationRedownloadFairuFileArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRegisterAppDeviceArgs = {
  channels: Array<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  platform: Scalars['String']['input'];
  portal: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationRegisterTvmPushTokenArgs = {
  installationId: Scalars['ID']['input'];
  platform: TvmPushPlatform;
  token: Scalars['String']['input'];
};


export type MutationRemoveMarketplaceSelectionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveTvmFavoriteArgs = {
  entity?: InputMaybe<Scalars['ID']['input']>;
  showtime?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationRemoveTvmFavoriteMultipleArgs = {
  entityIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  showtimeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type MutationRemoveUserFavoriteArgs = {
  entity_id: Scalars['ID']['input'];
};


export type MutationRemoveUserFavoriteFromGroupArgs = {
  entities?: InputMaybe<Array<Scalars['ID']['input']>>;
  group?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationRenameFairuFileArgs = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};


export type MutationRenameFairuFolderArgs = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};


export type MutationReplaceFairuFileArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRequestAccountDeletionArgs = {
  portal: UserSettingPortal;
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRequestVgnCarAdUploadUrlArgs = {
  filename?: InputMaybe<Scalars['String']['input']>;
};


export type MutationResendActivationLinkArgs = {
  email: Scalars['String']['input'];
  portal?: InputMaybe<UserSettingPortal>;
};


export type MutationResetUserPasswordArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  portal?: InputMaybe<UserSettingPortal>;
  template?: InputMaybe<Scalars['String']['input']>;
};


export type MutationResolveHtmlArgs = {
  html?: InputMaybe<Scalars['String']['input']>;
};


export type MutationResyncMovieArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type MutationResyncPersonArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type MutationResyncShowArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRevokeFairuRakuCredentialArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSendTvmAppFeedbackArgs = {
  comment?: InputMaybe<Scalars['String']['input']>;
  platform: Scalars['String']['input'];
  rating: Scalars['Int']['input'];
};


export type MutationSendTvmNotificationArgs = {
  body?: InputMaybe<Scalars['String']['input']>;
  dedupeKey?: InputMaybe<Scalars['String']['input']>;
  payload?: InputMaybe<Scalars['String']['input']>;
  remindAt?: InputMaybe<Scalars['DateTime']['input']>;
  title: Scalars['String']['input'];
  type?: InputMaybe<TvmNotificationType>;
  userId: Scalars['ID']['input'];
};


export type MutationSetFairuFileVisibilityArgs = {
  id: Scalars['ID']['input'];
  private: Scalars['Boolean']['input'];
};


export type MutationSetPasswordWithCodeArgs = {
  code: Scalars['String']['input'];
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type MutationSetPasswordWithTokenArgs = {
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationSetPromotionalCodeArgs = {
  basketId: Scalars['String']['input'];
  basketUuid: Scalars['String']['input'];
  promotionalCode: Scalars['String']['input'];
};


export type MutationSetTvmFavoriteSeenArgs = {
  entity: Scalars['ID']['input'];
  seen?: Scalars['Boolean']['input'];
};


export type MutationSetTvmFavoriteSortingArgs = {
  entities?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  showtimes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  type: TvmFavoriteType;
};


export type MutationSetTvmMatchReadyArgs = {
  id: Scalars['ID']['input'];
  ready?: Scalars['Boolean']['input'];
};


export type MutationSetUserFavoriteArgs = {
  entity_id: Scalars['ID']['input'];
  group_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  order?: InputMaybe<Scalars['Int']['input']>;
  portal: UserSettingPortal;
  type: UserFavoriteType;
};


export type MutationSetUserSettingArgs = {
  data?: InputMaybe<CreateUserSettingEntry>;
};


export type MutationSheetsRequestSetUploadArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSheetsRequestUploadPathArgs = {
  name: Scalars['String']['input'];
};


export type MutationStartFairuPdfSignatureRequestArgs = {
  id: Scalars['ID']['input'];
};


export type MutationStartTvmMatchSessionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSubmitContactArgs = {
  email: Scalars['String']['input'];
  fields?: InputMaybe<Array<ContactFormField>>;
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  text: Scalars['String']['input'];
};


export type MutationSubmitDataSubjectRequestArgs = {
  additionalInfo?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  formToken?: InputMaybe<Scalars['String']['input']>;
  lastName: Scalars['String']['input'];
  origin?: InputMaybe<Scalars['String']['input']>;
  portal: Scalars['String']['input'];
  type: Scalars['String']['input'];
  website?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSubmitRevocationArgs = {
  additionalInfo?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  origin?: InputMaybe<Scalars['String']['input']>;
  portal: Scalars['String']['input'];
  street: Scalars['String']['input'];
  zip: Scalars['String']['input'];
};


export type MutationSubmitRevocationAuthenticatedArgs = {
  additionalInfo?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  portal: Scalars['String']['input'];
  street: Scalars['String']['input'];
  zip: Scalars['String']['input'];
};


export type MutationSubmitSurveyResponseArgs = {
  answers: Scalars['String']['input'];
  meta?: InputMaybe<Scalars['String']['input']>;
  portal?: InputMaybe<Scalars['String']['input']>;
  schemaVersion?: InputMaybe<Scalars['String']['input']>;
  surveyKey: Scalars['String']['input'];
};


export type MutationSubscribeToNewsletterArgs = {
  acceptMarketing?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstname?: InputMaybe<Scalars['String']['input']>;
  lastname?: InputMaybe<Scalars['String']['input']>;
  newsletter?: InputMaybe<Scalars['ID']['input']>;
  salutation?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSubscribeToNewsletterBrevoArgs = {
  acceptMarketing?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstname?: InputMaybe<Scalars['String']['input']>;
  lastname?: InputMaybe<Scalars['String']['input']>;
  newsletter?: InputMaybe<Scalars['ID']['input']>;
  salutation?: InputMaybe<Scalars['String']['input']>;
  skipDoubleOptIn?: InputMaybe<Scalars['Boolean']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSubscribeToNewsletterCustomerIoArgs = {
  acceptMarketing?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstname?: InputMaybe<Scalars['String']['input']>;
  lastname?: InputMaybe<Scalars['String']['input']>;
  newsletter?: InputMaybe<Scalars['ID']['input']>;
  salutation?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSubscribeToNewslettersArgs = {
  data?: InputMaybe<Array<SubscribeToNewsletterData>>;
};


export type MutationSubscribeToNewslettersBrevoArgs = {
  data?: InputMaybe<Array<SubscribeToNewsletterData>>;
};


export type MutationSubscribeToNewslettersCustomerIoArgs = {
  data?: InputMaybe<Array<SubscribeToNewsletterData>>;
};


export type MutationSwipeTvmMatchArgs = {
  direction: TvmMatchSwipeDirection;
  entity: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


export type MutationSyncFairuCatalogArgs = {
  id: Scalars['ID']['input'];
};


export type MutationTrackActivityArgs = {
  meta?: InputMaybe<Scalars['String']['input']>;
  portal: UserSettingPortal;
  subjectId?: InputMaybe<Scalars['String']['input']>;
  type: PointEventType;
};


export type MutationTransformChannelShowtimeArgs = {
  data?: InputMaybe<TvmTransformChannelShowtime>;
};


export type MutationUnblockFairuFileArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUnbookVgnEventArgs = {
  eventId: Scalars['ID']['input'];
};


export type MutationUnregisterAppDeviceArgs = {
  token: Scalars['String']['input'];
};


export type MutationUnsubscribeFromNewsletterArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  newsletter?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUnsubscribeFromNewsletterBrevoArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  newsletter?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUpdateArchiveIssueArgs = {
  data: UpdateArchiveIssue;
};


export type MutationUpdateBasketAddressesArgs = {
  basketId: Scalars['String']['input'];
  basketUuid: Scalars['String']['input'];
  billingAddress?: InputMaybe<BasketAddressInput>;
  shippingAddress?: InputMaybe<BasketAddressInput>;
};


export type MutationUpdateCarBrandArgs = {
  data: VgnUpdateCarBrand;
};


export type MutationUpdateCarModelArgs = {
  data: VgnUpdateCarModel;
};


export type MutationUpdateChannelArgs = {
  data?: InputMaybe<InputChannel>;
};


export type MutationUpdateCinemaArgs = {
  data?: InputMaybe<InputCinema>;
};


export type MutationUpdateEpisodeArgs = {
  data?: InputMaybe<InputEpisode>;
};


export type MutationUpdateFairuBackupArgs = {
  data: FairuBackupDto;
};


export type MutationUpdateFairuBlueprintArgs = {
  data: FairuBlueprintDto;
};


export type MutationUpdateFairuCatalogArgs = {
  data: FairuCatalogDto;
};


export type MutationUpdateFairuCatalogEntryArgs = {
  data: FairuCatalogEntryDto;
};


export type MutationUpdateFairuCopyrightArgs = {
  data: FairuCopyrightDto;
};


export type MutationUpdateFairuDiskArgs = {
  data: FairuDiskDto;
};


export type MutationUpdateFairuDmcaComplainArgs = {
  data: FairuDmcaDto;
};


export type MutationUpdateFairuFieldArgs = {
  data: FairuFieldDto;
};


export type MutationUpdateFairuFieldsetArgs = {
  data: FairuFieldsetDto;
};


export type MutationUpdateFairuFileArgs = {
  data: FairuFileDto;
};


export type MutationUpdateFairuFilesMetadataArgs = {
  ids: Array<Scalars['ID']['input']>;
  metadata: Array<FairuFileMetadataInput>;
};


export type MutationUpdateFairuFolderArgs = {
  data: FairuFolderDto;
};


export type MutationUpdateFairuGalleryArgs = {
  data: FairuGalleryDto;
};


export type MutationUpdateFairuImageCaptionArgs = {
  caption: Scalars['String']['input'];
  fileId: Scalars['ID']['input'];
  galleryId: Scalars['ID']['input'];
  portal: Scalars['String']['input'];
};


export type MutationUpdateFairuLabelArgs = {
  data: FairuLabelDto;
};


export type MutationUpdateFairuLicenseArgs = {
  data: FairuLicenseDto;
};


export type MutationUpdateFairuRoleArgs = {
  data: FairuRoleDto;
};


export type MutationUpdateFairuTagArgs = {
  data: FairuTagDto;
};


export type MutationUpdateFairuTenantArgs = {
  ai_blur_faces?: InputMaybe<Scalars['Boolean']['input']>;
  ai_language?: InputMaybe<Scalars['String']['input']>;
  ai_nsfw?: InputMaybe<Scalars['Boolean']['input']>;
  avatar_id?: InputMaybe<Scalars['ID']['input']>;
  block_files_with_error?: InputMaybe<Scalars['Boolean']['input']>;
  custom_domain?: InputMaybe<Scalars['String']['input']>;
  fallback_image_blocked_id?: InputMaybe<Scalars['ID']['input']>;
  fallback_image_id?: InputMaybe<Scalars['ID']['input']>;
  force_file_alt?: InputMaybe<Scalars['Boolean']['input']>;
  force_file_caption?: InputMaybe<Scalars['Boolean']['input']>;
  force_file_copyright?: InputMaybe<Scalars['Boolean']['input']>;
  force_file_description?: InputMaybe<Scalars['Boolean']['input']>;
  force_file_policy?: InputMaybe<Scalars['Boolean']['input']>;
  force_license?: InputMaybe<Scalars['Boolean']['input']>;
  hide_dotfiles?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  use_ai?: InputMaybe<Scalars['Boolean']['input']>;
  use_ai_onupload?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationUpdateFairuVideoChannelArgs = {
  id: Scalars['ID']['input'];
  input: FairuVideoChannelInput;
};


export type MutationUpdateFairuWebhookArgs = {
  data: FairuWebhookDto;
};


export type MutationUpdateFairuWorkflowArgs = {
  data: FairuWorkflowDto;
};


export type MutationUpdateGenreArgs = {
  data?: InputMaybe<InputGenre>;
};


export type MutationUpdateGustoCategoryArgs = {
  data: UpdateGustoCategory;
};


export type MutationUpdateGustoCountryArgs = {
  data: UpdateGustoCountry;
};


export type MutationUpdateGustoIngredientArgs = {
  data: UpdateGustoIngredient;
};


export type MutationUpdateGustoIssueArgs = {
  data: UpdateGustoIssue;
};


export type MutationUpdateGustoOccasionArgs = {
  data: UpdateGustoOccasion;
};


export type MutationUpdateGustoRecipeArgs = {
  data: UpdateGustoRecipe;
};


export type MutationUpdateGustoRecipePropertyArgs = {
  data: UpdateGustoProperty;
};


export type MutationUpdateGustoTipArgs = {
  data: UpdateGustoTip;
};


export type MutationUpdateLawSurveyArgs = {
  admin?: InputMaybe<Scalars['Boolean']['input']>;
  adminData?: InputMaybe<LawAdminInput>;
  categoryId?: InputMaybe<Scalars['String']['input']>;
  data?: InputMaybe<LawFinalInput>;
  entries?: InputMaybe<Array<LawSurveyEntryInput>>;
  id: Scalars['String']['input'];
  slug: Scalars['String']['input'];
  updateKind: LawUpdateKindType;
};


export type MutationUpdateMarketplaceSelectionArgs = {
  id: Scalars['ID']['input'];
  listingSnapshot?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationUpdateMooncalendarArgs = {
  data?: InputMaybe<UpdateMooncalendarInput>;
};


export type MutationUpdateMovieArgs = {
  data?: InputMaybe<InputMovie>;
};


export type MutationUpdateMyNewsletterPreferencesCustomerIoArgs = {
  acceptNewsletter?: Scalars['Boolean']['input'];
  preferences: Array<NewsletterPreferenceInput>;
};


export type MutationUpdatePersonArgs = {
  data?: InputMaybe<InputPerson>;
};


export type MutationUpdatePersonablesArgs = {
  data?: InputMaybe<InputPersonable>;
};


export type MutationUpdateProviderArgs = {
  data?: InputMaybe<InputProvider>;
};


export type MutationUpdateQuoteArgs = {
  data?: InputMaybe<InputQuote>;
};


export type MutationUpdateShowArgs = {
  data?: InputMaybe<InputShow>;
};


export type MutationUpdateTt500BankFinancialsBackendArgs = {
  admin?: InputMaybe<Scalars['Boolean']['input']>;
  data?: InputMaybe<Tt500UpdateBankFinancialsBackend>;
  id: Scalars['String']['input'];
  slug: Scalars['String']['input'];
  updateKind: Tt500UpdateKindType;
};


export type MutationUpdateTt500CompanyArgs = {
  data?: InputMaybe<Tt500UpdateCompany>;
};


export type MutationUpdateTt500CompanyBackendArgs = {
  admin?: InputMaybe<Scalars['Boolean']['input']>;
  data?: InputMaybe<Tt500UpdateCompanyBackend>;
  id: Scalars['String']['input'];
  slug: Scalars['String']['input'];
  updateKind: Tt500UpdateKindType;
};


export type MutationUpdateTt500CompanyFinancialsBackendArgs = {
  admin?: InputMaybe<Scalars['Boolean']['input']>;
  data?: InputMaybe<Tt500UpdateCompanyFinancialsBackend>;
  id: Scalars['String']['input'];
  slug: Scalars['String']['input'];
  updateKind: Tt500UpdateKindType;
};


export type MutationUpdateTt500InsuranceFinancialsBackendArgs = {
  admin?: InputMaybe<Scalars['Boolean']['input']>;
  data?: InputMaybe<Tt500UpdateInsuranceFinancialsBackend>;
  id: Scalars['String']['input'];
  slug: Scalars['String']['input'];
  updateKind: Tt500UpdateKindType;
};


export type MutationUpdateTt500PersonArgs = {
  data?: InputMaybe<Tt500UpdatePerson>;
};


export type MutationUpdateTvmPushPreferencesArgs = {
  input: TvmPushPreferencesInput;
};


export type MutationUpdateUserFavoriteGroupArgs = {
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  parent?: InputMaybe<Scalars['ID']['input']>;
  sort?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationUpdateVgnArchiveArticleArgs = {
  data?: InputMaybe<VgnArchiveArticleUpdate>;
};


export type MutationUpdateVgnCarAdArgs = {
  data?: InputMaybe<VgnUpdateCarAd>;
};


export type MutationUpdateVgnEventArgs = {
  data?: InputMaybe<VgnUpdateEvent>;
};


export type MutationUpdateVgnEventCategoryArgs = {
  data?: InputMaybe<VgnUpdateEventCategory>;
};


export type MutationUpdateVgnEventSectionArgs = {
  data?: InputMaybe<VgnUpdateEventSection>;
};


export type MutationUpdateVgnSheetArgs = {
  data?: InputMaybe<VgnSheetUpdate>;
};


export type MutationUpdateVodArgs = {
  data?: InputMaybe<InputVod>;
};


export type MutationUploadDataSubjectDocumentsArgs = {
  formular?: InputMaybe<DataSubjectDocumentInput>;
  meldezettel?: InputMaybe<DataSubjectDocumentInput>;
  reisepass?: InputMaybe<DataSubjectDocumentInput>;
  token: Scalars['String']['input'];
};


export type MutationVerifyPasswordResetCodeArgs = {
  code: Scalars['String']['input'];
  email: Scalars['String']['input'];
};


export type MutationVgnChangePasswordArgs = {
  email: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
  oldPassword: Scalars['String']['input'];
};


export type MutationVgnConfirmArgs = {
  token: Scalars['String']['input'];
};


export type MutationVgnCreateUserArgs = {
  attributes?: InputMaybe<Array<VgnUserAttributeInput>>;
  customer_id?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  oesv_id?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  plz?: InputMaybe<Scalars['String']['input']>;
  salutation: VgnSalutation;
};


export type MutationVgnLoginArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type MutationVgnRefreshTokenArgs = {
  token: Scalars['String']['input'];
};


export type MutationVgnRegisterArgs = {
  attributes?: InputMaybe<Array<VgnUserAttributeInput>>;
  customer_id?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  oesv_id?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  plz?: InputMaybe<Scalars['String']['input']>;
  portal?: InputMaybe<Scalars['String']['input']>;
  salutation: VgnSalutation;
};


export type MutationVgnRequestPasswordResetArgs = {
  email: Scalars['String']['input'];
  portal?: InputMaybe<Scalars['String']['input']>;
};


export type MutationVgnResendActivationArgs = {
  email: Scalars['String']['input'];
  portal?: InputMaybe<Scalars['String']['input']>;
};


export type MutationVgnResetPasswordArgs = {
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationVgnUpdateUserArgs = {
  attributes?: InputMaybe<Array<VgnUserAttributeInput>>;
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  salutation?: InputMaybe<VgnSalutation>;
};

export type MyNewsletterPreference = {
  __typename?: 'MyNewsletterPreference';
  newsletter: Scalars['ID']['output'];
  subscribed: Scalars['Boolean']['output'];
};

export type MyNewsletterPreferences = {
  __typename?: 'MyNewsletterPreferences';
  preferences: Array<MyNewsletterPreference>;
  unsubscribed: Scalars['Boolean']['output'];
};

/** Whether the authenticated user has already submitted a given survey. */
export type MySurveyStatus = {
  __typename?: 'MySurveyStatus';
  submitted: Scalars['Boolean']['output'];
  submittedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Navigation list for a portal. */
export type Navigation = {
  __typename?: 'Navigation';
  /** Handle. */
  handle?: Maybe<Scalars['String']['output']>;
  /** Unique primary key. */
  id?: Maybe<Scalars['String']['output']>;
  /** Items */
  items?: Maybe<Array<Maybe<NavigationItem>>>;
  /** Title. */
  title?: Maybe<Scalars['String']['output']>;
};

/** Navigation list item for a navigation. */
export type NavigationItem = {
  __typename?: 'NavigationItem';
  /** Children. */
  children?: Maybe<Array<Maybe<NavigationItem>>>;
  /** Unique primary key. */
  id?: Maybe<Scalars['String']['output']>;
  /** Is it a title element without a clickable text? */
  only_title?: Maybe<Scalars['Boolean']['output']>;
  /** Additional parameter */
  parameter?: Maybe<Scalars['String']['output']>;
  /** Slug. */
  slug?: Maybe<Scalars['String']['output']>;
  /** Title. */
  title?: Maybe<Scalars['String']['output']>;
  /** Type of navigation item. */
  type?: Maybe<Scalars['String']['output']>;
  /** Url. */
  url?: Maybe<Scalars['String']['output']>;
};

export type Newsletter = {
  __typename?: 'Newsletter';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<FairuAsset>;
  /** Brevo List ID */
  list?: Maybe<Scalars['String']['output']>;
  preferences_tagline?: Maybe<Scalars['String']['output']>;
  preferences_text?: Maybe<Scalars['String']['output']>;
  preview_url?: Maybe<Scalars['String']['output']>;
  sending_frequency?: Maybe<Scalars['String']['output']>;
  /** The slug is required to fetch the newsletter */
  slug?: Maybe<Scalars['String']['output']>;
  /** Title for the newsletter - will be shown on the content element */
  title?: Maybe<Scalars['String']['output']>;
};


export type NewsletterDescriptionArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};


export type NewsletterPreferences_TextArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NewsletterOverview = {
  __typename?: 'NewsletterOverview';
  feedback?: Maybe<Array<Maybe<NewsletterOverviewFeedback>>>;
  feedback_headline?: Maybe<Scalars['String']['output']>;
  marketing_consent_summary?: Maybe<Scalars['String']['output']>;
  marketing_consent_text?: Maybe<Scalars['String']['output']>;
  newsletter_consent_summary?: Maybe<Scalars['String']['output']>;
  newsletter_consent_text?: Maybe<Scalars['String']['output']>;
  newsletters?: Maybe<Array<Maybe<Newsletter>>>;
  portal?: Maybe<Scalars['String']['output']>;
  privacy_text?: Maybe<Scalars['String']['output']>;
  subheadline?: Maybe<Scalars['String']['output']>;
  teaser_cta_label?: Maybe<Scalars['String']['output']>;
  teaser_headline?: Maybe<Scalars['String']['output']>;
  teaser_image?: Maybe<FairuAsset>;
  teaser_text?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};


export type NewsletterOverviewMarketing_Consent_TextArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};


export type NewsletterOverviewNewsletter_Consent_TextArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};


export type NewsletterOverviewPrivacy_TextArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};


export type NewsletterOverviewTeaser_TextArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NewsletterOverviewFeedback = {
  __typename?: 'NewsletterOverviewFeedback';
  image?: Maybe<FairuAsset>;
  name?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['String']['output']>;
  stars?: Maybe<Scalars['Int']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type NewsletterPreferenceInput = {
  /** ID of a published TV-Media newsletter entry. */
  newsletter: Scalars['ID']['input'];
  /** Explicit preference for this newsletter's mapped topics; other topics are left unchanged. */
  subscribed: Scalars['Boolean']['input'];
};

export type NewsletterPreferencesUpdateResult = {
  __typename?: 'NewsletterPreferencesUpdateResult';
  success: Scalars['Boolean']['output'];
};

export type NewsletterSubscriptionResult = {
  __typename?: 'NewsletterSubscriptionResult';
  redirect_url?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type NowEntryItem = CinemaShowtime | TvChannelShowtime;

/** A paginated list of NowEntryItem items. */
export type NowEntryItemPaginator = {
  __typename?: 'NowEntryItemPaginator';
  /** A list of NowEntryItem items. */
  data: Array<NowEntryItem>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type Oewa = {
  __typename?: 'Oewa';
  /** Category key */
  category_key?: Maybe<Scalars['String']['output']>;
  /** Category id */
  id?: Maybe<Scalars['String']['output']>;
  /** Page key */
  page_key?: Maybe<Scalars['String']['output']>;
  /** Profile key */
  profile_key?: Maybe<Scalars['String']['output']>;
};

/** Allows ordering a list of records. */
export type OrderByClause = {
  /** The column that is used for ordering. */
  column: Scalars['String']['input'];
  /** The direction that is used for ordering. */
  order: SortOrder;
};

/** Aggregate functions when ordering by a relation without specifying a column. */
export enum OrderByRelationAggregateFunction {
  /** Amount of items. */
  Count = 'COUNT'
}

/** Aggregate functions when ordering by a relation that may specify a column. */
export enum OrderByRelationWithColumnAggregateFunction {
  /** Average. */
  Avg = 'AVG',
  /** Amount of items. */
  Count = 'COUNT',
  /** Maximum. */
  Max = 'MAX',
  /** Minimum. */
  Min = 'MIN',
  /** Sum. */
  Sum = 'SUM'
}

export type Page = {
  __typename?: 'Page';
  /** Ad settings for the page */
  ad_settings?: Maybe<AdSetting>;
  /** Content */
  content?: Maybe<Array<Maybe<PageContentElement>>>;
  /** Created at */
  created_at?: Maybe<Scalars['DateTime']['output']>;
  /** Disable ads for the article */
  disable_ads?: Maybe<Scalars['Boolean']['output']>;
  /** Id */
  id: Scalars['ID']['output'];
  /** Meta data */
  metadata?: Maybe<Meta>;
  /** More teaser is used for boxes */
  more_teaser?: Maybe<Scalars['String']['output']>;
  more_teaser_headline?: Maybe<Scalars['String']['output']>;
  /** More teaser image should be used in an overview box */
  more_teaser_image?: Maybe<FairuAsset>;
  /** Oewa data */
  oewa?: Maybe<Oewa>;
  /** Outbrain compliant */
  outbrain_compliant?: Maybe<Scalars['Boolean']['output']>;
  /** Outbrain deactivated */
  outbrain_disabled?: Maybe<Scalars['Boolean']['output']>;
  /** Url of the page */
  path?: Maybe<Scalars['String']['output']>;
  power_branding?: Maybe<PowerBranding>;
  /** Is the entry published  */
  published?: Maybe<Scalars['Boolean']['output']>;
  /** Show title */
  show_title?: Maybe<Scalars['Boolean']['output']>;
  /** Slug of the page */
  slug?: Maybe<Scalars['String']['output']>;
  /** Full slug of the page */
  slug_full?: Maybe<Scalars['String']['output']>;
  /** Title of the page */
  title?: Maybe<Scalars['String']['output']>;
  /** Updated at */
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};


export type PageMore_TeaserArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PageSlugArgs = {
  simple?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageContentElement = PageContentElementAll | PageContentElementArticles | PageContentElementArticlesApa | PageContentElementArticlesGusto | PageContentElementArticlesIds | PageContentElementArticlesMixed | PageContentElementArticlesRessort | PageContentElementArticlesRotation | PageContentElementArticlesTopics | PageContentElementBarCharts | PageContentElementBestArticles | PageContentElementBoxes | PageContentElementCalculators | PageContentElementCarAdForm | PageContentElementCardsGrid | PageContentElementContactForms | PageContentElementCta | PageContentElementEntityAd | PageContentElementEntitySearchPage | PageContentElementEvents | PageContentElementEventsOverview | PageContentElementFairuGalleries | PageContentElementFeatureColumns | PageContentElementFers | PageContentElementHero | PageContentElementHeroClean | PageContentElementHeroImages | PageContentElementHorizontalPanels | PageContentElementHubspot | PageContentElementImmoUnited | PageContentElementLeadForm | PageContentElementListicles | PageContentElementNewsletterBoxes | PageContentElementNewsletterSignup | PageContentElementOfferCalculator | PageContentElementPeopleCards | PageContentElementPricingCards | PageContentElementSectionHead | PageContentElementSpecial | PageContentElementSplitText | PageContentElementStage | PageContentElementStoryEmbed | PageContentElementSubscriptionAd | PageContentElementTeams | PageContentElementTextWithPanel | PageContentElementTimeline | PageContentElementTvmAutomaticLanes | PageContentElementTvmCustomLane | PageContentElementTvmCustomLaneAd | PageContentElementTvmSports | PageContentElementTvmTopics | PageContentElementTvmWatchlist | PageContentElementTvmshorts | PageContentElementVgnBrands | PageContentElementVgnFactbox;

export type PageContentElementAll = {
  __typename?: 'PageContentElementAll';
  /** Anchor. */
  anchor?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Array<Maybe<ContentElement>>>;
  /** Element is only visible for logged in users */
  only_logged_in?: Maybe<Scalars['Boolean']['output']>;
  /** Show videos */
  show_videos?: Maybe<Scalars['Boolean']['output']>;
  /** Title */
  title?: Maybe<Scalars['String']['output']>;
  /** Title link */
  title_link?: Maybe<Scalars['String']['output']>;
  /** Open title link in new window */
  title_link_blank_window?: Maybe<Scalars['Boolean']['output']>;
};

export type PageContentElementArticles = {
  __typename?: 'PageContentElementArticles';
  /** Articles */
  articles?: Maybe<Array<Maybe<Article>>>;
  /** Big ad */
  big_ad?: Maybe<Scalars['Boolean']['output']>;
  /** Mode */
  mode?: Maybe<Scalars['String']['output']>;
  /** Element is only visible for logged in users */
  only_logged_in?: Maybe<Scalars['Boolean']['output']>;
  /** Show images */
  show_images?: Maybe<Scalars['Boolean']['output']>;
  /** Show videos */
  show_videos?: Maybe<Scalars['Boolean']['output']>;
  /** Title */
  title?: Maybe<Scalars['String']['output']>;
  /** Title link */
  title_link?: Maybe<Scalars['String']['output']>;
  /** Open title link in new window */
  title_link_blank_window?: Maybe<Scalars['Boolean']['output']>;
};

export type PageContentElementArticlesApa = {
  __typename?: 'PageContentElementArticlesApa';
  /** Articles */
  articles?: Maybe<Array<Maybe<Article>>>;
  /** Big ad */
  big_ad?: Maybe<Scalars['Boolean']['output']>;
  /** Mode */
  mode?: Maybe<Scalars['String']['output']>;
  /** Element is only visible for logged in users */
  only_logged_in?: Maybe<Scalars['Boolean']['output']>;
  /** Title */
  title?: Maybe<Scalars['String']['output']>;
  /** Title link */
  title_link?: Maybe<Scalars['String']['output']>;
  /** Open title link in new window */
  title_link_blank_window?: Maybe<Scalars['Boolean']['output']>;
};

export type PageContentElementArticlesGusto = {
  __typename?: 'PageContentElementArticlesGusto';
  /** Entries (also contains articles) */
  gusto_entries?: Maybe<Array<GustoArticle>>;
  /** Mode */
  mode?: Maybe<Scalars['String']['output']>;
  /** Element is only visible for logged in users */
  only_logged_in?: Maybe<Scalars['Boolean']['output']>;
  /** Title */
  title?: Maybe<Scalars['String']['output']>;
  /** Title link */
  title_link?: Maybe<Scalars['String']['output']>;
  /** Open title link in new window */
  title_link_blank_window?: Maybe<Scalars['Boolean']['output']>;
};

export type PageContentElementArticlesIds = {
  __typename?: 'PageContentElementArticlesIds';
  /** Articles */
  articles?: Maybe<Array<Maybe<Article>>>;
  /** Big ad */
  big_ad?: Maybe<Scalars['Boolean']['output']>;
  /** Mode */
  mode?: Maybe<Scalars['String']['output']>;
  /** Element is only visible for logged in users */
  only_logged_in?: Maybe<Scalars['Boolean']['output']>;
  /** Show videos */
  show_videos?: Maybe<Scalars['Boolean']['output']>;
  /** Title */
  title?: Maybe<Scalars['String']['output']>;
  /** Title link */
  title_link?: Maybe<Scalars['String']['output']>;
  /** Open title link in new window */
  title_link_blank_window?: Maybe<Scalars['Boolean']['output']>;
};

export type PageContentElementArticlesMixed = {
  __typename?: 'PageContentElementArticlesMixed';
  /** Articles (APA and regular mixed chronologically) */
  articles?: Maybe<Array<Maybe<Article>>>;
  /** Big ad */
  big_ad?: Maybe<Scalars['Boolean']['output']>;
  /** Mode */
  mode?: Maybe<Scalars['String']['output']>;
  /** Element is only visible for logged in users */
  only_logged_in?: Maybe<Scalars['Boolean']['output']>;
  /** Title */
  title?: Maybe<Scalars['String']['output']>;
  /** Title link */
  title_link?: Maybe<Scalars['String']['output']>;
  /** Open title link in new window */
  title_link_blank_window?: Maybe<Scalars['Boolean']['output']>;
};

export type PageContentElementArticlesRessort = {
  __typename?: 'PageContentElementArticlesRessort';
  /** Articles */
  articles?: Maybe<Array<Maybe<Article>>>;
  /** Big ad */
  big_ad?: Maybe<Scalars['Boolean']['output']>;
  extra_link?: Maybe<Scalars['String']['output']>;
  extra_link_text?: Maybe<Scalars['String']['output']>;
  /** Mode */
  mode?: Maybe<Scalars['String']['output']>;
  /** Element is only visible for logged in users */
  only_logged_in?: Maybe<Scalars['Boolean']['output']>;
  /** Show videos */
  show_videos?: Maybe<Scalars['Boolean']['output']>;
  /** Title */
  title?: Maybe<Scalars['String']['output']>;
  /** Title link */
  title_link?: Maybe<Scalars['String']['output']>;
  /** Open title link in new window */
  title_link_blank_window?: Maybe<Scalars['Boolean']['output']>;
};

export type PageContentElementArticlesRotation = {
  __typename?: 'PageContentElementArticlesRotation';
  article_groups?: Maybe<Array<PageContentElementArticlesRotationGroupInformation>>;
  articles?: Maybe<Array<Article>>;
  /** Element is only visible for logged in users */
  only_logged_in?: Maybe<Scalars['Boolean']['output']>;
  /** Rotation delay in seconds */
  rotation_time?: Maybe<Scalars['Int']['output']>;
  /** Title */
  title?: Maybe<Scalars['String']['output']>;
  /** Title link */
  title_link?: Maybe<Scalars['String']['output']>;
  /** Open title link in new window */
  title_link_blank_window?: Maybe<Scalars['Boolean']['output']>;
};

export type PageContentElementArticlesRotationGroupInformation = {
  __typename?: 'PageContentElementArticlesRotationGroupInformation';
  amount?: Maybe<Scalars['Int']['output']>;
  big_ad?: Maybe<Scalars['Boolean']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type PageContentElementArticlesTopics = {
  __typename?: 'PageContentElementArticlesTopics';
  /** Articles */
  articles?: Maybe<Array<Maybe<Article>>>;
  /** Big ad */
  big_ad?: Maybe<Scalars['Boolean']['output']>;
  extra_link?: Maybe<Scalars['String']['output']>;
  extra_link_text?: Maybe<Scalars['String']['output']>;
  /** Mode */
  mode?: Maybe<Scalars['String']['output']>;
  /** Element is only visible for logged in users */
  only_logged_in?: Maybe<Scalars['Boolean']['output']>;
  /** Show videos */
  show_videos?: Maybe<Scalars['Boolean']['output']>;
  /** Title */
  title?: Maybe<Scalars['String']['output']>;
  /** Title link */
  title_link?: Maybe<Scalars['String']['output']>;
  /** Open title link in new window */
  title_link_blank_window?: Maybe<Scalars['Boolean']['output']>;
};

export type PageContentElementBarCharts = {
  __typename?: 'PageContentElementBarCharts';
  charts?: Maybe<Array<Maybe<BarChart>>>;
  columns?: Maybe<Scalars['String']['output']>;
  /** Element is only visible for logged in users */
  only_logged_in?: Maybe<Scalars['Boolean']['output']>;
  style_variant?: Maybe<Scalars['String']['output']>;
};

export type PageContentElementBestArticles = {
  __typename?: 'PageContentElementBestArticles';
  /** Articles */
  best_articles?: Maybe<Array<Maybe<Article>>>;
  /** Enabled */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** Headline */
  headline?: Maybe<Scalars['String']['output']>;
  /** Initial articles */
  initial_articles?: Maybe<Scalars['Int']['output']>;
  /** Layout */
  layout?: Maybe<Scalars['String']['output']>;
  /** Max articles */
  max_articles?: Maybe<Scalars['Int']['output']>;
  /** Earliest publish date (cut-off, optional) */
  min_publish_date?: Maybe<Scalars['String']['output']>;
  /** Element is only visible for logged in users */
  only_logged_in?: Maybe<Scalars['Boolean']['output']>;
  /** Portal (for articles resolver) */
  portal?: Maybe<Scalars['String']['output']>;
  /** Short line under the headline */
  subline?: Maybe<Scalars['String']['output']>;
  /** Time span */
  time_span?: Maybe<Scalars['String']['output']>;
};

export type PageContentElementBoxes = {
  __typename?: 'PageContentElementBoxes';
  entries?: Maybe<Array<Entry>>;
  /** Element is only visible for logged in users */
  only_logged_in?: Maybe<Scalars['Boolean']['output']>;
};

export type PageContentElementCalculators = {
  __typename?: 'PageContentElementCalculators';
  calculator?: Maybe<Form>;
  /** Inline calculator schema JSON (avoids a clientside roundtrip to calculatorForm). */
  json?: Maybe<Scalars['String']['output']>;
  /** Element is only visible for logged in users */
  only_logged_in?: Maybe<Scalars['Boolean']['output']>;
  /** Title */
  title?: Maybe<Scalars['String']['output']>;
  /** Title link */
  title_link?: Maybe<Scalars['String']['output']>;
  /** Open title link in new window */
  title_link_blank_window?: Maybe<Scalars['Boolean']['output']>;
};

export type PageContentElementCarAdForm = {
  __typename?: 'PageContentElementCarAdForm';
  /** Element is only visible for logged in users */
  only_logged_in?: Maybe<Scalars['Boolean']['output']>;
  /** Title */
  title?: Maybe<Scalars['String']['output']>;
  /** Title link */
  title_link?: Maybe<Scalars['String']['output']>;
  /** Open title link in new window */
  title_link_blank_window?: Maybe<Scalars['Boolean']['output']>;
};

export type PageContentElementCardsGrid = {
  __typename?: 'PageContentElementCardsGrid';
  card_style?: Maybe<Scalars['String']['output']>;
  cards?: Maybe<Array<Maybe<CardsGridCard>>>;
  columns?: Maybe<Scalars['String']['output']>;
  /** Element is only visible for logged in users */
  only_logged_in?: Maybe<Scalars['Boolean']['output']>;
  style_variant?: Maybe<Scalars['String']['output']>;
};

export type PageContentElementContactForms = {
  __typename?: 'PageContentElementContactForms';
  form?: Maybe<ContactForm>;
  /** Element is only visible for logged in users */
  only_logged_in?: Maybe<Scalars['Boolean']['output']>;
  /** Title */
  title?: Maybe<Scalars['String']['output']>;
  /** Title link */
  title_link?: Maybe<Scalars['String']['output']>;
  /** Open title link in new window */
  title_link_blank_window?: Maybe<Scalars['Boolean']['output']>;
};

export type PageContentElementCta = {
  __typename?: 'PageContentElementCta';
  /** Button link */
  cta_button_link?: Maybe<Scalars['String']['output']>;
  /** Button text */
  cta_button_text?: Maybe<Scalars['String']['output']>;
  /** Headline */
  cta_headline?: Maybe<Scalars['String']['output']>;
  /** Style variant */
  cta_style?: Maybe<Scalars['String']['output']>;
  /** Text */
  cta_text?: Maybe<Scalars['String']['output']>;
  /** Element is only visible for logged in users */
  only_logged_in?: Maybe<Scalars['Boolean']['output']>;
};


export type PageContentElementCtaCta_TextArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageContentElementEntityAd = {
  __typename?: 'PageContentElementEntityAd';
  /** TvChannel */
  channel_id?: Maybe<Scalars['String']['output']>;
  /** Link url */
  cta_link?: Maybe<Scalars['String']['output']>;
  /** Link text */
  cta_text?: Maybe<Scalars['String']['output']>;
  /** Asset for this entry */
  custom_asset?: Maybe<FairuAsset>;
  /** Entity entry */
  entity?: Maybe<TvmEntity>;
  /** Entity id */
  entity_id?: Maybe<Scalars['String']['output']>;
  /** Use a connection to provider or tv channel */
  entity_type?: Maybe<Scalars['String']['output']>;
  /** Use a connection to provider or tv channel */
  focus_type?: Maybe<Scalars['String']['output']>;
  /** Title or headline */
  headline?: Maybe<Scalars['String']['output']>;
  /** Image text next to the small logo */
  image_text?: Maybe<Scalars['String']['output']>;
  /** Asset for this entry (logo) */
  logo_small?: Maybe<FairuAsset>;
  /** Is this entry an ad */
  mark_as_ad?: Maybe<Scalars['Boolean']['output']>;
  /** Element is only visible for logged in users */
  only_logged_in?: Maybe<Scalars['Boolean']['output']>;
  /** Provider */
  provider_id?: Maybe<Scalars['String']['output']>;
  start_date?: Maybe<Scalars['String']['output']>;
  /** Text */
  text?: Maybe<Scalars['String']['output']>;
  /** Type */
  type?: Maybe<Scalars['String']['output']>;
};


export type PageContentElementEntityAdTextArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageContentElementEntitySearchPage = {
  __typename?: 'PageContentElementEntitySearchPage';
  /** Element is only visible for logged in users */
  only_logged_in?: Maybe<Scalars['Boolean']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type PageContentElementEvents = {
  __typename?: 'PageContentElementEvents';
  /** Element is only visible for logged in users */
  only_logged_in?: Maybe<Scalars['Boolean']['output']>;
  query?: Maybe<VgnEventQuery>;
  /** Title */
  title?: Maybe<Scalars['String']['output']>;
  /** Title link */
  title_link?: Maybe<Scalars['String']['output']>;
  /** Open title link in new window */
  title_link_blank_window?: Maybe<Scalars['Boolean']['output']>;
};

export type PageContentElementEventsOverview = {
  __typename?: 'PageContentElementEventsOverview';
  /** Element is only visible for logged in users */
  only_logged_in?: Maybe<Scalars['Boolean']['output']>;
  portal?: Maybe<Scalars['String']['output']>;
  /** Title */
  title?: Maybe<Scalars['String']['output']>;
  /** Title link */
  title_link?: Maybe<Scalars['String']['output']>;
  /** Open title link in new window */
  title_link_blank_window?: Maybe<Scalars['Boolean']['output']>;
};

export type PageContentElementFairuGalleries = {
  __typename?: 'PageContentElementFairuGalleries';
  galleries?: Maybe<Array<FairuGallery>>;
  /** Element is only visible for logged in users */
  only_logged_in?: Maybe<Scalars['Boolean']['output']>;
  /** Title */
  title?: Maybe<Scalars['String']['output']>;
  /** Title link */
  title_link?: Maybe<Scalars['String']['output']>;
  /** Open title link in new window */
  title_link_blank_window?: Maybe<Scalars['Boolean']['output']>;
};

export type PageContentElementFeatureColumns = {
  __typename?: 'PageContentElementFeatureColumns';
  blocks?: Maybe<Array<Maybe<FeatureColumnBlock>>>;
  /** Element is only visible for logged in users */
  only_logged_in?: Maybe<Scalars['Boolean']['output']>;
  plus_body?: Maybe<Scalars['String']['output']>;
  plus_label?: Maybe<Scalars['String']['output']>;
  plus_title?: Maybe<Scalars['String']['output']>;
  style_variant?: Maybe<Scalars['String']['output']>;
};


export type PageContentElementFeatureColumnsPlus_BodyArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageContentElementFers = {
  __typename?: 'PageContentElementFers';
  /** Element is only visible for logged in users */
  only_logged_in?: Maybe<Scalars['Boolean']['output']>;
  /** Title */
  title?: Maybe<Scalars['String']['output']>;
  /** Title link */
  title_link?: Maybe<Scalars['String']['output']>;
  /** Open title link in new window */
  title_link_blank_window?: Maybe<Scalars['Boolean']['output']>;
};

export type PageContentElementHero = {
  __typename?: 'PageContentElementHero';
  /** Slides of hero element */
  hero_slides?: Maybe<Array<Maybe<HeroSlide>>>;
  /** Type of hero element */
  hero_type?: Maybe<Scalars['String']['output']>;
  /** Element is only visible for logged in users */
  only_logged_in?: Maybe<Scalars['Boolean']['output']>;
  /** Text */
  text?: Maybe<Scalars['String']['output']>;
  /** Title */
  title?: Maybe<Scalars['String']['output']>;
};


export type PageContentElementHeroTextArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageContentElementHeroClean = {
  __typename?: 'PageContentElementHeroClean';
  cta2_label?: Maybe<Scalars['String']['output']>;
  cta2_url?: Maybe<Scalars['String']['output']>;
  cta_label?: Maybe<Scalars['String']['output']>;
  cta_url?: Maybe<Scalars['String']['output']>;
  emphasis_color?: Maybe<Scalars['String']['output']>;
  eyebrow?: Maybe<Scalars['String']['output']>;
  headline_emphasis?: Maybe<Scalars['String']['output']>;
  headline_main?: Maybe<Scalars['String']['output']>;
  image?: Maybe<FairuAsset>;
  nav_anchors?: Maybe<Array<Maybe<HeroCleanNavAnchor>>>;
  /** Element is only visible for logged in users */
  only_logged_in?: Maybe<Scalars['Boolean']['output']>;
  stats?: Maybe<Array<Maybe<HeroCleanStat>>>;
  style_variant?: Maybe<Scalars['String']['output']>;
  sub?: Maybe<Scalars['String']['output']>;
};


export type PageContentElementHeroCleanSubArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageContentElementHeroImages = {
  __typename?: 'PageContentElementHeroImages';
  /** Title or headline */
  headline?: Maybe<Scalars['String']['output']>;
  /** Images */
  images?: Maybe<Array<Maybe<FairuAsset>>>;
  /** Element is only visible for logged in users */
  only_logged_in?: Maybe<Scalars['Boolean']['output']>;
  /** Text */
  text?: Maybe<Scalars['String']['output']>;
};


export type PageContentElementHeroImagesTextArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageContentElementHorizonalPanel = {
  __typename?: 'PageContentElementHorizonalPanel';
  color?: Maybe<Scalars['String']['output']>;
  color_text?: Maybe<Scalars['String']['output']>;
  headline?: Maybe<Scalars['String']['output']>;
  image?: Maybe<FairuAsset>;
  subheadline?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type PageContentElementHorizontalPanels = {
  __typename?: 'PageContentElementHorizontalPanels';
  description?: Maybe<Scalars['String']['output']>;
  headline?: Maybe<Scalars['String']['output']>;
  /** Element is only visible for logged in users */
  only_logged_in?: Maybe<Scalars['Boolean']['output']>;
  panels?: Maybe<Array<Maybe<PageContentElementHorizonalPanel>>>;
};


export type PageContentElementHorizontalPanelsDescriptionArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageContentElementHubspot = {
  __typename?: 'PageContentElementHubspot';
  form_id?: Maybe<Scalars['String']['output']>;
  /** Element is only visible for logged in users */
  only_logged_in?: Maybe<Scalars['Boolean']['output']>;
  portal_id?: Maybe<Scalars['String']['output']>;
  /** Title */
  title?: Maybe<Scalars['String']['output']>;
  /** Title link */
  title_link?: Maybe<Scalars['String']['output']>;
  /** Open title link in new window */
  title_link_blank_window?: Maybe<Scalars['Boolean']['output']>;
};

export type PageContentElementImmoUnited = {
  __typename?: 'PageContentElementImmoUnited';
  /** Listings fetched from the Immo United feed (cached, refreshed once daily) */
  listings?: Maybe<Array<Maybe<ImmoUnitedListing>>>;
  /** Element is only visible for logged in users */
  only_logged_in?: Maybe<Scalars['Boolean']['output']>;
  /** Title override */
  title_override?: Maybe<Scalars['String']['output']>;
};

export type PageContentElementLeadForm = {
  __typename?: 'PageContentElementLeadForm';
  consent_label?: Maybe<Scalars['String']['output']>;
  form_id?: Maybe<Scalars['String']['output']>;
  format_options?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  location_options?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Element is only visible for logged in users */
  only_logged_in?: Maybe<Scalars['Boolean']['output']>;
  period_options?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  show_phone?: Maybe<Scalars['Boolean']['output']>;
  show_position?: Maybe<Scalars['Boolean']['output']>;
  style_variant?: Maybe<Scalars['String']['output']>;
  submit_label?: Maybe<Scalars['String']['output']>;
  success_message?: Maybe<Scalars['String']['output']>;
};


export type PageContentElementLeadFormConsent_LabelArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PageContentElementLeadFormSuccess_MessageArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageContentElementListicles = {
  __typename?: 'PageContentElementListicles';
  custom_link_text?: Maybe<Scalars['String']['output']>;
  /** List of genre ids */
  genre_filter?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** List of genre ids which should be excluded */
  genre_filter_excluded?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Ids of items */
  items?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Limit of entries */
  limit?: Maybe<Scalars['String']['output']>;
  /** Listicle type */
  listicle_type?: Maybe<ListicleType>;
  /** Only live events should be used. If listicle type is channel and the query is setting this option has an effect. */
  onlyLive?: Maybe<Scalars['Boolean']['output']>;
  /** Only event that are now should be used. If listicle type is channel and the query is setting this option has an effect. */
  onlyNow?: Maybe<Scalars['Boolean']['output']>;
  /** Only primetime tv entries should be loaded. If listicle type is channel and the query is setting this option has an effect. */
  onlyPrimetime?: Maybe<Scalars['Boolean']['output']>;
  /** Only sports tv entries should be loaded. If listicle type is channel and the query is setting this option has an effect. */
  onlySport?: Maybe<Scalars['Boolean']['output']>;
  /** Only entries with asset */
  onlyWithAssets?: Maybe<Scalars['Boolean']['output']>;
  /** Element is only visible for logged in users */
  only_logged_in?: Maybe<Scalars['Boolean']['output']>;
  /** List of genre ids */
  provider_filter?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** GraphQL query mode. */
  query?: Maybe<Scalars['String']['output']>;
  /** Search term */
  searchterm?: Maybe<Scalars['String']['output']>;
  /** Sort by new */
  sortByNew?: Maybe<Scalars['Boolean']['output']>;
  /** Title */
  title?: Maybe<Scalars['String']['output']>;
  /** Title link */
  title_link?: Maybe<Scalars['String']['output']>;
  /** Open title link in new window */
  title_link_blank_window?: Maybe<Scalars['Boolean']['output']>;
};

export type PageContentElementNewsletterBoxes = {
  __typename?: 'PageContentElementNewsletterBoxes';
  newsletters?: Maybe<Array<Maybe<Newsletter>>>;
  /** Element is only visible for logged in users */
  only_logged_in?: Maybe<Scalars['Boolean']['output']>;
  per_row?: Maybe<Scalars['Int']['output']>;
};

export type PageContentElementNewsletterSignup = {
  __typename?: 'PageContentElementNewsletterSignup';
  /** cta | newsletter */
  action_type?: Maybe<Scalars['String']['output']>;
  cta?: Maybe<Link>;
  cta_title?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  image?: Maybe<FairuAsset>;
  /** Newsletter entry id, submit via the same signup mutation as popovers */
  newsletter_id?: Maybe<Scalars['String']['output']>;
  /** Element is only visible for logged in users */
  only_logged_in?: Maybe<Scalars['Boolean']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};


export type PageContentElementNewsletterSignupDescriptionArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageContentElementOfferCalculator = {
  __typename?: 'PageContentElementOfferCalculator';
  budget_enabled?: Maybe<Scalars['Boolean']['output']>;
  /** Element is only visible for logged in users */
  only_logged_in?: Maybe<Scalars['Boolean']['output']>;
  pdf_enabled?: Maybe<Scalars['Boolean']['output']>;
  price_list?: Maybe<Scalars['String']['output']>;
  request_anchor?: Maybe<Scalars['String']['output']>;
  request_label?: Maybe<Scalars['String']['output']>;
  style_variant?: Maybe<Scalars['String']['output']>;
};

export type PageContentElementPeopleCards = {
  __typename?: 'PageContentElementPeopleCards';
  columns?: Maybe<Scalars['String']['output']>;
  /** Element is only visible for logged in users */
  only_logged_in?: Maybe<Scalars['Boolean']['output']>;
  people?: Maybe<Array<Maybe<PeopleCard>>>;
  style_variant?: Maybe<Scalars['String']['output']>;
};

export type PageContentElementPricingCards = {
  __typename?: 'PageContentElementPricingCards';
  cards?: Maybe<Array<Maybe<PricingCard>>>;
  columns?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  /** Element is only visible for logged in users */
  only_logged_in?: Maybe<Scalars['Boolean']['output']>;
  style_variant?: Maybe<Scalars['String']['output']>;
};


export type PageContentElementPricingCardsNoteArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageContentElementSectionHead = {
  __typename?: 'PageContentElementSectionHead';
  anchor?: Maybe<Scalars['String']['output']>;
  emphasis_color?: Maybe<Scalars['String']['output']>;
  eyebrow?: Maybe<Scalars['String']['output']>;
  headline_emphasis?: Maybe<Scalars['String']['output']>;
  headline_main?: Maybe<Scalars['String']['output']>;
  lede?: Maybe<Scalars['String']['output']>;
  /** Element is only visible for logged in users */
  only_logged_in?: Maybe<Scalars['Boolean']['output']>;
  style_variant?: Maybe<Scalars['String']['output']>;
};

export type PageContentElementSheet = {
  __typename?: 'PageContentElementSheet';
  sheets?: Maybe<Scalars['JSON']['output']>;
  /** Title */
  title?: Maybe<Scalars['String']['output']>;
};

export type PageContentElementSpecial = {
  __typename?: 'PageContentElementSpecial';
  /** Backgroud image */
  bg_image?: Maybe<FairuAsset>;
  /** Marquee text */
  marquee_text?: Maybe<Scalars['String']['output']>;
  /** Element is only visible for logged in users */
  only_logged_in?: Maybe<Scalars['Boolean']['output']>;
  /** Sheets */
  sheets?: Maybe<Array<Maybe<Sheet>>>;
  /** Type */
  special_type?: Maybe<Scalars['String']['output']>;
  /** Subtitle */
  subtitle?: Maybe<Scalars['String']['output']>;
  /** Text */
  text?: Maybe<Scalars['String']['output']>;
  /** Title */
  title?: Maybe<Scalars['String']['output']>;
};


export type PageContentElementSpecialMarquee_TextArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PageContentElementSpecialTextArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageContentElementSplitText = {
  __typename?: 'PageContentElementSplitText';
  body?: Maybe<Scalars['String']['output']>;
  /** Element is only visible for logged in users */
  only_logged_in?: Maybe<Scalars['Boolean']['output']>;
  pullquote?: Maybe<Scalars['String']['output']>;
  style_variant?: Maybe<Scalars['String']['output']>;
};


export type PageContentElementSplitTextBodyArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PageContentElementSplitTextPullquoteArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageContentElementStage = {
  __typename?: 'PageContentElementStage';
  items?: Maybe<Array<Maybe<StageElement>>>;
  /** Element is only visible for logged in users */
  only_logged_in?: Maybe<Scalars['Boolean']['output']>;
  /** Show videos */
  show_videos?: Maybe<Scalars['Boolean']['output']>;
  /** Title */
  title?: Maybe<Scalars['String']['output']>;
  /** Title link */
  title_link?: Maybe<Scalars['String']['output']>;
  /** Open title link in new window */
  title_link_blank_window?: Maybe<Scalars['Boolean']['output']>;
};

/** Scrollytelling embed on pages — same contract as ContentElementStoryEmbed. */
export type PageContentElementStoryEmbed = {
  __typename?: 'PageContentElementStoryEmbed';
  /** Anchor. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** Renderer key from the story registry (sticky_crossfade, karte, timeline, ...) */
  element?: Maybe<Scalars['String']['output']>;
  /** Headline. */
  headline?: Maybe<Scalars['String']['output']>;
  /** Headline size */
  headline_level?: Maybe<Scalars['Int']['output']>;
  /** Element is only visible for logged in users */
  only_logged_in?: Maybe<Scalars['Boolean']['output']>;
  /** Storyboard steps as JSON array string */
  steps?: Maybe<Scalars['String']['output']>;
  /** Optional data handle for storyPois/storyData */
  story?: Maybe<Scalars['String']['output']>;
};

export type PageContentElementSubscriptionAd = {
  __typename?: 'PageContentElementSubscriptionAd';
  /** Element is only visible for logged in users */
  only_logged_in?: Maybe<Scalars['Boolean']['output']>;
  /** Subscription ad */
  subscription_ad?: Maybe<SubscriptionAd>;
  /** Title */
  title?: Maybe<Scalars['String']['output']>;
  /** Title link */
  title_link?: Maybe<Scalars['String']['output']>;
  /** Open title link in new window */
  title_link_blank_window?: Maybe<Scalars['Boolean']['output']>;
};

export type PageContentElementTeams = {
  __typename?: 'PageContentElementTeams';
  disable_more_button?: Maybe<Scalars['Boolean']['output']>;
  /** Display mode for the list */
  mode?: Maybe<Scalars['String']['output']>;
  /** Element is only visible for logged in users */
  only_logged_in?: Maybe<Scalars['Boolean']['output']>;
  teams?: Maybe<Array<Maybe<Team>>>;
  /** Title */
  title?: Maybe<Scalars['String']['output']>;
  /** Title link */
  title_link?: Maybe<Scalars['String']['output']>;
  /** Open title link in new window */
  title_link_blank_window?: Maybe<Scalars['Boolean']['output']>;
};

export type PageContentElementTextWithPanel = {
  __typename?: 'PageContentElementTextWithPanel';
  body?: Maybe<Scalars['String']['output']>;
  headline_emphasis?: Maybe<Scalars['String']['output']>;
  headline_main?: Maybe<Scalars['String']['output']>;
  /** Element is only visible for logged in users */
  only_logged_in?: Maybe<Scalars['Boolean']['output']>;
  panel_items?: Maybe<Array<Maybe<TextWithPanelItem>>>;
  panel_title?: Maybe<Scalars['String']['output']>;
  style_variant?: Maybe<Scalars['String']['output']>;
};


export type PageContentElementTextWithPanelBodyArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageContentElementTimeline = {
  __typename?: 'PageContentElementTimeline';
  note?: Maybe<Scalars['String']['output']>;
  /** Element is only visible for logged in users */
  only_logged_in?: Maybe<Scalars['Boolean']['output']>;
  stages?: Maybe<Array<Maybe<TimelineStage>>>;
  style_variant?: Maybe<Scalars['String']['output']>;
};


export type PageContentElementTimelineNoteArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageContentElementTvmAutomaticLanes = {
  __typename?: 'PageContentElementTvmAutomaticLanes';
  /** Lanes of this element. Pass `recommend` to only return lanes that are (or are not) flagged as recommended. */
  lanes?: Maybe<Array<TvmLane>>;
  /** Element is only visible for logged in users */
  only_logged_in?: Maybe<Scalars['Boolean']['output']>;
};


export type PageContentElementTvmAutomaticLanesLanesArgs = {
  recommend?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageContentElementTvmCustomLane = {
  __typename?: 'PageContentElementTvmCustomLane';
  /** Lane items */
  items?: Maybe<Array<Maybe<TvmCustomLaneItem>>>;
  /** Element is only visible for logged in users */
  only_logged_in?: Maybe<Scalars['Boolean']['output']>;
  /** Title */
  title?: Maybe<Scalars['String']['output']>;
  /** Title link */
  title_link?: Maybe<Scalars['String']['output']>;
  /** Open title link in new window */
  title_link_blank_window?: Maybe<Scalars['Boolean']['output']>;
};

export type PageContentElementTvmCustomLaneAd = {
  __typename?: 'PageContentElementTvmCustomLaneAd';
  /** Favicon */
  favicon?: Maybe<FairuAsset>;
  /** Lane items */
  items?: Maybe<Array<Maybe<TvmCustomLaneItem>>>;
  /** Link Text */
  link_text?: Maybe<Scalars['String']['output']>;
  /** Element is only visible for logged in users */
  only_logged_in?: Maybe<Scalars['Boolean']['output']>;
  /** Title */
  title?: Maybe<Scalars['String']['output']>;
  /** Title link */
  title_link?: Maybe<Scalars['String']['output']>;
  /** Open title link in new window */
  title_link_blank_window?: Maybe<Scalars['Boolean']['output']>;
};

export type PageContentElementTvmSports = {
  __typename?: 'PageContentElementTvmSports';
  entries?: Maybe<TvmSportQuery>;
  /** Element is only visible for logged in users */
  only_logged_in?: Maybe<Scalars['Boolean']['output']>;
  /** Title */
  title?: Maybe<Scalars['String']['output']>;
  /** Title link */
  title_link?: Maybe<Scalars['String']['output']>;
  /** Open title link in new window */
  title_link_blank_window?: Maybe<Scalars['Boolean']['output']>;
};

export type PageContentElementTvmTopics = {
  __typename?: 'PageContentElementTvmTopics';
  entries?: Maybe<TvmTopicQuery>;
  /** Element is only visible for logged in users */
  only_logged_in?: Maybe<Scalars['Boolean']['output']>;
};

export type PageContentElementTvmWatchlist = {
  __typename?: 'PageContentElementTvmWatchlist';
  /** Element is only visible for logged in users */
  only_logged_in?: Maybe<Scalars['Boolean']['output']>;
  query?: Maybe<TvmFavoritesRequestQuery>;
  /** Title */
  title?: Maybe<Scalars['String']['output']>;
  /** Title link */
  title_link?: Maybe<Scalars['String']['output']>;
  /** Open title link in new window */
  title_link_blank_window?: Maybe<Scalars['Boolean']['output']>;
};

export type PageContentElementTvmshorts = {
  __typename?: 'PageContentElementTvmshorts';
  /** Element is only visible for logged in users */
  only_logged_in?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Legacy wrapper, now served from the same CMS collection. Use `shorts`. */
  query_shorts?: Maybe<TvmShortQuery>;
  /** Shorts of this element, read from the CMS collection. */
  shorts?: Maybe<Array<TvmShort>>;
  /** Title */
  title?: Maybe<Scalars['String']['output']>;
  /** Title link */
  title_link?: Maybe<Scalars['String']['output']>;
  /** Open title link in new window */
  title_link_blank_window?: Maybe<Scalars['Boolean']['output']>;
};

export type PageContentElementVgnBrands = {
  __typename?: 'PageContentElementVgnBrands';
  /** All VGN Brands */
  brands?: Maybe<Array<Maybe<VgnBrand>>>;
  /** CTA buttons */
  ctas?: Maybe<Array<Maybe<CtaButton>>>;
  /** Element is only visible for logged in users */
  only_logged_in?: Maybe<Scalars['Boolean']['output']>;
  /** Short line under the headline */
  subline?: Maybe<Scalars['String']['output']>;
  /** Title override */
  title_override?: Maybe<Scalars['String']['output']>;
};

export type PageContentElementVgnFactbox = {
  __typename?: 'PageContentElementVgnFactbox';
  /** CTA buttons */
  ctas?: Maybe<Array<Maybe<CtaButton>>>;
  /** Key figures from VGN Company global */
  key_figures?: Maybe<Array<Maybe<VgnKeyFigure>>>;
  /** Source note for the figures (MA / ÖAK / ÖWA …), from the same global */
  key_figures_source?: Maybe<Scalars['String']['output']>;
  /** Element is only visible for logged in users */
  only_logged_in?: Maybe<Scalars['Boolean']['output']>;
  /** Title override */
  title_override?: Maybe<Scalars['String']['output']>;
};

/** Information about pagination using a fully featured paginator. */
export type PaginatorInfo = {
  __typename?: 'PaginatorInfo';
  /** Number of items in the current page. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Index of the current page. */
  currentPage?: Maybe<Scalars['Int']['output']>;
  /** Index of the first item in the current page. */
  firstItem?: Maybe<Scalars['Int']['output']>;
  /** Are there more pages after this one? */
  hasMorePages?: Maybe<Scalars['Boolean']['output']>;
  /** Index of the last item in the current page. */
  lastItem?: Maybe<Scalars['Int']['output']>;
  /** Index of the last available page. */
  lastPage?: Maybe<Scalars['Int']['output']>;
  /** Number of items per page. */
  perPage?: Maybe<Scalars['Int']['output']>;
  /** Number of total available items. */
  total?: Maybe<Scalars['Int']['output']>;
};

export type PaidContent = {
  __typename?: 'PaidContent';
  free_from?: Maybe<Scalars['Date']['output']>;
  free_until?: Maybe<Scalars['Date']['output']>;
  is_paid_content?: Maybe<Scalars['Boolean']['output']>;
  paid_content_types?: Maybe<Array<Maybe<PaidContentType>>>;
  permission?: Maybe<Scalars['String']['output']>;
};

export type PaidContentType = {
  __typename?: 'PaidContentType';
  id: Scalars['ID']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type PaymentMethodInput = {
  bankAccount?: InputMaybe<BankAccountInput>;
  stripeAccount?: InputMaybe<StripeAccountInput>;
  type: PaymentMethodType;
};

export enum PaymentMethodType {
  Invoice = 'INVOICE',
  Sepa = 'SEPA',
  Stripe = 'STRIPE'
}

export type Paywall = {
  __typename?: 'Paywall';
  /** Meta text */
  meta?: Maybe<Scalars['String']['output']>;
  products?: Maybe<Array<Maybe<PaywallProduct>>>;
  /** Text */
  text?: Maybe<Scalars['String']['output']>;
  /** Title for paywall */
  title?: Maybe<Scalars['String']['output']>;
};

export type PaywallProduct = {
  __typename?: 'PaywallProduct';
  /** Defines if the product is marked as best choice for customers */
  best_choice?: Maybe<Scalars['Boolean']['output']>;
  /** Paywall product entry */
  product?: Maybe<SubscriptionAd>;
};

export type PaywallProductMapping = {
  __typename?: 'PaywallProductMapping';
  article_type?: Maybe<Scalars['ID']['output']>;
  article_type_slug?: Maybe<Scalars['String']['output']>;
  article_type_title?: Maybe<Scalars['String']['output']>;
  /** Product ids from the compax system */
  products?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type PeopleCard = {
  __typename?: 'PeopleCard';
  body?: Maybe<Scalars['String']['output']>;
  contacts?: Maybe<Array<Maybe<PeopleCardContact>>>;
  image?: Maybe<FairuAsset>;
  name?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};


export type PeopleCardBodyArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PeopleCardContact = {
  __typename?: 'PeopleCardContact';
  link?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** Person information */
export type Person = {
  __typename?: 'Person';
  /** Main Article id */
  article_id?: Maybe<Scalars['String']['output']>;
  /** Article ids */
  article_ids?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Articles */
  articles?: Maybe<Array<Maybe<ArticleShort>>>;
  /** Id for the profile picture */
  asset_id?: Maybe<Scalars['String']['output']>;
  /** Birthplace */
  birth_place?: Maybe<Scalars['String']['output']>;
  /** Birthday */
  born_at?: Maybe<Scalars['String']['output']>;
  /** Company / Restaurant / Organisation */
  company?: Maybe<Scalars['String']['output']>;
  /** Created at */
  created_at?: Maybe<Scalars['DateTime']['output']>;
  /** Description */
  description?: Maybe<Scalars['String']['output']>;
  /** Death day */
  died_at?: Maybe<Scalars['String']['output']>;
  /** Edudation information */
  education?: Maybe<Scalars['String']['output']>;
  /** Enriched */
  enriched?: Maybe<Scalars['Boolean']['output']>;
  /** Episode for the person */
  episodes?: Maybe<Array<Maybe<Episode>>>;
  /** Familiy information */
  family?: Maybe<Scalars['String']['output']>;
  /** Gender */
  gender?: Maybe<Scalars['String']['output']>;
  /** Unique primary key. */
  id: Scalars['ID']['output'];
  /** Profile image */
  image?: Maybe<FairuAsset>;
  /** Job */
  job?: Maybe<Scalars['String']['output']>;
  /** Pivot information */
  meta?: Maybe<PersonMeta>;
  /** Meta data */
  metadata?: Maybe<Meta>;
  /** Movie ids */
  movie_ids?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Movies for the person */
  movies?: Maybe<MoviePaginationList>;
  /** Interviewed person or part of the interview. */
  name?: Maybe<Scalars['String']['output']>;
  /** Original id is set if the the entry has been transformed */
  original_id?: Maybe<Scalars['String']['output']>;
  /** Published */
  published?: Maybe<Scalars['Boolean']['output']>;
  /** Quote ids */
  quote_ids?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Quotes */
  quotes?: Maybe<Array<Maybe<Quote>>>;
  /** Data reviewed */
  reviewed?: Maybe<Scalars['Boolean']['output']>;
  /** Show ids */
  show_ids?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Shows for the person */
  shows?: Maybe<ShowPaginationList>;
  /** Slug */
  slug?: Maybe<Scalars['String']['output']>;
  /** Biography */
  summary?: Maybe<Scalars['String']['output']>;
  /** Tags for the person */
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Summary Long */
  text_lg?: Maybe<Scalars['String']['output']>;
  /** Summary Medium */
  text_md?: Maybe<Scalars['String']['output']>;
  /** Summary Small */
  text_sm?: Maybe<Scalars['String']['output']>;
  title_post?: Maybe<Scalars['String']['output']>;
  title_pre?: Maybe<Scalars['String']['output']>;
  /** Tmdb id */
  tmdb_id?: Maybe<Scalars['String']['output']>;
  /** Score */
  tmdb_score?: Maybe<Scalars['Float']['output']>;
  /** Ranking score behind orderBy: "popularity" - catalogue relevance, credits and TMDB popularity combined. Null until the scoring job has reached the person. */
  tvm_score?: Maybe<Scalars['Float']['output']>;
  /** Updated at */
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};


/** Person information */
export type PersonArticlesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


/** Person information */
export type PersonDescriptionArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Person information */
export type PersonEducationArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Person information */
export type PersonEpisodesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


/** Person information */
export type PersonFamilyArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Person information */
export type PersonMoviesArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


/** Person information */
export type PersonQuotesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


/** Person information */
export type PersonShowsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type PersonCoOccurrence = {
  __typename?: 'PersonCoOccurrence';
  /** The co-occurring person */
  person: Person;
  /** IDs of the shared works */
  sharedWorkIds: Array<Scalars['ID']['output']>;
  /** Number of works (Movies/Shows/Episodes) shared with the source person */
  sharedWorks: Scalars['Int']['output'];
};

/** One person in a ContentElementPersonList - stored inline on the article, not linked to the persons collection or to a CP user. */
export type PersonListEntry = {
  __typename?: 'PersonListEntry';
  /** Short description */
  description?: Maybe<Scalars['String']['output']>;
  /** First name */
  first_name?: Maybe<Scalars['String']['output']>;
  /** Portrait */
  image?: Maybe<FairuAsset>;
  /** Last name */
  last_name?: Maybe<Scalars['String']['output']>;
  /** Role or label shown under the name, e.g. "Gründerin & Bauingenieurin" */
  position?: Maybe<Scalars['String']['output']>;
};

export type PersonMeta = {
  __typename?: 'PersonMeta';
  /** Positions will only be attached in the correct relation */
  positions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Rolenames will only be attached in the correct relation */
  rolenames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type PersonMetaPositionsArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PersonPaginationList = {
  __typename?: 'PersonPaginationList';
  data?: Maybe<Array<Maybe<Person>>>;
  paginatorInfo?: Maybe<DefaultPaginator>;
};

export enum PersonRoleFilter {
  Cast = 'CAST',
  Crew = 'CREW',
  Director = 'DIRECTOR'
}

export type Personable = {
  __typename?: 'Personable';
  /** Entity */
  entity?: Maybe<Entity>;
  /** Person id */
  person_id: Scalars['ID']['output'];
  /** Entity model */
  personable_id: Scalars['ID']['output'];
  /** Position */
  position?: Maybe<Scalars['String']['output']>;
  /** Rolename */
  rolename?: Maybe<Scalars['String']['output']>;
};

export type PersonablePaginationList = {
  __typename?: 'PersonablePaginationList';
  data?: Maybe<Array<Maybe<Personable>>>;
  paginatorInfo?: Maybe<DefaultPaginator>;
};

export type PersonablePosition = {
  __typename?: 'PersonablePosition';
  label?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type PersonsPaginationList = {
  __typename?: 'PersonsPaginationList';
  data?: Maybe<Array<Maybe<Person>>>;
  paginatorInfo?: Maybe<DefaultPaginator>;
};

export type PointAward = {
  __typename?: 'PointAward';
  awarded_at?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  points: Scalars['Int']['output'];
  rule_key: Scalars['String']['output'];
  window_end?: Maybe<Scalars['String']['output']>;
  window_start?: Maybe<Scalars['String']['output']>;
};

export enum PointEventType {
  ArticleRead = 'ARTICLE_READ',
  RecipeRated = 'RECIPE_RATED',
  RecipeSearched = 'RECIPE_SEARCHED'
}

export type Popover = {
  __typename?: 'Popover';
  action_type?: Maybe<Scalars['String']['output']>;
  blacklist?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  cta?: Maybe<Link>;
  cta_title?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  frequency?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  image?: Maybe<FairuAsset>;
  newsletter_id?: Maybe<Scalars['String']['output']>;
  overlap?: Maybe<Scalars['Boolean']['output']>;
  portal?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  trigger?: Maybe<Scalars['String']['output']>;
  whitelist?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type PopoverDescriptionArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PowerBranding = {
  __typename?: 'PowerBranding';
  id: Scalars['ID']['output'];
  power_branding_color_bg?: Maybe<Scalars['String']['output']>;
  power_branding_color_fg?: Maybe<Scalars['String']['output']>;
  power_branding_color_primary?: Maybe<Scalars['String']['output']>;
  power_branding_color_surface?: Maybe<Scalars['String']['output']>;
  power_branding_image_landscape?: Maybe<FairuAsset>;
  power_branding_image_portrait?: Maybe<FairuAsset>;
  power_branding_url?: Maybe<Scalars['String']['output']>;
};

export type PricingCard = {
  __typename?: 'PricingCard';
  cta_label?: Maybe<Scalars['String']['output']>;
  cta_url?: Maybe<Scalars['String']['output']>;
  featured?: Maybe<Scalars['Boolean']['output']>;
  featured_badge?: Maybe<Scalars['String']['output']>;
  headline?: Maybe<Scalars['String']['output']>;
  includes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  price_eur?: Maybe<Scalars['String']['output']>;
  price_label?: Maybe<Scalars['String']['output']>;
  price_pp?: Maybe<Scalars['String']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  tag?: Maybe<Scalars['String']['output']>;
};

export type Product = {
  __typename?: 'Product';
  /** Description of the product. */
  description?: Maybe<Scalars['String']['output']>;
  /** Unique primary key. */
  id: Scalars['ID']['output'];
  /** Image for the product. */
  image?: Maybe<FairuAsset>;
  /** URL link for the product. */
  link?: Maybe<Scalars['String']['output']>;
  /** Portal this product belongs to. */
  portal?: Maybe<Scalars['String']['output']>;
  /** Price of the product. */
  price?: Maybe<Scalars['String']['output']>;
  /** Ressorts this product is linked to. */
  resorts?: Maybe<Array<Maybe<Ressort>>>;
  /** Slug or alias for the product. */
  slug?: Maybe<Scalars['String']['output']>;
  /** Title of the product. */
  title?: Maybe<Scalars['String']['output']>;
};


export type ProductDescriptionArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProductFilter = {
  /** Filter by portal */
  portal?: InputMaybe<Scalars['String']['input']>;
  /** Filter by resort ID */
  ressort?: InputMaybe<Scalars['String']['input']>;
  /** Search in title and description */
  search?: InputMaybe<Scalars['String']['input']>;
};

export type ProductsOfferingBasketEntry = {
  __typename?: 'ProductsOfferingBasketEntry';
  basketEntryType?: Maybe<Scalars['String']['output']>;
  billType?: Maybe<Scalars['String']['output']>;
  discounts?: Maybe<Array<Maybe<ProductsOfferingDiscount>>>;
  documents?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  existingService?: Maybe<Scalars['Boolean']['output']>;
  loyaltyPoints?: Maybe<Scalars['Int']['output']>;
  offeringId?: Maybe<Scalars['Int']['output']>;
  offeringName?: Maybe<Scalars['String']['output']>;
  oneTimeCharges?: Maybe<Array<Maybe<ProductsOfferingCharge>>>;
  options?: Maybe<Array<Maybe<ProductsOfferingBasketEntry>>>;
  print?: Maybe<Scalars['Boolean']['output']>;
  product?: Maybe<ProductsOfferingProduct>;
  quantity?: Maybe<Scalars['Int']['output']>;
  startDtRequested?: Maybe<Scalars['String']['output']>;
  tariff?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  uuid?: Maybe<Scalars['String']['output']>;
};

export type ProductsOfferingBonus = {
  __typename?: 'ProductsOfferingBonus';
  bonusName?: Maybe<Scalars['String']['output']>;
  costs?: Maybe<Scalars['Float']['output']>;
  deliveryCost?: Maybe<Scalars['Float']['output']>;
};

export type ProductsOfferingCharge = {
  __typename?: 'ProductsOfferingCharge';
  amount?: Maybe<Scalars['Float']['output']>;
  amountDiscounts?: Maybe<Scalars['Float']['output']>;
  amountNet?: Maybe<Scalars['Float']['output']>;
  amountNetDiscounts?: Maybe<Scalars['Float']['output']>;
  charge?: Maybe<ProductsOfferingChargeRef>;
  chargeMode?: Maybe<CustomerStatus>;
  chargeType?: Maybe<CustomerStatus>;
  taxRate?: Maybe<Scalars['Float']['output']>;
  undiscountedAmount?: Maybe<Scalars['Float']['output']>;
  undiscountedAmountNet?: Maybe<Scalars['Float']['output']>;
  unitAmount?: Maybe<Scalars['Float']['output']>;
  unitAmountNet?: Maybe<Scalars['Float']['output']>;
};

export type ProductsOfferingChargeRef = {
  __typename?: 'ProductsOfferingChargeRef';
  id?: Maybe<Scalars['Int']['output']>;
};

export type ProductsOfferingDiscount = {
  __typename?: 'ProductsOfferingDiscount';
  amount?: Maybe<Scalars['Float']['output']>;
  amountNet?: Maybe<Scalars['Float']['output']>;
  discountName?: Maybe<Scalars['String']['output']>;
  discountType?: Maybe<ProductsOfferingDiscountType>;
  id?: Maybe<Scalars['Int']['output']>;
  percentage?: Maybe<Scalars['Float']['output']>;
  taxRate?: Maybe<Scalars['Float']['output']>;
};

export type ProductsOfferingDiscountType = {
  __typename?: 'ProductsOfferingDiscountType';
  id?: Maybe<Scalars['Int']['output']>;
};

export type ProductsOfferingOneTimeTotal = {
  __typename?: 'ProductsOfferingOneTimeTotal';
  amount?: Maybe<Scalars['Float']['output']>;
  amountDiscounts?: Maybe<Scalars['Float']['output']>;
  amountNet?: Maybe<Scalars['Float']['output']>;
  amountNetDiscounts?: Maybe<Scalars['Float']['output']>;
  chargeMode?: Maybe<CustomerStatus>;
  chargeType?: Maybe<CustomerStatus>;
  taxAmounts?: Maybe<Array<Maybe<ProductsOfferingTaxAmount>>>;
  undiscountedAmount?: Maybe<Scalars['Float']['output']>;
  undiscountedAmountNet?: Maybe<Scalars['Float']['output']>;
};

export type ProductsOfferingProduct = {
  __typename?: 'ProductsOfferingProduct';
  id?: Maybe<Scalars['Int']['output']>;
};

export type ProductsOfferingRecurringTotal = {
  __typename?: 'ProductsOfferingRecurringTotal';
  amount?: Maybe<Scalars['Float']['output']>;
  amountDiscounts?: Maybe<Scalars['Float']['output']>;
  amountNet?: Maybe<Scalars['Float']['output']>;
  amountNetDiscounts?: Maybe<Scalars['Float']['output']>;
  chargeMode?: Maybe<CustomerStatus>;
  chargeType?: Maybe<CustomerStatus>;
  taxAmounts?: Maybe<Array<Maybe<ProductsOfferingTaxAmount>>>;
  undiscountedAmount?: Maybe<Scalars['Float']['output']>;
  undiscountedAmountNet?: Maybe<Scalars['Float']['output']>;
};

export type ProductsOfferingResult = {
  __typename?: 'ProductsOfferingResult';
  bonuses?: Maybe<Array<Maybe<ProductsOfferingBonus>>>;
  deliveryCost?: Maybe<Scalars['Float']['output']>;
  entries?: Maybe<Array<Maybe<ProductsOfferingBasketEntry>>>;
  id: Scalars['String']['output'];
  legal_cancel?: Maybe<Scalars['String']['output']>;
  legal_text?: Maybe<Scalars['String']['output']>;
  priceAfterOffering?: Maybe<ProductsOfferingTotal>;
  total: ProductsOfferingTotal;
  uuid: Scalars['String']['output'];
  vnFeProductDisplays?: Maybe<Array<Maybe<VnFeProductDisplay>>>;
};

export type ProductsOfferingTaxAmount = {
  __typename?: 'ProductsOfferingTaxAmount';
  amount?: Maybe<Scalars['Float']['output']>;
  taxRate?: Maybe<Scalars['Float']['output']>;
};

export type ProductsOfferingTotal = {
  __typename?: 'ProductsOfferingTotal';
  oneTime?: Maybe<ProductsOfferingOneTimeTotal>;
  recurring?: Maybe<ProductsOfferingRecurringTotal>;
};

export type PromotionalCodeResult = {
  __typename?: 'PromotionalCodeResult';
  amount?: Maybe<Scalars['Float']['output']>;
  campaign?: Maybe<Scalars['Int']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  promotionalCode?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type Provider = {
  __typename?: 'Provider';
  /** Article id */
  article_id?: Maybe<Scalars['String']['output']>;
  /** Id for the profile picture */
  asset_id?: Maybe<Scalars['String']['output']>;
  /** Id for the profile picture */
  asset_white_id?: Maybe<Scalars['String']['output']>;
  /** Configured grouping; does not modify stored providers or offers. */
  collapse: ProviderCollapse;
  favorite?: Maybe<TvmFavorite>;
  /** Unique Id */
  id: Scalars['ID']['output'];
  /** Provider image */
  image?: Maybe<FairuAsset>;
  /** Provider image */
  image_white?: Maybe<FairuAsset>;
  /** Meta data */
  metadata?: Maybe<Meta>;
  /** Movies */
  movies?: Maybe<Array<Maybe<Movie>>>;
  /** Name of the provider */
  name?: Maybe<Scalars['String']['output']>;
  /** Phone number */
  phone?: Maybe<Scalars['String']['output']>;
  /** Published entry */
  published?: Maybe<Scalars['Boolean']['output']>;
  /** Review */
  review?: Maybe<Scalars['String']['output']>;
  /** Shows */
  shows?: Maybe<Array<Maybe<Show>>>;
  /** Slug */
  slug?: Maybe<Scalars['String']['output']>;
  /** Sort */
  sort?: Maybe<Scalars['Int']['output']>;
  /** Sponsoring */
  sponsoring?: Maybe<Scalars['Boolean']['output']>;
  /** Type within the service entity */
  type?: Maybe<Scalars['String']['output']>;
  /** Url */
  url?: Maybe<Scalars['String']['output']>;
  /** Movies */
  vods?: Maybe<Array<Maybe<Vod>>>;
  youtube_channel_id?: Maybe<Scalars['String']['output']>;
  youtube_fetching?: Maybe<Scalars['Boolean']['output']>;
};


export type ProviderReviewArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Explicit config hierarchy. Independent providers are neither parents nor variants. */
export type ProviderCollapse = {
  __typename?: 'ProviderCollapse';
  canonical_slug: Scalars['String']['output'];
  is_parent: Scalars['Boolean']['output'];
  is_variant: Scalars['Boolean']['output'];
  member_slugs: Array<Scalars['String']['output']>;
  parent_slug?: Maybe<Scalars['String']['output']>;
};

/** A paginated list of Provider items. */
export type ProviderPaginator = {
  __typename?: 'ProviderPaginator';
  /** A list of Provider items. */
  data: Array<Provider>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type Query = {
  __typename?: 'Query';
  activeUserTransitions?: Maybe<Array<Maybe<UserTransition>>>;
  appleTvApp?: Maybe<Array<Maybe<AppleTvAppLine>>>;
  archiveIssue?: Maybe<ArchiveIssue>;
  archiveIssues?: Maybe<ArchiveIssuePagination>;
  archivePage?: Maybe<ArchivePage>;
  archivePages: Array<ArchivePage>;
  archiveYears: Array<ArchiveYearStats>;
  /** Get a single article */
  article?: Maybe<Article>;
  /** List multiple articles. */
  articles?: Maybe<Array<Maybe<Article>>>;
  /**
   * The most recent articles across a set of ressorts, newest first.
   *
   * Editorial alternative to ordering by pageviews: on portals like woman or gusto
   * the best-read stories are frequently Gewinnspiele or advertorials, so a
   * "trending" feed misrepresents the brand. `ressorts` takes SLUGS (not uuids) and
   * matches child ressorts too — most woman ressorts (Impact, Culture, …) are
   * parents whose articles only reference them via ressort_parent_id.
   *
   * `max` is the total number returned across the whole set, not per ressort.
   */
  articlesByRessorts?: Maybe<Array<Maybe<Article>>>;
  /** List multiple articles. */
  articlesMeili?: Maybe<Array<Maybe<Article>>>;
  /** List the newest articles. */
  articlesNew?: Maybe<ArticlePaginatorSimple>;
  /** List multiple articles. */
  articlesPaginated?: Maybe<ArticlePaginatorSimple>;
  /** Single calculator form by slug (filename), including the full JSON body. */
  calculatorForm?: Maybe<CalculatorForm>;
  /** All calculator form definitions (id, slug, title — no body). */
  calculatorForms?: Maybe<Array<Maybe<CalculatorForm>>>;
  carBrand?: Maybe<VgnCarBrand>;
  carBrands: Array<VgnCarBrand>;
  carModel?: Maybe<VgnCarModel>;
  carModels: Array<VgnCarModel>;
  carad?: Maybe<VgnCarAd>;
  carads?: Maybe<VgnCarAdList>;
  channel?: Maybe<TvChannel>;
  channelDates?: Maybe<Array<Maybe<ChannelDate>>>;
  channelEntries?: Maybe<TvChannelList>;
  channelList: TvChannelPaginator;
  /**
   * Lean channel→logo list, sorted by `sort`. Two uses:
   * - Frontend delivery: default args return only channels that already have a logo.
   * - Logo-mapping audit: pass `onlyWithLogo: false, onlyPublished: false` to list
   *   every channel with its raw `asset_id` (null = still needs to be linked).
   */
  channelLogos?: Maybe<Array<Maybe<ChannelLogo>>>;
  channelShowtime?: Maybe<TvChannelShowtime>;
  channelShowtimeByEventId?: Maybe<TvChannelShowtime>;
  channelShowtimeList?: Maybe<Array<Maybe<TvChannelShowtime>>>;
  channelShowtimeNow?: Maybe<TvChannelShowtime>;
  channelShowtimes?: Maybe<ShowtimesPaginationList>;
  channelShowtimesList?: Maybe<Array<Maybe<TvChannelShowtime>>>;
  /** Will return a list of showtimes that needs to be mapped */
  channelShowtimesNeedsMapping?: Maybe<Array<TvChannelShowtime>>;
  channels: TvChannelPaginator;
  checkCustomerSubscription?: Maybe<Array<Maybe<Scalars['Boolean']['output']>>>;
  checkWorkflowPasswordReset?: Maybe<VerifyUserAccountResult>;
  cinema?: Maybe<Cinema>;
  cinemaDates?: Maybe<Array<Maybe<CinemaDate>>>;
  cinemas: CinemaPaginator;
  cities: CityPaginator;
  city?: Maybe<City>;
  /**
   * Persons that frequently appear in the same works as the source person
   * (e.g. recurring actor–director pairings, ensemble casts).
   */
  coOccurringPersons?: Maybe<Array<PersonCoOccurrence>>;
  collage?: Maybe<Collage>;
  collagen?: Maybe<CollagePaginatorSimple>;
  collection?: Maybe<Collection>;
  collectionBySlug?: Maybe<Collection>;
  collections?: Maybe<Array<Maybe<Collection>>>;
  collectionsPaginated?: Maybe<TvmCollectionPaginationList>;
  compaxSessionStatus?: Maybe<CompaxSessionStatusResult>;
  compaxSubscriptions?: Maybe<CompaxSubscriptionsResult>;
  compaxValidToken?: Maybe<CompaxTokenResult>;
  currentCinemaPoster?: Maybe<Array<Maybe<CinemaPoster>>>;
  currentStatus?: Maybe<Scalars['String']['output']>;
  customerAccounts?: Maybe<Array<Maybe<CustomerAccounts>>>;
  customerAccountsSepa?: Maybe<Array<Maybe<CustomerAccounts>>>;
  /**
   * Compax product ids the customer is currently entitled to, derived
   * through the same flatten + per-service status/date logic that
   * produces their permissions. Use this to gate content on a specific
   * product instead of re-deriving from customerContracts.activeServices.
   */
  customerActiveProductIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  customerBill?: Maybe<CustomerBill>;
  customerBills?: Maybe<Array<Maybe<CustomerBills>>>;
  /**
   * Number of contract services (active and inactive, sub-services flattened)
   * of the customer behind the token; null when Compax could not answer.
   * Accepts the raw customer-scoped Compax token of the anonymous overlay
   * checkout. Used there to tell whether a submission that errored (e.g. a
   * proxy timeout) created the order anyway: the overlay customer is created
   * fresh per checkout, so before its first order this is always 0.
   */
  customerContractServiceCount?: Maybe<Scalars['Int']['output']>;
  customerContracts?: Maybe<CustomerContracts>;
  customerContractsActive?: Maybe<CustomerContracts>;
  customerCurrent?: Maybe<CustomerUser>;
  customerData?: Maybe<CustomerData>;
  customerDeliveryComplaints?: Maybe<CustomerDeliveryExtendedValues>;
  customerDeliveryComplaintsContract?: Maybe<CustomerDeliveryComplaintsContractResult>;
  customerDeliverySuspensions?: Maybe<CustomerDeliveryExtendedValues>;
  customerDeliverySuspensionsActive?: Maybe<CustomerDeliverySuspensionsActiveResult>;
  customerVacationAddresses?: Maybe<Array<Maybe<CustomerAddress>>>;
  customerVacationAddressesOngoing?: Maybe<Array<Maybe<CustomerAddressRedirects>>>;
  /** Staff-only: mint a fresh short-lived signed download URL for one document. */
  dataSubjectDocumentUrl?: Maybe<DataSubjectDocumentUrl>;
  /** Staff-only: fetch a data-subject request and its document metadata (no files). */
  dataSubjectRequestAdmin?: Maybe<DataSubjectRequestAdmin>;
  /** All discount codes for a portal (or all portals when omitted). */
  discountCodes?: Maybe<Array<Maybe<DiscountCode>>>;
  /** Discount codes whose linked subscription's compax_product_id matches. */
  discountCodesForCompaxProduct?: Maybe<Array<Maybe<DiscountCode>>>;
  /** Discount codes whose linked subscription page id matches. */
  discountCodesForSubscription?: Maybe<Array<Maybe<DiscountCode>>>;
  /** Anti-bot token for the Betroffenenrechte form: fetched on page load, required with submit once enforcement is on. */
  dsrFormToken: Scalars['String']['output'];
  emailMailRequest?: Maybe<MailRequest>;
  emailMailRequests: MailRequestPaginationList;
  entities?: Maybe<EntityPaginationList>;
  entity?: Maybe<EntityEntry>;
  episode?: Maybe<Episode>;
  episodes: EpisodePaginator;
  event?: Maybe<VgnEvent>;
  eventcategories?: Maybe<VgnEventCategoryList>;
  eventcategory?: Maybe<VgnEventCategory>;
  eventplaces?: Maybe<VgnEventPlaceList>;
  events?: Maybe<VgnEventList>;
  eventsection?: Maybe<VgnEventSection>;
  eventsections?: Maybe<VgnEventSectionList>;
  /** Get a single external link. */
  externalLink?: Maybe<Link>;
  /** List external links. */
  externalLinks?: Maybe<Array<Maybe<Link>>>;
  /** Get all files AND empty folders with full path, cursor-paginated for S3-compatible listing (max 5000 entries per page) */
  fairuAllFilesFlat: FairuAllFilesFlatResult;
  /** Get a single backup target */
  fairuBackup?: Maybe<FairuBackup>;
  /** Get a list of backup targets for the tenant */
  fairuBackups?: Maybe<FairuBackupList>;
  /** Get a single blueprint, by id or by handle */
  fairuBlueprint?: Maybe<FairuBlueprint>;
  /** Get the metadata blueprints defined in the tenant */
  fairuBlueprints?: Maybe<FairuBlueprintList>;
  /** Get a single catalog, by id or by handle */
  fairuCatalog?: Maybe<FairuCatalog>;
  /** Get the shared option catalogs defined in the tenant */
  fairuCatalogs?: Maybe<FairuCatalogList>;
  /** Get a single copyright entry in the tenant */
  fairuCopyright?: Maybe<FairuCopyright>;
  /** Get a list of copyrights for the tenant */
  fairuCopyrights?: Maybe<FairuCopyrightList>;
  /** Get a single sync disk configuration */
  fairuDisk?: Maybe<FairuDisk>;
  /** Get a single sync disk status */
  fairuDiskStatus?: Maybe<FairuDiskStatus>;
  /** Get a list of sync configuration for the tenant */
  fairuDisks?: Maybe<FairuDiskList>;
  /** Get a single dmca report */
  fairuDmca?: Maybe<FairuDmca>;
  /** Get a list of sync configuration for the tenant */
  fairuDmcas?: Maybe<FairuDmcaList>;
  /** Get a single fieldset, by id or by handle */
  fairuFieldset?: Maybe<FairuFieldset>;
  /** Get the fieldsets defined in the tenant */
  fairuFieldsets?: Maybe<FairuFieldsetList>;
  /** Get a single file data */
  fairuFile?: Maybe<FairuAsset>;
  /**
   * Find an existing file by the SHA1 of its content, before uploading it.
   *
   * Answers with the oldest asset in the workspace that still holds those bytes
   * — never an archived, license-blocked or missing one — or null. A null is not
   * proof the content is new: the hash is written by a queued job after upload,
   * so a file that arrived moments ago may not be findable yet, and any asset
   * whose bytes were rewritten after upload (AI provenance marker, face blur)
   * carries the hash of the rewritten object rather than of what was sent.
   */
  fairuFileByFingerprint?: Maybe<FairuAsset>;
  /** Get a single file by its path (e.g., '/marketing/2024/hero.jpg') */
  fairuFileByPath?: Maybe<FairuAsset>;
  /** Get all comments for a single file. Requires file::view permission on the tenant. Not exposed on FairuAsset. */
  fairuFileComments?: Maybe<Array<FairuFileComment>>;
  /** Get only the files for a folder */
  fairuFiles?: Maybe<FairuAssetList>;
  /**
   * Find assets by their custom metadata.
   *
   * Values are matched exactly, in the database, so anything written through the
   * API is findable on the next request with no reindex in between.
   */
  fairuFilesByMetadata?: Maybe<FairuAssetList>;
  /** Get files filtered by tags (OR logic - files matching any of the given tags) */
  fairuFilesByTag?: Maybe<FairuAssetList>;
  /** Calculate total size in bytes for a list of file IDs (max 2000) */
  fairuFilesTotalSize: Scalars['Int']['output'];
  /** Get the folder data (files and folder) for a folder */
  fairuFolder?: Maybe<FairuFolderList>;
  /**
   * The blueprints that apply to a folder — its own and everything it inherits —
   * which is what a file placed in it would get.
   */
  fairuFolderBlueprints?: Maybe<Array<FairuAssetBlueprint>>;
  /** Get a single folder by its path (e.g., '/marketing/2024/summer') */
  fairuFolderByPath?: Maybe<FairuFolder>;
  /** Get list of galleries that should be displayed */
  fairuGalleries?: Maybe<FairuGalleryList>;
  /** Get single gallery */
  fairuGallery?: Maybe<FairuGallery>;
  /** Simple health check query */
  fairuHealthCheck?: Maybe<FairuHealthStatus>;
  /** The label set of this workspace, in the order it was arranged in. */
  fairuLabels?: Maybe<Array<FairuLabel>>;
  /** Get a single license information */
  fairuLicense?: Maybe<FairuLicense>;
  /** Get a list of licenses defined in the tenant */
  fairuLicenses?: Maybe<FairuLicenseList>;
  /**
   * The counts behind a filter panel: every option of every select, multi-select
   * and checkbox field, with how many assets it would leave.
   */
  fairuMetadataFacets?: Maybe<Array<FairuMetadataFacet>>;
  /** Get a list of files */
  fairuMultipleFiles?: Maybe<Array<Maybe<FairuAsset>>>;
  /**
   * A published channel, readable without an account.
   *
   * Open on purpose, the way `fairuFile` is: a CMS embedding a channel resolves
   * it before anyone has logged in. It answers exactly what a visitor to
   * `/channels/{id}` sees and nothing more — only active seasons, only active
   * episodes, only episodes whose video is still there, and none of the play
   * counts or publishing settings, which `@ownerOnly` withholds.
   *
   * Null for an unpublished channel, for a workspace that has the feature
   * switched off, and for a channel that does not exist. A caller cannot tell
   * those apart on purpose.
   *
   * By id only: a slug is unique inside a workspace and nowhere else, so it
   * cannot address a channel without one.
   */
  fairuPublicVideoChannel?: Maybe<FairuVideoChannel>;
  /**
   * One published channel of a workspace, by the name it is addressed with.
   *
   * The counterpart of `fairuVideoChannelBySlug` for a caller with no account,
   * and the query `fairuPublicVideoChannel` says it cannot be: a slug is unique
   * inside a workspace and nowhere else, so `tenant` has to name the workspace
   * before the slug means anything. That is what lets a site route
   * `/podcasts/die-werkstatt` rather than carry a uuid in every link.
   *
   * Null for an unpublished channel, for a workspace with the feature switched
   * off, for a slug that belongs to a different workspace, and for a slug that
   * belongs to nobody. A caller cannot tell those apart on purpose — a query
   * that answered differently for a taken slug would enumerate the names other
   * workspaces chose.
   */
  fairuPublicVideoChannelBySlug?: Maybe<FairuVideoChannel>;
  /**
   * The published channels of one workspace, readable without an account.
   *
   * The list `fairuPublicVideoChannel` cannot offer. It addresses a channel by
   * id because a slug needs a workspace to be unique in; the same gap makes a
   * list impossible without a workspace to list, and `tenant` is what supplies
   * one. With it an app that has nobody logged in can render a shelf of channels
   * and open one by name.
   *
   * Published channels only, and only the ones the workspace wants listed:
   * `exclude_from_list` is what it sets on a channel it publishes without
   * advertising, and this is an advertisement. The two queries that address a
   * channel directly still answer for such a channel, because whoever holds the
   * address was given it.
   *
   * Each row answers as `fairuPublicVideoChannel` does — no play counts, no
   * publishing settings, only active seasons and only episodes whose video is
   * still there.
   *
   * Empty for a workspace that does not exist, for one with the feature switched
   * off, and for an id that is not a workspace id. None of them is an error, so
   * a client can ask unconditionally and render nothing, and none of them reads
   * differently from the others.
   */
  fairuPublicVideoChannels?: Maybe<FairuVideoChannelList>;
  /** Get a list of Raku credentials (S3-compatible storage) for the tenant */
  fairuRakuCredentials: Array<FairuRakuCredential>;
  /** Get a single role information */
  fairuRole?: Maybe<FairuRole>;
  /** Get a list of roles defined in the tenant */
  fairuRoles?: Maybe<FairuRoleList>;
  /** Search names, captions, descriptions and metadata values within the tenant or selected library folders. Folder selection does not grant download access. */
  fairuSearch?: Maybe<FairuAssetList>;
  /** Get a list of sub-tenants for the current tenant */
  fairuSubTenants: Array<FairuTenant>;
  /** Get all supported domains (default proxy + verified custom domains). Cached for 5-15 minutes. */
  fairuSupportedDomains: Array<Scalars['String']['output']>;
  /** Get a single tag entry in the tenant */
  fairuTag?: Maybe<FairuTag>;
  /** Get a list of tags defined in the tenant */
  fairuTags?: Maybe<FairuTagList>;
  /** Get the information of the current tenant */
  fairuTenant?: Maybe<FairuTenant>;
  /** Get the information of a fairu user withing the tenant */
  fairuUser?: Maybe<FairuUser>;
  /** Get a list of users attached to the tenant */
  fairuUsers?: Maybe<FairuUserList>;
  fairuVideoChannel?: Maybe<FairuVideoChannel>;
  /** By slug, for a surface that addresses a channel by name rather than by id. */
  fairuVideoChannelBySlug?: Maybe<FairuVideoChannel>;
  /**
   * What goes live when, across every channel of the workspace.
   *
   * The one channel read that crosses channels, because that is the question a
   * calendar answers: a fortnight's plan is spread over several shows, and a
   * per-channel list can only show part of it.
   *
   * Only the episodes whose visibility *changes* inside the range — one of their
   * release dates falls in it. An episode that is simply out for the whole month
   * is not an entry; a calendar shows what happens, and a month view repeating
   * every episode ever published buries the three that matter. Both ends are
   * inclusive, and rows come back by the moment they move, earliest first.
   *
   * `from` defaults to today and `to` to a month later. A range is capped at a
   * year and the answer at 250 entries, so a wide window cannot become an
   * unbounded query. Empty when the workspace does not have the feature.
   */
  fairuVideoChannelSchedule: Array<FairuVideoChannelScheduleEntry>;
  /** Video channels of the workspace. Empty when the feature is switched off. */
  fairuVideoChannels?: Maybe<FairuVideoChannelList>;
  /** Get a single webhook */
  fairuWebhook?: Maybe<FairuWebhook>;
  /** Get a list of webhooks for the tenant */
  fairuWebhooks?: Maybe<FairuWebhookList>;
  /** Get a single workflow information */
  fairuWorkflow?: Maybe<FairuWorkflow>;
  /** Get a list of defined workflows of the tenant */
  fairuWorkflows?: Maybe<FairuWorkflowList>;
  favoriteGroup?: Maybe<UserFavoriteGroup>;
  favoriteGroups?: Maybe<Array<UserFavoriteGroup>>;
  favorites?: Maybe<Array<Maybe<UserFavorite>>>;
  favoritesPaginated?: Maybe<UserFavoriteList>;
  favoritesRecipes?: Maybe<GustoRecipeFavoritesRequest>;
  findBySlug?: Maybe<Entry>;
  /** List multiple galleries. */
  galleries?: Maybe<Array<Maybe<Gallery>>>;
  /** Get a single quote. */
  gallery?: Maybe<Gallery>;
  genre?: Maybe<Genre>;
  genres: GenrePaginator;
  getStates?: Maybe<Array<Maybe<CountryState>>>;
  /** List multiple globals. */
  globals?: Maybe<Global>;
  gustoAmountTypeEnumMapping: Array<GustoAmountTypeEnumMapping>;
  gustoAuthor?: Maybe<GustoAuthor>;
  gustoAuthors?: Maybe<GustoAuthorPagination>;
  gustoAuthorsByIds?: Maybe<GustoAuthorPagination>;
  gustoCategories?: Maybe<GustoRecipeCategoryPagination>;
  gustoCategoriesByIds?: Maybe<GustoRecipeCategoryPagination>;
  gustoCategory?: Maybe<GustoRecipeCategory>;
  gustoCountries?: Maybe<GustoCountryPagination>;
  gustoCountriesByIds?: Maybe<GustoCountryPagination>;
  gustoCountry?: Maybe<GustoCountry>;
  gustoGalleries?: Maybe<GustoGalleryPagination>;
  gustoGalleriesByIds?: Maybe<GustoGalleryPagination>;
  gustoGallery?: Maybe<GustoGallery>;
  gustoIngredient?: Maybe<GustoIngredient>;
  gustoIngredients?: Maybe<GustoIngredientPagination>;
  gustoIngredientsByIds?: Maybe<GustoIngredientPagination>;
  gustoIssue?: Maybe<GustoIssue>;
  gustoIssueYears?: Maybe<GustoIssueYearsPagination>;
  gustoIssues?: Maybe<GustoIssuePagination>;
  gustoOccasion?: Maybe<GustoOccasion>;
  gustoOccasions?: Maybe<GustoOccasionPagination>;
  gustoOccasionsByIds?: Maybe<GustoOccasionPagination>;
  gustoProperties?: Maybe<GustoRecipePropertiesPagination>;
  gustoPropertiesByIds?: Maybe<GustoRecipePropertiesPagination>;
  gustoProperty?: Maybe<GustoRecipeProperty>;
  gustoRecipe?: Maybe<GustoRecipe>;
  gustoRecipes?: Maybe<GustoRecipePagination>;
  gustoRecipesByIds?: Maybe<GustoRecipePagination>;
  gustoTip?: Maybe<GustoTip>;
  gustoTips?: Maybe<GustoTipPagination>;
  gustoTipsByIds?: Maybe<GustoTipPagination>;
  health?: Maybe<Health>;
  horoskop?: Maybe<Horoskop>;
  horoskops?: Maybe<Array<Maybe<Horoskop>>>;
  lawCategories: Array<LawCategory>;
  lawCompanies: Array<LawCompanyListItem>;
  lawCompany?: Maybe<LawCompany>;
  lawSurveyExport: Scalars['String']['output'];
  /** Get a single link collection. */
  linkCollection?: Maybe<LinkCollection>;
  /** List external links. */
  linkCollections?: Maybe<Array<Maybe<LinkCollection>>>;
  magazine_specials?: Maybe<Array<Maybe<Magazine>>>;
  /** Magazine covers. */
  magazines?: Maybe<Array<Maybe<Magazine>>>;
  /** Public list of editorial marketplace selections ordered by position. */
  marketplaceEditorialSelections: Array<MarketplaceEditorialSelection>;
  /** @deprecated The shorts import was removed — this query only serves the frozen mirror and will be dropped. */
  mcstreamy?: Maybe<McStreamyPaginationList>;
  /** @deprecated The shorts import was removed — this query only serves the frozen mirror and will be dropped. */
  mcstreamyById?: Maybe<McStreamy>;
  me?: Maybe<User>;
  mooncalendar?: Maybe<MooncalendarDayPaginationList>;
  mooncalendarDay?: Maybe<MoonCalendarDay>;
  mooncalendarDays?: Maybe<Array<Maybe<MoonCalendarDay>>>;
  mooncalendarItem?: Maybe<MoonCalendarDay>;
  movie?: Maybe<Movie>;
  movies?: Maybe<MoviesPaginationList>;
  moviesInCinema?: Maybe<MoviesPaginationList>;
  moviesList?: Maybe<Array<Maybe<Movie>>>;
  moviesNew: MoviePaginator;
  moviesNewestInCinema?: Maybe<MoviesPaginationList>;
  moviesPopularity: MoviePaginator;
  moviesTv: MoviePaginator;
  /** Active challenges with the current user's progress. */
  myChallenges?: Maybe<Array<ChallengeProgress>>;
  myNewsletter?: Maybe<Array<Maybe<Newsletter>>>;
  myNewsletterBrevo?: Maybe<Array<Maybe<Newsletter>>>;
  myNewsletterPreferencesCustomerIo: MyNewsletterPreferences;
  myNewsletters?: Maybe<Array<Maybe<Newsletter>>>;
  myNewslettersBrevo?: Maybe<Array<Maybe<Newsletter>>>;
  /** The current user's award history (most recent first). */
  myPointAwards?: Maybe<Array<PointAward>>;
  /** Total points balance for the current user. */
  myPoints?: Maybe<Scalars['Int']['output']>;
  /** Whether the authenticated caller has already submitted the given survey (for once-only gating). */
  mySurveyResponse?: Maybe<MySurveyStatus>;
  myZodiac?: Maybe<HoroskopZodiac>;
  navigation?: Maybe<Navigation>;
  navigationByHandle?: Maybe<Navigation>;
  navigationByHandles?: Maybe<Array<Maybe<Navigation>>>;
  /** List multiple users. */
  navigations?: Maybe<Array<Maybe<Navigation>>>;
  newsletter?: Maybe<Newsletter>;
  newsletterBrevo?: Maybe<Newsletter>;
  newsletter_overviews?: Maybe<Array<Maybe<NewsletterOverview>>>;
  newsletters?: Maybe<Array<Newsletter>>;
  newslettersBrevo?: Maybe<Array<Newsletter>>;
  now: NowEntryItemPaginator;
  /** Get a single page */
  page?: Maybe<Page>;
  /** List all pages. */
  pages?: Maybe<Array<Maybe<Page>>>;
  paywall?: Maybe<Paywall>;
  /** List all product mappings */
  paywallProducts?: Maybe<Array<PaywallProductMapping>>;
  person?: Maybe<Person>;
  personablePositions?: Maybe<Array<Maybe<PersonablePosition>>>;
  personables?: Maybe<PersonablePaginationList>;
  persons?: Maybe<PersonsPaginationList>;
  personsList?: Maybe<Array<Maybe<Person>>>;
  /** List photographers (Statamic users with jwt-events-update). Guarded — caller must have events:create + events:delete. */
  photographers?: Maybe<Array<Maybe<VgnPhotographer>>>;
  /** Returns all popovers for a portal. Filters by slug: popovers with a whitelist only match when slug is present; popovers with a blacklist return nothing when slug is present; others always return. */
  popovers?: Maybe<Array<Maybe<Popover>>>;
  preview?: Maybe<Entry>;
  /** A published price list with its published items as a JSON string. */
  priceList?: Maybe<Scalars['String']['output']>;
  /** Get a single product by ID */
  product?: Maybe<Product>;
  /** List all products with optional filters. */
  products?: Maybe<Array<Maybe<Product>>>;
  /** Get products by resort ID */
  productsByRessort?: Maybe<Array<Maybe<Product>>>;
  provider?: Maybe<Provider>;
  providers: ProviderPaginator;
  providersList?: Maybe<Array<Maybe<Provider>>>;
  /** Get a single quote. */
  quote?: Maybe<Quote>;
  /** List multiple quotes. */
  quotes?: Maybe<Array<Maybe<Quote>>>;
  /** Issue a short-lived single-use nonce required to submit a recipe rating (anonymous or logged-in). */
  ratingNonce?: Maybe<Scalars['String']['output']>;
  redirects?: Maybe<RedirectsPaginatorSimple>;
  /**
   * Find entities (Movies/Shows) related to a given source entity, scored by
   * shared Genres, Tags and Persons. Postgres-only aggregation in v1; later
   * swappable to a semantic-search strategy.
   */
  relatedEntities?: Maybe<Array<EntityEntry>>;
  resolveUrl?: Maybe<Scalars['String']['output']>;
  /** Get a single ressort. */
  ressort?: Maybe<Ressort>;
  /** Get all ressorts. */
  ressorts?: Maybe<Array<Maybe<Ressort>>>;
  season?: Maybe<Season>;
  service?: Maybe<ServiceEntity>;
  services: ServiceEntityPaginator;
  sessionValid?: Maybe<Scalars['Boolean']['output']>;
  showtimeClassifications?: Maybe<Array<Scalars['String']['output']>>;
  showtimeSports?: Maybe<Array<Scalars['String']['output']>>;
  staffPermissions?: Maybe<StaffPermissionsResult>;
  /** Get all static texts for a portal */
  staticTexts?: Maybe<Array<Maybe<StaticText>>>;
  /** Published POIs of one story as a JSON array string. */
  storyPois?: Maybe<Scalars['String']['output']>;
  stripePublicKey?: Maybe<StripePublicKeyResult>;
  /** Get a single subscription ad. */
  subscriptionAd?: Maybe<SubscriptionAd>;
  /** List all subscription ads. */
  subscriptionAds?: Maybe<Array<Maybe<SubscriptionAd>>>;
  /** Get a single subscription page. */
  subscriptionOverview?: Maybe<SubscriptionOverview>;
  /** List all subscription overviews. */
  subscriptionOverviews?: Maybe<Array<Maybe<SubscriptionOverview>>>;
  /** Get a single subscription page. */
  subscriptionPage?: Maybe<SubscriptionPage>;
  /** Look up a subscription page by its Compax offering id (used by /abo/checkout/[id] to fetch a single offering). */
  subscriptionPageByCompaxId?: Maybe<SubscriptionPage>;
  /** Look up a subscription page by its Shopify variant id (used to map Shopify checkouts to a Compax offering). */
  subscriptionPageByShopifyVariant?: Maybe<SubscriptionPage>;
  /** List all subscription pages. */
  subscriptionPages?: Maybe<Array<Maybe<SubscriptionPage>>>;
  /** Get a single subscription shop by id. */
  subscriptionShop?: Maybe<SubscriptionShop>;
  /** Get a single subscription shop by slug. */
  subscriptionShopBySlug?: Maybe<SubscriptionShop>;
  /** List all subscription shops ads. */
  subscriptionShops?: Maybe<Array<Maybe<SubscriptionShop>>>;
  /** Paginated raw export of survey submissions. Requires the woman:survey-analyst permission. */
  surveyResponses?: Maybe<SurveyResponseList>;
  /** VGN Team */
  team?: Maybe<Team>;
  /** VGN Teams */
  teams?: Maybe<Array<Maybe<Team>>>;
  topic?: Maybe<Topic>;
  topic_clusters?: Maybe<TopicClustersPaginatorSimple>;
  topics?: Maybe<TopicsPaginatorSimple>;
  trailer?: Maybe<Trailer>;
  trailers: TrailerPaginator;
  tt500Areas?: Maybe<Tt500AreaData>;
  tt500Asset?: Maybe<Tt500Asset>;
  tt500Assets: Tt500AssetPaginator;
  tt500BankBackend?: Maybe<Tt500BankBackend>;
  tt500BanksRankingBackend?: Maybe<Tt500BankBackendPagination>;
  tt500BusinessesBackend?: Maybe<Tt500BusinessBackendData>;
  tt500Companies?: Maybe<Tt500CompanyPagination>;
  tt500CompaniesBackend?: Maybe<Tt500CompanyBackendPagination>;
  tt500CompaniesEbitRankingBackend?: Maybe<Tt500CompanyBackendPagination>;
  tt500CompaniesEmployessRankingBackend?: Maybe<Tt500CompanyBackendPagination>;
  tt500CompaniesEquityRationRankingBackend?: Maybe<Tt500CompanyBackendPagination>;
  tt500CompaniesFreshBackend?: Maybe<Tt500CompanyBackendPagination>;
  tt500CompaniesRNDRankingBackend?: Maybe<Tt500CompanyBackendPagination>;
  tt500CompaniesRankingBackend?: Maybe<Tt500CompanyBackendPagination>;
  tt500CompaniesRevenueDeltasBackend?: Maybe<Tt500CompanyBackendPagination>;
  tt500Company?: Maybe<Tt500Company>;
  tt500CompanyBackend?: Maybe<Tt500DefaultBackend>;
  tt500ContactsSearch?: Maybe<Tt500ContactSearchData>;
  tt500FinanceReport?: Maybe<Tt500FinanceReportDefault>;
  tt500FinanceReports?: Maybe<Tt500FinanceReportPagination>;
  tt500FinanceReportsBanks?: Maybe<Tt500FinanceReportBanksPagination>;
  tt500FinanceReportsBiggestIncreaseEmployees?: Maybe<Tt500FinanceReportPagination>;
  tt500FinanceReportsInsurances?: Maybe<Tt500FinanceReportInsurancesPagination>;
  tt500FinanceReportsTopNew?: Maybe<Tt500FinanceReportPagination>;
  tt500Industries: Tt500CompanyIndustryPaginator;
  tt500Industry?: Maybe<Tt500CompanyIndustry>;
  tt500InsuranceBackend?: Maybe<Tt500InsuranceBackend>;
  tt500InsurancesRankingBackend?: Maybe<Tt500InsuranceBackendPagination>;
  tt500Person?: Maybe<Tt500Person>;
  tt500Persons?: Maybe<Tt500PersonPagination>;
  tt500Positions?: Maybe<Tt500PositionData>;
  tvmChangedEntries: Array<Maybe<Scalars['String']['output']>>;
  tvmFavorites: TvmFavoritePaginator;
  tvmFavoritesInTv: TvChannelShowtimePaginator;
  tvmFavoritesShowtimes: TvChannelShowtimePaginator;
  /** Single lane by its entry id — deliberately without the time window: whoever asks by id wants exactly this lane. */
  tvmLane?: Maybe<TvmLane>;
  /** Lanes from the tvmedia_lanes collection, live by their time window — no page required. recommend filters the "Empfohlen" flag. */
  tvmLanes?: Maybe<Array<TvmLane>>;
  /** One session, by id or by short code. */
  tvmMatchSession?: Maybe<TvmMatchSession>;
  /**
   * Catch up after missing broadcasts. Pass the highest `seq` received so far;
   * the answer is the current state of the session plus how many events were
   * missed. Call this on a gap in `seq` and on every reconnect — a client that
   * was offline cannot know what it slept through.
   */
  tvmMatchSessionSince: TvmMatchResync;
  /** Sessions the caller hosts or takes part in. */
  tvmMatchSessions: Array<TvmMatchSession>;
  /** The caller's inbox, newest first. Reminders stay hidden until due unless includeUpcoming. */
  tvmNotifications: TvmNotificationPaginator;
  /** How many due notifications the caller has not read — the badge number. */
  tvmNotificationsUnread: Scalars['Int']['output'];
  tvmPushPreferences: TvmPushPreferences;
  /** Paginated list of tvmShorts entries. Filtered to published entries by default. */
  tvmShorts?: Maybe<TvmShortPaginatorSimple>;
  /** Single tvmTopic entry by id or slug. Filtered to published entries by default. */
  tvmTopic?: Maybe<TvmTopicEntry>;
  /**
   * Change timestamps for tracked TvmTopics. Pass ids (max 200) to check
   * specific topics — unknown ids come back with null timestamps; pass
   * changedSince to get only topics whose data changed since then
   * (purge-runner mode); without arguments every tracked topic is returned.
   */
  tvmTopicChanges: Array<TvmTopicChange>;
  /** Paginated list of tvmTopic entries. Filtered to published entries by default. */
  tvmTopics?: Maybe<TvmTopicEntryPaginatorSimple>;
  /** Aggregated counts over the caller's decisions. */
  tvmUserDecisionSummary: TvmUserDecisionSummary;
  /** The caller's decision history — newest first, one row per decision made. */
  tvmUserDecisions: TvmUserDecisionPaginator;
  tvshow?: Maybe<Show>;
  tvshows?: Maybe<ShowsPaginationList>;
  tvshowsList?: Maybe<Array<Maybe<Show>>>;
  tvshowsNew: ShowPaginator;
  tvshowsPopularity: ShowPaginator;
  tvshowsTv: ShowPaginator;
  /**
   * Movies or Shows that lack editorial coverage (no article, no review)
   * despite having a high TMDB score. Useful for an editorial content
   * pipeline.
   */
  underservedEntities?: Maybe<Array<EntityEntry>>;
  /** Upcoming streaming releases (which provider publishes what, when). Defaults: country AT, from today, active offers only. */
  upcomingOffers: UpcomingOfferPaginator;
  /** Find a single user by an identifying attribute. */
  user?: Maybe<User>;
  /** Get user by email (internal use only, requires CMS_PERMISSIONS_TOKEN) */
  userByEmail?: Maybe<User>;
  /** Get user permissions by email */
  userPermissions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  userSettings?: Maybe<Array<UserSetting>>;
  /** List users that hold a given permission (internal use only, requires CMS_PERMISSIONS_TOKEN) */
  usersByPermission?: Maybe<Array<Maybe<User>>>;
  /** Verify if user is eligible based on sailing federation membership */
  verifySailingMember?: Maybe<VerifyUserEligibilityResult>;
  /** Combined verification for both VGN and sailing membership */
  verifyUserEligibility?: Maybe<VerifyUserEligibilityResult>;
  /** Verify if user is eligible for VGN services based on customer ID */
  verifyVgnCustomer?: Maybe<VerifyUserEligibilityResult>;
  vgnArchiveArticle?: Maybe<VgnArchiveArticle>;
  vgnArchiveArticles?: Maybe<VgnArchiveArticlePagination>;
  vgnArchiveSearchUnified?: Maybe<ArchiveSearchPagination>;
  vgnBrand?: Maybe<VgnBrand>;
  vgnBrandBySlug?: Maybe<VgnBrand>;
  vgnBrands?: Maybe<Array<Maybe<VgnBrand>>>;
  vgnCompany?: Maybe<VgnCompany>;
  vgnJob?: Maybe<VgnJob>;
  vgnJobBySlug?: Maybe<VgnJob>;
  vgnJobs?: Maybe<VgnJobs>;
  vgnJobsList?: Maybe<Array<Maybe<VgnJob>>>;
  vgnLatestCoversForMediums?: Maybe<Array<Maybe<VgnPublishingCalendar>>>;
  vgnLatestIssueOnline?: Maybe<VgnPublishingCalendar>;
  vgnLatestIssuesOnline?: Maybe<Array<Maybe<VgnPublishingCalendar>>>;
  vgnSheet?: Maybe<VgnSheet>;
  vgnSheets: VgnSheetPaginator;
  vgnSheetsByIds?: Maybe<VgnSheetPagination>;
  vgnUser?: Maybe<VgnUser>;
  vod?: Maybe<Vod>;
  vodList?: Maybe<Array<Maybe<Vod>>>;
  vods: VodPaginator;
  watchlinks: WatchLinkPaginator;
  /**
   * Curated TV viewing suggestions for a given time window, filtered by
   * genres, max runtime and providers.
   */
  whatToWatchTonight?: Maybe<Array<TvWatchSuggestion>>;
  xmlPage?: Maybe<XmlPage>;
  xmlPages?: Maybe<XmlPagePagination>;
  zodiacs?: Maybe<Array<Maybe<HoroskopZodiac>>>;
};


export type QueryArchiveIssueArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryArchiveIssuesArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  onlyPublished?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<VgnArchiveMedia>;
  year?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryArchivePageArgs = {
  issue: Scalars['String']['input'];
  medium: Scalars['String']['input'];
  page: Scalars['Int']['input'];
};


export type QueryArchivePagesArgs = {
  issue: Scalars['String']['input'];
  medium: Scalars['String']['input'];
};


export type QueryArchiveYearsArgs = {
  type?: InputMaybe<VgnArchiveMedia>;
};


export type QueryArticleArgs = {
  debug?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryArticlesArgs = {
  author?: InputMaybe<Scalars['String']['input']>;
  dateType?: InputMaybe<DateType>;
  from?: InputMaybe<Scalars['Date']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  max?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  orderDirection?: InputMaybe<Scalars['String']['input']>;
  portal?: InputMaybe<Scalars['String']['input']>;
  ressort?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryArticlesByRessortsArgs = {
  includeAdvertorial?: InputMaybe<Scalars['Boolean']['input']>;
  max?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  portal: Scalars['String']['input'];
  ressorts: Array<Scalars['String']['input']>;
};


export type QueryArticlesMeiliArgs = {
  author?: InputMaybe<Scalars['String']['input']>;
  dateType?: InputMaybe<DateType>;
  from?: InputMaybe<Scalars['Date']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  max?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  orderDirection?: InputMaybe<Scalars['String']['input']>;
  portal?: InputMaybe<Scalars['String']['input']>;
  ressort?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryArticlesNewArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  portal?: InputMaybe<Scalars['String']['input']>;
};


export type QueryArticlesPaginatedArgs = {
  author?: InputMaybe<Scalars['String']['input']>;
  dateType?: InputMaybe<DateType>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Scalars['Date']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  orderDirection?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  portal: Scalars['String']['input'];
  ressort?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
  topic?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCalculatorFormArgs = {
  slug: Scalars['String']['input'];
};


export type QueryCarBrandArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCarBrandsArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCarModelArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCarModelsArgs = {
  brandId: Scalars['ID']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCaradArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCaradsArgs = {
  brands?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  mileage?: InputMaybe<VgnCarMileageRange>;
  models?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  orderDirection?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  price?: InputMaybe<VgnCarPriceRange>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryChannelArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryChannelEntriesArgs = {
  date?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryChannelListArgs = {
  first?: Scalars['Int']['input'];
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  onlyPublished?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  slugs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryChannelLogosArgs = {
  onlyPublished?: InputMaybe<Scalars['Boolean']['input']>;
  onlyWithLogo?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryChannelShowtimeArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryChannelShowtimeByEventIdArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryChannelShowtimeListArgs = {
  channelIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  from?: InputMaybe<Scalars['DateTime']['input']>;
  onlyLive?: InputMaybe<Scalars['Boolean']['input']>;
  onlyNow?: InputMaybe<Scalars['Boolean']['input']>;
  onlySport?: InputMaybe<Scalars['Boolean']['input']>;
  until?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryChannelShowtimeNowArgs = {
  channelId?: InputMaybe<Scalars['String']['input']>;
  primetime?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryChannelShowtimesArgs = {
  channelId?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Scalars['DateTime']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  until?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryChannelShowtimesListArgs = {
  channelId?: InputMaybe<Scalars['String']['input']>;
  from?: InputMaybe<Scalars['DateTime']['input']>;
  until?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryChannelsArgs = {
  first?: Scalars['Int']['input'];
  onlyPublished?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  orderDirection?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCheckCustomerSubscriptionArgs = {
  medium?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCheckWorkflowPasswordResetArgs = {
  user_id: Scalars['String']['input'];
};


export type QueryCinemaArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCinemasArgs = {
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCitiesArgs = {
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  state_code?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCityArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCoOccurringPersonsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  minSharedWorks?: InputMaybe<Scalars['Int']['input']>;
  personId: Scalars['ID']['input'];
};


export type QueryCollageArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCollagenArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  portal?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCollectionArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  maxMappedItems?: InputMaybe<Scalars['Int']['input']>;
  random?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCollectionBySlugArgs = {
  maxMappedItems?: InputMaybe<Scalars['Int']['input']>;
  random?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCollectionsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  maxMappedItems?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCollectionsPaginatedArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  maxMappedItems?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCurrentCinemaPosterArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCustomerBillArgs = {
  billId: Scalars['String']['input'];
};


export type QueryCustomerDeliveryComplaintsContractArgs = {
  contractId: Scalars['String']['input'];
};


export type QueryDataSubjectDocumentUrlArgs = {
  documentKey: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};


export type QueryDataSubjectRequestAdminArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDiscountCodesArgs = {
  portal?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDiscountCodesForCompaxProductArgs = {
  compaxProductId: Scalars['String']['input'];
};


export type QueryDiscountCodesForSubscriptionArgs = {
  subscriptionId: Scalars['String']['input'];
};


export type QueryEmailMailRequestArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEmailMailRequestsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Array<MailRequestStatus>>;
};


export type QueryEntitiesArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  genres?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  genresExcluded?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  onlyWithAsset?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  orderDirection?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  person?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<TvmEntityType>;
  withUnpublished?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryEntityArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryEpisodeArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryEpisodesArgs = {
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryEventArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  portal?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryEventcategoriesArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  onlyPublished?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  portal?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryEventcategoryArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryEventplacesArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  portal: Scalars['String']['input'];
};


export type QueryEventsArgs = {
  categories?: InputMaybe<Array<Scalars['ID']['input']>>;
  cities?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Scalars['String']['input']>;
  onlyPublished?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  orderDirection?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  portal?: InputMaybe<Scalars['String']['input']>;
  presence?: InputMaybe<Array<InputMaybe<VgnEventPresence>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  sections?: InputMaybe<Array<Scalars['ID']['input']>>;
  type?: InputMaybe<Array<VgnEventType>>;
  until?: InputMaybe<Scalars['String']['input']>;
};


export type QueryEventsectionArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryEventsectionsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  onlyPublished?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  portal?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryExternalLinkArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryExternalLinksArgs = {
  max?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFairuAllFilesFlatArgs = {
  afterCursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFairuBackupArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFairuBackupsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFairuBlueprintArgs = {
  handle?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryFairuBlueprintsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFairuCatalogArgs = {
  handle?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryFairuCatalogsArgs = {
  includeFieldScoped?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFairuCopyrightArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryFairuCopyrightsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFairuDiskArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFairuDiskStatusArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFairuDisksArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFairuDmcaArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFairuDmcasArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFairuFieldsetArgs = {
  handle?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryFairuFieldsetsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFairuFileArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFairuFileByFingerprintArgs = {
  fingerprint: Scalars['String']['input'];
};


export type QueryFairuFileByPathArgs = {
  path: Scalars['String']['input'];
};


export type QueryFairuFileCommentsArgs = {
  file: Scalars['ID']['input'];
};


export type QueryFairuFilesArgs = {
  filter?: InputMaybe<FairuFolderFilter>;
  folder?: InputMaybe<Scalars['ID']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFairuFilesByMetadataArgs = {
  filters?: InputMaybe<Array<FairuMetadataFilterInput>>;
  folder?: InputMaybe<Scalars['ID']['input']>;
  folders?: InputMaybe<Array<Scalars['ID']['input']>>;
  includeDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  onlyIncomplete?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  orderDirection?: InputMaybe<FairuSortingDirection>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFairuFilesByTagArgs = {
  orderBy?: InputMaybe<Scalars['String']['input']>;
  orderDirection?: InputMaybe<FairuSortingDirection>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  tagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  tagNames?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryFairuFilesTotalSizeArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QueryFairuFolderArgs = {
  folder?: InputMaybe<Scalars['ID']['input']>;
  globalSearch?: InputMaybe<Scalars['Boolean']['input']>;
  onlyFolder?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  orderDirection?: InputMaybe<FairuSortingDirection>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFairuFolderBlueprintsArgs = {
  folder: Scalars['ID']['input'];
};


export type QueryFairuFolderByPathArgs = {
  path: Scalars['String']['input'];
};


export type QueryFairuGalleriesArgs = {
  from?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  orderDirection?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  tenants: Array<Scalars['ID']['input']>;
  until?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFairuGalleryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFairuLicenseArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryFairuLicensesArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFairuMetadataFacetsArgs = {
  filters?: InputMaybe<Array<FairuMetadataFilterInput>>;
  folder?: InputMaybe<Scalars['ID']['input']>;
  folders?: InputMaybe<Array<Scalars['ID']['input']>>;
  includeDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  onlyIncomplete?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFairuMultipleFilesArgs = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryFairuPublicVideoChannelArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFairuPublicVideoChannelBySlugArgs = {
  slug: Scalars['String']['input'];
  tenant: Scalars['ID']['input'];
};


export type QueryFairuPublicVideoChannelsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  tenant: Scalars['ID']['input'];
};


export type QueryFairuRoleArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFairuRolesArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFairuSearchArgs = {
  folders?: InputMaybe<Array<Scalars['ID']['input']>>;
  includeDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  orderDirection?: InputMaybe<FairuSortingDirection>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search: Scalars['String']['input'];
};


export type QueryFairuTagArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryFairuTagsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFairuUserArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFairuUsersArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFairuVideoChannelArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFairuVideoChannelBySlugArgs = {
  slug: Scalars['String']['input'];
};


export type QueryFairuVideoChannelScheduleArgs = {
  from?: InputMaybe<Scalars['DateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryFairuVideoChannelsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFairuWebhookArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFairuWebhooksArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFairuWorkflowArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFairuWorkflowsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFavoriteGroupArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFavoriteGroupsArgs = {
  portal: UserSettingPortal;
};


export type QueryFavoritesArgs = {
  portal: UserSettingPortal;
};


export type QueryFavoritesPaginatedArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  portal: UserSettingPortal;
};


export type QueryFavoritesRecipesArgs = {
  categories?: InputMaybe<Array<Scalars['ID']['input']>>;
  group?: InputMaybe<Scalars['ID']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  orderDirection?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  portal: UserSettingPortal;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFindBySlugArgs = {
  portal?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGalleriesArgs = {
  max?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGalleryArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGenreArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGenresArgs = {
  first?: Scalars['Int']['input'];
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ids_exclude?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  orderDirection?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  slugs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slugs_exclude?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  where?: InputMaybe<QueryGenresWhereWhereConditions>;
};


export type QueryGlobalsArgs = {
  portal?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGustoAuthorArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  uri?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGustoAuthorsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  onlyPublished?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGustoAuthorsByIdsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGustoCategoriesArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  onlyPublished?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGustoCategoriesByIdsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGustoCategoryArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  uri?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGustoCountriesArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  onlyPublished?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGustoCountriesByIdsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGustoCountryArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  uri?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGustoGalleriesArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  onlyPublished?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGustoGalleriesByIdsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGustoGalleryArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  uri?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGustoIngredientArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  uri?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGustoIngredientsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  onlyPopular?: InputMaybe<Scalars['Boolean']['input']>;
  onlyPublished?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGustoIngredientsByIdsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGustoIssueArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGustoIssueYearsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  onlyPublished?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGustoIssuesArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  onlyPublished?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGustoOccasionArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  uri?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGustoOccasionsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  onlyPublished?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGustoOccasionsByIdsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGustoPropertiesArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  onlyPublished?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGustoPropertiesByIdsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGustoPropertyArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  uri?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGustoRecipeArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  uri?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGustoRecipesArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  onlyPublished?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  searchExtended?: InputMaybe<GustoRecipeExtendedSearch>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<Scalars['String']['input']>;
  titleExact?: InputMaybe<Scalars['String']['input']>;
  visibleOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGustoRecipesByIdsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGustoTipArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGustoTipsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  onlyPublished?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGustoTipsByIdsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryHoroskopArgs = {
  date?: InputMaybe<Scalars['Date']['input']>;
  zodiac?: InputMaybe<Scalars['String']['input']>;
};


export type QueryHoroskopsArgs = {
  date?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryLawCategoriesArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryLawCompaniesArgs = {
  year: Scalars['Int']['input'];
};


export type QueryLawCompanyArgs = {
  id: Scalars['String']['input'];
  slug: Scalars['String']['input'];
};


export type QueryLawSurveyExportArgs = {
  year: Scalars['Int']['input'];
};


export type QueryLinkCollectionArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryLinkCollectionsArgs = {
  max?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMagazine_SpecialsArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMagazinesArgs = {
  context?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMcstreamyArgs = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMcstreamyByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMooncalendarArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMooncalendarDayArgs = {
  date?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryMooncalendarDaysArgs = {
  filter?: InputMaybe<Array<InputMaybe<MooncalendarOptions>>>;
  start: Scalars['Date']['input'];
  stop: Scalars['Date']['input'];
};


export type QueryMooncalendarItemArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryMovieArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMoviesArgs = {
  excludeUnpublished?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  genres?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  genresExcluded?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  onlyWithAsset?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  orderDirection?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  provider?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  withUnpublished?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryMoviesInCinemaArgs = {
  cinema?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Scalars['DateTime']['input']>;
  genres?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  genresExcluded?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  movieIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  onlyWithAsset?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  orderDirection?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  until?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryMoviesListArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryMoviesNewArgs = {
  first?: Scalars['Int']['input'];
  genres?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  genresExcluded?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  onlyWithAsset?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMoviesNewestInCinemaArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMoviesPopularityArgs = {
  first?: Scalars['Int']['input'];
  genres?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  genresExcluded?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  onlyWithAsset?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMoviesTvArgs = {
  first?: Scalars['Int']['input'];
  genres?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  genresExcluded?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  onlyWithAsset?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  orderDirection?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMyChallengesArgs = {
  portal?: InputMaybe<UserSettingPortal>;
};


export type QueryMyNewsletterArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  portal?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMyNewsletterBrevoArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  portal?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMyNewslettersArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  portals?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryMyNewslettersBrevoArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  portals?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryMyPointAwardsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMySurveyResponseArgs = {
  surveyKey: Scalars['String']['input'];
};


export type QueryMyZodiacArgs = {
  birthday?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryNavigationArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryNavigationByHandleArgs = {
  handle?: InputMaybe<Scalars['String']['input']>;
};


export type QueryNavigationByHandlesArgs = {
  handles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryNavigationsArgs = {
  handle?: InputMaybe<Scalars['String']['input']>;
};


export type QueryNewsletterArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  portal?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryNewsletterBrevoArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  portal?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryNewsletter_OverviewsArgs = {
  portal?: InputMaybe<Scalars['String']['input']>;
};


export type QueryNewslettersArgs = {
  portal: Scalars['String']['input'];
};


export type QueryNewslettersBrevoArgs = {
  portal: Scalars['String']['input'];
};


export type QueryNowArgs = {
  first: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPageArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPagesArgs = {
  max?: InputMaybe<Scalars['Int']['input']>;
  portal?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPaywallArgs = {
  portal?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPaywallProductsArgs = {
  portal?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPersonArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPersonablesArgs = {
  entity?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  person?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPersonsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  onlyWithArticle?: InputMaybe<Scalars['Boolean']['input']>;
  onlyWithAsset?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  orderDirection?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  withUnpublished?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPersonsListArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryPhotographersArgs = {
  portal?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPopoversArgs = {
  portal?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPreviewArgs = {
  token?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPriceListArgs = {
  slug: Scalars['String']['input'];
};


export type QueryProductArgs = {
  id: Scalars['String']['input'];
};


export type QueryProductsArgs = {
  filter?: InputMaybe<ProductFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryProductsByRessortArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  portal?: InputMaybe<Scalars['String']['input']>;
  ressort: Scalars['String']['input'];
};


export type QueryProviderArgs = {
  collapse?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryProvidersArgs = {
  collapse?: InputMaybe<Scalars['Boolean']['input']>;
  first?: Scalars['Int']['input'];
  onlyPublished?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  orderDirection?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryProvidersListArgs = {
  collapse?: InputMaybe<Scalars['Boolean']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  onlyPublished?: InputMaybe<Scalars['Boolean']['input']>;
  slugs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryQuoteArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryQuotesArgs = {
  max?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryRatingNonceArgs = {
  recipe: Scalars['ID']['input'];
};


export type QueryRedirectsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  portal?: InputMaybe<Scalars['String']['input']>;
};


export type QueryRelatedEntitiesArgs = {
  id: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  types?: InputMaybe<Array<TvmEntityType>>;
};


export type QueryResolveUrlArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryRessortArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  portal?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryRessortsArgs = {
  childIndicator?: InputMaybe<Scalars['String']['input']>;
  portal?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySeasonArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryServiceArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryServicesArgs = {
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryStaticTextsArgs = {
  portal?: InputMaybe<Scalars['String']['input']>;
};


export type QueryStoryPoisArgs = {
  story: Scalars['String']['input'];
};


export type QuerySubscriptionAdArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySubscriptionAdsArgs = {
  max?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySubscriptionOverviewArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  portal?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySubscriptionOverviewsArgs = {
  max?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySubscriptionPageArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  portal?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySubscriptionPageByCompaxIdArgs = {
  compaxId: Scalars['String']['input'];
};


export type QuerySubscriptionPageByShopifyVariantArgs = {
  variantId: Scalars['String']['input'];
};


export type QuerySubscriptionPagesArgs = {
  max?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySubscriptionShopArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySubscriptionShopBySlugArgs = {
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySubscriptionShopsArgs = {
  max?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySurveyResponsesArgs = {
  from?: InputMaybe<Scalars['DateTime']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  surveyKey: Scalars['String']['input'];
  to?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryTeamArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTopicArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  portal?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTopic_ClustersArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  portal?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTopicsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  portal?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTrailerArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTrailersArgs = {
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTt500AreasArgs = {
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTt500AssetArgs = {
  id: Scalars['String']['input'];
};


export type QueryTt500AssetsArgs = {
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTt500BankBackendArgs = {
  id: Scalars['String']['input'];
  slug: Scalars['String']['input'];
  year: Scalars['Int']['input'];
};


export type QueryTt500BanksRankingBackendArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Tt500CompanyType>;
  year: Scalars['Int']['input'];
};


export type QueryTt500BusinessesBackendArgs = {
  category?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTt500CompaniesArgs = {
  external_ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  industries?: InputMaybe<Array<Scalars['String']['input']>>;
  onlyPublished?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Tt500CompanyType>;
};


export type QueryTt500CompaniesBackendArgs = {
  external_finished?: InputMaybe<Scalars['Boolean']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internal_finished?: InputMaybe<Scalars['Boolean']['input']>;
  ksv?: InputMaybe<Scalars['Boolean']['input']>;
  ksv_checked?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Tt500CompanyType>;
  year: Scalars['Int']['input'];
};


export type QueryTt500CompaniesEbitRankingBackendArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  year: Scalars['Int']['input'];
};


export type QueryTt500CompaniesEmployessRankingBackendArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  year: Scalars['Int']['input'];
};


export type QueryTt500CompaniesEquityRationRankingBackendArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  year: Scalars['Int']['input'];
};


export type QueryTt500CompaniesFreshBackendArgs = {
  external_finished?: InputMaybe<Scalars['Boolean']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internal_finished?: InputMaybe<Scalars['Boolean']['input']>;
  ksv_checked?: InputMaybe<Scalars['Boolean']['input']>;
  netrevenue: Scalars['Float']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<Scalars['String']['input']>;
  started?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Tt500CompanyType>;
  year: Scalars['Int']['input'];
};


export type QueryTt500CompaniesRndRankingBackendArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  year: Scalars['Int']['input'];
};


export type QueryTt500CompaniesRankingBackendArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Tt500CompanyType>;
  year: Scalars['Int']['input'];
};


export type QueryTt500CompaniesRevenueDeltasBackendArgs = {
  threshold?: InputMaybe<Scalars['Float']['input']>;
  year: Scalars['Int']['input'];
};


export type QueryTt500CompanyArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTt500CompanyBackendArgs = {
  id: Scalars['String']['input'];
  slug: Scalars['String']['input'];
  year: Scalars['Int']['input'];
};


export type QueryTt500ContactsSearchArgs = {
  search: Scalars['String']['input'];
  year: Scalars['Int']['input'];
};


export type QueryTt500FinanceReportArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTt500FinanceReportsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  industries?: InputMaybe<Array<Scalars['String']['input']>>;
  onlyPublished?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  searchAttribute?: InputMaybe<Scalars['String']['input']>;
  searchAttributeValue?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Tt500CompanyType>;
  where?: InputMaybe<Tt500WhereInput>;
  year?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTt500FinanceReportsBanksArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  onlyPublished?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Tt500CompanyType>;
  year?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTt500FinanceReportsBiggestIncreaseEmployeesArgs = {
  onlyPublished?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTt500FinanceReportsInsurancesArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  onlyPublished?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Tt500CompanyType>;
  year?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTt500FinanceReportsTopNewArgs = {
  onlyPublished?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTt500IndustriesArgs = {
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTt500IndustryArgs = {
  id: Scalars['String']['input'];
  published?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryTt500InsuranceBackendArgs = {
  id: Scalars['String']['input'];
  slug: Scalars['String']['input'];
  year: Scalars['Int']['input'];
};


export type QueryTt500InsurancesRankingBackendArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Tt500CompanyType>;
  year: Scalars['Int']['input'];
};


export type QueryTt500PersonArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTt500PersonsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTt500PositionsArgs = {
  category?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTvmChangedEntriesArgs = {
  date: Scalars['String']['input'];
};


export type QueryTvmFavoritesArgs = {
  excludeTypes?: InputMaybe<Array<InputMaybe<TvmFavoriteType>>>;
  first?: Scalars['Int']['input'];
  includeTypes?: InputMaybe<Array<InputMaybe<TvmFavoriteType>>>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  orderDirection?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  seen?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryTvmFavoritesInTvArgs = {
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  first?: Scalars['Int']['input'];
  includeTypes?: InputMaybe<Array<InputMaybe<TvmFavoriteType>>>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  orderDirection?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTvmFavoritesShowtimesArgs = {
  first?: Scalars['Int']['input'];
  orderBy?: InputMaybe<Scalars['String']['input']>;
  orderDirection?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTvmLaneArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTvmLanesArgs = {
  recommend?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryTvmMatchSessionArgs = {
  code?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryTvmMatchSessionSinceArgs = {
  id: Scalars['ID']['input'];
  seq?: Scalars['Int']['input'];
};


export type QueryTvmMatchSessionsArgs = {
  state?: InputMaybe<TvmMatchSessionState>;
};


export type QueryTvmNotificationsArgs = {
  first?: Scalars['Int']['input'];
  includeUpcoming?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  unreadOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryTvmShortsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  onlyPublished?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTvmTopicArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  onlyPublished?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTvmTopicChangesArgs = {
  changedSince?: InputMaybe<Scalars['DateTime']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryTvmTopicsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  onlyPublished?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTvmUserDecisionsArgs = {
  entityType?: InputMaybe<TvmMatchEntityType>;
  first?: Scalars['Int']['input'];
  onlyLatestPerEntity?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTvshowArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTvshowsArgs = {
  excludeUnpublished?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  genres?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  genresExcluded?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  onlyWithAsset?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  orderDirection?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  provider?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  withUnpublished?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryTvshowsListArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryTvshowsNewArgs = {
  first?: Scalars['Int']['input'];
  genres?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  genresExcluded?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTvshowsPopularityArgs = {
  first?: Scalars['Int']['input'];
  genres?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  genresExcluded?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTvshowsTvArgs = {
  first?: Scalars['Int']['input'];
  genres?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUnderservedEntitiesArgs = {
  criteria?: InputMaybe<UnderservedCriteria>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  minTmdbScore?: InputMaybe<Scalars['Float']['input']>;
  type: TvmEntityType;
};


export type QueryUpcomingOffersArgs = {
  country?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  first?: Scalars['Int']['input'];
  from?: InputMaybe<Scalars['Date']['input']>;
  includeDeactivated?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  unmatchedOnly?: InputMaybe<Scalars['Boolean']['input']>;
  until?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryUserArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  portal?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  team?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUserByEmailArgs = {
  email: Scalars['String']['input'];
};


export type QueryUserPermissionsArgs = {
  email: Scalars['String']['input'];
};


export type QueryUserSettingsArgs = {
  portal?: InputMaybe<UserSettingPortal>;
};


export type QueryUsersByPermissionArgs = {
  permission: Scalars['String']['input'];
  portal?: InputMaybe<Scalars['String']['input']>;
};


export type QueryVerifySailingMemberArgs = {
  lastname: Scalars['String']['input'];
  oesv_id: Scalars['String']['input'];
  plz: Scalars['String']['input'];
};


export type QueryVerifyUserEligibilityArgs = {
  customer_id?: InputMaybe<Scalars['String']['input']>;
  lastname: Scalars['String']['input'];
  oesv_id?: InputMaybe<Scalars['String']['input']>;
  plz: Scalars['String']['input'];
};


export type QueryVerifyVgnCustomerArgs = {
  customer_id: Scalars['String']['input'];
  lastname: Scalars['String']['input'];
  plz: Scalars['String']['input'];
};


export type QueryVgnArchiveArticleArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<VgnArchiveMedia>;
};


export type QueryVgnArchiveArticlesArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Scalars['String']['input']>;
  highlightBackground?: InputMaybe<Scalars['String']['input']>;
  highlightForeground?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  issue?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  onlyPublished?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<VgnArchiveMedia>;
};


export type QueryVgnArchiveSearchUnifiedArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Scalars['String']['input']>;
  highlightBackground?: InputMaybe<Scalars['String']['input']>;
  highlightForeground?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search: Scalars['String']['input'];
  semanticRatio?: InputMaybe<Scalars['Float']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['String']['input']>;
  type: VgnArchiveMedia;
};


export type QueryVgnBrandArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryVgnBrandBySlugArgs = {
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryVgnBrandsArgs = {
  portal?: InputMaybe<Scalars['String']['input']>;
};


export type QueryVgnJobArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryVgnJobBySlugArgs = {
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryVgnJobsListArgs = {
  portal?: InputMaybe<Scalars['String']['input']>;
};


export type QueryVgnLatestCoversForMediumsArgs = {
  mediums: Array<Scalars['String']['input']>;
};


export type QueryVgnLatestIssueOnlineArgs = {
  issue?: InputMaybe<Scalars['String']['input']>;
  medium: Scalars['String']['input'];
};


export type QueryVgnLatestIssuesOnlineArgs = {
  max: Scalars['Int']['input'];
  medium: Scalars['String']['input'];
};


export type QueryVgnSheetArgs = {
  id: Scalars['String']['input'];
};


export type QueryVgnSheetsArgs = {
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryVgnSheetsByIdsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryVgnUserArgs = {
  email: Scalars['String']['input'];
};


export type QueryVodArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryVodListArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  onlyPublished?: InputMaybe<Scalars['Boolean']['input']>;
  provider?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  slugs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryVodsArgs = {
  first?: Scalars['Int']['input'];
  onlyPublished?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  orderDirection?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  provider?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryWatchlinksArgs = {
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryWhatToWatchTonightArgs = {
  excludedGenres?: InputMaybe<Array<Scalars['String']['input']>>;
  from?: InputMaybe<Scalars['DateTime']['input']>;
  genres?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  maxRuntime?: InputMaybe<Scalars['Int']['input']>;
  providerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  until?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryXmlPageArgs = {
  id: Scalars['String']['input'];
};


export type QueryXmlPagesArgs = {
  box?: InputMaybe<Scalars['String']['input']>;
  exactMatch?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  highlightBackground?: InputMaybe<Scalars['String']['input']>;
  highlightForeground?: InputMaybe<Scalars['String']['input']>;
  highlightLength?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  medium?: InputMaybe<Scalars['String']['input']>;
  month?: InputMaybe<Scalars['Int']['input']>;
  monthFrom?: InputMaybe<Scalars['Int']['input']>;
  monthTo?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  publish_date?: InputMaybe<Scalars['Date']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
  yearFrom?: InputMaybe<Scalars['Int']['input']>;
  yearTo?: InputMaybe<Scalars['Int']['input']>;
};

/** Allowed column names for Query.genres.where. */
export enum QueryGenresWhereColumn {
  Id = 'ID'
}

/** Dynamic WHERE conditions for the `where` argument of the query `genres`. */
export type QueryGenresWhereWhereConditions = {
  /** A set of conditions that requires all conditions to match. */
  AND?: InputMaybe<Array<QueryGenresWhereWhereConditions>>;
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: InputMaybe<QueryGenresWhereWhereConditionsRelation>;
  /** A set of conditions that requires at least one condition to match. */
  OR?: InputMaybe<Array<QueryGenresWhereWhereConditions>>;
  /** The column that is used for the condition. */
  column?: InputMaybe<QueryGenresWhereColumn>;
  /** The operator that is used for the condition. */
  operator?: InputMaybe<SqlOperator>;
  /** The value that is used for the condition. */
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

/** Dynamic WHERE HAS conditions for the `where` argument of the query `genres`. */
export type QueryGenresWhereWhereConditionsHasCondition = {
  /** A set of conditions that requires all conditions to match. */
  AND?: InputMaybe<Array<QueryGenresWhereWhereConditionsHasCondition>>;
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: InputMaybe<QueryGenresWhereWhereConditionsRelation>;
  /** A set of conditions that requires at least one condition to match. */
  OR?: InputMaybe<Array<QueryGenresWhereWhereConditionsHasCondition>>;
  /** The column that is used for the condition. */
  column?: InputMaybe<Scalars['String']['input']>;
  /** The operator that is used for the condition. */
  operator?: InputMaybe<SqlOperator>;
  /** The value that is used for the condition. */
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

/** Dynamic HAS conditions for WHERE conditions for the `where` argument of the query `genres`. */
export type QueryGenresWhereWhereConditionsRelation = {
  /** The amount to test. */
  amount?: InputMaybe<Scalars['Int']['input']>;
  /** Additional condition logic. */
  condition?: InputMaybe<QueryGenresWhereWhereConditionsHasCondition>;
  /** The comparison operator to test against the amount. */
  operator?: InputMaybe<SqlOperator>;
  /** The relation that is checked. */
  relation: Scalars['String']['input'];
};

export type Quote = {
  __typename?: 'Quote';
  /** Unique primary key. */
  id?: Maybe<Scalars['String']['output']>;
  /** Person */
  person?: Maybe<Person>;
  /** Source */
  source?: Maybe<Scalars['String']['output']>;
  /** Quote text */
  text?: Maybe<Scalars['String']['output']>;
  /** TVMedia Actor DB */
  tvmedia_person?: Maybe<Scalars['String']['output']>;
};

export type Redirect = {
  __typename?: 'Redirect';
  /** Id */
  id: Scalars['ID']['output'];
  /** Redirect from url */
  redirect_from?: Maybe<Scalars['String']['output']>;
  /** Redirect to url */
  redirect_target?: Maybe<Scalars['String']['output']>;
  /** Redirect mode */
  redirect_type?: Maybe<Scalars['Int']['output']>;
};

export type RedirectsPaginatorSimple = {
  __typename?: 'RedirectsPaginatorSimple';
  data?: Maybe<Array<Maybe<Redirect>>>;
  paginatorInfo?: Maybe<DefaultPaginator>;
};

export type ResetPasswordResult = {
  __typename?: 'ResetPasswordResult';
  error_text?: Maybe<Scalars['String']['output']>;
  redirect_url?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type Ressort = {
  __typename?: 'Ressort';
  /** Ad settings for the page */
  ad_settings?: Maybe<AdSetting>;
  articles?: Maybe<ArticlePaginatorSimple>;
  /** Content elements */
  content?: Maybe<Array<Maybe<ContentElement>>>;
  /** Description of the ressport */
  description?: Maybe<Scalars['String']['output']>;
  /** Disable ads for the ressort */
  disable_ads?: Maybe<Scalars['Boolean']['output']>;
  /** ID */
  id: Scalars['ID']['output'];
  /** Meta data */
  metadata?: Maybe<Meta>;
  /** More teaser is used for boxes */
  more_teaser?: Maybe<Scalars['String']['output']>;
  more_teaser_headline?: Maybe<Scalars['String']['output']>;
  /** More teaser image should be used in an overview box */
  more_teaser_image?: Maybe<FairuAsset>;
  newsletter?: Maybe<Newsletter>;
  /** Oewa data */
  oewa?: Maybe<Oewa>;
  /** Outbrain compliant */
  outbrain_compliant?: Maybe<Scalars['Boolean']['output']>;
  /** Outbrain deactivated */
  outbrain_disabled?: Maybe<Scalars['Boolean']['output']>;
  /** Paid content settings */
  paid_content?: Maybe<PaidContent>;
  /** Parent ressort */
  parent?: Maybe<Ressort>;
  recipes?: Maybe<GustoRessortQuery>;
  /** Slug */
  slug?: Maybe<Scalars['String']['output']>;
  social_media?: Maybe<Array<Maybe<CollageSocialMedia>>>;
  /** Subtitle */
  subtitle?: Maybe<Scalars['String']['output']>;
  /** Teams */
  teams?: Maybe<Array<Maybe<Team>>>;
  /** Title */
  title?: Maybe<Scalars['String']['output']>;
  /** Original title (set when title is overridden, e.g. in VGN context) */
  title_original?: Maybe<Scalars['String']['output']>;
  /** Single users that has been added to this ressort */
  users?: Maybe<Array<Maybe<User>>>;
};


export type RessortArticlesArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type RessortDescriptionArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RessortMore_TeaserArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RessortRecipesArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};

export type Review = {
  __typename?: 'Review';
  /** Entity id */
  entity_id?: Maybe<Scalars['String']['output']>;
  /** Review text */
  text?: Maybe<Scalars['String']['output']>;
};


export type ReviewTextArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The available SQL operators that are used to filter query results. */
export enum SqlOperator {
  /** Whether a value is within a range of values (`BETWEEN`) */
  Between = 'BETWEEN',
  /** Equal operator (`=`) */
  Eq = 'EQ',
  /** Greater than operator (`>`) */
  Gt = 'GT',
  /** Greater than or equal operator (`>=`) */
  Gte = 'GTE',
  /** Whether a value is within a set of values (`IN`) */
  In = 'IN',
  /** Whether a value is not null (`IS NOT NULL`) */
  IsNotNull = 'IS_NOT_NULL',
  /** Whether a value is null (`IS NULL`) */
  IsNull = 'IS_NULL',
  /** Simple pattern matching (`LIKE`) */
  Like = 'LIKE',
  /** Less than operator (`<`) */
  Lt = 'LT',
  /** Less than or equal operator (`<=`) */
  Lte = 'LTE',
  /** Not equal operator (`!=`) */
  Neq = 'NEQ',
  /** Whether a value is not within a range of values (`NOT BETWEEN`) */
  NotBetween = 'NOT_BETWEEN',
  /** Whether a value is not within a set of values (`NOT IN`) */
  NotIn = 'NOT_IN',
  /** Negation of simple pattern matching (`NOT LIKE`) */
  NotLike = 'NOT_LIKE'
}

/** Show season entry. */
export type Season = BaseInterface & {
  __typename?: 'Season';
  /** Created at */
  created_at?: Maybe<Scalars['DateTime']['output']>;
  /** Episodes */
  episodes: EpisodePaginator;
  /** Unique primary key. */
  id?: Maybe<Scalars['String']['output']>;
  /** Season number */
  nr?: Maybe<Scalars['Int']['output']>;
  /** Original Title of the enitity */
  original_title?: Maybe<Scalars['String']['output']>;
  /** Show */
  show?: Maybe<Show>;
  /** Title of the enitity */
  title?: Maybe<Scalars['String']['output']>;
  /** Updated at */
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};


/** Show season entry. */
export type SeasonEpisodesArgs = {
  first: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};

/** A paginated list of Season items. */
export type SeasonPaginator = {
  __typename?: 'SeasonPaginator';
  /** A list of Season items. */
  data: Array<Season>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type SeoInterface = {
  /** Custom open graph description */
  custom_open_graph_description?: Maybe<Scalars['String']['output']>;
  /** Open graph title */
  custom_open_graph_title?: Maybe<Scalars['String']['output']>;
  /** Twitter custom description */
  custom_twitter_description?: Maybe<Scalars['String']['output']>;
  /** Custom twitter title */
  custom_twitter_title?: Maybe<Scalars['String']['output']>;
  /** Google news title */
  google_news_title?: Maybe<Scalars['String']['output']>;
  /** Meta meta_description */
  meta_description?: Maybe<Scalars['String']['output']>;
  /** Meta title */
  meta_title?: Maybe<Scalars['String']['output']>;
  /** No follow */
  no_follow?: Maybe<Scalars['Boolean']['output']>;
  /** Should that entry be index */
  no_index?: Maybe<Scalars['Boolean']['output']>;
  /** Open graph description */
  open_graph_description?: Maybe<Scalars['String']['output']>;
  /** Open Graph Image */
  open_graph_image?: Maybe<FairuAsset>;
  /** Redirect url */
  redirect?: Maybe<Scalars['String']['output']>;
  /** Twitter description mode */
  twitter_description?: Maybe<Scalars['String']['output']>;
  /** Twitter Image */
  twitter_image?: Maybe<FairuAsset>;
};

export type ServiceEntity = Provider | TvChannel;

/** A paginated list of ServiceEntity items. */
export type ServiceEntityPaginator = {
  __typename?: 'ServiceEntityPaginator';
  /** A list of ServiceEntity items. */
  data: Array<ServiceEntity>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type Sheet = {
  __typename?: 'Sheet';
  /** Sheet image */
  sheet_image?: Maybe<FairuAsset>;
  /** Text */
  sheet_text?: Maybe<Scalars['String']['output']>;
  /** Title */
  sheet_title?: Maybe<Scalars['String']['output']>;
};


export type SheetSheet_TextArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SheetsUploadRequest = {
  __typename?: 'SheetsUploadRequest';
  get?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  mime?: Maybe<Scalars['String']['output']>;
  path?: Maybe<Scalars['String']['output']>;
  upload?: Maybe<Scalars['String']['output']>;
};

/** Show entry. */
export type Show = EntityInterface & {
  __typename?: 'Show';
  actor_ids?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Article ids */
  article_ids?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Asset id backdrop image */
  asset_backdrop_id?: Maybe<Scalars['String']['output']>;
  /** Asset id cover image */
  asset_id?: Maybe<Scalars['String']['output']>;
  /** Backdrop image */
  backdrop_image?: Maybe<FairuAsset>;
  /** cover image */
  cover_image?: Maybe<FairuAsset>;
  /** Created at */
  created_at?: Maybe<Scalars['DateTime']['output']>;
  crew_ids?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Id of the director */
  director_id?: Maybe<Scalars['String']['output']>;
  /** flat list of director ids for the show */
  director_ids?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** directors for the movie */
  directors?: Maybe<PersonPaginationList>;
  /** Enriched data  */
  enriched?: Maybe<Scalars['Boolean']['output']>;
  /** Episodes */
  episodes?: Maybe<Array<Maybe<Episode>>>;
  favorite?: Maybe<TvmFavorite>;
  /** Genre ids for the show */
  genre_ids?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Genres for the show */
  genres?: Maybe<Array<Maybe<Genre>>>;
  /** Unique primary key. */
  id: Scalars['ID']['output'];
  /** Imdb id */
  imdb_id?: Maybe<Scalars['String']['output']>;
  /** Id within the justwatch api */
  justwatch_id?: Maybe<Scalars['String']['output']>;
  /** Watch links */
  links?: Maybe<Array<Maybe<WatchLink>>>;
  /** Mediapress content id */
  mediapress_id?: Maybe<Scalars['String']['output']>;
  /** Meta data */
  metadata?: Maybe<Meta>;
  /** Original id is set if the the entry has been transformed */
  original_id?: Maybe<Scalars['String']['output']>;
  /** persons for the show */
  persons?: Maybe<PersonPaginationList>;
  /** Provider */
  provider?: Maybe<Array<Maybe<Provider>>>;
  /** Pubslihed */
  published?: Maybe<Scalars['Boolean']['output']>;
  /** Review */
  review?: Maybe<Scalars['String']['output']>;
  /** Reviewed data  */
  reviewed?: Maybe<Scalars['Boolean']['output']>;
  /** Run time in minutes */
  runtime?: Maybe<Scalars['Int']['output']>;
  /** Seasons */
  seasons: SeasonPaginator;
  /** Shorttitle of the enitity */
  short?: Maybe<Scalars['String']['output']>;
  /** Showtimes identifier */
  showtimes_id?: Maybe<Scalars['String']['output']>;
  /** Pivot information will only be attached if the querys root is a person. */
  singlePersonMetaInformation?: Maybe<PersonMeta>;
  /** Url-Slug */
  slug?: Maybe<Scalars['String']['output']>;
  /** Summary */
  summary?: Maybe<Scalars['String']['output']>;
  /** Tags for the show */
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Summary Long */
  text_lg?: Maybe<Scalars['String']['output']>;
  /** Summary Medium */
  text_md?: Maybe<Scalars['String']['output']>;
  /** Summary Small */
  text_sm?: Maybe<Scalars['String']['output']>;
  /** Title of the enitity */
  title?: Maybe<Scalars['String']['output']>;
  /** Tmdb id */
  tmdb_id?: Maybe<Scalars['String']['output']>;
  /** Score */
  tmdb_score?: Maybe<Scalars['Float']['output']>;
  /** TV airings from the programme, matched by entity, Mediapress or typed TMDB ID. */
  tvShowtimes: TvChannelShowtimePaginator;
  /** Airings running now on active channels with a Joyn livestream. Use channel.joyn_livestream for the live-TV button; stop is exclusive. */
  tvShowtimesNow: TvChannelShowtimePaginator;
  /** TV airings starting today. */
  tvShowtimesToday: TvChannelShowtimePaginator;
  /** Upcoming TV airings. Defaults to now through the end of the day seven days ahead. */
  tvShowtimesUpcoming: TvChannelShowtimePaginator;
  /** Score of TVMedia */
  tvm_score?: Maybe<Scalars['Int']['output']>;
  /** Upcoming streaming releases (synced daily) */
  upcoming_offers?: Maybe<Array<Maybe<UpcomingOffer>>>;
  /** Updated at */
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  /** Year of release */
  year?: Maybe<Scalars['Int']['output']>;
  /** Youtube id */
  youtube?: Maybe<Scalars['String']['output']>;
};


/** Show entry. */
export type ShowDirectorsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


/** Show entry. */
export type ShowGenresArgs = {
  flat?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Show entry. */
export type ShowPersonsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


/** Show entry. */
export type ShowReviewArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Show entry. */
export type ShowSeasonsArgs = {
  first: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};


/** Show entry. */
export type ShowSummaryArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Show entry. */
export type ShowText_LgArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Show entry. */
export type ShowText_MdArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Show entry. */
export type ShowText_SmArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Show entry. */
export type ShowTvShowtimesArgs = {
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<DateRange>;
};


/** Show entry. */
export type ShowTvShowtimesNowArgs = {
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};


/** Show entry. */
export type ShowTvShowtimesTodayArgs = {
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};


/** Show entry. */
export type ShowTvShowtimesUpcomingArgs = {
  first?: Scalars['Int']['input'];
  from?: InputMaybe<Scalars['DateTime']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  until?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ShowPaginationList = {
  __typename?: 'ShowPaginationList';
  data?: Maybe<Array<Maybe<Show>>>;
  paginatorInfo?: Maybe<DefaultPaginator>;
};

/** A paginated list of Show items. */
export type ShowPaginator = {
  __typename?: 'ShowPaginator';
  /** A list of Show items. */
  data: Array<Show>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type ShowsPaginationList = {
  __typename?: 'ShowsPaginationList';
  data?: Maybe<Array<Maybe<Show>>>;
  paginatorInfo?: Maybe<DefaultPaginator>;
};

export type ShowtimesPaginationList = {
  __typename?: 'ShowtimesPaginationList';
  data?: Maybe<Array<Maybe<TvChannelShowtime>>>;
  paginatorInfo?: Maybe<DefaultPaginator>;
};

export enum SocialMediaNetwork {
  Facebook = 'facebook',
  Instagram = 'instagram',
  InstagramReel = 'instagram_reel',
  Pinterest = 'pinterest',
  Tiktok = 'tiktok',
  Twitter = 'twitter'
}

export enum SocialMediaType {
  Facebook = 'facebook',
  Instagram = 'instagram',
  InstagramReel = 'instagram_reel',
  Linkedin = 'linkedin',
  Pinterest = 'pinterest',
  Spotify = 'spotify',
  Tiktok = 'tiktok',
  Twitter = 'twitter',
  Xing = 'xing',
  Youtube = 'youtube'
}

/** Directions for ordering a list of records. */
export enum SortOrder {
  /** Sort records in ascending order. */
  Asc = 'ASC',
  /** Sort records in descending order. */
  Desc = 'DESC'
}

export enum SpecialType {
  CinemaPage = 'cinema_page',
  MoviesSeriesMarquee = 'movies_series_marquee',
  ThisIsTvmedia = 'this_is_tvmedia',
  TvGuidePage = 'tv_guide_page'
}

/**
 * Staff capabilities of the token's user, read live (CP roles in the CMS + the local
 * permissions column). Write-side services authorise against this instead of the
 * `permissions` claim frozen into the bearer token, so a revoked role takes effect at once.
 */
export type StaffPermissionsResult = {
  __typename?: 'StaffPermissionsResult';
  permissions: Array<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  user_id?: Maybe<Scalars['String']['output']>;
};

export type StageElement = StageElementArticles | StageElementArticlesApa | StageElementArticlesIds | StageElementArticlesRessorts | StageElementBlock | StageElementGustoSearch | StageElementNewsletter | StageElementSubscriptionShop | StageElementVideo;

export type StageElementArticles = {
  __typename?: 'StageElementArticles';
  /** Articles */
  articles?: Maybe<Array<Maybe<Article>>>;
  /** Big ad */
  big_ad?: Maybe<Scalars['Boolean']['output']>;
  hide_mobile?: Maybe<Scalars['Boolean']['output']>;
  /** Mode */
  mode?: Maybe<Scalars['String']['output']>;
  /** Show images */
  show_images?: Maybe<Scalars['Boolean']['output']>;
  /** Show videos */
  show_videos?: Maybe<Scalars['Boolean']['output']>;
  /** Title */
  title?: Maybe<Scalars['String']['output']>;
  /** Title link */
  title_link?: Maybe<Scalars['String']['output']>;
  /** Open title link in new window */
  title_link_blank_window?: Maybe<Scalars['Boolean']['output']>;
  x?: Maybe<Scalars['Int']['output']>;
  y?: Maybe<Scalars['Int']['output']>;
};

export type StageElementArticlesApa = {
  __typename?: 'StageElementArticlesApa';
  /** Articles */
  articles?: Maybe<Array<Maybe<Article>>>;
  /** Big ad */
  big_ad?: Maybe<Scalars['Boolean']['output']>;
  hide_mobile?: Maybe<Scalars['Boolean']['output']>;
  /** Mode */
  mode?: Maybe<Scalars['String']['output']>;
  /** Title */
  title?: Maybe<Scalars['String']['output']>;
  /** Title link */
  title_link?: Maybe<Scalars['String']['output']>;
  /** Open title link in new window */
  title_link_blank_window?: Maybe<Scalars['Boolean']['output']>;
  x?: Maybe<Scalars['Int']['output']>;
  y?: Maybe<Scalars['Int']['output']>;
};

export type StageElementArticlesIds = {
  __typename?: 'StageElementArticlesIds';
  /** Articles */
  articles?: Maybe<Array<Maybe<Article>>>;
  /** Big ad */
  big_ad?: Maybe<Scalars['Boolean']['output']>;
  hide_mobile?: Maybe<Scalars['Boolean']['output']>;
  /** Mode */
  mode?: Maybe<Scalars['String']['output']>;
  /** Show videos */
  show_videos?: Maybe<Scalars['Boolean']['output']>;
  /** Title */
  title?: Maybe<Scalars['String']['output']>;
  /** Title link */
  title_link?: Maybe<Scalars['String']['output']>;
  /** Open title link in new window */
  title_link_blank_window?: Maybe<Scalars['Boolean']['output']>;
  x?: Maybe<Scalars['Int']['output']>;
  y?: Maybe<Scalars['Int']['output']>;
};

export type StageElementArticlesRessorts = {
  __typename?: 'StageElementArticlesRessorts';
  /** Articles */
  articles?: Maybe<Array<Maybe<Article>>>;
  /** Big ad */
  big_ad?: Maybe<Scalars['Boolean']['output']>;
  hide_mobile?: Maybe<Scalars['Boolean']['output']>;
  /** Mode */
  mode?: Maybe<Scalars['String']['output']>;
  /** Show videos */
  show_videos?: Maybe<Scalars['Boolean']['output']>;
  /** Title */
  title?: Maybe<Scalars['String']['output']>;
  /** Title link */
  title_link?: Maybe<Scalars['String']['output']>;
  /** Open title link in new window */
  title_link_blank_window?: Maybe<Scalars['Boolean']['output']>;
  x?: Maybe<Scalars['Int']['output']>;
  y?: Maybe<Scalars['Int']['output']>;
};

export type StageElementBlock = {
  __typename?: 'StageElementBlock';
  badge_text?: Maybe<Scalars['String']['output']>;
  headline?: Maybe<Scalars['String']['output']>;
  hide_mobile?: Maybe<Scalars['Boolean']['output']>;
  image?: Maybe<FairuAsset>;
  link?: Maybe<Scalars['String']['output']>;
  /** Text */
  text?: Maybe<Scalars['String']['output']>;
  x?: Maybe<Scalars['Int']['output']>;
  y?: Maybe<Scalars['Int']['output']>;
};


export type StageElementBlockTextArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StageElementGustoSearch = {
  __typename?: 'StageElementGustoSearch';
  /** Headline. */
  headline?: Maybe<Scalars['String']['output']>;
  hide_mobile?: Maybe<Scalars['Boolean']['output']>;
  recipe?: Maybe<GustoRecipe>;
  x?: Maybe<Scalars['Int']['output']>;
  y?: Maybe<Scalars['Int']['output']>;
};

export type StageElementNewsletter = {
  __typename?: 'StageElementNewsletter';
  /** Anchor. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** Headline. */
  headline?: Maybe<Scalars['String']['output']>;
  /** Headline size */
  headline_level?: Maybe<Scalars['Int']['output']>;
  hide_mobile?: Maybe<Scalars['Boolean']['output']>;
  /** Distribution list id provided by mailion */
  newsletter?: Maybe<Newsletter>;
  /** Teaser for the download. */
  teaser?: Maybe<Scalars['String']['output']>;
  x?: Maybe<Scalars['Int']['output']>;
  y?: Maybe<Scalars['Int']['output']>;
};


export type StageElementNewsletterTeaserArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StageElementSubscriptionShop = {
  __typename?: 'StageElementSubscriptionShop';
  /** Anchor. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** Headline. */
  headline?: Maybe<Scalars['String']['output']>;
  /** Headline size */
  headline_level?: Maybe<Scalars['Int']['output']>;
  hide_mobile?: Maybe<Scalars['Boolean']['output']>;
  /** Subscription ad */
  subscription_ad?: Maybe<SubscriptionAd>;
  x?: Maybe<Scalars['Int']['output']>;
  y?: Maybe<Scalars['Int']['output']>;
};

export type StageElementVideo = {
  __typename?: 'StageElementVideo';
  autoplay?: Maybe<Scalars['Boolean']['output']>;
  badge_text?: Maybe<Scalars['String']['output']>;
  /** Caption text for video */
  caption?: Maybe<Scalars['String']['output']>;
  /** Copyright text for video */
  copyright?: Maybe<Scalars['String']['output']>;
  hide_mobile?: Maybe<Scalars['Boolean']['output']>;
  /** JWPlayer Embed Code */
  jw_embed?: Maybe<Scalars['String']['output']>;
  /** JWPlayer Id */
  jw_player?: Maybe<Scalars['String']['output']>;
  video?: Maybe<FairuAsset>;
  /** Video source */
  video_source?: Maybe<Scalars['String']['output']>;
  x?: Maybe<Scalars['Int']['output']>;
  y?: Maybe<Scalars['Int']['output']>;
  /** Youtube Id */
  youtube?: Maybe<Scalars['String']['output']>;
};


export type StageElementVideoCaptionArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StaticText = {
  __typename?: 'StaticText';
  id?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
  value_plural?: Maybe<Scalars['String']['output']>;
};

export type StripeAccountInput = {
  paymentMethodId?: InputMaybe<Scalars['String']['input']>;
  stripeCustomerId: Scalars['String']['input'];
};

export type StripeCustomerResult = {
  __typename?: 'StripeCustomerResult';
  clientSecret: Scalars['String']['output'];
  stripeCustomerId: Scalars['String']['output'];
};

export type StripePublicKeyResult = {
  __typename?: 'StripePublicKeyResult';
  publicKey: Scalars['String']['output'];
};

export type SubmitSurveyResponseResult = {
  __typename?: 'SubmitSurveyResponseResult';
  /** True when a once-only survey was already submitted by this user (no new row written). */
  alreadySubmitted?: Maybe<Scalars['Boolean']['output']>;
  success: Scalars['Boolean']['output'];
};

export type SubscribeToNewsletterData = {
  acceptMarketing?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstname?: InputMaybe<Scalars['String']['input']>;
  lastname?: InputMaybe<Scalars['String']['input']>;
  newsletter?: InputMaybe<Scalars['ID']['input']>;
  salutation?: InputMaybe<Scalars['String']['input']>;
  skipDoubleOptIn?: InputMaybe<Scalars['Boolean']['input']>;
  /** Brevo SOURCE attribute, set on new contacts only, e.g. popover:<popover-slug> or content_element:<page-slug> */
  source?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionAd = {
  __typename?: 'SubscriptionAd';
  /** Image asset */
  asset?: Maybe<FairuAsset>;
  /** Button text */
  button_text?: Maybe<Scalars['String']['output']>;
  /** Id */
  id: Scalars['ID']['output'];
  /** Link */
  link?: Maybe<Scalars['String']['output']>;
  /** Product code */
  paywall_code?: Maybe<Scalars['String']['output']>;
  /** Pricy currency */
  paywall_currency?: Maybe<Scalars['String']['output']>;
  /** Paywall features */
  paywall_features?: Maybe<Array<Maybe<SubscriptionShopProductFeature>>>;
  /** Marketing code */
  paywall_marketing_code?: Maybe<Scalars['String']['output']>;
  /** Price */
  paywall_price?: Maybe<Scalars['String']['output']>;
  /** Price interval */
  paywall_price_interval?: Maybe<Scalars['String']['output']>;
  /** Paywall title */
  paywall_title?: Maybe<Scalars['String']['output']>;
  /** UTM */
  paywall_utm?: Maybe<Scalars['String']['output']>;
  /** Teaser */
  teaser?: Maybe<Scalars['String']['output']>;
  /** Title. */
  title?: Maybe<Scalars['String']['output']>;
  /** External title for the ad teaser */
  title_external?: Maybe<Scalars['String']['output']>;
};


export type SubscriptionAdTeaserArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SubscriptionOverview = {
  __typename?: 'SubscriptionOverview';
  add_epaper?: Maybe<Scalars['Boolean']['output']>;
  auto_balance?: Maybe<Scalars['Boolean']['output']>;
  button_link?: Maybe<Scalars['String']['output']>;
  button_text?: Maybe<Scalars['String']['output']>;
  epaper_portal?: Maybe<Scalars['String']['output']>;
  feedback?: Maybe<Array<SubscriptionPageFeeback>>;
  feedback_headline?: Maybe<Scalars['String']['output']>;
  headline_offers_left?: Maybe<Scalars['String']['output']>;
  headline_offers_right?: Maybe<Scalars['String']['output']>;
  /** Id */
  id: Scalars['ID']['output'];
  main_order_text?: Maybe<Scalars['String']['output']>;
  more?: Maybe<Scalars['String']['output']>;
  offers?: Maybe<Array<Maybe<SubscriptionOverviewOffer>>>;
  portal?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  subheadline?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type SubscriptionOverviewOffer = {
  __typename?: 'SubscriptionOverviewOffer';
  additional_subscription_offer?: Maybe<SubscriptionPage>;
  favorite?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  offer?: Maybe<SubscriptionPage>;
  position_right?: Maybe<Scalars['Boolean']['output']>;
  tagline?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type SubscriptionPage = {
  __typename?: 'SubscriptionPage';
  additional_text?: Maybe<Scalars['String']['output']>;
  banner_text?: Maybe<Scalars['String']['output']>;
  boxes?: Maybe<Array<SubscriptionPageBox>>;
  boxes_more?: Maybe<Scalars['String']['output']>;
  breaker_text?: Maybe<Scalars['String']['output']>;
  button_headline?: Maybe<Scalars['String']['output']>;
  buttons?: Maybe<Array<SubscriptionPageButton>>;
  compax_id?: Maybe<Scalars['String']['output']>;
  compax_marketing?: Maybe<Scalars['String']['output']>;
  compax_product_id?: Maybe<Scalars['String']['output']>;
  cta?: Maybe<Scalars['String']['output']>;
  cta_link?: Maybe<Scalars['String']['output']>;
  discount_show?: Maybe<Scalars['Boolean']['output']>;
  feedback?: Maybe<Array<SubscriptionPageFeeback>>;
  feedback_headline?: Maybe<Scalars['String']['output']>;
  hide_banner?: Maybe<Scalars['Boolean']['output']>;
  hide_breaker?: Maybe<Scalars['Boolean']['output']>;
  hide_cta?: Maybe<Scalars['Boolean']['output']>;
  /** Id */
  id: Scalars['ID']['output'];
  metadata?: Maybe<Meta>;
  more_subscriptions?: Maybe<Array<SubscriptionPage>>;
  mulitple_options_placeholder?: Maybe<Scalars['String']['output']>;
  multiple_options?: Maybe<Array<SubscriptionPageOption>>;
  overview_benefits?: Maybe<Scalars['String']['output']>;
  overview_buy_link?: Maybe<Scalars['String']['output']>;
  overview_image?: Maybe<FairuAsset>;
  overview_price_after?: Maybe<Scalars['String']['output']>;
  overview_price_previous?: Maybe<Scalars['String']['output']>;
  overview_price_textline_1?: Maybe<Scalars['String']['output']>;
  overview_price_textline_2?: Maybe<Scalars['String']['output']>;
  overview_subheadline?: Maybe<Scalars['String']['output']>;
  overview_tagline?: Maybe<Scalars['String']['output']>;
  overview_title?: Maybe<Scalars['String']['output']>;
  /** Allowed payment options (creditcard, sepa, invoice). Null on entries saved before this field existed — FE treats null as all allowed. */
  payment_options?: Maybe<Array<Scalars['String']['output']>>;
  portal?: Maybe<Scalars['String']['output']>;
  /** Price in euro */
  price?: Maybe<Scalars['String']['output']>;
  price_extra?: Maybe<Scalars['String']['output']>;
  shopify_variant_id?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  success_redirect?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  top_disclaimer?: Maybe<Scalars['String']['output']>;
  top_headline?: Maybe<Scalars['String']['output']>;
  top_image?: Maybe<FairuAsset>;
  top_subheadline?: Maybe<Scalars['String']['output']>;
  use_multiple_options?: Maybe<Scalars['Boolean']['output']>;
};

export type SubscriptionPageBox = {
  __typename?: 'SubscriptionPageBox';
  headline?: Maybe<Scalars['String']['output']>;
  image?: Maybe<FairuAsset>;
  text?: Maybe<Scalars['String']['output']>;
};


export type SubscriptionPageBoxTextArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SubscriptionPageButton = {
  __typename?: 'SubscriptionPageButton';
  button_link?: Maybe<Scalars['String']['output']>;
  button_text?: Maybe<Scalars['String']['output']>;
};

export type SubscriptionPageFeeback = {
  __typename?: 'SubscriptionPageFeeback';
  image?: Maybe<FairuAsset>;
  link?: Maybe<Scalars['String']['output']>;
  mode?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['String']['output']>;
  stars?: Maybe<Scalars['Int']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};


export type SubscriptionPageFeebackTextArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SubscriptionPageOption = {
  __typename?: 'SubscriptionPageOption';
  option_benefits?: Maybe<Scalars['String']['output']>;
  option_buy_link?: Maybe<Scalars['String']['output']>;
  option_disclaimer?: Maybe<Scalars['String']['output']>;
  option_image?: Maybe<FairuAsset>;
  option_price_after?: Maybe<Scalars['String']['output']>;
  option_price_previous?: Maybe<Scalars['String']['output']>;
  option_price_textline_1?: Maybe<Scalars['String']['output']>;
  option_price_textline_2?: Maybe<Scalars['String']['output']>;
  option_subheadline?: Maybe<Scalars['String']['output']>;
  option_title?: Maybe<Scalars['String']['output']>;
};


export type SubscriptionPageOptionOption_DisclaimerArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SubscriptionShop = {
  __typename?: 'SubscriptionShop';
  header_image_desktop?: Maybe<FairuAsset>;
  header_image_mobile?: Maybe<FairuAsset>;
  header_image_tablet?: Maybe<FairuAsset>;
  /** Startup headline */
  headline?: Maybe<Scalars['String']['output']>;
  /** Unique id */
  id?: Maybe<Scalars['String']['output']>;
  /** Meta data */
  metadata?: Maybe<Meta>;
  /** More button links */
  more_button_link?: Maybe<Scalars['String']['output']>;
  /** More button text */
  more_button_text?: Maybe<Scalars['String']['output']>;
  /** More headline h1 */
  more_headline_1?: Maybe<Scalars['String']['output']>;
  /** More headline h2 */
  more_headline_2?: Maybe<Scalars['String']['output']>;
  more_image_desktop?: Maybe<FairuAsset>;
  more_image_mobile?: Maybe<FairuAsset>;
  more_image_tablet?: Maybe<FairuAsset>;
  /** Teaser text for the more section */
  more_teaser?: Maybe<Scalars['String']['output']>;
  /** Text for the more section */
  more_text?: Maybe<Scalars['String']['output']>;
  /** Product 1 marketing code with binding */
  product_box_1_code_with_binding?: Maybe<Scalars['String']['output']>;
  /** Product 1 marketing code without binding */
  product_box_1_code_without_binding?: Maybe<Scalars['String']['output']>;
  /** Product 1 features */
  product_box_1_features?: Maybe<Array<Maybe<SubscriptionShopProductFeature>>>;
  /** Product 1 headline */
  product_box_1_headline?: Maybe<Scalars['String']['output']>;
  product_box_1_image_desktop?: Maybe<FairuAsset>;
  product_box_1_image_mobile?: Maybe<FairuAsset>;
  product_box_1_image_tablet?: Maybe<FairuAsset>;
  /** Product 1 offer with binding */
  product_box_1_offer_with_binding?: Maybe<Scalars['String']['output']>;
  /** Product 1 offer without binding */
  product_box_1_offer_without_binding?: Maybe<Scalars['String']['output']>;
  /** Product 1 Read more button */
  product_box_1_read_more_button?: Maybe<Scalars['String']['output']>;
  /** Product 1 tagline */
  product_box_1_tagline?: Maybe<Scalars['String']['output']>;
  /** Product 1 text */
  product_box_1_text?: Maybe<Scalars['String']['output']>;
  /** Product 2 marketing code with binding */
  product_box_2_code_with_binding?: Maybe<Scalars['String']['output']>;
  /** Product 2 marketing code without binding */
  product_box_2_code_without_binding?: Maybe<Scalars['String']['output']>;
  /** Product 2 features */
  product_box_2_features?: Maybe<Array<Maybe<SubscriptionShopProductFeature>>>;
  /** Product 2 headline */
  product_box_2_headline?: Maybe<Scalars['String']['output']>;
  product_box_2_image_desktop?: Maybe<FairuAsset>;
  product_box_2_image_mobile?: Maybe<FairuAsset>;
  product_box_2_image_tablet?: Maybe<FairuAsset>;
  /** Product 2 offer with binding */
  product_box_2_offer_with_binding?: Maybe<Scalars['String']['output']>;
  /** Product 2 offer without binding */
  product_box_2_offer_without_binding?: Maybe<Scalars['String']['output']>;
  /** Product 2 Read more button */
  product_box_2_read_more_button?: Maybe<Scalars['String']['output']>;
  /** Product 2 tagline */
  product_box_2_tagline?: Maybe<Scalars['String']['output']>;
  /** Product 2 text */
  product_box_2_text?: Maybe<Scalars['String']['output']>;
  /** Product 3 marketing code with binding */
  product_box_3_code_with_binding?: Maybe<Scalars['String']['output']>;
  /** Product 3 marketing code without binding */
  product_box_3_code_without_binding?: Maybe<Scalars['String']['output']>;
  /** Product 3 features */
  product_box_3_features?: Maybe<Array<Maybe<SubscriptionShopProductFeature>>>;
  /** Product 3 headline */
  product_box_3_headline?: Maybe<Scalars['String']['output']>;
  product_box_3_image_desktop?: Maybe<FairuAsset>;
  product_box_3_image_mobile?: Maybe<FairuAsset>;
  product_box_3_image_tablet?: Maybe<FairuAsset>;
  /** Product 3 offer with binding */
  product_box_3_offer_with_binding?: Maybe<Scalars['String']['output']>;
  /** Product 3 offer without binding */
  product_box_3_offer_without_binding?: Maybe<Scalars['String']['output']>;
  /** Product 3 Read more button */
  product_box_3_read_more_button?: Maybe<Scalars['String']['output']>;
  /** Product 3 tagline */
  product_box_3_tagline?: Maybe<Scalars['String']['output']>;
  /** Product 3 text */
  product_box_3_text?: Maybe<Scalars['String']['output']>;
  /** The slug to to identify a subscription shop page */
  slug?: Maybe<Scalars['String']['output']>;
  /** Startup teaser */
  teaser?: Maybe<Scalars['String']['output']>;
  /** Internal title */
  title?: Maybe<Scalars['String']['output']>;
  /** Startup toogle option 1 */
  toggle_option_1?: Maybe<Scalars['String']['output']>;
  /** Startup toogle option 2 */
  toggle_option_2?: Maybe<Scalars['String']['output']>;
  /** Upgrade section headline */
  upgrade_intro_headline?: Maybe<Scalars['String']['output']>;
  /** Upgrade teaser */
  upgrade_intro_text?: Maybe<Scalars['String']['output']>;
};


export type SubscriptionShopMore_TeaserArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SubscriptionShopMore_TextArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SubscriptionShopProduct_Box_1_TextArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SubscriptionShopProduct_Box_2_TextArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SubscriptionShopProduct_Box_3_TextArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SubscriptionShopTeaserArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SubscriptionShopUpgrade_Intro_TextArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SubscriptionShopProductFeature = {
  __typename?: 'SubscriptionShopProductFeature';
  text?: Maybe<Scalars['String']['output']>;
};

/** A single completed calculator/survey submission. `answers` is a JSON-encoded object. */
export type SurveyResponse = {
  __typename?: 'SurveyResponse';
  /** JSON-encoded snapshot of the submitted answers object. */
  answers: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  portal?: Maybe<Scalars['String']['output']>;
  schemaVersion?: Maybe<Scalars['String']['output']>;
  surveyKey: Scalars['String']['output'];
  userId: Scalars['ID']['output'];
};

export type SurveyResponseList = {
  __typename?: 'SurveyResponseList';
  data: Array<SurveyResponse>;
  paginatorInfo?: Maybe<DefaultPaginator>;
};

export enum Tt500AccountingBackendType {
  Ifrs = 'IFRS',
  Other = 'OTHER',
  Ugb = 'UGB'
}

export enum Tt500AccountingType {
  Ifrs = 'IFRS',
  Other = 'OTHER',
  Ugb = 'UGB'
}

export type Tt500Admin = {
  __typename?: 'TT500Admin';
  class?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstname?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  lastname?: Maybe<Scalars['String']['output']>;
};

export type Tt500Area = {
  __typename?: 'TT500Area';
  area_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type Tt500AreaData = {
  __typename?: 'TT500AreaData';
  data?: Maybe<Array<Tt500Area>>;
};

export type Tt500Asset = {
  __typename?: 'TT500Asset';
  external_path?: Maybe<Scalars['String']['output']>;
  file?: Maybe<GlideData>;
  id: Scalars['ID']['output'];
  origin?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};


export type Tt500AssetFileArgs = {
  fit?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<Scalars['String']['input']>;
  height?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

/** A paginated list of TT500Asset items. */
export type Tt500AssetPaginator = {
  __typename?: 'TT500AssetPaginator';
  /** A list of TT500Asset items. */
  data: Array<Tt500Asset>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type Tt500BankBackend = Tt500CompanyBackendInterface & {
  __typename?: 'TT500BankBackend';
  accounting_type?: Maybe<Tt500AccountingBackendType>;
  accounts_payable?: Maybe<Scalars['Float']['output']>;
  accounts_receivable?: Maybe<Scalars['Float']['output']>;
  admin?: Maybe<Tt500Admin>;
  admin_updated?: Maybe<Scalars['DateTime']['output']>;
  administrative_expenses?: Maybe<Scalars['Float']['output']>;
  annotation?: Maybe<Scalars['String']['output']>;
  basics_updated?: Maybe<Scalars['DateTime']['output']>;
  board?: Maybe<Array<Tt500PersonBackend>>;
  board_updated?: Maybe<Scalars['DateTime']['output']>;
  businesses?: Maybe<Array<Tt500BusinessesBackend>>;
  businesses_generated?: Maybe<Scalars['String']['output']>;
  businesses_updated?: Maybe<Scalars['DateTime']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  commission_result?: Maybe<Scalars['Float']['output']>;
  consolidated?: Maybe<Scalars['Boolean']['output']>;
  contacts?: Maybe<Array<Tt500Contact>>;
  contacts_updated?: Maybe<Scalars['DateTime']['output']>;
  core_capital_ratio?: Maybe<Scalars['Float']['output']>;
  core_capital_ratio_prev?: Maybe<Scalars['Float']['output']>;
  cost_income_ratio?: Maybe<Scalars['Float']['output']>;
  cost_income_ratio_prev?: Maybe<Scalars['Float']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  coverage_non_performing_loans?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  employees?: Maybe<Scalars['Int']['output']>;
  employees_delta?: Maybe<Scalars['Float']['output']>;
  employees_prev?: Maybe<Scalars['Int']['output']>;
  equity_capital?: Maybe<Scalars['Float']['output']>;
  exclude?: Maybe<Scalars['Boolean']['output']>;
  external_finished?: Maybe<Scalars['Boolean']['output']>;
  financials_updated?: Maybe<Scalars['DateTime']['output']>;
  footnote?: Maybe<Scalars['String']['output']>;
  holdings?: Maybe<Array<Tt500HoldingsBackend>>;
  holdings_updated?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  industries?: Maybe<Scalars['String']['output']>;
  internal_finished?: Maybe<Scalars['Boolean']['output']>;
  internal_note?: Maybe<Scalars['String']['output']>;
  is_group?: Maybe<Scalars['Boolean']['output']>;
  ksv?: Maybe<Scalars['Boolean']['output']>;
  ksv_checked?: Maybe<Scalars['Boolean']['output']>;
  lfdNr?: Maybe<Scalars['Int']['output']>;
  management?: Maybe<Array<Tt500PersonBackend>>;
  management_updated?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  net_interest_income?: Maybe<Scalars['Float']['output']>;
  net_interest_margin?: Maybe<Scalars['Float']['output']>;
  net_interest_margin_calc?: Maybe<Scalars['Float']['output']>;
  net_interest_margin_calc_prev?: Maybe<Scalars['Float']['output']>;
  net_interest_margin_prev?: Maybe<Scalars['Float']['output']>;
  non_performing_loans?: Maybe<Scalars['Float']['output']>;
  not_before?: Maybe<Scalars['DateTime']['output']>;
  operating_income?: Maybe<Scalars['Float']['output']>;
  owner?: Maybe<Scalars['String']['output']>;
  owners?: Maybe<Array<Tt500OwnersBackend>>;
  owners_generated?: Maybe<Scalars['String']['output']>;
  owners_updated?: Maybe<Scalars['DateTime']['output']>;
  persons?: Maybe<Array<Tt500PersonBackend>>;
  phone?: Maybe<Scalars['String']['output']>;
  postal_code?: Maybe<Scalars['String']['output']>;
  profit?: Maybe<Scalars['Float']['output']>;
  profit_risk_weighted_assets?: Maybe<Scalars['Float']['output']>;
  published?: Maybe<Scalars['Boolean']['output']>;
  ranking?: Maybe<Scalars['Int']['output']>;
  ranking_hidden?: Maybe<Scalars['Boolean']['output']>;
  ranking_prev?: Maybe<Scalars['String']['output']>;
  related?: Maybe<Array<Tt500CompanyBackendRelated>>;
  return_on_equity?: Maybe<Scalars['Float']['output']>;
  return_on_equity_prev?: Maybe<Scalars['Float']['output']>;
  savings_deposits?: Maybe<Scalars['Float']['output']>;
  share_commission_result?: Maybe<Scalars['Float']['output']>;
  share_commission_result_prev?: Maybe<Scalars['Float']['output']>;
  share_net_interest_income?: Maybe<Scalars['Float']['output']>;
  share_net_interest_income_prev?: Maybe<Scalars['Float']['output']>;
  share_trading_result?: Maybe<Scalars['Float']['output']>;
  share_trading_result_prev?: Maybe<Scalars['Float']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  total_assets?: Maybe<Scalars['Float']['output']>;
  total_assets_delta?: Maybe<Scalars['Float']['output']>;
  total_assets_prev?: Maybe<Scalars['Float']['output']>;
  trading_result?: Maybe<Scalars['Float']['output']>;
  type?: Maybe<Tt500CompanyType>;
  web?: Maybe<Scalars['String']['output']>;
  write_down_securities?: Maybe<Scalars['Float']['output']>;
  year?: Maybe<Scalars['Int']['output']>;
  year_financial?: Maybe<Scalars['String']['output']>;
  year_financial_high?: Maybe<Scalars['String']['output']>;
  year_financial_low?: Maybe<Scalars['String']['output']>;
};

export type Tt500BankBackendPagination = {
  __typename?: 'TT500BankBackendPagination';
  data?: Maybe<Array<Tt500BankBackend>>;
  paginatorInfo?: Maybe<DefaultPaginator>;
};

export type Tt500BusinessBackend = {
  __typename?: 'TT500BusinessBackend';
  category?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type Tt500BusinessBackendData = {
  __typename?: 'TT500BusinessBackendData';
  data?: Maybe<Array<Tt500BusinessBackend>>;
};

export type Tt500Businesses = {
  __typename?: 'TT500Businesses';
  business?: Maybe<Tt500Industry>;
  id: Scalars['ID']['output'];
};

export type Tt500BusinessesBackend = {
  __typename?: 'TT500BusinessesBackend';
  business: Tt500BusinessBackend;
  id: Scalars['ID']['output'];
  main?: Maybe<Scalars['String']['output']>;
};

export type Tt500Company = {
  __typename?: 'TT500Company';
  asset?: Maybe<Tt500Asset>;
  asset_id?: Maybe<Scalars['String']['output']>;
  businesses?: Maybe<Array<Tt500Businesses>>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  external_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  industries?: Maybe<Array<Tt500CompanyIndustry>>;
  logo?: Maybe<Scalars['String']['output']>;
  management?: Maybe<Array<Tt500PersonPosition>>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  postal_code?: Maybe<Scalars['String']['output']>;
  published?: Maybe<Scalars['Boolean']['output']>;
  ranking?: Maybe<Scalars['Int']['output']>;
  reports?: Maybe<Array<Tt500FinanceReport>>;
  slug?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  type: Tt500CompanyType;
  web?: Maybe<Scalars['String']['output']>;
};

export type Tt500CompanyBackend = {
  __typename?: 'TT500CompanyBackend';
  accounting_type?: Maybe<Tt500AccountingBackendType>;
  admin?: Maybe<Tt500Admin>;
  admin_updated?: Maybe<Scalars['DateTime']['output']>;
  annotation?: Maybe<Scalars['String']['output']>;
  basics_updated?: Maybe<Scalars['DateTime']['output']>;
  board?: Maybe<Array<Tt500PersonBackend>>;
  board_updated?: Maybe<Scalars['DateTime']['output']>;
  businesses?: Maybe<Array<Tt500BusinessesBackend>>;
  businesses_generated?: Maybe<Scalars['String']['output']>;
  businesses_updated?: Maybe<Scalars['DateTime']['output']>;
  cashflow_earnings?: Maybe<Scalars['Float']['output']>;
  cashflow_operating?: Maybe<Scalars['Float']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  consolidated?: Maybe<Scalars['Boolean']['output']>;
  contacts?: Maybe<Array<Tt500Contact>>;
  contacts_updated?: Maybe<Scalars['DateTime']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  ebit?: Maybe<Scalars['Float']['output']>;
  ebit_calc?: Maybe<Scalars['Float']['output']>;
  ebit_calc_prev?: Maybe<Scalars['Float']['output']>;
  ebit_prev?: Maybe<Scalars['Float']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  employees?: Maybe<Scalars['Int']['output']>;
  employees_delta?: Maybe<Scalars['Float']['output']>;
  employees_delta_prev?: Maybe<Scalars['Float']['output']>;
  employees_prev?: Maybe<Scalars['Int']['output']>;
  equity_capital?: Maybe<Scalars['Float']['output']>;
  equity_ratio_calc?: Maybe<Scalars['Float']['output']>;
  equity_ratio_prev_calc?: Maybe<Scalars['Float']['output']>;
  exclude?: Maybe<Scalars['Boolean']['output']>;
  export?: Maybe<Scalars['String']['output']>;
  export_markets?: Maybe<Scalars['String']['output']>;
  export_share?: Maybe<Scalars['Float']['output']>;
  external_finished?: Maybe<Scalars['Boolean']['output']>;
  financials_updated?: Maybe<Scalars['DateTime']['output']>;
  footnote?: Maybe<Scalars['String']['output']>;
  holdings?: Maybe<Array<Tt500HoldingsBackend>>;
  holdings_updated?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  industries?: Maybe<Scalars['String']['output']>;
  internal_finished?: Maybe<Scalars['Boolean']['output']>;
  internal_note?: Maybe<Scalars['String']['output']>;
  is_group?: Maybe<Scalars['Boolean']['output']>;
  ksv?: Maybe<Scalars['Boolean']['output']>;
  ksv_checked?: Maybe<Scalars['Boolean']['output']>;
  lfdNr?: Maybe<Scalars['Int']['output']>;
  management?: Maybe<Array<Tt500PersonBackend>>;
  management_updated?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  netdebt?: Maybe<Scalars['Float']['output']>;
  netrevenue?: Maybe<Scalars['Float']['output']>;
  netrevenue_delta?: Maybe<Scalars['Float']['output']>;
  netrevenue_prev?: Maybe<Scalars['Float']['output']>;
  not_before?: Maybe<Scalars['DateTime']['output']>;
  operational_success?: Maybe<Scalars['Float']['output']>;
  owner?: Maybe<Scalars['String']['output']>;
  owners?: Maybe<Array<Tt500OwnersBackend>>;
  owners_generated?: Maybe<Scalars['String']['output']>;
  owners_updated?: Maybe<Scalars['DateTime']['output']>;
  persons?: Maybe<Array<Tt500PersonBackend>>;
  phone?: Maybe<Scalars['String']['output']>;
  postal_code?: Maybe<Scalars['String']['output']>;
  published?: Maybe<Scalars['Boolean']['output']>;
  ranking?: Maybe<Scalars['Int']['output']>;
  ranking_hidden?: Maybe<Scalars['Boolean']['output']>;
  ranking_prev?: Maybe<Scalars['String']['output']>;
  related?: Maybe<Array<Tt500CompanyBackendRelated>>;
  rnd?: Maybe<Scalars['Float']['output']>;
  rnd_delta?: Maybe<Scalars['Float']['output']>;
  rnd_delta_prev?: Maybe<Scalars['Float']['output']>;
  rnd_prev?: Maybe<Scalars['Float']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  total_assets?: Maybe<Scalars['Float']['output']>;
  total_investments?: Maybe<Scalars['Float']['output']>;
  type?: Maybe<Tt500CompanyType>;
  web?: Maybe<Scalars['String']['output']>;
  year?: Maybe<Scalars['Int']['output']>;
  year_financial?: Maybe<Scalars['String']['output']>;
  year_financial_high?: Maybe<Scalars['String']['output']>;
  year_financial_low?: Maybe<Scalars['String']['output']>;
};

export type Tt500CompanyBackendInterface = {
  accounting_type?: Maybe<Tt500AccountingBackendType>;
  admin?: Maybe<Tt500Admin>;
  admin_updated?: Maybe<Scalars['DateTime']['output']>;
  annotation?: Maybe<Scalars['String']['output']>;
  basics_updated?: Maybe<Scalars['DateTime']['output']>;
  board?: Maybe<Array<Tt500PersonBackend>>;
  board_updated?: Maybe<Scalars['DateTime']['output']>;
  businesses?: Maybe<Array<Tt500BusinessesBackend>>;
  businesses_generated?: Maybe<Scalars['String']['output']>;
  businesses_updated?: Maybe<Scalars['DateTime']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  consolidated?: Maybe<Scalars['Boolean']['output']>;
  contacts?: Maybe<Array<Tt500Contact>>;
  contacts_updated?: Maybe<Scalars['DateTime']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  employees?: Maybe<Scalars['Int']['output']>;
  employees_delta?: Maybe<Scalars['Float']['output']>;
  exclude?: Maybe<Scalars['Boolean']['output']>;
  external_finished?: Maybe<Scalars['Boolean']['output']>;
  financials_updated?: Maybe<Scalars['DateTime']['output']>;
  footnote?: Maybe<Scalars['String']['output']>;
  holdings?: Maybe<Array<Tt500HoldingsBackend>>;
  holdings_updated?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  industries?: Maybe<Scalars['String']['output']>;
  internal_finished?: Maybe<Scalars['Boolean']['output']>;
  internal_note?: Maybe<Scalars['String']['output']>;
  is_group?: Maybe<Scalars['Boolean']['output']>;
  ksv?: Maybe<Scalars['Boolean']['output']>;
  ksv_checked?: Maybe<Scalars['Boolean']['output']>;
  lfdNr?: Maybe<Scalars['Int']['output']>;
  management?: Maybe<Array<Tt500PersonBackend>>;
  management_updated?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  not_before?: Maybe<Scalars['DateTime']['output']>;
  owner?: Maybe<Scalars['String']['output']>;
  owners?: Maybe<Array<Tt500OwnersBackend>>;
  owners_generated?: Maybe<Scalars['String']['output']>;
  owners_updated?: Maybe<Scalars['DateTime']['output']>;
  persons?: Maybe<Array<Tt500PersonBackend>>;
  phone?: Maybe<Scalars['String']['output']>;
  postal_code?: Maybe<Scalars['String']['output']>;
  published?: Maybe<Scalars['Boolean']['output']>;
  ranking?: Maybe<Scalars['Int']['output']>;
  ranking_hidden?: Maybe<Scalars['Boolean']['output']>;
  ranking_prev?: Maybe<Scalars['String']['output']>;
  related?: Maybe<Array<Tt500CompanyBackendRelated>>;
  slug?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Tt500CompanyType>;
  web?: Maybe<Scalars['String']['output']>;
  year?: Maybe<Scalars['Int']['output']>;
  year_financial?: Maybe<Scalars['String']['output']>;
  year_financial_high?: Maybe<Scalars['String']['output']>;
  year_financial_low?: Maybe<Scalars['String']['output']>;
};

export type Tt500CompanyBackendPagination = {
  __typename?: 'TT500CompanyBackendPagination';
  data?: Maybe<Array<Tt500CompanyBackend>>;
  paginatorInfo?: Maybe<DefaultPaginator>;
};

export type Tt500CompanyBackendRelated = {
  __typename?: 'TT500CompanyBackendRelated';
  id: Scalars['String']['output'];
  ranking?: Maybe<Scalars['Int']['output']>;
  year: Scalars['Int']['output'];
};

export type Tt500CompanyIndustry = {
  __typename?: 'TT500CompanyIndustry';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  published?: Maybe<Scalars['Boolean']['output']>;
};

/** A paginated list of TT500CompanyIndustry items. */
export type Tt500CompanyIndustryPaginator = {
  __typename?: 'TT500CompanyIndustryPaginator';
  /** A list of TT500CompanyIndustry items. */
  data: Array<Tt500CompanyIndustry>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type Tt500CompanyPagination = {
  __typename?: 'TT500CompanyPagination';
  data?: Maybe<Array<Tt500Company>>;
  paginatorInfo?: Maybe<DefaultPaginator>;
};

export type Tt500CompanyPosition = {
  function: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  kind: Scalars['String']['input'];
  year: Scalars['Int']['input'];
};

export type Tt500CompanyReport = {
  accounting_type?: InputMaybe<Tt500AccountingType>;
  annoation?: InputMaybe<Scalars['String']['input']>;
  corecapitalratio?: InputMaybe<Scalars['Float']['input']>;
  corecapitalratio_prev?: InputMaybe<Scalars['Float']['input']>;
  costincomeratio?: InputMaybe<Scalars['Float']['input']>;
  costincomeratio_prev?: InputMaybe<Scalars['Float']['input']>;
  damage?: InputMaybe<Scalars['Float']['input']>;
  damage_prev?: InputMaybe<Scalars['Float']['input']>;
  earnedpremium?: InputMaybe<Scalars['Float']['input']>;
  earnedpremium_delta?: InputMaybe<Scalars['Float']['input']>;
  ebit?: InputMaybe<Scalars['Float']['input']>;
  ebit_prev?: InputMaybe<Scalars['Float']['input']>;
  employees?: InputMaybe<Scalars['Int']['input']>;
  employees_delta?: InputMaybe<Scalars['Float']['input']>;
  equityratio?: InputMaybe<Scalars['Float']['input']>;
  excess?: InputMaybe<Scalars['Float']['input']>;
  footnote?: InputMaybe<Scalars['String']['input']>;
  health?: InputMaybe<Scalars['Float']['input']>;
  health_prev?: InputMaybe<Scalars['Float']['input']>;
  life?: InputMaybe<Scalars['Float']['input']>;
  life_prev?: InputMaybe<Scalars['Float']['input']>;
  netcombinedratio?: InputMaybe<Scalars['Float']['input']>;
  netcombinedratio_prev?: InputMaybe<Scalars['Float']['input']>;
  netinterestmargin?: InputMaybe<Scalars['Float']['input']>;
  netinterestmargin_prev?: InputMaybe<Scalars['Float']['input']>;
  netrevenue?: InputMaybe<Scalars['Float']['input']>;
  netrevenue_delta?: InputMaybe<Scalars['Float']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  ranking?: InputMaybe<Scalars['Int']['input']>;
  ranking_prev?: InputMaybe<Scalars['Int']['input']>;
  return?: InputMaybe<Scalars['Float']['input']>;
  share_commissionresult?: InputMaybe<Scalars['Float']['input']>;
  share_commissionresult_prev?: InputMaybe<Scalars['Float']['input']>;
  share_netinterestincome?: InputMaybe<Scalars['Float']['input']>;
  share_netinterestincome_prev?: InputMaybe<Scalars['Float']['input']>;
  share_tradingresult?: InputMaybe<Scalars['Float']['input']>;
  share_tradingresult_prev?: InputMaybe<Scalars['Float']['input']>;
  solvencyratio?: InputMaybe<Scalars['Float']['input']>;
  solvencyratio_prev?: InputMaybe<Scalars['Float']['input']>;
  totalassets?: InputMaybe<Scalars['Float']['input']>;
  totalassets_delta?: InputMaybe<Scalars['Float']['input']>;
  unitlinked?: InputMaybe<Scalars['Float']['input']>;
  unitlinked_prev?: InputMaybe<Scalars['Float']['input']>;
  year: Scalars['Int']['input'];
  year_financial?: InputMaybe<Scalars['String']['input']>;
  yield?: InputMaybe<Scalars['Float']['input']>;
  yield_prev?: InputMaybe<Scalars['Float']['input']>;
};

export enum Tt500CompanyType {
  Bank = 'BANK',
  Insurance = 'INSURANCE',
  Normal = 'NORMAL'
}

export type Tt500CompanyUpdateReport = {
  accounting_type?: InputMaybe<Tt500AccountingType>;
  annoation?: InputMaybe<Scalars['String']['input']>;
  corecapitalratio?: InputMaybe<Scalars['Float']['input']>;
  corecapitalratio_prev?: InputMaybe<Scalars['Float']['input']>;
  costincomeratio?: InputMaybe<Scalars['Float']['input']>;
  costincomeratio_prev?: InputMaybe<Scalars['Float']['input']>;
  damage?: InputMaybe<Scalars['Float']['input']>;
  damage_prev?: InputMaybe<Scalars['Float']['input']>;
  earnedpremium?: InputMaybe<Scalars['Float']['input']>;
  earnedpremium_delta?: InputMaybe<Scalars['Float']['input']>;
  ebit?: InputMaybe<Scalars['Float']['input']>;
  ebit_prev?: InputMaybe<Scalars['Float']['input']>;
  employees?: InputMaybe<Scalars['Int']['input']>;
  employees_delta?: InputMaybe<Scalars['Float']['input']>;
  equityratio?: InputMaybe<Scalars['Float']['input']>;
  excess?: InputMaybe<Scalars['Float']['input']>;
  footnote?: InputMaybe<Scalars['String']['input']>;
  health?: InputMaybe<Scalars['Float']['input']>;
  health_prev?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['ID']['input'];
  life?: InputMaybe<Scalars['Float']['input']>;
  life_prev?: InputMaybe<Scalars['Float']['input']>;
  netcombinedratio?: InputMaybe<Scalars['Float']['input']>;
  netcombinedratio_prev?: InputMaybe<Scalars['Float']['input']>;
  netinterestmargin?: InputMaybe<Scalars['Float']['input']>;
  netinterestmargin_prev?: InputMaybe<Scalars['Float']['input']>;
  netrevenue?: InputMaybe<Scalars['Float']['input']>;
  netrevenue_delta?: InputMaybe<Scalars['Float']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  ranking?: InputMaybe<Scalars['Int']['input']>;
  ranking_hidden?: InputMaybe<Scalars['Boolean']['input']>;
  ranking_prev?: InputMaybe<Scalars['Int']['input']>;
  return?: InputMaybe<Scalars['Float']['input']>;
  share_commissionresult?: InputMaybe<Scalars['Float']['input']>;
  share_commissionresult_prev?: InputMaybe<Scalars['Float']['input']>;
  share_netinterestincome?: InputMaybe<Scalars['Float']['input']>;
  share_netinterestincome_prev?: InputMaybe<Scalars['Float']['input']>;
  share_tradingresult?: InputMaybe<Scalars['Float']['input']>;
  share_tradingresult_prev?: InputMaybe<Scalars['Float']['input']>;
  solvencyratio?: InputMaybe<Scalars['Float']['input']>;
  solvencyratio_prev?: InputMaybe<Scalars['Float']['input']>;
  totalassets?: InputMaybe<Scalars['Float']['input']>;
  totalassets_delta?: InputMaybe<Scalars['Float']['input']>;
  unitlinked?: InputMaybe<Scalars['Float']['input']>;
  unitlinked_prev?: InputMaybe<Scalars['Float']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
  year_financial?: InputMaybe<Scalars['Int']['input']>;
  yield?: InputMaybe<Scalars['Float']['input']>;
  yield_prev?: InputMaybe<Scalars['Float']['input']>;
};

export type Tt500ConditionInput = {
  column: Scalars['String']['input'];
  operator: Scalars['String']['input'];
  value: Scalars['Float']['input'];
};

export type Tt500Contact = {
  __typename?: 'TT500Contact';
  address?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  fax?: Maybe<Scalars['String']['output']>;
  finished?: Maybe<Scalars['Boolean']['output']>;
  firstname?: Maybe<Scalars['String']['output']>;
  gender: Tt500PersonGender;
  id: Scalars['ID']['output'];
  info?: Maybe<Scalars['String']['output']>;
  lastname: Scalars['String']['output'];
  lfdNr?: Maybe<Scalars['Int']['output']>;
  mobile?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['String']['output']>;
  postal_code?: Maybe<Scalars['String']['output']>;
  primary?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type Tt500ContactSearchData = {
  __typename?: 'TT500ContactSearchData';
  data?: Maybe<Array<Tt500ContactSearchResult>>;
};

export type Tt500ContactSearchResult = {
  __typename?: 'TT500ContactSearchResult';
  company_id?: Maybe<Scalars['String']['output']>;
  company_name?: Maybe<Scalars['String']['output']>;
  company_slug?: Maybe<Scalars['String']['output']>;
  contact: Tt500Contact;
};

export type Tt500CreateCompany = {
  asset_id?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  management?: InputMaybe<Array<Tt500CompanyPosition>>;
  name?: InputMaybe<Scalars['String']['input']>;
  postal_code?: InputMaybe<Scalars['String']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  ranking?: InputMaybe<Scalars['Int']['input']>;
  reports?: InputMaybe<Array<Tt500CompanyReport>>;
  slug?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  type: Tt500CompanyType;
  web?: InputMaybe<Scalars['String']['input']>;
};

export type Tt500CreatePerson = {
  firstname: Scalars['String']['input'];
  gender?: InputMaybe<Tt500PersonGender>;
  lastname: Scalars['String']['input'];
};

export type Tt500DefaultBackend = Tt500CompanyBackendInterface & {
  __typename?: 'TT500DefaultBackend';
  accounting_type?: Maybe<Tt500AccountingBackendType>;
  admin?: Maybe<Tt500Admin>;
  admin_updated?: Maybe<Scalars['DateTime']['output']>;
  annotation?: Maybe<Scalars['String']['output']>;
  basics_updated?: Maybe<Scalars['DateTime']['output']>;
  board?: Maybe<Array<Tt500PersonBackend>>;
  board_updated?: Maybe<Scalars['DateTime']['output']>;
  businesses?: Maybe<Array<Tt500BusinessesBackend>>;
  businesses_generated?: Maybe<Scalars['String']['output']>;
  businesses_updated?: Maybe<Scalars['DateTime']['output']>;
  cashflow_earnings?: Maybe<Scalars['Float']['output']>;
  cashflow_operating?: Maybe<Scalars['Float']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  consolidated?: Maybe<Scalars['Boolean']['output']>;
  contacts?: Maybe<Array<Tt500Contact>>;
  contacts_updated?: Maybe<Scalars['DateTime']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  ebit?: Maybe<Scalars['Float']['output']>;
  ebit_prev?: Maybe<Scalars['Float']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  employees?: Maybe<Scalars['Int']['output']>;
  employees_delta?: Maybe<Scalars['Float']['output']>;
  employees_delta_prev?: Maybe<Scalars['Float']['output']>;
  equity_capital?: Maybe<Scalars['Float']['output']>;
  equity_ratio_calc?: Maybe<Scalars['Float']['output']>;
  equity_ratio_prev_calc?: Maybe<Scalars['Float']['output']>;
  exclude?: Maybe<Scalars['Boolean']['output']>;
  export?: Maybe<Scalars['String']['output']>;
  export_markets?: Maybe<Scalars['String']['output']>;
  export_share?: Maybe<Scalars['Float']['output']>;
  external_finished?: Maybe<Scalars['Boolean']['output']>;
  financials_updated?: Maybe<Scalars['DateTime']['output']>;
  footnote?: Maybe<Scalars['String']['output']>;
  holdings?: Maybe<Array<Tt500HoldingsBackend>>;
  holdings_updated?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  industries?: Maybe<Scalars['String']['output']>;
  internal_finished?: Maybe<Scalars['Boolean']['output']>;
  internal_note?: Maybe<Scalars['String']['output']>;
  is_group?: Maybe<Scalars['Boolean']['output']>;
  ksv?: Maybe<Scalars['Boolean']['output']>;
  ksv_checked?: Maybe<Scalars['Boolean']['output']>;
  lfdNr?: Maybe<Scalars['Int']['output']>;
  management?: Maybe<Array<Tt500PersonBackend>>;
  management_updated?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  netdebt?: Maybe<Scalars['Float']['output']>;
  netrevenue?: Maybe<Scalars['Float']['output']>;
  netrevenue_delta?: Maybe<Scalars['Float']['output']>;
  not_before?: Maybe<Scalars['DateTime']['output']>;
  operational_success?: Maybe<Scalars['Float']['output']>;
  owner?: Maybe<Scalars['String']['output']>;
  owners?: Maybe<Array<Tt500OwnersBackend>>;
  owners_generated?: Maybe<Scalars['String']['output']>;
  owners_updated?: Maybe<Scalars['DateTime']['output']>;
  persons?: Maybe<Array<Tt500PersonBackend>>;
  phone?: Maybe<Scalars['String']['output']>;
  postal_code?: Maybe<Scalars['String']['output']>;
  published?: Maybe<Scalars['Boolean']['output']>;
  ranking?: Maybe<Scalars['Int']['output']>;
  ranking_hidden?: Maybe<Scalars['Boolean']['output']>;
  ranking_prev?: Maybe<Scalars['String']['output']>;
  related?: Maybe<Array<Tt500CompanyBackendRelated>>;
  rnd?: Maybe<Scalars['Float']['output']>;
  rnd_delta?: Maybe<Scalars['Float']['output']>;
  rnd_delta_prev?: Maybe<Scalars['Float']['output']>;
  rnd_prev?: Maybe<Scalars['Float']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  total_assets?: Maybe<Scalars['Float']['output']>;
  total_investments?: Maybe<Scalars['Float']['output']>;
  type?: Maybe<Tt500CompanyType>;
  web?: Maybe<Scalars['String']['output']>;
  year?: Maybe<Scalars['Int']['output']>;
  year_financial?: Maybe<Scalars['String']['output']>;
  year_financial_high?: Maybe<Scalars['String']['output']>;
  year_financial_low?: Maybe<Scalars['String']['output']>;
};

export type Tt500FinanceReport = Tt500FinanceReportBank | Tt500FinanceReportDefault | Tt500FinanceReportInsurance;

export type Tt500FinanceReportBank = Tt500ResultInterface & {
  __typename?: 'TT500FinanceReportBank';
  accounting_type?: Maybe<Tt500AccountingType>;
  annoation?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Tt500Company>;
  /** TODO: Describe this field */
  corecapitalratio?: Maybe<Scalars['Float']['output']>;
  /** TODO: Describe this field */
  corecapitalratio_prev?: Maybe<Scalars['Float']['output']>;
  /** TODO: Describe this field */
  costincomeratio?: Maybe<Scalars['Float']['output']>;
  /** TODO: Describe this field */
  costincomeratio_prev?: Maybe<Scalars['Float']['output']>;
  employees?: Maybe<Scalars['Int']['output']>;
  employees_delta?: Maybe<Scalars['Float']['output']>;
  footnote?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  industry?: Maybe<Tt500CompanyIndustry>;
  management_female?: Maybe<Scalars['Int']['output']>;
  management_male?: Maybe<Scalars['Int']['output']>;
  /** TODO: Describe this field */
  netinterestmargin?: Maybe<Scalars['Float']['output']>;
  /** TODO: Describe this field */
  netinterestmargin_prev?: Maybe<Scalars['Float']['output']>;
  owner?: Maybe<Scalars['String']['output']>;
  ranking?: Maybe<Scalars['Int']['output']>;
  /** TODO: Describe this field */
  ranking_hidden?: Maybe<Scalars['Boolean']['output']>;
  ranking_prev?: Maybe<Scalars['Int']['output']>;
  /** TODO: Describe this field */
  returnonequity?: Maybe<Scalars['Float']['output']>;
  /** TODO: Describe this field */
  returnonequity_prev?: Maybe<Scalars['Float']['output']>;
  /** TODO: Describe this field */
  share_commissionresult?: Maybe<Scalars['Float']['output']>;
  /** TODO: Describe this field */
  share_commissionresult_prev?: Maybe<Scalars['Float']['output']>;
  /** TODO: Describe this field */
  share_netinterestincome?: Maybe<Scalars['Float']['output']>;
  /** TODO: Describe this field */
  share_netinterestincome_prev?: Maybe<Scalars['Float']['output']>;
  /** TODO: Describe this field */
  share_tradingresult?: Maybe<Scalars['Float']['output']>;
  /** TODO: Describe this field */
  share_tradingresult_prev?: Maybe<Scalars['Float']['output']>;
  /** TODO: Describe this field */
  totalassets?: Maybe<Scalars['Float']['output']>;
  /** TODO: Describe this field */
  totalassets_delta?: Maybe<Scalars['Float']['output']>;
  year: Scalars['Int']['output'];
  year_financial?: Maybe<Scalars['String']['output']>;
};

export type Tt500FinanceReportBanksPagination = {
  __typename?: 'TT500FinanceReportBanksPagination';
  data?: Maybe<Array<Tt500FinanceReportBank>>;
  paginatorInfo?: Maybe<DefaultPaginator>;
};

export type Tt500FinanceReportDefault = Tt500ResultInterface & {
  __typename?: 'TT500FinanceReportDefault';
  accounting_type?: Maybe<Tt500AccountingType>;
  annoation?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Tt500Company>;
  /** TODO: Describe this field */
  ebit?: Maybe<Scalars['Float']['output']>;
  /** TODO: Describe this field */
  ebit_prev?: Maybe<Scalars['Float']['output']>;
  employees?: Maybe<Scalars['Int']['output']>;
  employees_delta?: Maybe<Scalars['Float']['output']>;
  employees_increase?: Maybe<Scalars['Int']['output']>;
  employees_prev?: Maybe<Scalars['Int']['output']>;
  footnote?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  industry?: Maybe<Tt500CompanyIndustry>;
  management_female?: Maybe<Scalars['Int']['output']>;
  management_male?: Maybe<Scalars['Int']['output']>;
  /** TODO: Describe this field */
  netrevenue?: Maybe<Scalars['Float']['output']>;
  /** TODO: Describe this field */
  netrevenue_delta?: Maybe<Scalars['Float']['output']>;
  owner?: Maybe<Scalars['String']['output']>;
  ranking?: Maybe<Scalars['Int']['output']>;
  ranking_difference?: Maybe<Scalars['Int']['output']>;
  /** TODO: Describe this field */
  ranking_hidden?: Maybe<Scalars['Boolean']['output']>;
  ranking_prev?: Maybe<Scalars['Int']['output']>;
  year: Scalars['Int']['output'];
  /** The timeframe of the buisness year */
  year_financial?: Maybe<Scalars['String']['output']>;
};

export type Tt500FinanceReportInsurance = Tt500ResultInterface & {
  __typename?: 'TT500FinanceReportInsurance';
  accounting_type?: Maybe<Tt500AccountingType>;
  annoation?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Tt500Company>;
  /** TODO: Describe this field */
  damage?: Maybe<Scalars['Float']['output']>;
  /** TODO: Describe this field */
  damage_prev?: Maybe<Scalars['Float']['output']>;
  /** TODO: Describe this field */
  earnedpremium?: Maybe<Scalars['Float']['output']>;
  /** TODO: Describe this field */
  earnedpremium_delta?: Maybe<Scalars['Float']['output']>;
  employees?: Maybe<Scalars['Int']['output']>;
  employees_delta?: Maybe<Scalars['Float']['output']>;
  /** TODO: Describe this field */
  equityratio?: Maybe<Scalars['Float']['output']>;
  /** TODO: Describe this field */
  excess?: Maybe<Scalars['Float']['output']>;
  footnote?: Maybe<Scalars['String']['output']>;
  gross_premium?: Maybe<Scalars['Float']['output']>;
  /** TODO: Describe this field */
  health?: Maybe<Scalars['Float']['output']>;
  /** TODO: Describe this field */
  health_prev?: Maybe<Scalars['Float']['output']>;
  id: Scalars['String']['output'];
  industry?: Maybe<Tt500CompanyIndustry>;
  /** TODO: Describe this field */
  life?: Maybe<Scalars['Float']['output']>;
  /** TODO: Describe this field */
  life_prev?: Maybe<Scalars['Float']['output']>;
  management_female?: Maybe<Scalars['Int']['output']>;
  management_male?: Maybe<Scalars['Int']['output']>;
  /** TODO: Describe this field */
  netcombinedratio?: Maybe<Scalars['Float']['output']>;
  /** TODO: Describe this field */
  netcombinedratio_prev?: Maybe<Scalars['Float']['output']>;
  owner?: Maybe<Scalars['String']['output']>;
  ranking?: Maybe<Scalars['Int']['output']>;
  /** TODO: Describe this field */
  ranking_hidden?: Maybe<Scalars['Boolean']['output']>;
  ranking_prev?: Maybe<Scalars['Int']['output']>;
  /** TODO: Describe this field */
  return?: Maybe<Scalars['Float']['output']>;
  /** TODO: Describe this field */
  solvencyratio?: Maybe<Scalars['Float']['output']>;
  /** TODO: Describe this field */
  solvencyratio_prev?: Maybe<Scalars['Float']['output']>;
  /** TODO: Describe this field */
  unitlinked?: Maybe<Scalars['Float']['output']>;
  /** TODO: Describe this field */
  unitlinked_prev?: Maybe<Scalars['Float']['output']>;
  year: Scalars['Int']['output'];
  year_financial?: Maybe<Scalars['String']['output']>;
  /** TODO: Describe this field */
  yield?: Maybe<Scalars['Float']['output']>;
  /** TODO: Describe this field */
  yield_prev?: Maybe<Scalars['Float']['output']>;
};

export type Tt500FinanceReportInsurancesPagination = {
  __typename?: 'TT500FinanceReportInsurancesPagination';
  data?: Maybe<Array<Tt500FinanceReportInsurance>>;
  paginatorInfo?: Maybe<DefaultPaginator>;
};

export type Tt500FinanceReportPagination = {
  __typename?: 'TT500FinanceReportPagination';
  data?: Maybe<Array<Tt500FinanceReportDefault>>;
  paginatorInfo?: Maybe<DefaultPaginator>;
};

export type Tt500HoldingsBackend = {
  __typename?: 'TT500HoldingsBackend';
  country?: Maybe<Scalars['String']['output']>;
  holding_name: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lfdNr?: Maybe<Scalars['Int']['output']>;
  nominal_capital?: Maybe<Scalars['Float']['output']>;
  year?: Maybe<Scalars['Int']['output']>;
};

export type Tt500Industry = {
  __typename?: 'TT500Industry';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  published?: Maybe<Scalars['Boolean']['output']>;
};

export type Tt500InsuranceBackend = Tt500CompanyBackendInterface & {
  __typename?: 'TT500InsuranceBackend';
  accounting_type?: Maybe<Tt500AccountingBackendType>;
  admin?: Maybe<Tt500Admin>;
  admin_updated?: Maybe<Scalars['DateTime']['output']>;
  annotation?: Maybe<Scalars['String']['output']>;
  basics_updated?: Maybe<Scalars['DateTime']['output']>;
  board?: Maybe<Array<Tt500PersonBackend>>;
  board_updated?: Maybe<Scalars['DateTime']['output']>;
  businesses?: Maybe<Array<Tt500BusinessesBackend>>;
  businesses_generated?: Maybe<Scalars['String']['output']>;
  businesses_updated?: Maybe<Scalars['DateTime']['output']>;
  capital_investments?: Maybe<Scalars['Float']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  consolidated?: Maybe<Scalars['Boolean']['output']>;
  contacts?: Maybe<Array<Tt500Contact>>;
  contacts_updated?: Maybe<Scalars['DateTime']['output']>;
  cost_ratio?: Maybe<Scalars['Float']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  earned_premium?: Maybe<Scalars['Float']['output']>;
  earned_premium_delta?: Maybe<Scalars['Float']['output']>;
  earned_premium_prev?: Maybe<Scalars['Float']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  embedded_value?: Maybe<Scalars['Float']['output']>;
  employees?: Maybe<Scalars['Int']['output']>;
  employees_delta?: Maybe<Scalars['Float']['output']>;
  employees_prev?: Maybe<Scalars['Int']['output']>;
  equity?: Maybe<Scalars['Float']['output']>;
  equity_ratio?: Maybe<Scalars['Float']['output']>;
  equity_ratio_prev?: Maybe<Scalars['Float']['output']>;
  excess?: Maybe<Scalars['Float']['output']>;
  excess_prev?: Maybe<Scalars['Float']['output']>;
  exclude?: Maybe<Scalars['Boolean']['output']>;
  external_finished?: Maybe<Scalars['Boolean']['output']>;
  financials_updated?: Maybe<Scalars['DateTime']['output']>;
  footnote?: Maybe<Scalars['String']['output']>;
  gross_premium?: Maybe<Scalars['Float']['output']>;
  gross_profit?: Maybe<Scalars['Float']['output']>;
  holdings?: Maybe<Array<Tt500HoldingsBackend>>;
  holdings_updated?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  industries?: Maybe<Scalars['String']['output']>;
  insurance_benefits?: Maybe<Scalars['Float']['output']>;
  internal_finished?: Maybe<Scalars['Boolean']['output']>;
  internal_note?: Maybe<Scalars['String']['output']>;
  is_group?: Maybe<Scalars['Boolean']['output']>;
  ksv?: Maybe<Scalars['Boolean']['output']>;
  ksv_checked?: Maybe<Scalars['Boolean']['output']>;
  lfdNr?: Maybe<Scalars['Int']['output']>;
  loss_ratio?: Maybe<Scalars['Float']['output']>;
  management?: Maybe<Array<Tt500PersonBackend>>;
  management_updated?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  net_combined_ratio?: Maybe<Scalars['Float']['output']>;
  net_combined_ratio_prev?: Maybe<Scalars['Float']['output']>;
  net_financial_income?: Maybe<Scalars['Float']['output']>;
  net_income?: Maybe<Scalars['Float']['output']>;
  not_before?: Maybe<Scalars['DateTime']['output']>;
  owner?: Maybe<Scalars['String']['output']>;
  owners?: Maybe<Array<Tt500OwnersBackend>>;
  owners_generated?: Maybe<Scalars['String']['output']>;
  owners_updated?: Maybe<Scalars['DateTime']['output']>;
  persons?: Maybe<Array<Tt500PersonBackend>>;
  phone?: Maybe<Scalars['String']['output']>;
  postal_code?: Maybe<Scalars['String']['output']>;
  published?: Maybe<Scalars['Boolean']['output']>;
  ranking?: Maybe<Scalars['Int']['output']>;
  ranking_hidden?: Maybe<Scalars['Boolean']['output']>;
  ranking_prev?: Maybe<Scalars['String']['output']>;
  reinsurers_share?: Maybe<Scalars['Float']['output']>;
  related?: Maybe<Array<Tt500CompanyBackendRelated>>;
  return?: Maybe<Scalars['Float']['output']>;
  return_prev?: Maybe<Scalars['Float']['output']>;
  share_equities?: Maybe<Scalars['Float']['output']>;
  share_health_insurance?: Maybe<Scalars['Float']['output']>;
  share_health_insurance_calc?: Maybe<Scalars['Float']['output']>;
  share_health_insurance_calc_prev?: Maybe<Scalars['Float']['output']>;
  share_health_insurance_prev?: Maybe<Scalars['Float']['output']>;
  share_index_life_linked_insurance?: Maybe<Scalars['Float']['output']>;
  share_index_life_linked_insurance_calc?: Maybe<Scalars['Float']['output']>;
  share_index_life_linked_insurance_calc_prev?: Maybe<Scalars['Float']['output']>;
  share_index_life_linked_insurance_prev?: Maybe<Scalars['Float']['output']>;
  share_life_insurance?: Maybe<Scalars['Float']['output']>;
  share_life_insurance_calc?: Maybe<Scalars['Float']['output']>;
  share_life_insurance_calc_prev?: Maybe<Scalars['Float']['output']>;
  share_life_insurance_prev?: Maybe<Scalars['Float']['output']>;
  share_minorities?: Maybe<Scalars['Float']['output']>;
  share_others?: Maybe<Scalars['Float']['output']>;
  share_property_casualty?: Maybe<Scalars['Float']['output']>;
  share_property_casualty_calc?: Maybe<Scalars['Float']['output']>;
  share_property_casualty_calc_prev?: Maybe<Scalars['Float']['output']>;
  share_property_casualty_prev?: Maybe<Scalars['Float']['output']>;
  share_real_estate?: Maybe<Scalars['Float']['output']>;
  share_securities?: Maybe<Scalars['Float']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  solvency_i_ratio?: Maybe<Scalars['Float']['output']>;
  solvency_ii_ratio?: Maybe<Scalars['Float']['output']>;
  solvency_ii_ratio_prev?: Maybe<Scalars['Float']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  technical_reserves?: Maybe<Scalars['Float']['output']>;
  total_assets?: Maybe<Scalars['Float']['output']>;
  type?: Maybe<Tt500CompanyType>;
  web?: Maybe<Scalars['String']['output']>;
  year?: Maybe<Scalars['Int']['output']>;
  year_financial?: Maybe<Scalars['String']['output']>;
  year_financial_high?: Maybe<Scalars['String']['output']>;
  year_financial_low?: Maybe<Scalars['String']['output']>;
  yield?: Maybe<Scalars['Float']['output']>;
  yield_prev?: Maybe<Scalars['Float']['output']>;
};

export type Tt500InsuranceBackendPagination = {
  __typename?: 'TT500InsuranceBackendPagination';
  data?: Maybe<Array<Tt500InsuranceBackend>>;
  paginatorInfo?: Maybe<DefaultPaginator>;
};

export type Tt500OwnersBackend = {
  __typename?: 'TT500OwnersBackend';
  country?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lfdNr?: Maybe<Scalars['Int']['output']>;
  nominal_capital?: Maybe<Scalars['Float']['output']>;
  owner_name: Scalars['String']['output'];
  year?: Maybe<Scalars['Int']['output']>;
};

export type Tt500Person = {
  __typename?: 'TT500Person';
  firstname: Scalars['String']['output'];
  gender: Tt500PersonGender;
  id: Scalars['ID']['output'];
  lastname: Scalars['String']['output'];
  positions?: Maybe<Array<Tt500PersonPosition>>;
};

export type Tt500PersonBackend = {
  __typename?: 'TT500PersonBackend';
  area?: Maybe<Tt500Area>;
  email?: Maybe<Scalars['String']['output']>;
  firstname: Scalars['String']['output'];
  gender: Tt500PersonGender;
  id: Scalars['ID']['output'];
  lastname?: Maybe<Scalars['String']['output']>;
  lfdNr?: Maybe<Scalars['Int']['output']>;
  position?: Maybe<Tt500Position>;
  position_other?: Maybe<Scalars['String']['output']>;
  sort?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type: Tt500PersonType;
  year?: Maybe<Scalars['Int']['output']>;
};

export enum Tt500PersonGender {
  Divers = 'DIVERS',
  Female = 'FEMALE',
  Male = 'MALE',
  Unknown = 'UNKNOWN'
}

export type Tt500PersonPagination = {
  __typename?: 'TT500PersonPagination';
  data?: Maybe<Array<Tt500Person>>;
  paginatorInfo?: Maybe<DefaultPaginator>;
};

export type Tt500PersonPosition = {
  __typename?: 'TT500PersonPosition';
  company?: Maybe<Tt500Company>;
  firstname?: Maybe<Scalars['String']['output']>;
  function?: Maybe<Scalars['String']['output']>;
  gender: Tt500PersonGender;
  id: Scalars['ID']['output'];
  kind?: Maybe<Scalars['String']['output']>;
  lastname?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  year: Scalars['Int']['output'];
};

export enum Tt500PersonType {
  Aufsichtsrat = 'AUFSICHTSRAT',
  Management = 'MANAGEMENT'
}

export type Tt500Position = {
  __typename?: 'TT500Position';
  category?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  position_id?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Tt500CompanyType>;
};

export type Tt500PositionData = {
  __typename?: 'TT500PositionData';
  data?: Maybe<Array<Tt500Position>>;
};

export type Tt500ResultInterface = {
  accounting_type?: Maybe<Tt500AccountingType>;
  annoation?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Tt500Company>;
  employees?: Maybe<Scalars['Int']['output']>;
  employees_delta?: Maybe<Scalars['Float']['output']>;
  footnote?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  management_female?: Maybe<Scalars['Int']['output']>;
  management_male?: Maybe<Scalars['Int']['output']>;
  owner?: Maybe<Scalars['String']['output']>;
  ranking?: Maybe<Scalars['Int']['output']>;
  ranking_prev?: Maybe<Scalars['Int']['output']>;
  year: Scalars['Int']['output'];
  year_financial?: Maybe<Scalars['String']['output']>;
};

export type Tt500UpdateArea = {
  area_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type Tt500UpdateBankFinancialsBackend = {
  accounting_type?: InputMaybe<Tt500AccountingBackendType>;
  accounts_payable?: InputMaybe<Scalars['Float']['input']>;
  accounts_receivable?: InputMaybe<Scalars['Float']['input']>;
  administrative_expenses?: InputMaybe<Scalars['Float']['input']>;
  commission_result?: InputMaybe<Scalars['Float']['input']>;
  consolidated?: InputMaybe<Scalars['Boolean']['input']>;
  core_capital_ratio?: InputMaybe<Scalars['Float']['input']>;
  cost_income_ratio?: InputMaybe<Scalars['Float']['input']>;
  coverage_non_performing_loans?: InputMaybe<Scalars['Float']['input']>;
  employees?: InputMaybe<Scalars['Int']['input']>;
  equity_capital?: InputMaybe<Scalars['Float']['input']>;
  is_group?: InputMaybe<Scalars['Boolean']['input']>;
  net_interest_income?: InputMaybe<Scalars['Float']['input']>;
  net_interest_margin?: InputMaybe<Scalars['Float']['input']>;
  non_performing_loans?: InputMaybe<Scalars['Float']['input']>;
  operating_income?: InputMaybe<Scalars['Float']['input']>;
  profit?: InputMaybe<Scalars['Float']['input']>;
  profit_risk_weighted_assets?: InputMaybe<Scalars['Float']['input']>;
  ranking_hidden?: InputMaybe<Scalars['Boolean']['input']>;
  savings_deposits?: InputMaybe<Scalars['Float']['input']>;
  total_assets?: InputMaybe<Scalars['Float']['input']>;
  trading_result?: InputMaybe<Scalars['Float']['input']>;
  write_down_securities?: InputMaybe<Scalars['Float']['input']>;
  year_financial_high?: InputMaybe<Scalars['String']['input']>;
  year_financial_low?: InputMaybe<Scalars['String']['input']>;
};

export type Tt500UpdateBusinessBackend = {
  category?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type Tt500UpdateBusinessesBackend = {
  business: Tt500UpdateBusinessBackend;
  id: Scalars['ID']['input'];
  main?: InputMaybe<Scalars['String']['input']>;
};

export type Tt500UpdateCompany = {
  asset_id?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  management?: InputMaybe<Array<Tt500CompanyPosition>>;
  name?: InputMaybe<Scalars['String']['input']>;
  postal_code?: InputMaybe<Scalars['String']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  ranking?: InputMaybe<Scalars['Int']['input']>;
  reports?: InputMaybe<Array<Tt500CompanyUpdateReport>>;
  slug?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  type: Tt500CompanyType;
  web?: InputMaybe<Scalars['String']['input']>;
};

export type Tt500UpdateCompanyBackend = {
  annotation?: InputMaybe<Scalars['String']['input']>;
  board?: InputMaybe<Array<Tt500UpdatePersonBackend>>;
  businesses?: InputMaybe<Array<Tt500UpdateBusinessesBackend>>;
  city?: InputMaybe<Scalars['String']['input']>;
  contacts?: InputMaybe<Array<Tt500UpdateContact>>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  exclude?: InputMaybe<Scalars['Boolean']['input']>;
  external_finished?: InputMaybe<Scalars['Boolean']['input']>;
  footnote?: InputMaybe<Scalars['String']['input']>;
  holdings?: InputMaybe<Array<Tt500UpdateHoldingsBackend>>;
  industries?: InputMaybe<Scalars['String']['input']>;
  internal_finished?: InputMaybe<Scalars['Boolean']['input']>;
  internal_note?: InputMaybe<Scalars['String']['input']>;
  ksv?: InputMaybe<Scalars['Boolean']['input']>;
  ksv_checked?: InputMaybe<Scalars['Boolean']['input']>;
  management?: InputMaybe<Array<Tt500UpdatePersonBackend>>;
  name?: InputMaybe<Scalars['String']['input']>;
  not_before?: InputMaybe<Scalars['DateTime']['input']>;
  owners?: InputMaybe<Array<Tt500UpdateOwnersBackend>>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postal_code?: InputMaybe<Scalars['String']['input']>;
  ranking_hidden?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  web?: InputMaybe<Scalars['String']['input']>;
};

export type Tt500UpdateCompanyFinancialsBackend = {
  accounting_type?: InputMaybe<Tt500AccountingBackendType>;
  cashflow_earnings?: InputMaybe<Scalars['Float']['input']>;
  cashflow_operating?: InputMaybe<Scalars['Float']['input']>;
  consolidated?: InputMaybe<Scalars['Boolean']['input']>;
  employees?: InputMaybe<Scalars['Int']['input']>;
  equity_capital?: InputMaybe<Scalars['Float']['input']>;
  export_markets?: InputMaybe<Scalars['String']['input']>;
  export_share?: InputMaybe<Scalars['Float']['input']>;
  is_group?: InputMaybe<Scalars['Boolean']['input']>;
  netdebt?: InputMaybe<Scalars['Float']['input']>;
  netrevenue?: InputMaybe<Scalars['Float']['input']>;
  operational_success?: InputMaybe<Scalars['Float']['input']>;
  ranking_hidden?: InputMaybe<Scalars['Boolean']['input']>;
  rnd?: InputMaybe<Scalars['Float']['input']>;
  total_assets?: InputMaybe<Scalars['Float']['input']>;
  total_investments?: InputMaybe<Scalars['Float']['input']>;
  year_financial_high?: InputMaybe<Scalars['String']['input']>;
  year_financial_low?: InputMaybe<Scalars['String']['input']>;
};

export type Tt500UpdateContact = {
  address?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  fax?: InputMaybe<Scalars['String']['input']>;
  finished?: InputMaybe<Scalars['Boolean']['input']>;
  firstname?: InputMaybe<Scalars['String']['input']>;
  gender: Tt500PersonGender;
  id: Scalars['ID']['input'];
  info?: InputMaybe<Scalars['String']['input']>;
  lastname: Scalars['String']['input'];
  mobile?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
  postal_code?: InputMaybe<Scalars['String']['input']>;
  primary?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type Tt500UpdateHoldingsBackend = {
  country?: InputMaybe<Scalars['String']['input']>;
  holding_name: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  lfdNr?: InputMaybe<Scalars['Int']['input']>;
  nominal_capital?: InputMaybe<Scalars['Float']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type Tt500UpdateInsuranceFinancialsBackend = {
  accounting_type?: InputMaybe<Tt500AccountingBackendType>;
  capital_investments?: InputMaybe<Scalars['Float']['input']>;
  consolidated?: InputMaybe<Scalars['Boolean']['input']>;
  cost_ratio?: InputMaybe<Scalars['Float']['input']>;
  earned_premium?: InputMaybe<Scalars['Float']['input']>;
  embedded_value?: InputMaybe<Scalars['Float']['input']>;
  employees?: InputMaybe<Scalars['Int']['input']>;
  equity?: InputMaybe<Scalars['Float']['input']>;
  gross_premium?: InputMaybe<Scalars['Float']['input']>;
  gross_profit?: InputMaybe<Scalars['Float']['input']>;
  insurance_benefits?: InputMaybe<Scalars['Float']['input']>;
  is_group?: InputMaybe<Scalars['Boolean']['input']>;
  loss_ratio?: InputMaybe<Scalars['Float']['input']>;
  net_combined_ratio?: InputMaybe<Scalars['Float']['input']>;
  net_financial_income?: InputMaybe<Scalars['Float']['input']>;
  net_income?: InputMaybe<Scalars['Float']['input']>;
  ranking_hidden?: InputMaybe<Scalars['Boolean']['input']>;
  reinsurers_share?: InputMaybe<Scalars['Float']['input']>;
  share_equities?: InputMaybe<Scalars['Float']['input']>;
  share_health_insurance?: InputMaybe<Scalars['Float']['input']>;
  share_index_life_linked_insurance?: InputMaybe<Scalars['Float']['input']>;
  share_life_insurance?: InputMaybe<Scalars['Float']['input']>;
  share_minorities?: InputMaybe<Scalars['Float']['input']>;
  share_others?: InputMaybe<Scalars['Float']['input']>;
  share_property_casualty?: InputMaybe<Scalars['Float']['input']>;
  share_real_estate?: InputMaybe<Scalars['Float']['input']>;
  share_securities?: InputMaybe<Scalars['Float']['input']>;
  solvency_i_ratio?: InputMaybe<Scalars['Float']['input']>;
  solvency_ii_ratio?: InputMaybe<Scalars['Float']['input']>;
  technical_reserves?: InputMaybe<Scalars['Float']['input']>;
  total_assets?: InputMaybe<Scalars['Float']['input']>;
  year_financial_high?: InputMaybe<Scalars['String']['input']>;
  year_financial_low?: InputMaybe<Scalars['String']['input']>;
};

export enum Tt500UpdateKindType {
  Admin = 'ADMIN',
  Basics = 'BASICS',
  Board = 'BOARD',
  Business = 'BUSINESS',
  Contacts = 'CONTACTS',
  Final = 'FINAL',
  Financials = 'FINANCIALS',
  Financialsbank = 'FINANCIALSBANK',
  Financialsinsurance = 'FINANCIALSINSURANCE',
  Holdings = 'HOLDINGS',
  Management = 'MANAGEMENT',
  Owners = 'OWNERS'
}

export type Tt500UpdateOwnersBackend = {
  country?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  lfdNr?: InputMaybe<Scalars['Int']['input']>;
  nominal_capital?: InputMaybe<Scalars['Float']['input']>;
  owner_name: Scalars['String']['input'];
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type Tt500UpdatePerson = {
  firstname: Scalars['String']['input'];
  gender?: InputMaybe<Tt500PersonGender>;
  id: Scalars['ID']['input'];
  lastname: Scalars['String']['input'];
};

export type Tt500UpdatePersonBackend = {
  area?: InputMaybe<Tt500UpdateArea>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstname: Scalars['String']['input'];
  gender: Tt500PersonGender;
  id: Scalars['ID']['input'];
  lastname: Scalars['String']['input'];
  lfdNr?: InputMaybe<Scalars['Int']['input']>;
  position?: InputMaybe<Tt500UpdatePosition>;
  position_other?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type: Tt500PersonType;
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type Tt500UpdatePosition = {
  category?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  position_id?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Tt500CompanyType>;
};

export type Tt500WhereInput = {
  AND?: InputMaybe<Array<Tt500ConditionInput>>;
  OR?: InputMaybe<Array<Tt500ConditionInput>>;
};

export type TvChannel = {
  __typename?: 'TVChannel';
  /** Published */
  active?: Maybe<Scalars['Boolean']['output']>;
  /** Article id */
  article_id?: Maybe<Scalars['String']['output']>;
  /** Asset id */
  asset_id?: Maybe<Scalars['String']['output']>;
  /** Asset white id */
  asset_white_id?: Maybe<Scalars['String']['output']>;
  /** Custom open graph description */
  custom_open_graph_description?: Maybe<Scalars['String']['output']>;
  /** Open graph title */
  custom_open_graph_title?: Maybe<Scalars['String']['output']>;
  /** Twitter custom description */
  custom_twitter_description?: Maybe<Scalars['String']['output']>;
  /** Custom twitter title */
  custom_twitter_title?: Maybe<Scalars['String']['output']>;
  favorite?: Maybe<TvmFavorite>;
  /** ID */
  id: Scalars['ID']['output'];
  /** Asset for the preview */
  image?: Maybe<FairuAsset>;
  /** Asset for the preview / white */
  image_white?: Maybe<FairuAsset>;
  /** Joyn ID */
  joyn_id?: Maybe<Scalars['String']['output']>;
  /** Joyn Livestream Url */
  joyn_livestream?: Maybe<Scalars['String']['output']>;
  /** Mediapress identifier */
  mediapress_id?: Maybe<Scalars['String']['output']>;
  /** Meta data */
  metadata?: Maybe<Meta>;
  /** Name of the channel */
  name?: Maybe<Scalars['String']['output']>;
  /** No follow */
  no_follow?: Maybe<Scalars['Boolean']['output']>;
  /** Should that entry be index */
  no_index?: Maybe<Scalars['Boolean']['output']>;
  /** Open graph description */
  open_graph_description?: Maybe<Scalars['String']['output']>;
  /** Phone number */
  phone?: Maybe<Scalars['String']['output']>;
  /** Redirect url */
  redirect?: Maybe<Scalars['String']['output']>;
  /** Showtimes now playing */
  showtimeNow?: Maybe<TvChannelShowtime>;
  /** Showtimes */
  showtimes: TvChannelShowtimePaginator;
  /** Showtimes predefined */
  showtimesProgram: TvChannelShowtimePaginator;
  /** Showtimes for today */
  showtimesToday: TvChannelShowtimePaginator;
  /** Showtimes upcoming or between a range */
  showtimesUpcoming: TvChannelShowtimePaginator;
  /** Slug */
  slug?: Maybe<Scalars['String']['output']>;
  /** Sort */
  sort?: Maybe<Scalars['Int']['output']>;
  /** Sponsoring */
  sponsoring?: Maybe<Scalars['Boolean']['output']>;
  /** Twitter description mode */
  twitter_description?: Maybe<Scalars['String']['output']>;
  /** Type within the service entity */
  type?: Maybe<Scalars['String']['output']>;
  /** Url */
  url?: Maybe<Scalars['String']['output']>;
};


export type TvChannelRedirectArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};


export type TvChannelShowtimesArgs = {
  first: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<DateRange>;
};


export type TvChannelShowtimesProgramArgs = {
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type TvChannelShowtimesTodayArgs = {
  first: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type TvChannelShowtimesUpcomingArgs = {
  first?: Scalars['Int']['input'];
  from?: InputMaybe<Scalars['DateTime']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  until?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TvChannelDay = {
  __typename?: 'TVChannelDay';
  channel?: Maybe<TvChannel>;
  date?: Maybe<Scalars['String']['output']>;
  showtimes?: Maybe<Array<TvChannelShowtime>>;
};

export type TvChannelList = {
  __typename?: 'TVChannelList';
  data?: Maybe<Array<Maybe<TvChannelDay>>>;
  paginatorInfo?: Maybe<DefaultPaginator>;
};

/** A paginated list of TVChannel items. */
export type TvChannelPaginator = {
  __typename?: 'TVChannelPaginator';
  /** A list of TVChannel items. */
  data: Array<TvChannel>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type TvChannelShowtime = {
  __typename?: 'TVChannelShowtime';
  /** Text summary of actors */
  actors_summary?: Maybe<Scalars['String']['output']>;
  /** How many airings a mapping decision for this broadcast would cover — the same content, on every channel, past and future. Only populated by `channelShowtimesNeedsMapping`, null everywhere else. */
  airings?: Maybe<Scalars['Int']['output']>;
  /** Asset id */
  asset_id?: Maybe<Scalars['String']['output']>;
  /** Basecontent ID */
  basecontent_id?: Maybe<Scalars['String']['output']>;
  /** Joyn links published for this airing: the entry went online within 20 minutes of the slot, it is the dated edition of this day, or Joyn published it in the 36 hours before (ORF releases magazines online a day ahead; night and afternoon repeats of the previous evening). Library stock from earlier airings does not qualify. */
  broadcastLinks?: Maybe<Array<Maybe<ChannelBroadcastLink>>>;
  /** Joyn links for the content of this broadcast, whenever the catalog aired it — broadcastLinks plus older library stock. Use this to answer "can I watch this on Joyn?". */
  catalogLinks?: Maybe<Array<Maybe<ChannelBroadcastLink>>>;
  /** TV Channel information */
  channel?: Maybe<TvChannel>;
  channel_id?: Maybe<Scalars['String']['output']>;
  /** Content ID */
  content_id?: Maybe<Scalars['String']['output']>;
  /** Production countries */
  countries?: Maybe<Scalars['String']['output']>;
  /** Text summary of directors */
  directors_summary?: Maybe<Scalars['String']['output']>;
  /** Entity. This can be a movie or show. */
  entity?: Maybe<EntityEntry>;
  /** Episode number if show */
  episode?: Maybe<Scalars['Int']['output']>;
  /** Event ID */
  event_id?: Maybe<Scalars['String']['output']>;
  favorite?: Maybe<TvmFavorite>;
  /** Single genre text */
  genre?: Maybe<Scalars['String']['output']>;
  /** Does this entry have any kinds of subtitles */
  has_subtitles?: Maybe<Scalars['Boolean']['output']>;
  /** ID */
  id: Scalars['ID']['output'];
  /** Asset for the preview */
  image?: Maybe<FairuAsset>;
  /** Is this showtime in 4K? */
  is_4k?: Maybe<Scalars['Boolean']['output']>;
  /** Is this showtime in HD? */
  is_hd?: Maybe<Scalars['Boolean']['output']>;
  /** Is it a live event? */
  is_live?: Maybe<Scalars['Boolean']['output']>;
  /** Is sport related? */
  is_sport?: Maybe<Scalars['Boolean']['output']>;
  /** Is this showtime in stereo? */
  is_stereo?: Maybe<Scalars['Boolean']['output']>;
  /** Meta data */
  metadata?: Maybe<Meta>;
  /** Season number if show */
  season?: Maybe<Scalars['Int']['output']>;
  /** If it is a sport what kind of sport is it */
  sport?: Maybe<Scalars['String']['output']>;
  /** When will this showtime start */
  start?: Maybe<Scalars['DateTime']['output']>;
  /** Starttime as string */
  start_time?: Maybe<Scalars['String']['output']>;
  /** When will this stowtime stop */
  stop?: Maybe<Scalars['DateTime']['output']>;
  /** Stoptime as string */
  stop_time?: Maybe<Scalars['String']['output']>;
  /** Subtitle */
  subtitle?: Maybe<Scalars['String']['output']>;
  /** Summary text of the episode */
  summary?: Maybe<Scalars['String']['output']>;
  /** Title of the show */
  title?: Maybe<Scalars['String']['output']>;
  /** Type */
  type?: Maybe<Scalars['String']['output']>;
  /** Watch links for the related movie or show (streaming offers — e.g. for provider icons) */
  watchLinks?: Maybe<Array<Maybe<WatchLink>>>;
  /** Year */
  year?: Maybe<Scalars['Int']['output']>;
};


export type TvChannelShowtimeSummaryArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A paginated list of TVChannelShowtime items. */
export type TvChannelShowtimePaginator = {
  __typename?: 'TVChannelShowtimePaginator';
  /** A list of TVChannelShowtime items. */
  data: Array<TvChannelShowtime>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type TvmCollectionPaginationList = {
  __typename?: 'TVMCollectionPaginationList';
  data?: Maybe<Array<Maybe<Collection>>>;
  paginatorInfo?: Maybe<DefaultPaginator>;
};

export type TableColumn = TableColumnAsset | TableColumnBoolean | TableColumnFloat | TableColumnInteger | TableColumnSimple;

export type TableColumnAsset = {
  __typename?: 'TableColumnAsset';
  asset?: Maybe<FairuAsset>;
};

export type TableColumnBoolean = {
  __typename?: 'TableColumnBoolean';
  text?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Boolean']['output']>;
};


export type TableColumnBooleanTextArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TableColumnFloat = {
  __typename?: 'TableColumnFloat';
  text?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};


export type TableColumnFloatTextArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TableColumnInteger = {
  __typename?: 'TableColumnInteger';
  text?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Int']['output']>;
};


export type TableColumnIntegerTextArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TableColumnSimple = {
  __typename?: 'TableColumnSimple';
  text?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};


export type TableColumnSimpleTextArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TableRow = {
  __typename?: 'TableRow';
  /** Columns */
  columns?: Maybe<Array<Maybe<TableColumn>>>;
};

export type Team = {
  __typename?: 'Team';
  /** Team description */
  description?: Maybe<Scalars['String']['output']>;
  /** Id of team */
  id: Scalars['ID']['output'];
  /** Portal */
  portal?: Maybe<Scalars['String']['output']>;
  /** Slug of the team */
  slug?: Maybe<Scalars['String']['output']>;
  /** Team member */
  team?: Maybe<Array<Maybe<TeamMember>>>;
  /** Team name */
  title?: Maybe<Scalars['String']['output']>;
};


export type TeamDescriptionArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TeamMember = {
  __typename?: 'TeamMember';
  /** Position */
  position?: Maybe<Scalars['String']['output']>;
  /** User information */
  user?: Maybe<User>;
};

export type Text = {
  __typename?: 'Text';
  headline?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};


export type TextTextArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TextWithPanelItem = {
  __typename?: 'TextWithPanelItem';
  badge?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type TimelineStage = {
  __typename?: 'TimelineStage';
  body?: Maybe<Scalars['String']['output']>;
  headline_emphasis?: Maybe<Scalars['String']['output']>;
  headline_main?: Maybe<Scalars['String']['output']>;
  time_label?: Maybe<Scalars['String']['output']>;
};


export type TimelineStageBodyArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Topic = {
  __typename?: 'Topic';
  /** Ad settings for the page */
  ad_settings?: Maybe<AdSetting>;
  /** Advertorial entry */
  advertorial?: Maybe<Scalars['Boolean']['output']>;
  /** Advertorial text */
  advertorial_text?: Maybe<Scalars['String']['output']>;
  /** Related articles */
  articles?: Maybe<ArticlePaginatorSimple>;
  /** Articles per page on the topic page, maintained per topic in the CP. 0 = all, null = the default (9); either way capped at 90 per page so large topics paginate instead of loading everything. Used as the fallback when articles(perPage:) is omitted. */
  articles_per_page?: Maybe<Scalars['Int']['output']>;
  /** Content elements */
  content?: Maybe<Array<Maybe<ContentElement>>>;
  /** Created at */
  created_at?: Maybe<Scalars['DateTime']['output']>;
  /** Disable ads */
  disable_ads?: Maybe<Scalars['Boolean']['output']>;
  /** Content elements for the footer */
  footer_content?: Maybe<Array<Maybe<ContentElement>>>;
  /** Id of the topic */
  id: Scalars['ID']['output'];
  image_mode?: Maybe<Scalars['String']['output']>;
  /** Images for the topic */
  images?: Maybe<Array<Maybe<TopicImage>>>;
  /** Meta data */
  metadata?: Maybe<Meta>;
  /** More teaser is used for boxes */
  more_teaser?: Maybe<Scalars['String']['output']>;
  more_teaser_headline?: Maybe<Scalars['String']['output']>;
  /** More teaser image should be used in an overview box */
  more_teaser_image?: Maybe<FairuAsset>;
  /** Oewa data */
  oewa?: Maybe<Oewa>;
  /** Is the entry published  */
  published?: Maybe<Scalars['Boolean']['output']>;
  /** Slug for the topic. Can be used to query the entry */
  slug?: Maybe<Scalars['String']['output']>;
  /** Subhealdine for the topic */
  subtitle?: Maybe<Scalars['String']['output']>;
  /** Title of the topic */
  title?: Maybe<Scalars['String']['output']>;
  /** Updated at */
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  /** Url to the topic */
  url?: Maybe<Scalars['String']['output']>;
  /** Use the ressort design */
  use_category_design?: Maybe<Scalars['Boolean']['output']>;
};


export type TopicArticlesArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  portal?: InputMaybe<Scalars['String']['input']>;
};


export type TopicMore_TeaserArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TopicCluster = {
  __typename?: 'TopicCluster';
  id: Scalars['ID']['output'];
  portal?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  topics?: Maybe<Array<Maybe<Topic>>>;
};

export type TopicClustersPaginatorSimple = {
  __typename?: 'TopicClustersPaginatorSimple';
  data?: Maybe<Array<Maybe<TopicCluster>>>;
  paginatorInfo?: Maybe<DefaultPaginator>;
};

export type TopicImage = {
  __typename?: 'TopicImage';
  image?: Maybe<FairuAsset>;
  url?: Maybe<Scalars['String']['output']>;
};

export type TopicsPaginatorSimple = {
  __typename?: 'TopicsPaginatorSimple';
  data?: Maybe<Array<Maybe<Topic>>>;
  paginatorInfo?: Maybe<DefaultPaginator>;
};

export type Trailer = {
  __typename?: 'Trailer';
  /** Format for the trailer  */
  format?: Maybe<Scalars['String']['output']>;
  /** Unique Id */
  id: Scalars['ID']['output'];
  /** The related movie */
  movie?: Maybe<Movie>;
  /** Tmdb ID */
  tmdb_id?: Maybe<Scalars['String']['output']>;
  /** Link to the trailer */
  url?: Maybe<Scalars['String']['output']>;
};

/** A paginated list of Trailer items. */
export type TrailerPaginator = {
  __typename?: 'TrailerPaginator';
  /** A list of Trailer items. */
  data: Array<Trailer>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

/** Specify if you want to include or exclude trashed results from a query. */
export enum Trashed {
  /** Only return trashed results. */
  Only = 'ONLY',
  /** Return both trashed and non-trashed results. */
  With = 'WITH',
  /** Only return non-trashed results. */
  Without = 'WITHOUT'
}

export type TvWatchSuggestion = {
  __typename?: 'TvWatchSuggestion';
  /** The Movie or Show that will air */
  entity?: Maybe<EntityEntry>;
  /** Short human-readable reason that this entry fits the filters */
  reason?: Maybe<Scalars['String']['output']>;
  /** The concrete TV airing */
  showtime?: Maybe<TvChannelShowtime>;
};

export type TvmAutomaticLanesQuery = {
  __typename?: 'TvmAutomaticLanesQuery';
  entries?: Maybe<Array<TvmEntityEntry>>;
  id: Scalars['ID']['output'];
};

export type TvmCollectionQuery = {
  __typename?: 'TvmCollectionQuery';
  id?: Maybe<Scalars['ID']['output']>;
  items?: Maybe<Array<TvmEntityEntry>>;
};

export type TvmCustomLaneItem = {
  __typename?: 'TvmCustomLaneItem';
  image?: Maybe<FairuAsset>;
  link?: Maybe<Scalars['String']['output']>;
  subheadline?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type TvmEntity = {
  __typename?: 'TvmEntity';
  entity?: Maybe<TvmEntityEntry>;
  /** Id */
  id: Scalars['ID']['output'];
};

export type TvmEntityEntry = Movie | Show | Vod;

export enum TvmEntityType {
  Movie = 'MOVIE',
  Tvshow = 'TVSHOW'
}

export type TvmFavorite = {
  __typename?: 'TvmFavorite';
  entity?: Maybe<TvmFavoriteEntity>;
  id?: Maybe<Scalars['ID']['output']>;
  /** Ticked off as watched. Only movie and show entries carry it; every other type stays false. */
  seen?: Maybe<Scalars['Boolean']['output']>;
  /** When the entry was ticked off; null while it is unseen. */
  seen_at?: Maybe<Scalars['DateTime']['output']>;
};

export type TvmFavoriteData = {
  entity?: InputMaybe<Scalars['ID']['input']>;
  showtime?: InputMaybe<Scalars['ID']['input']>;
  type: TvmFavoriteType;
};

export type TvmFavoriteEntity = Cinema | Movie | Provider | Show | TvChannel | TvChannelShowtime;

/** A paginated list of TvmFavorite items. */
export type TvmFavoritePaginator = {
  __typename?: 'TvmFavoritePaginator';
  /** A list of TvmFavorite items. */
  data: Array<TvmFavorite>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export enum TvmFavoriteType {
  Channel = 'CHANNEL',
  ChannelShowtime = 'CHANNEL_SHOWTIME',
  Cinema = 'CINEMA',
  Movie = 'MOVIE',
  Provider = 'PROVIDER',
  Tvshow = 'TVSHOW'
}

export type TvmFavoritesRequestQuery = {
  __typename?: 'TvmFavoritesRequestQuery';
  entities?: Maybe<Array<Maybe<TvmFavorite>>>;
  query: Scalars['ID']['output'];
  showtimes?: Maybe<Array<Maybe<TvChannelShowtime>>>;
  type?: Maybe<Scalars['String']['output']>;
};

export type TvmLane = {
  __typename?: 'TvmLane';
  entries?: Maybe<Array<TvmEntityEntry>>;
  /** Entry id in the tvmedia_lanes collection */
  id?: Maybe<Scalars['ID']['output']>;
  /** Marked as recommended ("Empfohlen") in the CMS */
  recommend?: Maybe<Scalars['Boolean']['output']>;
  start?: Maybe<Scalars['String']['output']>;
  stop?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  title_link?: Maybe<Scalars['String']['output']>;
  title_link_text?: Maybe<Scalars['String']['output']>;
};

/** A title enough participants agreed on. */
export type TvmMatch = {
  __typename?: 'TvmMatch';
  entity?: Maybe<TvmEntityEntry>;
  entity_type: TvmMatchEntityType;
  id: Scalars['ID']['output'];
  like_count: Scalars['Int']['output'];
  matched_at?: Maybe<Scalars['DateTime']['output']>;
  /** Participants counted when this match was last evaluated */
  participant_count: Scalars['Int']['output'];
  /** Position in the ranked list, 1-based */
  rank: Scalars['Int']['output'];
  /** Weighted consensus, 1.0 = everybody liked it (superlikes push above 1.0) */
  score: Scalars['Float']['output'];
  superlike_count: Scalars['Int']['output'];
};

/** Answer to a delivery receipt. `ok` means recorded, nothing more. */
export type TvmMatchAck = {
  __typename?: 'TvmMatchAck';
  ok: Scalars['Boolean']['output'];
  seq: Scalars['Int']['output'];
};

/** One card of the frozen deck. */
export type TvmMatchCard = {
  __typename?: 'TvmMatchCard';
  entity?: Maybe<TvmEntityEntry>;
  entity_type: TvmMatchEntityType;
  id: Scalars['ID']['output'];
  /** The viewer's own swipe on this card, if they made one */
  own_direction?: Maybe<TvmMatchSwipeDirection>;
  position: Scalars['Int']['output'];
  tmdb_score?: Maybe<Scalars['Float']['output']>;
  /** TVM editorial score at the time the deck was frozen */
  tvm_score?: Maybe<Scalars['Float']['output']>;
};

/** Signature that lets a client subscribe to a session's private Pusher channel. */
export type TvmMatchChannelAuth = {
  __typename?: 'TvmMatchChannelAuth';
  /** Value for Echo's `auth` field */
  auth: Scalars['String']['output'];
  /** The channel the signature is valid for */
  channel: Scalars['String']['output'];
  /** Presence payload, if any */
  channel_data?: Maybe<Scalars['String']['output']>;
};

export enum TvmMatchDeckOrder {
  /** Highest TVM editorial score first */
  Curated = 'CURATED',
  /** Stable pseudo-random order, identical for every participant */
  Shuffled = 'SHUFFLED'
}

export enum TvmMatchEntityType {
  Movie = 'MOVIE',
  Tvshow = 'TVSHOW'
}

/** One participant of a session. */
export type TvmMatchParticipant = {
  __typename?: 'TvmMatchParticipant';
  display_name?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  joined_at?: Maybe<Scalars['DateTime']['output']>;
  last_seen_at?: Maybe<Scalars['DateTime']['output']>;
  /** host or member */
  role: Scalars['String']['output'];
  state: TvmMatchParticipantState;
  /** How many cards this participant has decided on */
  swipe_count: Scalars['Int']['output'];
  user_id: Scalars['ID']['output'];
};

export enum TvmMatchParticipantState {
  Finished = 'FINISHED',
  Joined = 'JOINED',
  Left = 'LEFT',
  Ready = 'READY'
}

/**
 * Answer to a resync: the current truth about a session, plus how far behind the
 * caller was.
 */
export type TvmMatchResync = {
  __typename?: 'TvmMatchResync';
  /** How many broadcasts the caller never saw. 0 means it was up to date. */
  missed: Scalars['Int']['output'];
  /** Sequence number of the last broadcast the server sent. */
  seq: Scalars['Int']['output'];
  session: TvmMatchSession;
  /** Convenience for `missed > 0`. */
  stale: Scalars['Boolean']['output'];
};

export type TvmMatchSession = {
  __typename?: 'TvmMatchSession';
  /** Short code to join, e.g. K7QM3D */
  code: Scalars['String']['output'];
  created_at?: Maybe<Scalars['DateTime']['output']>;
  /** The caller's remaining cards, in deck order */
  deck: Array<TvmMatchCard>;
  /** Number of cards in the frozen deck; 0 before the session starts */
  deck_size: Scalars['Int']['output'];
  expires_at?: Maybe<Scalars['DateTime']['output']>;
  finished_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  /** Is the caller the host of this session? */
  is_host: Scalars['Boolean']['output'];
  match_count: Scalars['Int']['output'];
  /** Positive swipes needed for a match; null means everybody */
  match_threshold?: Maybe<Scalars['Int']['output']>;
  /** Matched titles, best first. TVM editorial score breaks ties. */
  matches: Array<TvmMatch>;
  max_participants?: Maybe<Scalars['Int']['output']>;
  /** Where the deck comes from */
  mode: TvmMatchSourceMode;
  name?: Maybe<Scalars['String']['output']>;
  /** How many cards the caller has already decided on */
  own_progress: Scalars['Int']['output'];
  participant_count: Scalars['Int']['output'];
  participants: Array<TvmMatchParticipant>;
  /** Streaming filter set at create time; empty means every provider */
  providers: Array<Scalars['String']['output']>;
  /**
   * Position of the last broadcast sent for this session. A client compares it
   * with the highest `seq` it has received to tell whether it is up to date.
   */
  seq: Scalars['Int']['output'];
  /** Lane / collection the deck was built from, informational */
  source_ref?: Maybe<Scalars['String']['output']>;
  started_at?: Maybe<Scalars['DateTime']['output']>;
  state: TvmMatchSessionState;
};


export type TvmMatchSessionDeckArgs = {
  includeSwiped?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type TvmMatchSessionMatchesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  onlyMatched?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum TvmMatchSessionState {
  /** Finished — only the ranked matches remain */
  Done = 'DONE',
  /** Created, participants can join with the code */
  Open = 'OPEN',
  /** Deck frozen, swiping is live */
  Started = 'STARTED',
  /** Lobby closed, waiting for everybody to be ready */
  Waiting = 'WAITING'
}

export enum TvmMatchSourceMode {
  /** An explicit list of entity ids, resolved by the client from a CMS lane */
  Lane = 'LANE',
  /** The merged watchlists of everybody who joined */
  SharedWatchlist = 'SHARED_WATCHLIST',
  /** The host's own watchlist (favorites) */
  Watchlist = 'WATCHLIST'
}

export type TvmMatchSwipe = {
  __typename?: 'TvmMatchSwipe';
  created_at?: Maybe<Scalars['DateTime']['output']>;
  direction: TvmMatchSwipeDirection;
  entity_id: Scalars['ID']['output'];
  entity_type: TvmMatchEntityType;
  id: Scalars['ID']['output'];
};

export enum TvmMatchSwipeDirection {
  Dislike = 'DISLIKE',
  Like = 'LIKE',
  Superlike = 'SUPERLIKE'
}

/** What a swipe produced. */
export type TvmMatchSwipeResult = {
  __typename?: 'TvmMatchSwipeResult';
  /** True only on the swipe that turned this title into a match */
  became_match: Scalars['Boolean']['output'];
  /** The match row for this title — present even before it qualifies as a match */
  match?: Maybe<TvmMatch>;
  session: TvmMatchSession;
  swipe: TvmMatchSwipe;
};

/** One entry in a user's inbox — a message or a reminder. */
export type TvmNotification = {
  __typename?: 'TvmNotification';
  body?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  /** Whatever the sender attached, as a JSON string — entity refs, deep links. */
  payload?: Maybe<Scalars['String']['output']>;
  read_at?: Maybe<Scalars['DateTime']['output']>;
  /** Reminders surface once this moment has passed; null means immediately. */
  remind_at?: Maybe<Scalars['DateTime']['output']>;
  title: Scalars['String']['output'];
  type: TvmNotificationType;
};

/** A paginated list of TvmNotification items. */
export type TvmNotificationPaginator = {
  __typename?: 'TvmNotificationPaginator';
  /** A list of TvmNotification items. */
  data: Array<TvmNotification>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

/** What kind of notification sits in a user's inbox. */
export enum TvmNotificationType {
  /** Delivered right away. */
  Message = 'MESSAGE',
  /** Carries remind_at and surfaces once that moment has come. */
  Reminder = 'REMINDER'
}

/** Person information */
export type TvmPerson = {
  __typename?: 'TvmPerson';
  /** Main Article id */
  article_id?: Maybe<Scalars['String']['output']>;
  /** Article ids */
  article_ids?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Articles */
  articles?: Maybe<Array<Maybe<ArticleShort>>>;
  /** Id for the profile picture */
  asset_id?: Maybe<Scalars['String']['output']>;
  /** Birthplace */
  birth_place?: Maybe<Scalars['String']['output']>;
  /** Birthday */
  born_at?: Maybe<Scalars['String']['output']>;
  /** Created at */
  created_at?: Maybe<Scalars['DateTime']['output']>;
  /** Deathday */
  died_at?: Maybe<Scalars['String']['output']>;
  /** Enriched */
  enriched?: Maybe<Scalars['Boolean']['output']>;
  /** Episode for the person */
  episodes?: Maybe<Array<Maybe<Episode>>>;
  /** Gender */
  gender?: Maybe<Scalars['String']['output']>;
  /** Unique primary key. */
  id: Scalars['ID']['output'];
  /** Profile image */
  image?: Maybe<FairuAsset>;
  /** Job of the person */
  job?: Maybe<Scalars['String']['output']>;
  /** Pivot information */
  meta?: Maybe<PersonMeta>;
  /** Meta data */
  metadata?: Maybe<Meta>;
  /** Movie ids */
  movie_ids?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Movies for the person */
  movies?: Maybe<MoviePaginationList>;
  /** Name of the person */
  name?: Maybe<Scalars['String']['output']>;
  /** Original id is set if the the entry has been transformed */
  original_id?: Maybe<Scalars['String']['output']>;
  /** Published */
  published?: Maybe<Scalars['Boolean']['output']>;
  /** Quote ids */
  quote_ids?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Quotes */
  quotes?: Maybe<Array<Maybe<Quote>>>;
  /** Data reviewed */
  reviewed?: Maybe<Scalars['Boolean']['output']>;
  /** Show ids */
  show_ids?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Shows for the person */
  shows?: Maybe<ShowPaginationList>;
  /** Slug */
  slug?: Maybe<Scalars['String']['output']>;
  /** Biography */
  summary?: Maybe<Scalars['String']['output']>;
  /** Tags for the person */
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Summary Long */
  text_lg?: Maybe<Scalars['String']['output']>;
  /** Summary Medium */
  text_md?: Maybe<Scalars['String']['output']>;
  /** Summary Small */
  text_sm?: Maybe<Scalars['String']['output']>;
  /** Tmdb id */
  tmdb_id?: Maybe<Scalars['String']['output']>;
  /** Score */
  tmdb_score?: Maybe<Scalars['Float']['output']>;
  /** Ranking score behind orderBy: "popularity" - catalogue relevance, credits and TMDB popularity combined. Null until the scoring job has reached the person. */
  tvm_score?: Maybe<Scalars['Float']['output']>;
  /** Updated at */
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};


/** Person information */
export type TvmPersonArticlesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


/** Person information */
export type TvmPersonEpisodesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


/** Person information */
export type TvmPersonMoviesArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


/** Person information */
export type TvmPersonQuotesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


/** Person information */
export type TvmPersonShowsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

/** The operating system of this app installation. */
export enum TvmPushPlatform {
  Android = 'ANDROID',
  Ios = 'IOS',
  Web = 'WEB'
}

/** Account-wide push categories; the device permission remains separate. */
export type TvmPushPreferences = {
  __typename?: 'TvmPushPreferences';
  editorial: Scalars['Boolean']['output'];
  joynAvailability: Scalars['Boolean']['output'];
  reminderMinutes: Scalars['Int']['output'];
  /** Mute watchlist pushes (upcoming airing, Joyn availability) for titles ticked off as seen. The daily digest and the inbox are unaffected. */
  skipSeen: Scalars['Boolean']['output'];
  tvReminders: Scalars['Boolean']['output'];
};

export type TvmPushPreferencesInput = {
  editorial: Scalars['Boolean']['input'];
  joynAvailability: Scalars['Boolean']['input'];
  reminderMinutes: Scalars['Int']['input'];
  /** Optional: omitted keeps the stored value, so older app versions do not reset it. */
  skipSeen?: InputMaybe<Scalars['Boolean']['input']>;
  tvReminders: Scalars['Boolean']['input'];
};

/** A short video entry linked to a TVMedia movie or show. */
export type TvmShort = {
  __typename?: 'TvmShort';
  /** Author of the short */
  author?: Maybe<User>;
  /** Description */
  description?: Maybe<Scalars['String']['output']>;
  /** Linked movie or show */
  entity?: Maybe<TvmEntityEntry>;
  id: Scalars['ID']['output'];
  /** Slug */
  slug?: Maybe<Scalars['String']['output']>;
  /** Manual sort order (ascending) */
  sort?: Maybe<Scalars['Int']['output']>;
  /** Title */
  title?: Maybe<Scalars['String']['output']>;
  /** Uploaded video file */
  video?: Maybe<FairuAsset>;
};


/** A short video entry linked to a TVMedia movie or show. */
export type TvmShortDescriptionArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TvmShortPaginatorSimple = {
  __typename?: 'TvmShortPaginatorSimple';
  data?: Maybe<Array<Maybe<TvmShort>>>;
  paginatorInfo?: Maybe<DefaultPaginator>;
};

export type TvmShortQuery = {
  __typename?: 'TvmShortQuery';
  id: Scalars['ID']['output'];
  /** Shorts from the tvmedia_shorts collection - standard feed in editorial sort order, or the curated selection in its picked order. */
  shorts?: Maybe<Array<TvmShort>>;
  title?: Maybe<Scalars['String']['output']>;
  title_link?: Maybe<Scalars['String']['output']>;
};

export type TvmSportQuery = {
  __typename?: 'TvmSportQuery';
  id: Scalars['ID']['output'];
  showtimes?: Maybe<Array<TvChannelShowtime>>;
};

export type TvmTopic = {
  __typename?: 'TvmTopic';
  id: Scalars['ID']['output'];
  showtimes?: Maybe<Array<TvChannelShowtime>>;
  /** Slug */
  slug?: Maybe<Scalars['String']['output']>;
  /** Title */
  title?: Maybe<Scalars['String']['output']>;
  /** Title link */
  title_link?: Maybe<Scalars['String']['output']>;
};


export type TvmTopicShowtimesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * Cheap change beacon for a TvmTopic: read from the tracked state table only.
 * Poll this instead of re-resolving the heavy TvmTopic entity, e.g. to derive
 * purge tasks.
 */
export type TvmTopicChange = {
  __typename?: 'TvmTopicChange';
  /** When the topic's exposed showtimes list last changed. Null while the topic is untracked. */
  dataChangedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The raw TvmTopic entity id. */
  id: Scalars['ID']['output'];
  /** Earliest moment the list changes by itself (min stop of the exposed showtimes). */
  nextChangeAt?: Maybe<Scalars['DateTime']['output']>;
  /** URL slug of the topic — for building the page/purge URL. */
  slug?: Maybe<Scalars['String']['output']>;
  /** Display title of the topic. */
  title?: Maybe<Scalars['String']['output']>;
};

export type TvmTopicEntry = {
  __typename?: 'TvmTopicEntry';
  /** Ad settings for the page */
  ad_settings?: Maybe<AdSetting>;
  cover_image?: Maybe<FairuAsset>;
  /** Disable ads for this entry */
  disable_ads?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  metadata?: Maybe<Meta>;
  /** Outbrain compliant */
  outbrain_compliant?: Maybe<Scalars['Boolean']['output']>;
  /** Outbrain deactivated */
  outbrain_disabled?: Maybe<Scalars['Boolean']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  topic: TvmTopic;
};


export type TvmTopicEntryTextArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TvmTopicEntryPaginatorSimple = {
  __typename?: 'TvmTopicEntryPaginatorSimple';
  data?: Maybe<Array<Maybe<TvmTopicEntry>>>;
  paginatorInfo?: Maybe<DefaultPaginator>;
};

export type TvmTopicQuery = {
  __typename?: 'TvmTopicQuery';
  topics?: Maybe<Array<TvmTopic>>;
};

export type TvmTransformChannelShowtime = {
  entity_id?: InputMaybe<Scalars['ID']['input']>;
  showtime_id: Scalars['ID']['input'];
  type: TvmTransformChannelShowtimeType;
};

export enum TvmTransformChannelShowtimeType {
  Movie = 'MOVIE',
  Tvshow = 'TVSHOW'
}

/** A durable taste signal, the raw material for user profiles. */
export type TvmUserDecision = {
  __typename?: 'TvmUserDecision';
  decided_at: Scalars['DateTime']['output'];
  decision: TvmMatchSwipeDirection;
  entity?: Maybe<TvmEntityEntry>;
  entity_id: Scalars['ID']['output'];
  entity_type: TvmMatchEntityType;
  id: Scalars['ID']['output'];
  /** Where the decision came from, e.g. tvinder */
  source: Scalars['String']['output'];
  /** Id within that source, e.g. the session id */
  source_id?: Maybe<Scalars['ID']['output']>;
};

/** A paginated list of TvmUserDecision items. */
export type TvmUserDecisionPaginator = {
  __typename?: 'TvmUserDecisionPaginator';
  /** A list of TvmUserDecision items. */
  data: Array<TvmUserDecision>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type TvmUserDecisionSummary = {
  __typename?: 'TvmUserDecisionSummary';
  dislikes: Scalars['Int']['output'];
  likes: Scalars['Int']['output'];
  /** Share of decisions that were positive, 0..1 */
  positive_ratio: Scalars['Float']['output'];
  superlikes: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum UnderservedCriteria {
  NoArticle = 'NO_ARTICLE',
  NoReview = 'NO_REVIEW'
}

/** Upcoming streaming release for a title (which provider publishes what, when). Synced daily. */
export type UpcomingOffer = {
  __typename?: 'UpcomingOffer';
  /** ISO-2 country of the offer */
  country?: Maybe<Scalars['String']['output']>;
  /** Set when this offer is no longer listed (date moved or dropped) */
  deactivated_at?: Maybe<Scalars['DateTime']['output']>;
  /** Path of the source detail page (e.g. /at/Film/...) */
  detail_path?: Maybe<Scalars['String']['output']>;
  /** Local Movie/Show id — null when the source title has no DB match */
  entity_id?: Maybe<Scalars['String']['output']>;
  /** movie | show */
  entity_type?: Maybe<Scalars['String']['output']>;
  /** First time this offer was reported */
  first_seen_at?: Maybe<Scalars['DateTime']['output']>;
  /** Unique primary key. */
  id: Scalars['ID']['output'];
  /** Last time this offer was reported */
  last_seen_at?: Maybe<Scalars['DateTime']['output']>;
  /** Monetization (flatrate | buy | rent) — may be null */
  monetization?: Maybe<Scalars['String']['output']>;
  /** Matched local movie (when entity_type = movie) */
  movie?: Maybe<Movie>;
  /** Provider id */
  provider_id?: Maybe<Scalars['Int']['output']>;
  /** Provider that publishes the release (e.g. Netflix) */
  provider_name?: Maybe<Scalars['String']['output']>;
  /** Release type (e.g. digital) */
  release_type?: Maybe<Scalars['String']['output']>;
  /** Release date (window start) */
  release_window_from?: Maybe<Scalars['Date']['output']>;
  /** Release window end */
  release_window_to?: Maybe<Scalars['Date']['output']>;
  /** Matched local show (when entity_type = show) */
  show?: Maybe<Show>;
  /** Upstream source title id */
  source_id?: Maybe<Scalars['Int']['output']>;
  /** Title as reported by the source (fallback when entity_id is null) */
  source_title?: Maybe<Scalars['String']['output']>;
};

/** A paginated list of UpcomingOffer items. */
export type UpcomingOfferPaginator = {
  __typename?: 'UpcomingOfferPaginator';
  /** A list of UpcomingOffer items. */
  data: Array<UpcomingOffer>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type UpdateArchiveIssue = {
  articles?: InputMaybe<Array<Scalars['String']['input']>>;
  cover_image_path?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  filename?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  issue_number?: InputMaybe<Scalars['Int']['input']>;
  month?: InputMaybe<Scalars['String']['input']>;
  origin_id?: InputMaybe<Scalars['String']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  published_at?: InputMaybe<Scalars['DateTime']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<VgnArchiveMedia>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateBasketAddressesResult = {
  __typename?: 'UpdateBasketAddressesResult';
  deliveryCost?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  shipping?: Maybe<BasketShippingCharge>;
  singleProductShippingCosts?: Maybe<Scalars['Float']['output']>;
  total?: Maybe<ProductsOfferingTotal>;
  uuid?: Maybe<Scalars['String']['output']>;
};

export type UpdateGustoCategory = {
  custom_open_graph_description?: InputMaybe<Scalars['String']['input']>;
  custom_open_graph_title?: InputMaybe<Scalars['String']['input']>;
  custom_twitter_description?: InputMaybe<Scalars['String']['input']>;
  custom_twitter_title?: InputMaybe<Scalars['String']['input']>;
  google_news_title?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  meta_description?: InputMaybe<Scalars['String']['input']>;
  meta_title?: InputMaybe<Scalars['String']['input']>;
  no_follow?: InputMaybe<Scalars['Boolean']['input']>;
  no_index?: InputMaybe<Scalars['Boolean']['input']>;
  open_graph_description?: InputMaybe<Scalars['String']['input']>;
  redirect?: InputMaybe<Scalars['String']['input']>;
  ressort_id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  twitter_description?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateGustoCountry = {
  custom_open_graph_description?: InputMaybe<Scalars['String']['input']>;
  custom_open_graph_title?: InputMaybe<Scalars['String']['input']>;
  custom_twitter_description?: InputMaybe<Scalars['String']['input']>;
  custom_twitter_title?: InputMaybe<Scalars['String']['input']>;
  google_news_title?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  meta_description?: InputMaybe<Scalars['String']['input']>;
  meta_title?: InputMaybe<Scalars['String']['input']>;
  no_follow?: InputMaybe<Scalars['Boolean']['input']>;
  no_index?: InputMaybe<Scalars['Boolean']['input']>;
  open_graph_description?: InputMaybe<Scalars['String']['input']>;
  redirect?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  twitter_description?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateGustoIngredient = {
  bread_units?: InputMaybe<Scalars['Float']['input']>;
  caffeine?: InputMaybe<Scalars['Float']['input']>;
  calories?: InputMaybe<Scalars['Float']['input']>;
  /** kJ value */
  calorific_value?: InputMaybe<Scalars['Float']['input']>;
  carbohydrates?: InputMaybe<Scalars['Float']['input']>;
  carbohydrates_sugar?: InputMaybe<Scalars['Float']['input']>;
  custom_open_graph_description?: InputMaybe<Scalars['String']['input']>;
  custom_open_graph_title?: InputMaybe<Scalars['String']['input']>;
  custom_twitter_description?: InputMaybe<Scalars['String']['input']>;
  custom_twitter_title?: InputMaybe<Scalars['String']['input']>;
  fat?: InputMaybe<Scalars['Float']['input']>;
  google_news_title?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  meta_description?: InputMaybe<Scalars['String']['input']>;
  meta_title?: InputMaybe<Scalars['String']['input']>;
  no_follow?: InputMaybe<Scalars['Boolean']['input']>;
  no_index?: InputMaybe<Scalars['Boolean']['input']>;
  open_graph_description?: InputMaybe<Scalars['String']['input']>;
  protein?: InputMaybe<Scalars['Float']['input']>;
  redirect?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  twitter_description?: InputMaybe<Scalars['String']['input']>;
  water?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateGustoIssue = {
  cover_image_path?: InputMaybe<Scalars['String']['input']>;
  filename?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  issue_number?: InputMaybe<Scalars['Int']['input']>;
  month?: InputMaybe<Scalars['String']['input']>;
  origin_id?: InputMaybe<Scalars['String']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  recipes?: InputMaybe<Array<Scalars['ID']['input']>>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateGustoOccasion = {
  custom_open_graph_description?: InputMaybe<Scalars['String']['input']>;
  custom_open_graph_title?: InputMaybe<Scalars['String']['input']>;
  custom_twitter_description?: InputMaybe<Scalars['String']['input']>;
  custom_twitter_title?: InputMaybe<Scalars['String']['input']>;
  google_news_title?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  meta_description?: InputMaybe<Scalars['String']['input']>;
  meta_title?: InputMaybe<Scalars['String']['input']>;
  no_follow?: InputMaybe<Scalars['Boolean']['input']>;
  no_index?: InputMaybe<Scalars['Boolean']['input']>;
  open_graph_description?: InputMaybe<Scalars['String']['input']>;
  redirect?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  twitter_description?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateGustoProperty = {
  custom_open_graph_description?: InputMaybe<Scalars['String']['input']>;
  custom_open_graph_title?: InputMaybe<Scalars['String']['input']>;
  custom_twitter_description?: InputMaybe<Scalars['String']['input']>;
  custom_twitter_title?: InputMaybe<Scalars['String']['input']>;
  google_news_title?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  meta_description?: InputMaybe<Scalars['String']['input']>;
  meta_title?: InputMaybe<Scalars['String']['input']>;
  no_follow?: InputMaybe<Scalars['Boolean']['input']>;
  no_index?: InputMaybe<Scalars['Boolean']['input']>;
  open_graph_description?: InputMaybe<Scalars['String']['input']>;
  redirect?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  twitter_description?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateGustoRecipe = {
  bread_units?: InputMaybe<Scalars['Float']['input']>;
  caffeine?: InputMaybe<Scalars['Float']['input']>;
  calories?: InputMaybe<Scalars['Float']['input']>;
  /** kJ value */
  calorific_value?: InputMaybe<Scalars['Float']['input']>;
  carbohydrates?: InputMaybe<Scalars['Float']['input']>;
  carbohydrates_sugar?: InputMaybe<Scalars['Float']['input']>;
  categories?: InputMaybe<Array<Scalars['ID']['input']>>;
  category_id?: InputMaybe<Scalars['ID']['input']>;
  cholesterine?: InputMaybe<Scalars['Float']['input']>;
  countries?: InputMaybe<Array<Scalars['ID']['input']>>;
  cover_image_id?: InputMaybe<Scalars['ID']['input']>;
  cover_image_when_video_id?: InputMaybe<Scalars['ID']['input']>;
  custom_open_graph_description?: InputMaybe<Scalars['String']['input']>;
  custom_open_graph_title?: InputMaybe<Scalars['String']['input']>;
  custom_twitter_description?: InputMaybe<Scalars['String']['input']>;
  custom_twitter_title?: InputMaybe<Scalars['String']['input']>;
  fat?: InputMaybe<Scalars['Float']['input']>;
  google_news_title?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  images?: InputMaybe<Array<Scalars['ID']['input']>>;
  ingredient_groups?: InputMaybe<Array<InputGustoRecipeIngredientGroup>>;
  issue_id?: InputMaybe<Scalars['ID']['input']>;
  level?: InputMaybe<GustoRecipeLevel>;
  meta_description?: InputMaybe<Scalars['String']['input']>;
  meta_title?: InputMaybe<Scalars['String']['input']>;
  no_follow?: InputMaybe<Scalars['Boolean']['input']>;
  no_index?: InputMaybe<Scalars['Boolean']['input']>;
  occasions?: InputMaybe<Array<Scalars['ID']['input']>>;
  open_graph_description?: InputMaybe<Scalars['String']['input']>;
  portal?: InputMaybe<Scalars['String']['input']>;
  properties?: InputMaybe<Array<Scalars['ID']['input']>>;
  protein?: InputMaybe<Scalars['Float']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  redirect?: InputMaybe<Scalars['String']['input']>;
  servings?: InputMaybe<Scalars['Int']['input']>;
  servings_unit?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  steps?: InputMaybe<Array<InputGustoRecipeStep>>;
  teaser?: InputMaybe<Scalars['String']['input']>;
  teaser_short?: InputMaybe<Scalars['String']['input']>;
  time?: InputMaybe<Scalars['Int']['input']>;
  time_hint?: InputMaybe<Scalars['String']['input']>;
  tips?: InputMaybe<Array<Scalars['ID']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_short?: InputMaybe<Scalars['String']['input']>;
  twitter_description?: InputMaybe<Scalars['String']['input']>;
  users?: InputMaybe<Array<Scalars['ID']['input']>>;
  water?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateGustoTip = {
  advertorial?: InputMaybe<Scalars['Boolean']['input']>;
  custom_open_graph_description?: InputMaybe<Scalars['String']['input']>;
  custom_open_graph_title?: InputMaybe<Scalars['String']['input']>;
  custom_twitter_description?: InputMaybe<Scalars['String']['input']>;
  custom_twitter_title?: InputMaybe<Scalars['String']['input']>;
  google_news_title?: InputMaybe<Scalars['String']['input']>;
  headline?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  image_id?: InputMaybe<Scalars['ID']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  logo_id?: InputMaybe<Scalars['ID']['input']>;
  meta_description?: InputMaybe<Scalars['String']['input']>;
  meta_title?: InputMaybe<Scalars['String']['input']>;
  no_follow?: InputMaybe<Scalars['Boolean']['input']>;
  no_index?: InputMaybe<Scalars['Boolean']['input']>;
  open_graph_description?: InputMaybe<Scalars['String']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  redirect?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  twitter_description?: InputMaybe<Scalars['String']['input']>;
};

/** Account of a person who utilizes this application. */
export type User = {
  __typename?: 'User';
  /** Articles from the user */
  articles?: Maybe<ArticlePaginatorSimple>;
  avatar?: Maybe<FairuAsset>;
  /** Avatar as a plain CardImage read from the baked sidecar (no FairuAsset federation). */
  avatar_card?: Maybe<CardImage>;
  /** When the account was created. */
  created_at?: Maybe<Scalars['DateTime']['output']>;
  /** Description. */
  description?: Maybe<Scalars['String']['output']>;
  /** Unique email address. */
  email?: Maybe<Scalars['String']['output']>;
  /** When the email was verified. */
  email_verified_at?: Maybe<Scalars['DateTime']['output']>;
  /** Facebook Account for the user */
  facebook?: Maybe<Scalars['String']['output']>;
  /** Fairu home folder ID for photographer uploads */
  fairu_home_folder_id?: Maybe<Scalars['String']['output']>;
  /** Unique primary key. */
  id: Scalars['ID']['output'];
  /** Instagram Account for the user */
  instagram?: Maybe<Scalars['String']['output']>;
  /** Jobs of this user */
  jobs?: Maybe<Array<UserJob>>;
  /** LinkedIn Account for the user */
  linkedin?: Maybe<Scalars['String']['output']>;
  /** Meta data */
  metadata?: Maybe<Meta>;
  /** Non-unique name. */
  name?: Maybe<Scalars['String']['output']>;
  /** List of permissions */
  permissions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Position in team context, else the user's own Funktion (job_title) */
  position?: Maybe<Scalars['String']['output']>;
  /** Profile link */
  profile?: Maybe<Scalars['String']['output']>;
  /** Recipes from gusto */
  recipes?: Maybe<GustoAuthorRequest>;
  /** Slug */
  slug?: Maybe<Scalars['String']['output']>;
  /** Tiktok Account for the user */
  tiktok?: Maybe<Scalars['String']['output']>;
  /** Twitter Account for the user */
  twitter?: Maybe<Scalars['String']['output']>;
  /** When the account was last updated. */
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  /** Website for the user */
  website?: Maybe<Scalars['String']['output']>;
};


/** Account of a person who utilizes this application. */
export type UserArticlesArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  portal?: InputMaybe<Scalars['String']['input']>;
};


/** Account of a person who utilizes this application. */
export type UserDescriptionArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Account of a person who utilizes this application. */
export type UserRecipesArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};

export type UserFavorite = Article | GustoRecipe;

export type UserFavoriteGroup = {
  __typename?: 'UserFavoriteGroup';
  children?: Maybe<Array<UserFavoriteGroup>>;
  entries?: Maybe<Array<UserFavorite>>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  sort?: Maybe<Scalars['Int']['output']>;
};

export type UserFavoriteList = {
  __typename?: 'UserFavoriteList';
  data?: Maybe<Array<UserFavorite>>;
  paginatorInfo?: Maybe<DefaultPaginator>;
};

export enum UserFavoriteType {
  Article = 'ARTICLE',
  Gustorecipe = 'GUSTORECIPE'
}

export type UserJob = {
  __typename?: 'UserJob';
  id: Scalars['ID']['output'];
  slug?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type UserSetting = {
  __typename?: 'UserSetting';
  id: Scalars['ID']['output'];
  key: Scalars['ID']['output'];
  portal: UserSettingPortal;
  type: UserSettingEntryType;
  user_id: Scalars['ID']['output'];
  value?: Maybe<UserSettingEntry>;
};

export type UserSettingEntry = UserSettingEntryBoolean | UserSettingEntryFloat | UserSettingEntryInteger | UserSettingEntryJson | UserSettingEntryText;

export type UserSettingEntryBoolean = {
  __typename?: 'UserSettingEntryBoolean';
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type UserSettingEntryFloat = {
  __typename?: 'UserSettingEntryFloat';
  value?: Maybe<Scalars['Float']['output']>;
};

export type UserSettingEntryInteger = {
  __typename?: 'UserSettingEntryInteger';
  value?: Maybe<Scalars['Int']['output']>;
};

export type UserSettingEntryJson = {
  __typename?: 'UserSettingEntryJson';
  value?: Maybe<Scalars['String']['output']>;
};

export type UserSettingEntryText = {
  __typename?: 'UserSettingEntryText';
  value?: Maybe<Scalars['String']['output']>;
};

export enum UserSettingEntryType {
  Boolean = 'BOOLEAN',
  Float = 'FLOAT',
  Integer = 'INTEGER',
  Json = 'JSON',
  Text = 'TEXT'
}

export enum UserSettingPortal {
  All = 'ALL',
  Autorevue = 'AUTOREVUE',
  Gusto = 'GUSTO',
  News = 'NEWS',
  Trend = 'TREND',
  Tt500 = 'TT500',
  Tvmedia = 'TVMEDIA',
  Woman = 'WOMAN'
}

export type UserTransition = {
  __typename?: 'UserTransition';
  id: Scalars['ID']['output'];
  new_id: Scalars['String']['output'];
  prev_id: Scalars['String']['output'];
};

export type VerifyUserAccountResult = {
  __typename?: 'VerifyUserAccountResult';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type VerifyUserEligibilityResult = {
  __typename?: 'VerifyUserEligibilityResult';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  valid: Scalars['Boolean']['output'];
};

export type VgnArchiveArticleUpdate = {
  author?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type VgnAuthResult = {
  __typename?: 'VgnAuthResult';
  error_text?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type VgnBrand = {
  __typename?: 'VgnBrand';
  /** Subscription page (/abos): what the subscription includes */
  abo_benefits?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Subscription page (/abos): cover of the linked magazine issue, maintained in the magazines collection */
  abo_cover?: Maybe<Scalars['String']['output']>;
  /** Subscription page (/abos): target of the 'Zum Abo' button; brands without one are not listed */
  abo_link?: Maybe<Scalars['String']['output']>;
  ad_formats?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Target of the brand page's 'Mehr anzeigen' button; empty = link to the portal itself */
  articles_link?: Maybe<Scalars['String']['output']>;
  brand?: Maybe<Scalars['String']['output']>;
  brand_positioning?: Maybe<Scalars['String']['output']>;
  /**
   * Renamed to `claim`. Kept so deployed frontends keep working through the recompose; remove once every consumer selects `claim`.
   * @deprecated Use `claim`.
   */
  brand_short?: Maybe<Scalars['String']['output']>;
  channels?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Short brand claim, e.g. "Das Wirtschaftsmagazin" */
  claim?: Maybe<Scalars['String']['output']>;
  contact_persons?: Maybe<Array<Maybe<User>>>;
  description?: Maybe<Scalars['String']['output']>;
  /** Ecosystem slider shown below the brand profile */
  ecosystem_headline?: Maybe<Scalars['String']['output']>;
  ecosystem_items?: Maybe<Array<Maybe<VgnBrandEcosystemItem>>>;
  ecosystem_subline?: Maybe<Scalars['String']['output']>;
  epaper?: Maybe<Scalars['String']['output']>;
  focus_areas?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  headline?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  logo?: Maybe<FairuAsset>;
  media_data_link?: Maybe<Scalars['String']['output']>;
  media_data_link_2?: Maybe<Scalars['String']['output']>;
  media_data_text?: Maybe<Scalars['String']['output']>;
  /** Optional second media-data button (e.g. Print vs. Online) */
  media_data_text_2?: Maybe<Scalars['String']['output']>;
  oewa?: Maybe<Scalars['String']['output']>;
  /** Source note under the digital figure, e.g. "Digital (ÖWA)" or "Eigenangabe" */
  oewa_source?: Maybe<Scalars['String']['output']>;
  oewa_unit?: Maybe<Scalars['String']['output']>;
  portal?: Maybe<Scalars['String']['output']>;
  print_data?: Maybe<Scalars['String']['output']>;
  /** Source note under the print figure, e.g. "Print (MA)" */
  print_source?: Maybe<Scalars['String']['output']>;
  print_unit?: Maybe<Scalars['String']['output']>;
  site_link?: Maybe<Scalars['String']['output']>;
  /** Subscription page (/abos): tagline above the cover */
  slogan?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  teaser?: Maybe<Scalars['String']['output']>;
  teaser_image?: Maybe<FairuAsset>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  video?: Maybe<Scalars['String']['output']>;
};


export type VgnBrandBrand_PositioningArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};


export type VgnBrandTeaserArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};

/** One entry of a brand's ecosystem slider. */
export type VgnBrandEcosystemItem = {
  __typename?: 'VgnBrandEcosystemItem';
  image?: Maybe<FairuAsset>;
  label?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
};

export type VgnCarAd = {
  __typename?: 'VgnCarAd';
  active?: Maybe<Scalars['Boolean']['output']>;
  basis_negotiations?: Maybe<VgnCarAdBasisNegotiations>;
  brand?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  condition?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  equipment?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  fuel?: Maybe<Scalars['String']['output']>;
  horsepower?: Maybe<Scalars['Float']['output']>;
  /** Id */
  id: Scalars['ID']['output'];
  images?: Maybe<Array<Scalars['ID']['output']>>;
  initial_approval_month?: Maybe<Scalars['Int']['output']>;
  initial_approval_year?: Maybe<Scalars['Int']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  mileage?: Maybe<Scalars['Float']['output']>;
  model_name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  postal_code?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  reviewed?: Maybe<Scalars['Boolean']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  submitted?: Maybe<Scalars['Boolean']['output']>;
  terms_accepted?: Maybe<Scalars['Boolean']['output']>;
  updated_at?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['ID']['output']>;
};


export type VgnCarAdConditionArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};


export type VgnCarAdEquipmentArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};


export type VgnCarAdReasonArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum VgnCarAdBasisNegotiations {
  Fix = 'fix',
  Negotiable = 'negotiable'
}

export type VgnCarAdList = {
  __typename?: 'VgnCarAdList';
  data?: Maybe<Array<VgnCarAd>>;
  paginatorInfo?: Maybe<DefaultPaginator>;
};

export type VgnCarAdUpload = {
  __typename?: 'VgnCarAdUpload';
  id: Scalars['ID']['output'];
  upload_url?: Maybe<Scalars['String']['output']>;
};

export type VgnCarBrand = {
  __typename?: 'VgnCarBrand';
  autoscout24_id?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  models: Array<VgnCarModel>;
  name: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['String']['output']>;
};

export type VgnCarMileageRange = {
  start?: InputMaybe<Scalars['Float']['input']>;
  stop?: InputMaybe<Scalars['Float']['input']>;
};

export type VgnCarModel = {
  __typename?: 'VgnCarModel';
  autoscout24_id?: Maybe<Scalars['Int']['output']>;
  brand?: Maybe<VgnCarBrand>;
  brand_id: Scalars['ID']['output'];
  created_at?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['String']['output']>;
};

export type VgnCarPriceRange = {
  start?: InputMaybe<Scalars['Float']['input']>;
  stop?: InputMaybe<Scalars['Float']['input']>;
};

export type VgnCompany = {
  __typename?: 'VgnCompany';
  abos_headline?: Maybe<Scalars['String']['output']>;
  abos_service_ctas?: Maybe<Array<Maybe<CtaButton>>>;
  abos_service_headline?: Maybe<Scalars['String']['output']>;
  abos_service_text?: Maybe<Scalars['String']['output']>;
  abos_subline?: Maybe<Scalars['String']['output']>;
  brands_headline?: Maybe<Scalars['String']['output']>;
  brands_subline?: Maybe<Scalars['String']['output']>;
  contact_sections?: Maybe<Array<Maybe<VgnContactSection>>>;
  cta_ownership?: Maybe<Array<Maybe<CtaButton>>>;
  faq_headline?: Maybe<Scalars['String']['output']>;
  /** Optional intro per FAQ category, shown on /faq when that filter is active */
  faq_intros?: Maybe<Array<Maybe<VgnFaqIntro>>>;
  faq_items?: Maybe<Array<Maybe<VgnFaqItem>>>;
  faq_page_headline?: Maybe<Scalars['String']['output']>;
  /** Replaces faq_headline; that one is only used while this is empty */
  faq_page_subline?: Maybe<Scalars['String']['output']>;
  footer_brands?: Maybe<Array<Maybe<VgnBrand>>>;
  hero_image?: Maybe<FairuAsset>;
  hero_text?: Maybe<Scalars['String']['output']>;
  hero_title?: Maybe<Scalars['String']['output']>;
  history?: Maybe<Array<Maybe<VgnHistoryItem>>>;
  key_figures?: Maybe<Array<Maybe<VgnKeyFigure>>>;
  key_figures_source?: Maybe<Scalars['String']['output']>;
  kontakt_headline?: Maybe<Scalars['String']['output']>;
  kontakt_subline?: Maybe<Scalars['String']['output']>;
  management_ctas?: Maybe<Array<Maybe<CtaButton>>>;
  management_team?: Maybe<Array<Maybe<User>>>;
  mission_headline?: Maybe<Scalars['String']['output']>;
  mission_text?: Maybe<Scalars['String']['output']>;
  newsroom_headline?: Maybe<Scalars['String']['output']>;
  newsroom_subline?: Maybe<Scalars['String']['output']>;
  owners?: Maybe<Array<Maybe<User>>>;
  ownership_text?: Maybe<Scalars['String']['output']>;
  social_links?: Maybe<Array<Maybe<VgnSocialLink>>>;
  standards_ctas?: Maybe<Array<Maybe<CtaButton>>>;
  standards_headline?: Maybe<Scalars['String']['output']>;
  standards_introduction?: Maybe<Scalars['String']['output']>;
  standards_items?: Maybe<Array<Maybe<VgnStandardItem>>>;
};


export type VgnCompanyAbos_Service_TextArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};


export type VgnCompanyHero_TextArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};


export type VgnCompanyMission_TextArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};


export type VgnCompanyOwnership_TextArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};


export type VgnCompanyStandards_IntroductionArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VgnContactSection = {
  __typename?: 'VgnContactSection';
  ctas?: Maybe<Array<Maybe<CtaButton>>>;
  description?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type VgnCreateCarAd = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  basis_negotiations?: InputMaybe<VgnCarAdBasisNegotiations>;
  brand?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  condition?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  equipment?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  fuel?: InputMaybe<Scalars['String']['input']>;
  horsepower?: InputMaybe<Scalars['Float']['input']>;
  /** Id */
  id?: InputMaybe<Scalars['ID']['input']>;
  images?: InputMaybe<Array<Scalars['ID']['input']>>;
  initial_approval_month?: InputMaybe<Scalars['Int']['input']>;
  initial_approval_year?: InputMaybe<Scalars['Int']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  mileage?: InputMaybe<Scalars['Float']['input']>;
  model_name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postal_code?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  reviewed?: InputMaybe<Scalars['Boolean']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  submitted?: InputMaybe<Scalars['Boolean']['input']>;
  terms_accepted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VgnCreateCarBrand = {
  autoscout24_id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
};

export type VgnCreateCarModel = {
  autoscout24_id?: InputMaybe<Scalars['Int']['input']>;
  brand_id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type VgnCreateEvent = {
  accreditation?: InputMaybe<Scalars['Boolean']['input']>;
  article_id?: InputMaybe<Scalars['ID']['input']>;
  asset_id?: InputMaybe<Scalars['ID']['input']>;
  auto_publish_gallery?: InputMaybe<Scalars['Boolean']['input']>;
  categories?: InputMaybe<Array<Scalars['ID']['input']>>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  dates?: InputMaybe<Array<VgnCreateEventDate>>;
  description?: InputMaybe<Scalars['String']['input']>;
  gallery_id?: InputMaybe<Scalars['ID']['input']>;
  /** Id */
  id?: InputMaybe<Scalars['ID']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** Hand the event to a photographer straight away: provisions their Fairu upload folder and mails the credentials, exactly as bookVgnEvent does. The resulting booking behaves like a self-booking and can be unbooked or reassigned. */
  photographer_email?: InputMaybe<Scalars['String']['input']>;
  portal: Scalars['String']['input'];
  postal_code?: InputMaybe<Scalars['String']['input']>;
  presence?: InputMaybe<VgnEventPresence>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  sections?: InputMaybe<Array<Scalars['ID']['input']>>;
  slug?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<VgnEventType>;
  website?: InputMaybe<Scalars['String']['input']>;
  website_tickets?: InputMaybe<Scalars['String']['input']>;
  woman_event?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VgnCreateEventCategory = {
  id?: InputMaybe<Scalars['ID']['input']>;
  portal?: InputMaybe<Scalars['String']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type VgnCreateEventDate = {
  complete_day?: InputMaybe<Scalars['Boolean']['input']>;
  from: Scalars['String']['input'];
  until: Scalars['String']['input'];
};

export type VgnCreateEventSection = {
  id?: InputMaybe<Scalars['ID']['input']>;
  portal?: InputMaybe<Scalars['String']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type VgnEvent = {
  __typename?: 'VgnEvent';
  accreditation?: Maybe<Scalars['Boolean']['output']>;
  article?: Maybe<Article>;
  asset?: Maybe<FairuAsset>;
  auto_publish_gallery?: Maybe<Scalars['Boolean']['output']>;
  bookedUser?: Maybe<BookedEventUser>;
  categories?: Maybe<Array<VgnEventCategory>>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['String']['output']>;
  dates?: Maybe<Array<VgnEventDate>>;
  description?: Maybe<Scalars['String']['output']>;
  gallery?: Maybe<FairuGallery>;
  gallery_id?: Maybe<Scalars['ID']['output']>;
  ics?: Maybe<Scalars['String']['output']>;
  /** Id */
  id: Scalars['ID']['output'];
  images_uploaded_at?: Maybe<Scalars['String']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  portal?: Maybe<Scalars['String']['output']>;
  postal_code?: Maybe<Scalars['String']['output']>;
  presence?: Maybe<VgnEventPresence>;
  published?: Maybe<Scalars['Boolean']['output']>;
  sections?: Maybe<Array<VgnEventSection>>;
  slug?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<VgnEventType>;
  updated_at?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
  website_tickets?: Maybe<Scalars['String']['output']>;
  woman_event?: Maybe<Scalars['Boolean']['output']>;
};


export type VgnEventDescriptionArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VgnEventCategory = {
  __typename?: 'VgnEventCategory';
  /** Id */
  id: Scalars['ID']['output'];
  portal?: Maybe<Scalars['String']['output']>;
  published?: Maybe<Scalars['Boolean']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type VgnEventCategoryList = {
  __typename?: 'VgnEventCategoryList';
  data?: Maybe<Array<VgnEventCategory>>;
  paginatorInfo?: Maybe<DefaultPaginator>;
};

export type VgnEventDate = {
  __typename?: 'VgnEventDate';
  complete_day?: Maybe<Scalars['Boolean']['output']>;
  from?: Maybe<Scalars['String']['output']>;
  /** Id */
  id: Scalars['ID']['output'];
  until?: Maybe<Scalars['String']['output']>;
};

export type VgnEventList = {
  __typename?: 'VgnEventList';
  data?: Maybe<Array<VgnEvent>>;
  paginatorInfo?: Maybe<DefaultPaginator>;
};

export type VgnEventPlace = {
  __typename?: 'VgnEventPlace';
  city?: Maybe<Scalars['String']['output']>;
};

export type VgnEventPlaceList = {
  __typename?: 'VgnEventPlaceList';
  data?: Maybe<Array<VgnEventPlace>>;
  paginatorInfo?: Maybe<DefaultPaginator>;
};

export enum VgnEventPresence {
  Mixed = 'mixed',
  None = 'none',
  Offline = 'offline',
  Online = 'online'
}

export type VgnEventQuery = {
  __typename?: 'VgnEventQuery';
  events?: Maybe<Array<VgnEvent>>;
  /** Id */
  query: Scalars['ID']['output'];
};

export type VgnEventSection = {
  __typename?: 'VgnEventSection';
  /** Id */
  id: Scalars['ID']['output'];
  portal?: Maybe<Scalars['String']['output']>;
  published?: Maybe<Scalars['Boolean']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type VgnEventSectionList = {
  __typename?: 'VgnEventSectionList';
  data?: Maybe<Array<VgnEventSection>>;
  paginatorInfo?: Maybe<DefaultPaginator>;
};

export enum VgnEventType {
  Free = 'free',
  Invite = 'invite',
  None = 'none',
  Paid = 'paid'
}

export type VgnFaqIntro = {
  __typename?: 'VgnFaqIntro';
  /** Must match the category on the FAQ entries; matched case-insensitively via its slug */
  category?: Maybe<Scalars['String']['output']>;
  intro?: Maybe<Scalars['String']['output']>;
};


export type VgnFaqIntroIntroArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VgnFaqItem = {
  __typename?: 'VgnFaqItem';
  answer?: Maybe<Scalars['String']['output']>;
  /** Filter label on /faq; also the deep link (/faq#<slugified category>) */
  category?: Maybe<Scalars['String']['output']>;
  question?: Maybe<Scalars['String']['output']>;
};


export type VgnFaqItemAnswerArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VgnHistoryItem = {
  __typename?: 'VgnHistoryItem';
  description?: Maybe<Scalars['String']['output']>;
  year?: Maybe<Scalars['String']['output']>;
};

export type VgnJob = {
  __typename?: 'VgnJob';
  contact_email?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  pdf?: Maybe<FairuAsset>;
  portal?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  title?: Maybe<Scalars['String']['output']>;
};


export type VgnJobDescriptionArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VgnJobs = {
  __typename?: 'VgnJobs';
  about_text?: Maybe<Scalars['String']['output']>;
  cta_email?: Maybe<Scalars['String']['output']>;
  cta_headline?: Maybe<Scalars['String']['output']>;
  cta_text?: Maybe<Scalars['String']['output']>;
  headline?: Maybe<Scalars['String']['output']>;
  hero_image?: Maybe<FairuAsset>;
  subtitle?: Maybe<Scalars['String']['output']>;
  video?: Maybe<FairuAsset>;
  warum_headline?: Maybe<Scalars['String']['output']>;
  warum_intro?: Maybe<Scalars['String']['output']>;
  warum_points?: Maybe<Array<Maybe<VgnJobsWarumPoint>>>;
};


export type VgnJobsAbout_TextArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};


export type VgnJobsCta_TextArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};


export type VgnJobsWarum_IntroArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VgnJobsWarumPoint = {
  __typename?: 'VgnJobsWarumPoint';
  description?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type VgnKeyFigure = {
  __typename?: 'VgnKeyFigure';
  label?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type VgnLoginResult = {
  __typename?: 'VgnLoginResult';
  error_code?: Maybe<Scalars['String']['output']>;
  error_text?: Maybe<Scalars['String']['output']>;
  refresh_token?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  token?: Maybe<Scalars['String']['output']>;
  user?: Maybe<VgnUser>;
};

export type VgnPhotographer = {
  __typename?: 'VgnPhotographer';
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export enum VgnSalutation {
  An = 'AN',
  Firma = 'FIRMA',
  Frau = 'FRAU',
  Herr = 'HERR'
}

export type VgnSheet = {
  __typename?: 'VgnSheet';
  context?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  path?: Maybe<Scalars['String']['output']>;
  sheets?: Maybe<Scalars['JSON']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type VgnSheetInput = {
  context?: InputMaybe<Scalars['String']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  sheets?: InputMaybe<Scalars['JSON']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type VgnSheetPagination = {
  __typename?: 'VgnSheetPagination';
  data?: Maybe<Array<VgnSheet>>;
  paginatorInfo?: Maybe<DefaultPaginator>;
};

/** A paginated list of VgnSheet items. */
export type VgnSheetPaginator = {
  __typename?: 'VgnSheetPaginator';
  /** A list of VgnSheet items. */
  data: Array<VgnSheet>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type VgnSheetUpdate = {
  context?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  sheets?: InputMaybe<Scalars['JSON']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type VgnSheetUpload = {
  __typename?: 'VgnSheetUpload';
  path?: Maybe<Scalars['String']['output']>;
  sheets?: Maybe<Scalars['JSON']['output']>;
};

export type VgnSocialLink = {
  __typename?: 'VgnSocialLink';
  platform?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type VgnStandardItem = {
  __typename?: 'VgnStandardItem';
  description?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type VgnUpdateCarAd = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  basis_negotiations?: InputMaybe<VgnCarAdBasisNegotiations>;
  brand?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  condition?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  equipment?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  fuel?: InputMaybe<Scalars['String']['input']>;
  horsepower?: InputMaybe<Scalars['Float']['input']>;
  /** Id */
  id: Scalars['ID']['input'];
  images?: InputMaybe<Array<Scalars['ID']['input']>>;
  initial_approval_month?: InputMaybe<Scalars['Int']['input']>;
  initial_approval_year?: InputMaybe<Scalars['Int']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  mileage?: InputMaybe<Scalars['Float']['input']>;
  model_name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postal_code?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  reviewed?: InputMaybe<Scalars['Boolean']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  submitted?: InputMaybe<Scalars['Boolean']['input']>;
  terms_accepted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VgnUpdateCarBrand = {
  autoscout24_id?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type VgnUpdateCarModel = {
  autoscout24_id?: InputMaybe<Scalars['Int']['input']>;
  brand_id?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type VgnUpdateEvent = {
  accreditation?: InputMaybe<Scalars['Boolean']['input']>;
  article_id?: InputMaybe<Scalars['ID']['input']>;
  asset_id?: InputMaybe<Scalars['ID']['input']>;
  auto_publish_gallery?: InputMaybe<Scalars['Boolean']['input']>;
  categories?: InputMaybe<Array<Scalars['ID']['input']>>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  dates?: InputMaybe<Array<VgnCreateEventDate>>;
  description?: InputMaybe<Scalars['String']['input']>;
  gallery_id?: InputMaybe<Scalars['ID']['input']>;
  /** Id */
  id: Scalars['ID']['input'];
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  portal?: InputMaybe<Scalars['String']['input']>;
  postal_code?: InputMaybe<Scalars['String']['input']>;
  presence?: InputMaybe<VgnEventPresence>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  sections?: InputMaybe<Array<Scalars['ID']['input']>>;
  slug?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<VgnEventType>;
  website?: InputMaybe<Scalars['String']['input']>;
  website_tickets?: InputMaybe<Scalars['String']['input']>;
  woman_event?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VgnUpdateEventCategory = {
  id: Scalars['ID']['input'];
  portal?: InputMaybe<Scalars['String']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type VgnUpdateEventSection = {
  id: Scalars['ID']['input'];
  portal?: InputMaybe<Scalars['String']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type VgnUser = {
  __typename?: 'VgnUser';
  attributes?: Maybe<Array<VgnUserAttribute>>;
  email: Scalars['String']['output'];
  email_verified_at?: Maybe<Scalars['String']['output']>;
  first_name: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  last_login_at?: Maybe<Scalars['String']['output']>;
  last_name: Scalars['String']['output'];
  salutation: VgnSalutation;
};

export type VgnUserAttribute = {
  __typename?: 'VgnUserAttribute';
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  valid: Scalars['Boolean']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type VgnUserAttributeInput = {
  key: Scalars['String']['input'];
  valid: Scalars['Boolean']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

export type VnFeProductDisplay = {
  __typename?: 'VnFeProductDisplay';
  digital?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  productDescription?: Maybe<Scalars['String']['output']>;
  productGroup?: Maybe<Scalars['Int']['output']>;
  productShortDescription?: Maybe<Scalars['String']['output']>;
  readersLoungeIncluded?: Maybe<Scalars['Boolean']['output']>;
  touchPoints?: Maybe<Array<Maybe<VnFeProductTouchPoint>>>;
};

export type VnFeProductTouchPoint = {
  __typename?: 'VnFeProductTouchPoint';
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
};

export type Vod = EntityInterface & {
  __typename?: 'Vod';
  /** Asset id  */
  asset_id?: Maybe<Scalars['String']['output']>;
  /** If image cannot be hosted within the ecosystem due to legal reasons */
  asset_url?: Maybe<Scalars['String']['output']>;
  /** Backdrop image */
  backdrop_image?: Maybe<VodImage>;
  /** cover image */
  cover_image?: Maybe<VodImage>;
  /** Created at */
  created_at?: Maybe<Scalars['DateTime']['output']>;
  /** eg. youtube video id */
  external_id?: Maybe<Scalars['String']['output']>;
  /** Unique primary key. */
  id: Scalars['ID']['output'];
  /** IMDB Id */
  imdb_id?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<Provider>;
  provider_id?: Maybe<Scalars['ID']['output']>;
  /** Published */
  published?: Maybe<Scalars['Boolean']['output']>;
  /** Run time */
  runtime?: Maybe<Scalars['Int']['output']>;
  /** Shorttitle of the enitity */
  short?: Maybe<Scalars['String']['output']>;
  /** Slug of the entry */
  slug?: Maybe<Scalars['String']['output']>;
  /** Title of the enitity */
  title?: Maybe<Scalars['String']['output']>;
  /** TMDB Id */
  tmdb_id?: Maybe<Scalars['String']['output']>;
  /** Score */
  tmdb_score?: Maybe<Scalars['Float']['output']>;
  /** Type of VOD content */
  type?: Maybe<Scalars['String']['output']>;
  /** Updated at */
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  /** Deeplink to the entry */
  url?: Maybe<Scalars['String']['output']>;
  /** Year of release */
  year?: Maybe<Scalars['Int']['output']>;
};

export type VodImage = FairuAsset | VodImageFallback;

export type VodImageFallback = {
  __typename?: 'VodImageFallback';
  url?: Maybe<Scalars['String']['output']>;
};

/** A paginated list of Vod items. */
export type VodPaginator = {
  __typename?: 'VodPaginator';
  /** A list of Vod items. */
  data: Array<Vod>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export enum VodType {
  None = 'NONE',
  Youtube = 'YOUTUBE'
}

/** Watch links for a movie or show. */
export type WatchLink = {
  __typename?: 'WatchLink';
  /** Currency */
  currency?: Maybe<Scalars['String']['output']>;
  /** Unique primary key. */
  id: Scalars['ID']['output'];
  /** Deeplink to the portal */
  link?: Maybe<Scalars['String']['output']>;
  /** Movie */
  movie?: Maybe<Movie>;
  /** Price */
  price?: Maybe<Scalars['Float']['output']>;
  /** Pricing model */
  pricing?: Maybe<Scalars['String']['output']>;
  /** Provider */
  provider?: Maybe<Scalars['String']['output']>;
  /** Provider */
  providerEntry?: Maybe<Provider>;
  /** Show */
  show?: Maybe<Show>;
  /** Original provider slug from the imported offer, before grouping. */
  source_provider?: Maybe<Scalars['String']['output']>;
  /** Tmdb ID */
  tmdb_id?: Maybe<Scalars['String']['output']>;
};

/** A paginated list of WatchLink items. */
export type WatchLinkPaginator = {
  __typename?: 'WatchLinkPaginator';
  /** A list of WatchLink items. */
  data: Array<WatchLink>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

/** Dynamic WHERE conditions for queries. */
export type WhereConditions = {
  /** A set of conditions that requires all conditions to match. */
  AND?: InputMaybe<Array<WhereConditions>>;
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: InputMaybe<WhereConditionsRelation>;
  /** A set of conditions that requires at least one condition to match. */
  OR?: InputMaybe<Array<WhereConditions>>;
  /** The column that is used for the condition. */
  column?: InputMaybe<Scalars['String']['input']>;
  /** The operator that is used for the condition. */
  operator?: InputMaybe<SqlOperator>;
  /** The value that is used for the condition. */
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

/** Dynamic WHERE conditions for HAS conditions. */
export type WhereConditionsHasCondition = {
  /** A set of conditions that requires all conditions to match. */
  AND?: InputMaybe<Array<WhereConditionsHasCondition>>;
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: InputMaybe<WhereConditionsRelation>;
  /** A set of conditions that requires at least one condition to match. */
  OR?: InputMaybe<Array<WhereConditionsHasCondition>>;
  /** The column that is used for the condition. */
  column?: InputMaybe<Scalars['String']['input']>;
  /** The operator that is used for the condition. */
  operator?: InputMaybe<SqlOperator>;
  /** The value that is used for the condition. */
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

/** Dynamic HAS conditions for WHERE condition queries. */
export type WhereConditionsRelation = {
  /** The amount to test. */
  amount?: InputMaybe<Scalars['Int']['input']>;
  /** Additional condition logic. */
  condition?: InputMaybe<WhereConditionsHasCondition>;
  /** The comparison operator to test against the amount. */
  operator?: InputMaybe<SqlOperator>;
  /** The relation that is checked. */
  relation: Scalars['String']['input'];
};

export type XmlPage = {
  __typename?: 'XMLPage';
  box?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  file_path: Scalars['String']['output'];
  formatted_content?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image_height?: Maybe<Scalars['Int']['output']>;
  image_path?: Maybe<Scalars['String']['output']>;
  image_url?: Maybe<Scalars['String']['output']>;
  image_width?: Maybe<Scalars['Int']['output']>;
  medium?: Maybe<Scalars['String']['output']>;
  month?: Maybe<Scalars['Int']['output']>;
  ocr_date?: Maybe<Scalars['Date']['output']>;
  page_number?: Maybe<Scalars['String']['output']>;
  publish_date?: Maybe<Scalars['Date']['output']>;
  /** Small rendition for grids (400 px portrait, 800 px landscape). Falls back to image_url for media without a thumbnail tier, so it is always safe to render. */
  thumb_url?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  year?: Maybe<Scalars['Int']['output']>;
};

export type XmlPagePagination = {
  __typename?: 'XMLPagePagination';
  data?: Maybe<Array<XmlPage>>;
  paginatorInfo?: Maybe<DefaultPaginator>;
};

export type CreateMooncalendarInput = {
  ascendent?: InputMaybe<Scalars['String']['input']>;
  bad_bodycare?: InputMaybe<Scalars['Boolean']['input']>;
  bad_cleaning?: InputMaybe<Scalars['Boolean']['input']>;
  bad_cleaning_windows?: InputMaybe<Scalars['Boolean']['input']>;
  bad_cuthair?: InputMaybe<Scalars['Boolean']['input']>;
  bad_facecare?: InputMaybe<Scalars['Boolean']['input']>;
  bad_laundry?: InputMaybe<Scalars['Boolean']['input']>;
  bad_love?: InputMaybe<Scalars['Boolean']['input']>;
  bad_nails?: InputMaybe<Scalars['Boolean']['input']>;
  bad_party?: InputMaybe<Scalars['Boolean']['input']>;
  bad_planting?: InputMaybe<Scalars['Boolean']['input']>;
  bad_traveling?: InputMaybe<Scalars['Boolean']['input']>;
  bad_waterplants?: InputMaybe<Scalars['Boolean']['input']>;
  date: Scalars['String']['input'];
  good_bodycare?: InputMaybe<Scalars['Boolean']['input']>;
  good_cleaning?: InputMaybe<Scalars['Boolean']['input']>;
  good_cleaning_windows?: InputMaybe<Scalars['Boolean']['input']>;
  good_cuthair?: InputMaybe<Scalars['Boolean']['input']>;
  good_facecare?: InputMaybe<Scalars['Boolean']['input']>;
  good_laundry?: InputMaybe<Scalars['Boolean']['input']>;
  good_love?: InputMaybe<Scalars['Boolean']['input']>;
  good_nails?: InputMaybe<Scalars['Boolean']['input']>;
  good_party?: InputMaybe<Scalars['Boolean']['input']>;
  good_planting?: InputMaybe<Scalars['Boolean']['input']>;
  good_traveling?: InputMaybe<Scalars['Boolean']['input']>;
  good_waterplants?: InputMaybe<Scalars['Boolean']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  zodiac?: InputMaybe<Scalars['String']['input']>;
  zodiac_time?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateMooncalendarInput = {
  ascendent?: InputMaybe<Scalars['String']['input']>;
  bad_bodycare?: InputMaybe<Scalars['Boolean']['input']>;
  bad_cleaning?: InputMaybe<Scalars['Boolean']['input']>;
  bad_cleaning_windows?: InputMaybe<Scalars['Boolean']['input']>;
  bad_cuthair?: InputMaybe<Scalars['Boolean']['input']>;
  bad_facecare?: InputMaybe<Scalars['Boolean']['input']>;
  bad_laundry?: InputMaybe<Scalars['Boolean']['input']>;
  bad_love?: InputMaybe<Scalars['Boolean']['input']>;
  bad_nails?: InputMaybe<Scalars['Boolean']['input']>;
  bad_party?: InputMaybe<Scalars['Boolean']['input']>;
  bad_planting?: InputMaybe<Scalars['Boolean']['input']>;
  bad_traveling?: InputMaybe<Scalars['Boolean']['input']>;
  bad_waterplants?: InputMaybe<Scalars['Boolean']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  good_bodycare?: InputMaybe<Scalars['Boolean']['input']>;
  good_cleaning?: InputMaybe<Scalars['Boolean']['input']>;
  good_cleaning_windows?: InputMaybe<Scalars['Boolean']['input']>;
  good_cuthair?: InputMaybe<Scalars['Boolean']['input']>;
  good_facecare?: InputMaybe<Scalars['Boolean']['input']>;
  good_laundry?: InputMaybe<Scalars['Boolean']['input']>;
  good_love?: InputMaybe<Scalars['Boolean']['input']>;
  good_nails?: InputMaybe<Scalars['Boolean']['input']>;
  good_party?: InputMaybe<Scalars['Boolean']['input']>;
  good_planting?: InputMaybe<Scalars['Boolean']['input']>;
  good_traveling?: InputMaybe<Scalars['Boolean']['input']>;
  good_waterplants?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  text?: InputMaybe<Scalars['String']['input']>;
  zodiac?: InputMaybe<Scalars['String']['input']>;
  zodiac_time?: InputMaybe<Scalars['String']['input']>;
};

export type VgnArchiveArticle = {
  __typename?: 'vgnArchiveArticle';
  author?: Maybe<Scalars['String']['output']>;
  department?: Maybe<Scalars['String']['output']>;
  formatted_text?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  images?: Maybe<Array<VgnArchiveArticlesImages>>;
  issue?: Maybe<Scalars['String']['output']>;
  page_end?: Maybe<Scalars['String']['output']>;
  page_start?: Maybe<Scalars['String']['output']>;
  /** The printed pages the article spans. reader_image_url and pdf_url only for the medium's readers. */
  pages?: Maybe<Array<ArchivePage>>;
  published: Scalars['DateTime']['output'];
  slug?: Maybe<Scalars['String']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  text: Scalars['String']['output'];
  title: Scalars['String']['output'];
  type?: Maybe<VgnArchiveMedia>;
};

export type VgnArchiveArticlePagination = {
  __typename?: 'vgnArchiveArticlePagination';
  data?: Maybe<Array<VgnArchiveArticle>>;
  paginatorInfo?: Maybe<DefaultPaginator>;
};

export type VgnArchiveArticlesImages = {
  __typename?: 'vgnArchiveArticlesImages';
  id: Scalars['ID']['output'];
  path?: Maybe<Scalars['String']['output']>;
};

export enum VgnArchiveMedia {
  Autorevue = 'AUTOREVUE',
  Format = 'FORMAT',
  Gusto = 'GUSTO',
  News = 'NEWS',
  Trend = 'TREND',
  Tvmedia = 'TVMEDIA',
  Woman = 'WOMAN',
  Yachtrevue = 'YACHTREVUE'
}

export type VgnPublishingCalendar = {
  __typename?: 'vgnPublishingCalendar';
  cover?: Maybe<Scalars['String']['output']>;
  cover_image?: Maybe<Scalars['String']['output']>;
  /** A special edition of the medium ("balance" for WOMAN Balance), null for a regular issue */
  edition?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  issue?: Maybe<Scalars['String']['output']>;
  issue_continuous?: Maybe<Scalars['String']['output']>;
  issue_long?: Maybe<Scalars['String']['output']>;
  latest_date?: Maybe<Scalars['Date']['output']>;
  medium?: Maybe<Scalars['String']['output']>;
  page_count?: Maybe<Scalars['Int']['output']>;
  pages?: Maybe<Array<ArchivePage>>;
  path?: Maybe<Scalars['String']['output']>;
  portal?: Maybe<Scalars['String']['output']>;
  publish_date?: Maybe<Scalars['Date']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  vgn_date?: Maybe<Scalars['Date']['output']>;
};

/** One possible value for a given Enum. Enum values are unique values, not a placeholder for a string or numeric value. However an Enum value is returned in a JSON response as a string. */
export type __EnumValue = {
  __typename?: '__EnumValue';
  name: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  isDeprecated: Scalars['Boolean']['output'];
  deprecationReason?: Maybe<Scalars['String']['output']>;
};

/** Object and Interface types are described by a list of Fields, each of which has a name, potentially a list of arguments, and a return type. */
export type __Field = {
  __typename?: '__Field';
  name: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  args: Array<__InputValue>;
  type: __Type;
  isDeprecated: Scalars['Boolean']['output'];
  deprecationReason?: Maybe<Scalars['String']['output']>;
};


/** Object and Interface types are described by a list of Fields, each of which has a name, potentially a list of arguments, and a return type. */
export type __FieldArgsArgs = {
  includeDeprecated?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Arguments provided to Fields or Directives and the input fields of an InputObject are represented as Input Values which describe their type and optionally a default value. */
export type __InputValue = {
  __typename?: '__InputValue';
  name: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  type: __Type;
  /** A GraphQL-formatted string representing the default value for this input value. */
  defaultValue?: Maybe<Scalars['String']['output']>;
  isDeprecated: Scalars['Boolean']['output'];
  deprecationReason?: Maybe<Scalars['String']['output']>;
};

/**
 * The fundamental unit of any GraphQL Schema is the type. There are many kinds of types in GraphQL as represented by the `__TypeKind` enum.
 *
 * Depending on the kind of a type, certain fields describe information about that type. Scalar types provide no information beyond a name, description and optional `specifiedByURL`, while Enum types provide their values. Object and Interface types provide the fields they describe. Abstract types, Union and Interface, provide the Object types possible at runtime. List and NonNull types compose other types.
 */
export type __Type = {
  __typename?: '__Type';
  kind: __TypeKind;
  name?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  specifiedByURL?: Maybe<Scalars['String']['output']>;
  fields?: Maybe<Array<__Field>>;
  interfaces?: Maybe<Array<__Type>>;
  possibleTypes?: Maybe<Array<__Type>>;
  enumValues?: Maybe<Array<__EnumValue>>;
  inputFields?: Maybe<Array<__InputValue>>;
  ofType?: Maybe<__Type>;
  isOneOf?: Maybe<Scalars['Boolean']['output']>;
};


/**
 * The fundamental unit of any GraphQL Schema is the type. There are many kinds of types in GraphQL as represented by the `__TypeKind` enum.
 *
 * Depending on the kind of a type, certain fields describe information about that type. Scalar types provide no information beyond a name, description and optional `specifiedByURL`, while Enum types provide their values. Object and Interface types provide the fields they describe. Abstract types, Union and Interface, provide the Object types possible at runtime. List and NonNull types compose other types.
 */
export type __TypeFieldsArgs = {
  includeDeprecated?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * The fundamental unit of any GraphQL Schema is the type. There are many kinds of types in GraphQL as represented by the `__TypeKind` enum.
 *
 * Depending on the kind of a type, certain fields describe information about that type. Scalar types provide no information beyond a name, description and optional `specifiedByURL`, while Enum types provide their values. Object and Interface types provide the fields they describe. Abstract types, Union and Interface, provide the Object types possible at runtime. List and NonNull types compose other types.
 */
export type __TypeEnumValuesArgs = {
  includeDeprecated?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * The fundamental unit of any GraphQL Schema is the type. There are many kinds of types in GraphQL as represented by the `__TypeKind` enum.
 *
 * Depending on the kind of a type, certain fields describe information about that type. Scalar types provide no information beyond a name, description and optional `specifiedByURL`, while Enum types provide their values. Object and Interface types provide the fields they describe. Abstract types, Union and Interface, provide the Object types possible at runtime. List and NonNull types compose other types.
 */
export type __TypeInputFieldsArgs = {
  includeDeprecated?: InputMaybe<Scalars['Boolean']['input']>;
};

/** An enum describing what kind of type a given `__Type` is. */
export enum __TypeKind {
  /** Indicates this type is a scalar. */
  Scalar = 'SCALAR',
  /** Indicates this type is an object. `fields` and `interfaces` are valid fields. */
  Object = 'OBJECT',
  /** Indicates this type is an interface. `fields`, `interfaces`, and `possibleTypes` are valid fields. */
  Interface = 'INTERFACE',
  /** Indicates this type is a union. `possibleTypes` is a valid field. */
  Union = 'UNION',
  /** Indicates this type is an enum. `enumValues` is a valid field. */
  Enum = 'ENUM',
  /** Indicates this type is an input object. `inputFields` is a valid field. */
  InputObject = 'INPUT_OBJECT',
  /** Indicates this type is a list. `ofType` is a valid field. */
  List = 'LIST',
  /** Indicates this type is a non-null. `ofType` is a valid field. */
  NonNull = 'NON_NULL'
}
